"use client"
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x5) => x5.done ? resolve(x5.value) : Promise.resolve(x5.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
import "@xstyled/system";
import {
  useTheme,
  useTh,
  useColorMode,
  useColor as useColor2,
  useSpace,
  useShadow,
  useRadius,
  useViewportWidth,
  useScreens,
  useUp,
  useDown
} from "@xstyled/styled-components";

// src/components/Accordion/Accordion.tsx
import * as React6 from "react";
import styled2 from "@xstyled/styled-components";
import { useChildrenValidation as useChildrenValidation2, useControllableState } from "@aircall/hooks";

// src/components/Flex/Flex.tsx
import { compose as compose2, createCss as createCss2, flexboxes, gap } from "@xstyled/styled-components";

// src/components/Box/Box.tsx
import {
  alignSelf,
  backgrounds,
  borders,
  color,
  compose,
  createCss,
  effects,
  flex,
  flexBasis,
  flexGrow,
  flexShrink,
  gridArea,
  gridColumn,
  gridRow,
  interactivity,
  justifySelf,
  layout,
  order,
  sizing,
  space,
  tables,
  overflow,
  overflowX,
  overflowY
} from "@xstyled/styled-components";
var flexboxItem = compose(flex, flexGrow, flexShrink, flexBasis, justifySelf, alignSelf, order);
var gridItem = compose(gridArea, gridColumn, gridRow);
var boxSystem = compose(
  space,
  sizing,
  layout,
  interactivity,
  effects,
  borders,
  tables,
  backgrounds,
  flexboxItem,
  gridItem,
  color,
  overflow,
  overflowX,
  overflowY
);
var { x } = createCss(boxSystem);
var Box = x.div;
var Box_default = Box;

// src/components/Flex/Flex.tsx
var flexSystem = compose2(boxSystem, flexboxes, gap);
var { x: x2 } = createCss2(flexSystem);
var Flex = x2.div;
Flex.defaultProps = {
  display: "flex"
};
var Flex_default = Flex;

// src/components/Accordion/components/AccordionItem.tsx
import React5 from "react";
import { useChildrenValidation } from "@aircall/hooks";

// src/components/Accordion/contexts/MainContext.tsx
import * as React from "react";
var AccordionMainContext = React.createContext(null);

// src/components/Accordion/contexts/SubContext.tsx
import * as React2 from "react";
var AccordionSubContext = React2.createContext(null);

// src/components/Accordion/components/AccordionBody.tsx
import React3, { useContext as useContext3 } from "react";
import styled from "@xstyled/styled-components";
import { AnimatePresence, motion } from "framer-motion";
var AccordionBodyWrapper = styled(motion.div)`
  z-index: 0;
  display: block;
  width: 100%;
  max-height: 100%;
  flex-shrink: 1;
  overflow-y: auto;
  color: text-base;
`;
var animationVariants = {
  enter: {
    opacity: 1,
    height: "max-content",
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    },
    overflow: "hidden"
  }
};
var AccordionBody = (_a) => {
  var _b = _a, { children } = _b, styleProps = __objRest(_b, ["children"]);
  const { selectedItemId } = useContext3(AccordionMainContext);
  const { id } = useContext3(AccordionSubContext);
  return /* @__PURE__ */ React3.createElement(AnimatePresence, null, selectedItemId === id && /* @__PURE__ */ React3.createElement(
    AccordionBodyWrapper,
    __spreadValues({
      variants: animationVariants,
      initial: "exit",
      animate: "enter",
      exit: "exit"
    }, styleProps),
    children
  ));
};
AccordionBody.displayName = "AccordionBody";

// src/components/Accordion/components/AccordionHeader.tsx
import * as React4 from "react";
var AccordionHeader = (_a) => {
  var _b = _a, { children } = _b, styleProps = __objRest(_b, ["children"]);
  const { onItemClick } = React4.useContext(AccordionMainContext);
  const { id } = React4.useContext(AccordionSubContext);
  const handleSelect = React4.useCallback(() => {
    onItemClick == null ? void 0 : onItemClick(id);
  }, [id, onItemClick]);
  return /* @__PURE__ */ React4.createElement(Flex_default, __spreadValues({ zIndex: 1, onClick: handleSelect, "data-test": `accordion-header-${id}` }, styleProps), children);
};
AccordionHeader.displayName = "AccordionHeader";

// src/components/Accordion/components/AccordionItem.tsx
function AccordionItem({ children, id }) {
  useChildrenValidation(children, "AccordionItem", [AccordionHeader, AccordionBody]);
  return /* @__PURE__ */ React5.createElement(AccordionSubContext.Provider, { value: { id } }, children);
}
AccordionItem.displayName = "AccordionItem";

// src/components/Accordion/Accordion.tsx
var AccordionWrapper = styled2(Flex_default).attrs({
  flexDirection: "column",
  flexShrink: 1,
  minHeight: 0,
  maxHeight: "auto",
  height: "max-content"
})``;
var Accordion = (_a) => {
  var _b = _a, {
    children,
    selected: selectedProp,
    defaultSelected,
    onChange
  } = _b, accordionProps = __objRest(_b, [
    "children",
    "selected",
    "defaultSelected",
    "onChange"
  ]);
  const [selectedItemId, setSelectedItemId] = useControllableState({
    prop: selectedProp,
    defaultProp: defaultSelected,
    onChange
  });
  useChildrenValidation2(children, "AccordionItem", AccordionItem);
  return /* @__PURE__ */ React6.createElement(
    AccordionMainContext.Provider,
    {
      value: {
        selectedItemId,
        onItemClick: setSelectedItemId
      }
    },
    /* @__PURE__ */ React6.createElement(AccordionWrapper, __spreadValues({}, accordionProps), children)
  );
};

// src/components/ActionMenu/ActionMenu.tsx
import * as React44 from "react";

// src/components/Dropdown/Dropdown.tsx
import React17 from "react";

// src/components/Popover/components/PopoverArrow.tsx
import * as React10 from "react";
import { useComposedRefs } from "@aircall/hooks";

// src/components/Popover/contexts/popover.ts
import * as React7 from "react";
var PopoverContext = React7.createContext(null);
var usePopoverContext = () => React7.useContext(PopoverContext);

// src/components/Popover/contexts/popover-placement.ts
import * as React8 from "react";
var PopoverPlacementContext = React8.createContext(null);
var usePopoverPlacement = () => React8.useContext(PopoverPlacementContext);

// src/components/Popover/contexts/popover-arrow.ts
import * as React9 from "react";
var PopoverArrowContext = React9.createContext(null);
var usePopoverArrow = () => React9.useContext(PopoverArrowContext);

// src/components/Popover/components/PopoverArrow.tsx
var PopoverArrow = React10.forwardRef(
  (props, forwardedRef) => {
    const { offset, children } = props;
    const context = usePopoverArrow();
    const { onArrowOffsetChange } = context;
    const composedRefs = useComposedRefs(forwardedRef, (node) => context.onArrowChange(node));
    React10.useEffect(() => onArrowOffsetChange(offset), [onArrowOffsetChange, offset]);
    return /* @__PURE__ */ React10.createElement("span", { style: __spreadProps(__spreadValues({}, context.arrowStyles), { pointerEvents: "none" }), ref: composedRefs }, children);
  }
);

// src/components/Popover/components/PopoverContent.tsx
import * as React12 from "react";
import {
  useCloseOnClick,
  useCloseOnScroll,
  useComposedRefs as useComposedRefs2,
  useRect,
  useSize,
  useWindowSize
} from "@aircall/hooks";

// src/components/Portal/Portal.tsx
import * as React11 from "react";
import ReactDOM from "react-dom";
import { useSafeLayoutEffect } from "@aircall/hooks";

// src/components/Box/MotionBox.tsx
import { motion as motion2 } from "framer-motion";
var MotionBox = motion2(Box_default);

// src/components/Portal/Portal.tsx
var MAX_Z_INDEX = 2147483647;
var Portal = React11.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { containerRef, zIndex = MAX_Z_INDEX } = _b, portalProps = __objRest(_b, ["containerRef", "zIndex"]);
    var _a2, _b2;
    const hostElement = (_b2 = containerRef == null ? void 0 : containerRef.current) != null ? _b2 : (_a2 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a2.body;
    const [, forceUpdate] = React11.useState({});
    useSafeLayoutEffect(() => {
      forceUpdate({});
    }, []);
    if (!hostElement) {
      return null;
    }
    const domNode = ReactDOM.createPortal(
      /* @__PURE__ */ React11.createElement(
        Box_default,
        __spreadProps(__spreadValues({}, portalProps), {
          ref: forwardedRef,
          style: (
            /**
             * If the Portal is injected in `body`, we assume we want whatever is portalled
             * to appear on top of everything. Ideally this would be handled by making sure the
             * app root creates a new stacking context, however this is quite hard to automate.
             * For this reason, we have opted for setting the max z-index on the portal itself.
             */
            hostElement === document.body ? {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex
            } : void 0
          )
        })
      ),
      hostElement
    );
    return /* @__PURE__ */ React11.createElement(React11.Fragment, null, domNode);
  }
);

// src/components/Popover/styled.ts
import styled3, { keyframes } from "@xstyled/styled-components";
var slideUpAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" }
});
var slideRightAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(-2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" }
});
var slideDownAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(-2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" }
});
var slideLeftAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" }
});
var StyledContent = styled3(Flex_default)`
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  animation-fill-mode: forwards;
  will-change: transform, opacity;

  &[data-state='open'] {
    &[data-side='top'] {
      animation-name: ${slideDownAndFade};
    }
    &[data-side='right'] {
      animation-name: ${slideLeftAndFade};
    }
    &[data-side='bottom'] {
      animation-name: ${slideUpAndFade};
    }
    &[data-side='left'] {
      animation-name: ${slideRightAndFade};
    }
  }
`;

// src/components/Popover/utils.ts
function getPlacementData({
  anchorRect,
  popoverSize,
  arrowSize,
  arrowOffset = 0,
  side,
  sideOffset = 0,
  align,
  alignOffset = 0,
  shouldAvoidCollisions = true,
  collisionBoundariesRect,
  collisionTolerance = 0,
  arrowPointsAtCenter = false,
  takeViewportHeight
}) {
  if (!anchorRect || !popoverSize || !collisionBoundariesRect) {
    return {
      popoverStyles: UNMEASURED_POPPER_STYLES,
      arrowStyles: UNMEASURED_ARROW_STYLES
    };
  }
  const allPlacementPoints = getAllPlacementPoints(
    popoverSize,
    anchorRect,
    sideOffset,
    alignOffset,
    arrowSize
  );
  const popoverPoint = allPlacementPoints[side][align];
  if (shouldAvoidCollisions === false) {
    const popoverStyles2 = getPlacementStylesForPoint(popoverPoint);
    let arrowStyles2 = UNMEASURED_ARROW_STYLES;
    if (arrowSize) {
      arrowStyles2 = getPopoverArrowStyles({
        anchorRect,
        popoverSize,
        arrowSize,
        arrowOffset,
        side,
        align,
        arrowPointsAtCenter
      });
    }
    const transformOrigin2 = getTransformOrigin(popoverSize, side, align, arrowOffset, arrowSize);
    return {
      popoverStyles: __spreadProps(__spreadValues({}, popoverStyles2), {
        ["--popover-transform-origin"]: transformOrigin2
      }),
      arrowStyles: arrowStyles2,
      placedSide: side,
      placedAlign: align
    };
  }
  const popoverRect = DOMRect.fromRect(__spreadValues(__spreadValues({}, popoverSize), popoverPoint));
  const collisionBoundariesRectWithTolerance = getContractedRect(
    collisionBoundariesRect,
    collisionTolerance
  );
  const popoverCollisions = getCollisions(popoverRect, collisionBoundariesRectWithTolerance);
  const oppositeSide = getOppositeSide(side);
  const oppositeSidePopoverPoint = allPlacementPoints[oppositeSide][align];
  const updatedOppositeSidePopoverPoint = DOMRect.fromRect(__spreadValues(__spreadValues({}, popoverSize), oppositeSidePopoverPoint));
  const oppositeSidePopoverCollisions = getCollisions(
    updatedOppositeSidePopoverPoint,
    collisionBoundariesRectWithTolerance
  );
  const placedSide = getSideAccountingForCollisions(
    side,
    popoverCollisions,
    oppositeSidePopoverCollisions
  );
  const placedAlign = getAlignAccountingForCollisions(
    popoverSize,
    anchorRect,
    side,
    align,
    popoverCollisions,
    collisionBoundariesRect,
    takeViewportHeight
  );
  const placedPopoverPoint = allPlacementPoints[placedSide][placedAlign];
  const popoverStyles = getPlacementStylesForPoint(placedPopoverPoint);
  let arrowStyles = UNMEASURED_ARROW_STYLES;
  if (arrowSize) {
    arrowStyles = getPopoverArrowStyles({
      anchorRect,
      popoverSize,
      arrowSize,
      arrowOffset,
      side: placedSide,
      align: placedAlign,
      arrowPointsAtCenter
    });
  }
  const transformOrigin = getTransformOrigin(
    popoverSize,
    placedSide,
    placedAlign,
    arrowOffset,
    arrowSize
  );
  return {
    popoverStyles: __spreadProps(__spreadValues({}, popoverStyles), {
      ["--popover-transform-origin"]: transformOrigin
    }),
    arrowStyles,
    placedSide,
    placedAlign
  };
}
function getAllPlacementPoints(popoverSize, anchorRect, sideOffset = 0, alignOffset = 0, arrowSize) {
  const arrowBaseToTipLength = arrowSize ? arrowSize.height : 0;
  const x5 = getPopoverSlotsForAxis(anchorRect, popoverSize, "x");
  const y = getPopoverSlotsForAxis(anchorRect, popoverSize, "y");
  const topY = y.before - sideOffset - arrowBaseToTipLength;
  const bottomY = y.after + sideOffset + arrowBaseToTipLength;
  const leftX = x5.before - sideOffset - arrowBaseToTipLength;
  const rightX = x5.after + sideOffset + arrowBaseToTipLength;
  const map = {
    top: {
      start: { x: x5.start + alignOffset, y: topY },
      center: { x: x5.center, y: topY },
      end: { x: x5.end - alignOffset, y: topY }
    },
    right: {
      start: { x: rightX, y: y.start + alignOffset },
      center: { x: rightX, y: y.center },
      end: { x: rightX, y: y.end - alignOffset }
    },
    bottom: {
      start: { x: x5.start + alignOffset, y: bottomY },
      center: { x: x5.center, y: bottomY },
      end: { x: x5.end - alignOffset, y: bottomY }
    },
    left: {
      start: { x: leftX, y: y.start + alignOffset },
      center: { x: leftX, y: y.center },
      end: { x: leftX, y: y.end - alignOffset }
    }
  };
  return map;
}
function getPopoverSlotsForAxis(anchorRect, popoverSize, axis) {
  const startSide = axis === "x" ? "left" : "top";
  const anchorStart = anchorRect[startSide];
  const dimension = axis === "x" ? "width" : "height";
  const anchorDimension = anchorRect[dimension];
  const popoverDimension = popoverSize[dimension];
  return {
    before: anchorStart - popoverDimension,
    start: anchorStart,
    center: anchorStart + (anchorDimension - popoverDimension) / 2,
    end: anchorStart + anchorDimension - popoverDimension,
    after: anchorStart + anchorDimension
  };
}
function getSideAccountingForCollisions(side, collisions, oppositeSideCollisions) {
  const oppositeSide = getOppositeSide(side);
  if (collisions[side] <= 0 && oppositeSideCollisions[oppositeSide] <= 0)
    return side;
  else if (collisions[side] > 0 && oppositeSideCollisions[oppositeSide] > 0)
    return collisions[side] < oppositeSideCollisions[oppositeSide] ? side : oppositeSide;
  return collisions[side] <= 0 ? side : oppositeSide;
}
function getAlignAccountingForCollisions(popoverSize, anchorSize, side, align, collisions, collisionBoundariesRect, takeViewportHeight) {
  var _a;
  const isHorizontalSide = side === "top" || side === "bottom";
  const startBound = isHorizontalSide ? "left" : "top";
  const endBound = isHorizontalSide ? "right" : "bottom";
  const dimension = isHorizontalSide ? "width" : "height";
  const isAnchorBigger = anchorSize[dimension] > popoverSize[dimension];
  const anchorTopSpace = anchorSize.top;
  const anchorBottomSpace = ((_a = collisionBoundariesRect == null ? void 0 : collisionBoundariesRect.height) != null ? _a : 0) - anchorSize.top - (anchorSize == null ? void 0 : anchorSize.height);
  if (takeViewportHeight && anchorTopSpace < popoverSize.height && anchorBottomSpace < popoverSize.height) {
    if (anchorTopSpace < anchorBottomSpace) {
      return "start";
    }
    if (anchorTopSpace > anchorBottomSpace) {
      return "end";
    }
  }
  if (align === "start" || align === "center") {
    if (collisions[startBound] > 0 && isAnchorBigger || collisions[endBound] > 0 && !isAnchorBigger) {
      return "end";
    }
  }
  if (align === "end" || align === "center") {
    if (collisions[endBound] > 0 && isAnchorBigger || collisions[startBound] > 0 && !isAnchorBigger) {
      return "start";
    }
  }
  return align;
}
function getPlacementStylesForPoint(point) {
  const x5 = Math.round(point.x + window.scrollX);
  const y = Math.round(point.y + window.scrollY);
  return {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "max-content",
    willChange: "transform",
    transform: `translate3d(${x5}px, ${y}px, 0)`
  };
}
function getTransformOrigin(popoverSize, side, align, arrowOffset, arrowSize) {
  const isHorizontalSide = side === "top" || side === "bottom";
  const arrowBaseLength = arrowSize ? arrowSize.width : 0;
  const arrowBaseToTipLength = arrowSize ? arrowSize.height : 0;
  const sideOffset = arrowBaseToTipLength;
  const alignOffset = arrowBaseLength / 2 + arrowOffset;
  let x5 = "";
  let y = "";
  if (isHorizontalSide) {
    x5 = {
      start: `${alignOffset}px`,
      center: "center",
      end: `${popoverSize.width - alignOffset}px`
    }[align];
    y = side === "top" ? `${popoverSize.height + sideOffset}px` : `${-sideOffset}px`;
  } else {
    x5 = side === "left" ? `${popoverSize.width + sideOffset}px` : `${-sideOffset}px`;
    y = {
      start: `${alignOffset}px`,
      center: "center",
      end: `${popoverSize.height - alignOffset}px`
    }[align];
  }
  return `${x5} ${y}`;
}
var UNMEASURED_POPPER_STYLES = {
  // position: 'fixed' here is important because it will take the popover
  // out of the flow so it does not disturb the position of the anchor
  position: "fixed",
  top: 0,
  left: 0,
  opacity: 0,
  transform: "translate3d(0, -200%, 0)"
};
var UNMEASURED_ARROW_STYLES = {
  // given the arrow is nested inside the popover,
  // make sure that it is out of the flow and doesn't hinder then popover's measurement
  position: "absolute",
  opacity: 0
};
function getPopoverArrowStyles({
  anchorRect,
  popoverSize,
  arrowSize,
  arrowOffset,
  side,
  align,
  arrowPointsAtCenter
}) {
  const popoverCenterX = (popoverSize.width - arrowSize.width) / 2;
  const popoverCenterY = (popoverSize.height - arrowSize.width) / 2;
  const anchorCenterX = (anchorRect.width - arrowSize.width) / 2;
  const anchorCenterY = (anchorRect.width - arrowSize.width) / 2;
  const rotationMap = { top: 0, right: 90, bottom: 180, left: -90 };
  const rotation = rotationMap[side];
  const arrowMaxDimension = Math.max(arrowSize.width, arrowSize.height);
  const styles = {
    // we make sure we put the arrow inside a 1:1 ratio container
    // this is to make the rotation handling simpler
    // as we do no need to worry about changing the transform-origin
    width: `${arrowMaxDimension}px`,
    height: `${arrowMaxDimension}px`,
    // rotate the arrow appropriately
    transform: `rotate(${rotation}deg)`,
    willChange: "transform",
    // position the arrow appropriately
    position: "absolute",
    [side]: "100%",
    // Because the arrow gets rotated (see `transform above`)
    // and we are putting it inside a 1:1 ratio container
    // we need to adjust the CSS direction from `ltr` to `rtl`
    // in some circumstances
    direction: getArrowCssDirection(side, align)
  };
  if (side === "top" || side === "bottom") {
    if (arrowPointsAtCenter) {
      if (align === "start") {
        styles.left = `${anchorCenterX}px`;
      }
      if (align === "center") {
        styles.left = `${popoverCenterX}px`;
      }
      if (align === "end") {
        styles.right = `${anchorCenterX}px`;
      }
    } else {
      if (align === "start") {
        styles.left = `${arrowOffset}px`;
      }
      if (align === "center") {
        styles.left = `${popoverCenterX}px`;
      }
      if (align === "end") {
        styles.right = `${arrowOffset}px`;
      }
    }
  }
  if (side === "left" || side === "right") {
    if (arrowPointsAtCenter) {
      if (align === "start") {
        styles.top = `${anchorCenterY}px`;
      }
      if (align === "center") {
        styles.top = `${popoverCenterY}px`;
      }
      if (align === "end") {
        styles.bottom = `${anchorCenterY}px`;
      }
    } else {
      if (align === "start") {
        styles.top = `${arrowOffset}px`;
      }
      if (align === "center") {
        styles.top = `${popoverCenterY}px`;
      }
      if (align === "end") {
        styles.bottom = `${arrowOffset}px`;
      }
    }
  }
  return styles;
}
function getArrowCssDirection(side, align) {
  if ((side === "top" || side === "right") && align === "end") {
    return "rtl";
  }
  if ((side === "bottom" || side === "left") && align !== "end") {
    return "rtl";
  }
  return "ltr";
}
function getOppositeSide(side) {
  const oppositeSides = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  };
  return oppositeSides[side];
}
function getContractedRect(rect, amount) {
  return DOMRect.fromRect({
    width: rect.width - amount * 2,
    height: rect.height - amount * 2,
    x: rect.left + amount,
    y: rect.top + amount
  });
}
function getCollisions(rect, collisionBoundariesRect) {
  return {
    top: collisionBoundariesRect.top - rect.top,
    right: rect.right - collisionBoundariesRect.right,
    bottom: rect.bottom - collisionBoundariesRect.bottom,
    left: collisionBoundariesRect.left - rect.left
  };
}
function getLeftoverViewportHeight({
  side,
  takeViewportHeight,
  collisionBoundariesRect,
  anchorRect,
  sideOffset,
  align
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  if (!takeViewportHeight || !side) {
    return void 0;
  }
  if (["left", "right"].includes(side)) {
    if (align === "start") {
      return ((_a = collisionBoundariesRect == null ? void 0 : collisionBoundariesRect.height) != null ? _a : 0) - ((_b = anchorRect == null ? void 0 : anchorRect.top) != null ? _b : 0) - 16;
    }
    if (align === "end") {
      return ((_c = anchorRect == null ? void 0 : anchorRect.height) != null ? _c : 0) + ((_d = anchorRect == null ? void 0 : anchorRect.top) != null ? _d : 0) - 16;
    }
    if (align === "center") {
      return void 0;
    }
  }
  return side === "bottom" ? ((_e = collisionBoundariesRect == null ? void 0 : collisionBoundariesRect.height) != null ? _e : 0) - ((_f = anchorRect == null ? void 0 : anchorRect.bottom) != null ? _f : 0) - sideOffset - 16 : ((_g = anchorRect == null ? void 0 : anchorRect.top) != null ? _g : 0) - ((_h = collisionBoundariesRect == null ? void 0 : collisionBoundariesRect.top) != null ? _h : 0) - sideOffset - 16;
}

// src/components/Popover/components/PopoverContent.tsx
var PopoverContent = React12.forwardRef(
  (props, forwaredRef) => {
    const _a = props, { portalled = true, zIndex } = _a, popoverContent = __objRest(_a, ["portalled", "zIndex"]);
    const { open } = usePopoverContext();
    if (!open) {
      return null;
    }
    const PopoverComponent = /* @__PURE__ */ React12.createElement(PopoverContentImpl, __spreadProps(__spreadValues({}, popoverContent), { ref: forwaredRef }));
    return portalled ? /* @__PURE__ */ React12.createElement(Portal, { containerRef: props.portalContainerRef, zIndex }, PopoverComponent) : PopoverComponent;
  }
);
var PopoverContentImpl = React12.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, {
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset,
      collisionTolerance,
      avoidCollisions = true,
      children,
      takeTriggerWidth = false,
      takeViewportHeight = false,
      closeOnOutsideClick = true,
      closeOnInsideClick = false,
      arrowPointsAtCenter = false
    } = _b, contentProps = __objRest(_b, [
      "side",
      "sideOffset",
      "align",
      "alignOffset",
      "collisionTolerance",
      "avoidCollisions",
      "children",
      "takeTriggerWidth",
      "takeViewportHeight",
      "closeOnOutsideClick",
      "closeOnInsideClick",
      "arrowPointsAtCenter"
    ]);
    const context = usePopoverContext();
    const [arrowOffset, setArrowOffset] = React12.useState();
    const anchorRect = useRect(context.trigger);
    const [content, setContent] = React12.useState(null);
    const contentSize = useSize(content);
    const [arrow, setArrow] = React12.useState(null);
    const arrowSize = useSize(arrow);
    const composedRefs = useComposedRefs2(forwardedRef, (node) => setContent(node));
    const closeContent = () => context.setOpen(false);
    useCloseOnClick({
      container: document.body,
      triggerNode: context.trigger,
      node: content,
      closeOnInsideClick,
      onClose: () => closeOnOutsideClick && context.setOpen(false)
    });
    useCloseOnScroll({
      container: window,
      node: content,
      onClose: closeContent
    });
    const windowSize = useWindowSize();
    const collisionBoundariesRect = windowSize ? DOMRect.fromRect(__spreadProps(__spreadValues({}, windowSize), { x: 0, y: 0 })) : void 0;
    const { popoverStyles, arrowStyles, placedSide, placedAlign } = getPlacementData({
      anchorRect,
      popoverSize: contentSize,
      arrowSize,
      arrowOffset,
      side,
      sideOffset,
      align,
      alignOffset,
      shouldAvoidCollisions: avoidCollisions,
      collisionBoundariesRect,
      collisionTolerance,
      arrowPointsAtCenter,
      takeViewportHeight
    });
    const isPlaced = placedSide !== void 0;
    const maxHeight2 = getLeftoverViewportHeight({
      side: placedSide,
      anchorRect,
      collisionBoundariesRect,
      sideOffset,
      takeViewportHeight,
      align: placedAlign
    });
    return /* @__PURE__ */ React12.createElement(PopoverPlacementContext.Provider, { value: { side: placedSide, align: placedAlign } }, /* @__PURE__ */ React12.createElement(
      PopoverArrowContext.Provider,
      {
        value: {
          arrowStyles,
          onArrowChange: setArrow,
          onArrowOffsetChange: setArrowOffset
        }
      },
      /* @__PURE__ */ React12.createElement("div", { style: popoverStyles }, /* @__PURE__ */ React12.createElement(
        StyledContent,
        __spreadProps(__spreadValues({}, contentProps), {
          ref: composedRefs,
          "data-side": placedSide,
          "data-align": placedAlign,
          "data-state": context.open ? "open" : "closed",
          w: takeTriggerWidth ? anchorRect == null ? void 0 : anchorRect.width : void 0,
          maxHeight: maxHeight2,
          style: {
            // if the PopoverContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? "none" : void 0
          }
        }),
        children
      ))
    ));
  }
);

// src/components/Popover/components/PopoverRoot.tsx
import * as React13 from "react";
import { useControllableState as useControllableState2 } from "@aircall/hooks";
var PopoverRoot = ({
  children,
  open: openProp,
  defaultOpen,
  onOpenChange
}) => {
  const [trigger, setTrigger] = React13.useState(null);
  const [open = false, setOpen] = useControllableState2({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ React13.createElement(
    PopoverContext.Provider,
    {
      value: {
        trigger,
        onTriggerChange: setTrigger,
        open,
        setOpen,
        toggleOpen: React13.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen])
      }
    },
    children
  );
};

// src/components/Popover/components/PopoverTrigger.tsx
import * as React14 from "react";
import { useCloseOnEscape, useComposedRefs as useComposedRefs3 } from "@aircall/hooks";

// src/utils/handlers.ts
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
}

// src/components/Popover/components/PopoverTrigger.tsx
var PopoverTrigger = React14.forwardRef(
  (_a, triggerRef) => {
    var _b = _a, { children } = _b, triggerProps = __objRest(_b, ["children"]);
    var _a2, _b2;
    const child = React14.Children.only(children);
    const { onTriggerChange, open, setOpen } = usePopoverContext();
    const closePopoverContent = () => {
      setOpen(false);
    };
    useCloseOnEscape(open, closePopoverContent);
    const ref = React14.useRef(null);
    const composedRefs = useComposedRefs3(child.ref, triggerRef, ref);
    React14.useEffect(() => {
      onTriggerChange(ref.current);
    });
    return React14.cloneElement(child, __spreadProps(__spreadValues(__spreadValues({}, child.props), triggerProps), {
      ref: composedRefs,
      onBlur: composeEventHandlers((_a2 = child.props) == null ? void 0 : _a2.onBlur, triggerProps.onBlur),
      onClick: composeEventHandlers((_b2 = child.props) == null ? void 0 : _b2.onClick, triggerProps.onClick)
    }));
  }
);

// src/components/Popover/Popover.tsx
var Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Arrow: PopoverArrow
};

// src/components/Dropdown/components/DropdownContent/DropdownContent.tsx
import * as React15 from "react";
var DropdownContent = (_a) => {
  var _b = _a, {
    children,
    sideOffset = 8,
    overflowY: overflowY2 = "auto"
  } = _b, popoverContent = __objRest(_b, [
    "children",
    "sideOffset",
    "overflowY"
  ]);
  return /* @__PURE__ */ React15.createElement(
    Popover.Content,
    __spreadProps(__spreadValues({}, popoverContent), {
      sideOffset,
      overflowY: overflowY2,
      boxShadow: 1,
      borderRadius: "sm",
      bg: "surface-interactive-default",
      py: 2
    }),
    children
  );
};

// src/components/Dropdown/components/DropdownTrigger/DropdownTrigger.tsx
import * as React16 from "react";

// src/components/Dropdown/contexts/context.ts
var useDropdownContext = usePopoverContext;

// src/components/Dropdown/components/DropdownTrigger/DropdownTrigger.tsx
var DropdownTrigger = React16.forwardRef(
  (_a, ref) => {
    var _b = _a, { triggerOnHover } = _b, triggerProps = __objRest(_b, ["triggerOnHover"]);
    const { toggleOpen } = useDropdownContext();
    const onClick = (event) => {
      if (triggerOnHover)
        return;
      event.stopPropagation();
      toggleOpen();
    };
    const onMouseEnter = (event) => {
      if (!triggerOnHover)
        return;
      toggleOpen();
    };
    const onMouseLeave = (event) => {
      if (!triggerOnHover)
        return;
      toggleOpen();
    };
    return /* @__PURE__ */ React16.createElement(
      Popover.Trigger,
      __spreadProps(__spreadValues({}, triggerProps), {
        ref,
        onClick,
        onMouseEnter,
        onMouseLeave
      })
    );
  }
);

// src/components/Dropdown/Dropdown.tsx
var Dropdown = (_a) => {
  var _b = _a, {
    trigger,
    triggerOnHover = false,
    side = "bottom",
    align = "center",
    defaultVisible = false,
    visible,
    onVisibilityChange,
    closeOnInsideClick = true,
    children,
    "data-test": testId = "dropdown",
    maxWidth = 344
  } = _b, otherProps = __objRest(_b, [
    "trigger",
    "triggerOnHover",
    "side",
    "align",
    "defaultVisible",
    "visible",
    "onVisibilityChange",
    "closeOnInsideClick",
    "children",
    "data-test",
    "maxWidth"
  ]);
  return /* @__PURE__ */ React17.createElement(Popover.Root, { defaultOpen: defaultVisible, open: visible, onOpenChange: onVisibilityChange }, /* @__PURE__ */ React17.createElement(DropdownTrigger, { triggerOnHover }, trigger), /* @__PURE__ */ React17.createElement(
    DropdownContent,
    __spreadValues({
      side,
      align,
      "data-test": testId,
      maxWidth,
      closeOnInsideClick
    }, otherProps),
    children
  ));
};

// src/components/Dropdown/components/DropdownButton/DropdownButton.tsx
import * as React25 from "react";

// src/components/Button/Button.tsx
import * as React24 from "react";

// src/internal/forward-ref.ts
import { forwardRef as forwardReactRef } from "react";
function forwardRef6(component) {
  return forwardReactRef(component);
}

// src/components/Form/components/Form/Form.tsx
import * as React20 from "react";

// src/components/Form/contexts/formContext.ts
import * as React18 from "react";
var FormContext = React18.createContext(null);
var useFormContext = () => React18.useContext(FormContext);

// src/components/Form/contexts/formItemContext.ts
import * as React19 from "react";
var FormItemContext = React19.createContext(null);
var useFormItemContext = () => React19.useContext(FormItemContext);

// src/components/Form/components/Form/Form.tsx
var Form = (_a) => {
  var _b = _a, {
    size: size2 = "regular",
    children
  } = _b, otherFormProps = __objRest(_b, [
    "size",
    "children"
  ]);
  return /* @__PURE__ */ React20.createElement(FormContext.Provider, { value: { size: size2 } }, /* @__PURE__ */ React20.createElement("form", __spreadValues({}, otherFormProps), children));
};
var Form_default = Form;

// src/components/Form/components/FormItem/FormItem.tsx
import * as React22 from "react";

// src/components/Grid/Grid.tsx
import { compose as compose3, createCss as createCss3, flexboxes as flexboxes2, grids } from "@xstyled/styled-components";
var gridSystem = compose3(boxSystem, flexboxes2, grids);
var { x: x3 } = createCss3(gridSystem);
var Grid = x3.div;
Grid.defaultProps = {
  display: "grid"
};

// src/components/Typography/Typography.tsx
import { compose as compose4, createCss as createCss4, style, typography } from "@xstyled/styled-components";
var wordBreak = style({
  prop: "wordBreak"
});
var variant = style({
  prop: "variant",
  css: (value) => ({ theme }) => ({
    fontSize: theme.typography[value].fontSize,
    lineHeight: theme.typography[value].lineHeight,
    fontWeight: theme.typography[value].fontWeight
  })
});
var ellipsis = style({
  prop: "ellipsis",
  css: (value) => {
    if (typeof value === "number" && value > 0)
      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        WebkitLineClamp: value,
        WebkitBoxOrient: "vertical",
        display: "-webkit-box"
      };
    if (value === true) {
      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
    } else
      return {};
  }
});
var typographySystem = compose4(boxSystem, typography, wordBreak, variant, ellipsis);
var { x: x4 } = createCss4(typographySystem);
var Typography = x4.div;
Typography.defaultProps = {
  variant: "bodyMediumS",
  fontFamily: "default"
};
var Typography_default = Typography;

// src/components/Typography/Link.tsx
import React21 from "react";
import styled4 from "@xstyled/styled-components";

// src/utils/general.ts
function noop() {
  return void 0;
}
function mapValues(value, iterator) {
  return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, iterator(v)]));
}

// src/utils/theme.ts
import {
  generateHexAlphaVariants,
  th
} from "@xstyled/styled-components";
var fromTheme = (key, fallback) => th(key, fallback);
var getColor = (key, fallback) => th.color(key, fallback);
var getRadii = (key, fallback) => th.radius(key, fallback);
var getSpace = (key, fallback) => th.space(key, fallback);
var getShadow = (key, fallback) => th.shadow(key, fallback);

// src/utils/colors.ts
import { getLuminance } from "polished";
function textColor(color4, white, dark) {
  const isColorLight = getLuminance(color4) > 0.179;
  return isColorLight ? dark : white;
}

// src/utils/string.ts
var join = (values, separator = " ") => values.filter(Boolean).join(separator);

// src/components/Typography/Link.tsx
var CustomTypography = styled4(Typography_default)`
  display: inline;
  background-color: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  color: ${getColor("text-interactive-primary")};

  &:hover {
    text-decoration: underline;
    color: ${getColor("text-interactive-primary-hover")};
  }

  &:active {
    color: ${getColor("text-interactive-primary-active")};
  }
`;
var Link = (props) => {
  return /* @__PURE__ */ React21.createElement(CustomTypography, __spreadValues({ variant: "bodyMediumS", as: "a" }, props));
};
var Link_default = Link;

// src/components/Form/components/FormItem/FormItem.tsx
var FormItem = (_a) => {
  var _b = _a, {
    label,
    labelId,
    name,
    helpText,
    validationStatus,
    children
  } = _b, otherStylingProps = __objRest(_b, [
    "label",
    "labelId",
    "name",
    "helpText",
    "validationStatus",
    "children"
  ]);
  const error = validationStatus === "error";
  return /* @__PURE__ */ React22.createElement(FormItemContext.Provider, { value: { validationStatus, name } }, /* @__PURE__ */ React22.createElement(Grid, __spreadValues({ gap: "xxs" }, otherStylingProps), label && /* @__PURE__ */ React22.createElement(Typography_default, { textAlign: "start", color: "text-base", as: "label", htmlFor: name, id: labelId }, label), children, helpText && /* @__PURE__ */ React22.createElement(
    Typography_default,
    {
      textAlign: "start",
      color: error ? "text-critical" : "text-placeholder",
      variant: "supportingMediumXS"
    },
    helpText
  )));
};
var FormItem_default = FormItem;

// src/components/Button/components/StyledButton.tsx
import styled5 from "@xstyled/styled-components";

// src/styles/utility-groups/size.ts
import { style as style2 } from "@xstyled/styled-components";
var size = style2({
  prop: "size",
  css: ["width", "height"]
});

// src/styles/utility-groups/outline.ts
import { css } from "@xstyled/styled-components";
var outlineStyles = css`
  /* 
   * We use &&, and reset outline-style due to normalize.css rules,
   * which affect Firefox browser default outline styles.
   * More info here: https://github.com/necolas/normalize.css/issues/627
   */
  outline-style: auto;
  outline-width: 1px;
  outline-offset: 4px;
  outline-color: Highlight;
  outline-color: -webkit-focus-ring-color;
`;
var outlineFocusVisible = css`
  /*
   * Using :focus-visible instead of :focus is needed
   * to keep default browser :focus + :active styles behaviour
   */
  &&:focus-visible {
    ${outlineStyles}
  }

  &&:focus:not(:focus-visible) {
    outline-color: transparent;
  }
`;

// src/components/Button/utils.tsx
import * as React23 from "react";
import { css as css2 } from "@xstyled/styled-components";

// src/components/Button/constants.ts
var linkSizes = {
  xSmall: {
    height: "28px",
    minWidth: "28px",
    padding: "0 8px"
  },
  small: {
    height: "40px",
    minWidth: "40px",
    padding: "0 8px"
  },
  regular: {
    height: "48px",
    minWidth: "48px",
    padding: "0 8px"
  },
  large: {
    height: "56px",
    minWidth: "56px",
    padding: "0 8px"
  }
};
var buttonSizes = {
  xSmall: {
    height: "28px",
    minWidth: "28px",
    padding: "0 8px"
  },
  small: {
    height: "40px",
    minWidth: "40px",
    padding: "0 16px"
  },
  regular: {
    height: "48px",
    minWidth: "48px",
    padding: "0 16px"
  },
  large: {
    height: "56px",
    minWidth: "56px",
    padding: "0 16px"
  }
};
var iconButtonSizes = {
  xSmall: {
    height: "16px",
    width: "16px"
  },
  small: {
    height: "24px",
    width: "24px"
  },
  regular: {
    height: "24px",
    width: "24px"
  },
  large: {
    height: "24px",
    width: "24px"
  }
};

// src/components/Button/utils.tsx
var makeButtonVariant = ({
  variant: variant2,
  disabled,
  mode,
  readOnly
}) => {
  const getBackgroundColor = (color4, state) => {
    switch (mode) {
      case "outline":
      case "link":
        return "transparent";
      case "ghost":
        return join([color4, "ghost", state], "-");
      default:
        return join([color4, state], "-");
    }
  };
  const getBorderColor = (color4, state) => {
    switch (mode) {
      case "link":
        return "transparent";
      case "ghost":
        return join([color4, "ghost", state], "-");
      default:
        return join([color4, state], "-");
    }
  };
  const getTextColor = (color4, state) => {
    switch (mode) {
      case "fill":
        return "text-contrast-light";
      case "ghost":
        return join([color4, "ghost"], "-");
      default:
        return join([color4, state], "-");
    }
  };
  if (disabled) {
    return css2`
      pointer-events: none;
      background-color: ${mode === "ghost" ? "transparent" : getBackgroundColor("surface-interactive-disabled")};
      border-color: ${getBorderColor("graphic-disabled")};
      cursor: not-allowed;
      color: text-disabled;
      svg {
        fill: text-disabled;
      }
    `;
  }
  return css2`
    color: ${getTextColor(`text-interactive-${variant2}`)};
    svg {
      fill: ${getTextColor(`text-interactive-${variant2}`)};
    }

    background-color: ${getBackgroundColor(`surface-interactive-${variant2}`)};
    border-color: ${getBorderColor(`graphic-interactive-${variant2}`)};

    ${!readOnly && css2`
      :hover {
        background-color: ${getBackgroundColor(`surface-interactive-${variant2}`, "hover")};
        border-color: ${getBorderColor(`graphic-interactive-${variant2}`, "hover")};
        color: ${getTextColor(`text-interactive-${variant2}`, "hover")};
        svg {
          fill: ${getTextColor(`text-interactive-${variant2}`, "hover")};
        }
      }

      :active {
        background-color: ${getBackgroundColor(`surface-interactive-${variant2}`, "active")};
        border-color: ${getBorderColor(`graphic-interactive-${variant2}`, "active")};
        color: ${getTextColor(`text-interactive-${variant2}`, "active")};
        svg {
          fill: ${getTextColor(`text-interactive-${variant2}`, "active")};
        }
      }
    `}
  `;
};
var makeButtonTypography = ({
  mode,
  buttonSize,
  disabled,
  theme
}) => {
  const typography3 = buttonSize === "xSmall" ? theme.typography.bodyMediumS : theme.typography.bodyMediumM;
  if (mode === "link") {
    return css2`
      ${typography3}

      ${disabled ? void 0 : css2`
            &:hover,
            &:active,
            &:focus-visible {
              text-decoration: underline;
            }
          `}
    `;
  }
  return css2`
    ${typography3}

    &:hover,
    &:active,
    &:focus-visible {
      text-decoration: none;
    }
  `;
};
var makeButtonSize = ({ mode, buttonSize }) => {
  if (mode === "link") {
    return linkSizes[buttonSize];
  }
  return buttonSizes[buttonSize];
};
var makeIconButtonSize = ({ mode, buttonSize }) => {
  return css2`
    svg {
      ${iconButtonSizes[buttonSize]}
    }
  `;
};
var shouldForwardProp = (prop) => !["mode", "buttonSize", "variant", "block", "shape"].includes(prop);
var spaceChildren = (children) => {
  return React23.Children.map(children, (child) => {
    if (typeof child === "string") {
      return /* @__PURE__ */ React23.createElement("span", null, child);
    }
    return child;
  });
};

// src/components/Button/components/StyledButton.tsx
var StyledButton = styled5(Flex_default).withConfig({ shouldForwardProp })`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2;
  white-space: nowrap;
  text-align: center;
  font-family: default;
  transition: default;
  background-image: none;
  border: 1.5px solid transparent;
  touch-action: manipulation;
  border-radius: ${({ shape }) => getRadii(shape === "circle" ? "full" : "sm")};
  cursor: ${({ readOnly }) => readOnly ? "normal" : "pointer"};
  width: ${({ block }) => block ? "100%" : void 0};
  user-select: none;

  ${makeButtonVariant}
  ${makeButtonTypography}
  ${makeButtonSize}
  ${makeIconButtonSize}
  ${outlineFocusVisible}

  :has(> *:only-child):has(> svg) {
    padding: 0;
  }
`;

// src/components/Button/Button.tsx
var Button = forwardRef6(
  (_a, ref) => {
    var _b = _a, {
      size: size2,
      variant: variant2 = "primary",
      mode = "fill",
      disabled = false,
      readOnly = false,
      block = false,
      onClick,
      children,
      onMouseUp,
      shape = "default",
      type = "button",
      as = "button"
    } = _b, otherStyleProps = __objRest(_b, [
      "size",
      "variant",
      "mode",
      "disabled",
      "readOnly",
      "block",
      "onClick",
      "children",
      "onMouseUp",
      "shape",
      "type",
      "as"
    ]);
    const formContext = useFormContext();
    const buttonSize = size2 || (formContext == null ? void 0 : formContext.size) || "regular";
    const childrenNodes = spaceChildren(children);
    const handleMouseUp = React24.useCallback(
      (event) => {
        event.currentTarget.blur();
        onMouseUp == null ? void 0 : onMouseUp(event);
      },
      [onMouseUp]
    );
    return /* @__PURE__ */ React24.createElement(
      StyledButton,
      __spreadValues(__spreadProps(__spreadValues({}, { as, type, ref, buttonSize, variant: variant2, mode, disabled, readOnly, block, shape }), {
        onClick: readOnly ? void 0 : onClick,
        onMouseUp: handleMouseUp
      }), otherStyleProps),
      childrenNodes
    );
  }
);
Button.displayName = "Button";

// src/components/Dropdown/components/DropdownButton/DropdownButton.tsx
import { ChevronDownOutlined, ChevronUpOutlined } from "@aircall/icons";
var DropdownButton = React25.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      iconOpen = /* @__PURE__ */ React25.createElement(ChevronUpOutlined, null),
      iconClose = /* @__PURE__ */ React25.createElement(ChevronDownOutlined, null),
      variant: variant2 = "primary",
      children,
      "data-test": testId = "dropdown-button"
    } = _b, props = __objRest(_b, [
      "iconOpen",
      "iconClose",
      "variant",
      "children",
      "data-test"
    ]);
    const { open } = useDropdownContext();
    return /* @__PURE__ */ React25.createElement(Button, __spreadProps(__spreadValues({}, props), { variant: variant2, ref, "data-test": testId }), children, open ? iconOpen : iconClose);
  }
);

// src/components/Menu/hooks/useMenuSelection.ts
import * as React26 from "react";
import { useControllableState as useControllableState3 } from "@aircall/hooks";
var useMenuSelection = ({
  selectionMode = "single",
  selectedKeys: controlledSelectedKeys,
  defaultSelectedKeys = [],
  onSelect,
  onDeselect,
  onSelectionChange,
  disabled
}) => {
  const [selectedKeys = [], setSelectedKeys] = useControllableState3({
    prop: controlledSelectedKeys,
    defaultProp: selectionMode === "none" ? [] : defaultSelectedKeys,
    onChange: onSelectionChange
  });
  const computedSelectedKeys = React26.useMemo(() => {
    switch (selectionMode) {
      case "none":
        return [];
      case "single":
        return selectedKeys.length ? [selectedKeys[0]] : [];
      case "multiple":
        return selectedKeys;
    }
  }, [selectionMode, selectedKeys]);
  const onItemSelect = React26.useCallback(
    (key) => {
      if (disabled || selectionMode === "none") {
        return;
      }
      if (selectedKeys.includes(key)) {
        if (selectionMode === "multiple") {
          const nextSelectedKeys = selectedKeys.filter((k) => k !== key);
          setSelectedKeys(nextSelectedKeys);
          onDeselect == null ? void 0 : onDeselect(key, nextSelectedKeys);
        } else {
          const nextSelectedKeys = [key];
          setSelectedKeys(nextSelectedKeys);
          onSelect == null ? void 0 : onSelect(key, nextSelectedKeys);
        }
      } else {
        const nextSelectedKeys = selectionMode === "single" ? [key] : [...selectedKeys, key];
        setSelectedKeys(nextSelectedKeys);
        onSelect == null ? void 0 : onSelect(key, nextSelectedKeys);
      }
    },
    [selectedKeys, onDeselect, onSelect, disabled, selectionMode, setSelectedKeys]
  );
  return {
    onItemSelect,
    menuDisabled: disabled,
    selectedKeys: computedSelectedKeys,
    selectionMode,
    setSelectedKeys
  };
};

// src/components/Menu/contexts/MenuContext.ts
import * as React27 from "react";
var MenuContext = React27.createContext(null);
var useMenu = () => {
  return React27.useContext(MenuContext);
};

// src/components/Menu/contexts/MenuProvider.tsx
import * as React28 from "react";
var MenuProvider = ({
  selectionMode,
  size: size2,
  bordered = false,
  readOnly,
  selectedKeys: controlledSelectedKeys,
  defaultSelectedKeys = [],
  onSelect,
  onDeselect,
  onSelectionChange,
  disabled,
  children
}) => {
  const { menuDisabled, onItemSelect, selectedKeys, setSelectedKeys } = useMenuSelection({
    selectedKeys: controlledSelectedKeys,
    selectionMode,
    defaultSelectedKeys,
    onSelect,
    onDeselect,
    onSelectionChange,
    disabled
  });
  const value = React28.useMemo(
    () => ({
      selectionMode,
      menuDisabled,
      menuBordered: bordered,
      menuReadOnly: readOnly,
      onItemSelect,
      selectedKeys,
      size: size2,
      setSelectedKeys
    }),
    [
      bordered,
      menuDisabled,
      onItemSelect,
      readOnly,
      selectedKeys,
      selectionMode,
      setSelectedKeys,
      size2
    ]
  );
  return /* @__PURE__ */ React28.createElement(MenuContext.Provider, { value }, children);
};

// src/components/Menu/components/MenuItem.tsx
import * as React38 from "react";

// src/components/Menu/components/MenuItemPrimitive.tsx
import * as React37 from "react";

// src/components/Checkbox/Checkbox.tsx
import React29, { forwardRef as forwardRef8, useCallback as useCallback5 } from "react";
import { useControllableState as useControllableState4 } from "@aircall/hooks";
import { MinusOutlined, TickOutlined } from "@aircall/icons";

// src/components/Form/hooks/useForm/useForm.ts
var useForm = ({
  validationStatus,
  id,
  size: size2
}) => {
  var _a;
  const formContext = useFormContext();
  const formItemContext = useFormItemContext();
  const componentStatus = validationStatus != null ? validationStatus : formItemContext == null ? void 0 : formItemContext.validationStatus;
  const componentId = id != null ? id : formItemContext == null ? void 0 : formItemContext.name;
  const componentSize = (_a = size2 != null ? size2 : formContext == null ? void 0 : formContext.size) != null ? _a : "regular";
  const error = componentStatus === "error";
  return {
    componentStatus,
    componentId,
    componentSize,
    error
  };
};

// src/components/Checkbox/components/CheckboxLabel.tsx
import { styled as styled6 } from "@xstyled/styled-components";
var CheckboxLabel = styled6(Typography_default).attrs({
  as: "span",
  "data-test": "checkbox-label"
})`
  grid-area: label;
  align-self: center;
  user-select: none;
  margin-left: 2;
`;
CheckboxLabel.displayName = "CheckboxLabel";

// src/components/Checkbox/components/StyledCheckboxContainer.tsx
import styled7, { css as css3 } from "@xstyled/styled-components";

// src/components/Checkbox/constants.ts
var CHECKBOX_SIZES_MAP = {
  small: "16px",
  regular: "24px",
  large: "32px"
};
var CHECKBOX_TICK_SIZES_MAP = {
  small: "14px",
  regular: "22px",
  large: "30px"
};

// src/components/Checkbox/components/StyledCheckboxContainer.tsx
var makeCheckboxSize = ({ checkboxSize }) => {
  const size2 = CHECKBOX_SIZES_MAP[checkboxSize];
  return css3`
    width: ${size2};
    height: ${size2};
  `;
};
var StyledCheckboxContainer = styled7(Flex_default)`
  position: relative;
  align-items: center;
  justify-content: center;
  transition: background 300ms, border-color 300ms;
  user-select: none;
  border: 1.5px solid transparent;
  border-radius: xs;

  input {
    // We can't focus on a hidden element. So we use opacity:0 instead of display: none here.
    opacity: 0;
    position: absolute;
  }

  ${makeCheckboxSize}

  &&:has(input:focus-visible) {
    ${outlineStyles}
  }

  &&:has(input:focus:not(:focus-visible)) {
    outline-color: transparent;
  }
`;

// src/components/Checkbox/components/StyledCheckboxLayout.tsx
import styled9, { css as css4, getColor as getColor2 } from "@xstyled/styled-components";

// src/components/Checkbox/components/CheckboxDescription.tsx
import { styled as styled8 } from "@xstyled/styled-components";
var CheckboxDescription = styled8(Typography_default).attrs({
  as: "span",
  "data-test": "checkbox-description"
})`
  grid-area: description;
  margin-top: 2;
  margin-left: 2;
  user-select: none;
`;
CheckboxDescription.displayName = "CheckboxDescription";

// src/components/Checkbox/components/StyledCheckboxLayout.tsx
var makeCheckboxTypography = ({
  checkboxSize,
  disabled,
  theme
}) => {
  return css4`
    ${CheckboxLabel} {
      ${checkboxSize === "small" ? theme.typography.bodyRegularS : theme.typography.bodyRegularM};
      color: ${getColor2(disabled ? "text-disabled" : "text-base")};
    }

    ${CheckboxDescription} {
      ${theme.typography.supportingRegularS};
      color: ${getColor2(disabled ? "text-disabled" : "text-secondary")};
    }
  `;
};
var makeCheckboxColor = ({
  checked,
  indeterminate,
  disabled,
  error
}) => {
  if (disabled) {
    return css4`
      ${StyledCheckboxContainer} {
        background-color: ${getColor2("surface-disabled")};
        border-color: ${getColor2("graphic-disabled")};
      }
    `;
  }
  let bgColor, borderColor, bgColorHover, borderColorHover, bgColorActive, borderColorActive;
  if ((checked || indeterminate) && error) {
    bgColor = getColor2("surface-interactive-critical");
    borderColor = getColor2("graphic-interactive-critical");
    bgColorHover = getColor2("surface-interactive-critical-hover");
    borderColorHover = getColor2("graphic-interactive-critical-hover");
    bgColorActive = getColor2("surface-interactive-critical-active");
    borderColorActive = getColor2("graphic-interactive-critical-active");
  } else if ((checked || indeterminate) && !error) {
    bgColor = getColor2("surface-interactive-primary");
    borderColor = getColor2("graphic-interactive-primary");
    bgColorHover = getColor2("surface-interactive-primary-hover");
    borderColorHover = getColor2("graphic-interactive-primary-hover");
    bgColorActive = getColor2("surface-interactive-primary-active");
    borderColorActive = getColor2("graphic-interactive-primary-active");
  } else if (!checked && error) {
    bgColor = getColor2("surface-interactive-primary-ghost");
    borderColor = getColor2("graphic-interactive-critical");
    bgColorHover = getColor2("surface-interactive-critical-ghost-hover");
    borderColorHover = getColor2("graphic-interactive-critical-hover");
    bgColorActive = getColor2("surface-interactive-critical-ghost-active");
    borderColorActive = getColor2("graphic-interactive-critical-active");
  } else {
    bgColor = getColor2("surface-interactive-primary-ghost");
    borderColor = getColor2("graphic-interactive-default");
    bgColorHover = getColor2("surface-interactive-primary-ghost-hover");
    borderColorHover = getColor2("graphic-interactive-default-hover");
    bgColorActive = getColor2("surface-interactive-primary-ghost-active");
    borderColorActive = getColor2("graphic-interactive-default-active");
  }
  return css4`
    ${StyledCheckboxContainer} {
      background-color: ${bgColor};
      border-color: ${borderColor};
    }

    &:hover {
      ${StyledCheckboxContainer} {
        background-color: ${bgColorHover};
        border-color: ${borderColorHover};
      }
    }

    &:active {
      ${StyledCheckboxContainer} {
        background-color: ${bgColorActive};
        border-color: ${borderColorActive};
      }
    }
  `;
};
var StyledCheckboxLayout = styled9(Grid)`
  display: inline-grid;
  grid-template-areas:
    'icon label'
    '. description';
  grid-template-rows: 1fr auto;
  justify-content: flex-start;
  align-items: center;
  pointer-events: ${({ readOnly }) => readOnly ? "none" : "all"};

  &,
  input {
    cursor: ${({ disabled, readOnly }) => disabled || readOnly ? void 0 : "pointer"};
  }

  ${makeCheckboxTypography}
  ${makeCheckboxColor}
`;

// src/components/Checkbox/utils.ts
var getIndicatorColor = (disabled) => {
  if (disabled) {
    return "icon-disabled";
  }
  return "icon-contrast-light";
};

// src/components/Checkbox/Checkbox.tsx
var Checkbox = forwardRef8(
  (_a, ref) => {
    var _b = _a, {
      disabled = false,
      size: size2,
      checked: checkedProp,
      indeterminate,
      validationStatus,
      defaultChecked = false,
      onChange,
      children,
      id,
      readOnly,
      autoFocus,
      onMouseUp
    } = _b, otherStyleProps = __objRest(_b, [
      "disabled",
      "size",
      "checked",
      "indeterminate",
      "validationStatus",
      "defaultChecked",
      "onChange",
      "children",
      "id",
      "readOnly",
      "autoFocus",
      "onMouseUp"
    ]);
    const { componentId, componentSize, error } = useForm({ validationStatus, id, size: size2 });
    const [checked = defaultChecked, setChecked] = useControllableState4({
      prop: checkedProp,
      defaultProp: defaultChecked,
      onChange
    });
    const handleOnChange = useCallback5(
      (event) => {
        if (!disabled) {
          const { checked: checked2 } = event.target;
          setChecked(checked2);
        }
      },
      [disabled, setChecked]
    );
    const handleMouseUp = React29.useCallback(
      (event) => {
        event.currentTarget.blur();
        onMouseUp == null ? void 0 : onMouseUp(event);
      },
      [onMouseUp]
    );
    const childNode = typeof children === "string" ? /* @__PURE__ */ React29.createElement(CheckboxLabel, null, children) : children;
    return /* @__PURE__ */ React29.createElement(
      StyledCheckboxLayout,
      __spreadValues(__spreadValues({
        as: "label",
        htmlFor: componentId
      }, { readOnly, disabled, checkboxSize: componentSize, error, checked, indeterminate }), otherStyleProps),
      /* @__PURE__ */ React29.createElement(StyledCheckboxContainer, { gridArea: "icon", checkboxSize: componentSize }, /* @__PURE__ */ React29.createElement(
        "input",
        {
          id: componentId,
          ref,
          "data-test": "checkbox",
          type: "checkbox",
          "aria-checked": checked,
          autoFocus,
          checked,
          disabled,
          onChange: handleOnChange,
          onMouseUp: handleMouseUp
        }
      ), indeterminate ? /* @__PURE__ */ React29.createElement(
        MinusOutlined,
        {
          color: getIndicatorColor(disabled),
          size: CHECKBOX_TICK_SIZES_MAP[componentSize]
        }
      ) : checked && /* @__PURE__ */ React29.createElement(
        TickOutlined,
        {
          "data-test": "checkbox-check",
          color: getIndicatorColor(disabled),
          size: CHECKBOX_TICK_SIZES_MAP[componentSize]
        }
      )),
      childNode
    );
  }
);
Checkbox.displayName = "Checkbox";

// src/components/Menu/components/MenuItemCheckArea.tsx
import * as React30 from "react";
var MenuItemCheckArea = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React30.createElement(Box_default, __spreadProps(__spreadValues({}, boxProps), { gridArea: "checked", ml: 2, w: 24 }), children);
};

// src/components/Menu/components/MenuItemCheckboxArea.tsx
import * as React31 from "react";
var MenuItemCheckboxArea = (_a) => {
  var _b = _a, {
    children
  } = _b, flexProps = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React31.createElement(Flex_default, __spreadProps(__spreadValues({}, flexProps), { gridArea: "checkbox", mr: 2 }), children);
};

// src/components/Menu/components/MenuItemCheckIcon.tsx
import * as React34 from "react";

// src/components/Icon/Icon.tsx
import React33, { forwardRef as forwardRef9 } from "react";
import styled10, { keyframes as keyframes2, css as css5, color as color2, space as space2, opacity } from "@xstyled/styled-components";

// src/components/Icon/context.ts
import React32 from "react";
var IconContext = React32.createContext(null);
var IconProvider = IconContext.Provider;
var useIconContext = () => React32.useContext(IconContext);

// src/components/Icon/utils.ts
var shouldForwardProp2 = (prop, defaultValidationFn) => !["size", "color", "mode"].includes(prop) && defaultValidationFn(prop);

// src/components/Icon/Icon.tsx
var rotate = keyframes2`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
var IconContainer = styled10(Box_default).withConfig({
  shouldForwardProp: shouldForwardProp2
})`
  line-height: 0;
  cursor: ${({ onClick }) => onClick && "pointer"};
  ${space2};

  > svg {
    ${size};
    ${color2};
    ${opacity};
    animation: ${({ spin }) => spin && css5`
        ${rotate} 2s linear infinite
      `};
  }
`;
var Icon = forwardRef9(
  (_a, ref) => {
    var _b = _a, { component: Component, size: size2 = "24px", spin, color: color4 } = _b, otherStyleProps = __objRest(_b, ["component", "size", "spin", "color"]);
    const iconContext = useIconContext();
    let IconComponent2 = null;
    if (typeof Component === "string") {
      if (!iconContext) {
        console.error(
          "Cannot select the icon component without the icons given using the `<IconProvider>`."
        );
        return null;
      }
      const selectableIcons = iconContext.icons;
      const IconComp = selectableIcons == null ? void 0 : selectableIcons[Component];
      if (!IconComp) {
        console.error(
          `Cannot find the corresponding icon component: ${Component}. Available icons are:`,
          Object.keys(selectableIcons || {})
        );
        return null;
      }
      IconComponent2 = IconComp;
    } else {
      IconComponent2 = Component;
    }
    return /* @__PURE__ */ React33.createElement(IconContainer, __spreadValues({ ref, size: size2, spin, color: color4 }, otherStyleProps), /* @__PURE__ */ React33.createElement(IconComponent2, null));
  }
);
var Icon_default = Icon;

// src/components/Menu/components/MenuItemCheckIcon.tsx
import { TickOutlined as TickOutlined2 } from "@aircall/icons";
var MenuItemCheckIcon = () => {
  return /* @__PURE__ */ React34.createElement(Icon_default, { component: TickOutlined2, size: 24, color: "icon-primary" });
};

// src/components/Menu/components/MenuItemLabel.tsx
import * as React35 from "react";
import styled11 from "@xstyled/styled-components";
var StyledMenuItemLabel = styled11(Typography_default)``;
var MenuItemLabel = (_a) => {
  var _b = _a, { children } = _b, typographyProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React35.createElement(StyledMenuItemLabel, __spreadProps(__spreadValues({ variant: "bodyRegularS" }, typographyProps), { gridArea: "label" }), children);
};

// src/components/Menu/components/StyledMenuItem.ts
import styled13, { css as css6 } from "@xstyled/styled-components";

// src/components/Menu/components/MenuItemDescription.tsx
import * as React36 from "react";
import styled12 from "@xstyled/styled-components";
var StyledMenuItemDescription = styled12(Typography_default)``;
var MenuItemDescription = (_a) => {
  var _b = _a, { children } = _b, typographyProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React36.createElement(
    StyledMenuItemDescription,
    __spreadProps(__spreadValues({
      color: "text-secondary",
      variant: "supportingRegularS"
    }, typographyProps), {
      gridArea: "description"
    }),
    children
  );
};

// src/components/Menu/components/StyledMenuItem.ts
var MENU_ITEM_SIZES = {
  small: "40px",
  regular: "48px",
  large: "56px",
  xLarge: "64px"
};
var makeMenuItemInteractive = ({
  disabled,
  readOnly
}) => {
  return css6`
    cursor: ${disabled ? "not-allowed" : readOnly ? "normal" : "pointer"};
  `;
};
var makeMenuItemDisabled = ({ disabled }) => {
  if (!disabled) {
    return css6`
      &,
      &:hover,
      &:active {
        color: ${getColor("text-base")};
      }
    `;
  }
  return css6`
    color: ${getColor("text-disabled")};
    background-color: ${getColor("surface-disabled")};

    ${StyledMenuItemLabel} {
      color: ${getColor("text-disabled")};
    }

    ${StyledMenuItemDescription} {
      color: ${getColor("text-disabled")};
    }
  `;
};
var makeMenuItemSize = ({ size: size2 }) => {
  const itemSize = MENU_ITEM_SIZES[size2];
  return css6`
    height: ${itemSize};
  `;
};
var makeMenuItemBorder = ({ bordered }) => {
  return css6`
    border-top: 1px solid;
    border-top-color: ${bordered ? getColor("graphic-default") : "transparent"};
    &:last-child {
      border-bottom: 1px solid;
      border-bottom-color: ${bordered ? getColor("graphic-default") : "transparent"};
    }
  `;
};
var makeMenuItemVariant = ({ disabled, readOnly }) => {
  if (disabled) {
    return null;
  }
  return css6`
    background-color: ${getColor("surface-interactive-default")};

    ${!readOnly && css6`
      :hover {
        background-color: ${getColor("surface-interactive-default-hover")};
      }

      :active,
      :focus {
        background-color: ${getColor("surface-interactive-default-active")};
      }
    `}
  `;
};
var StyledMenuItem = styled13(Grid).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop)
})(
  ({ theme }) => css6`
    position: relative;
    justify-content: flex-start;
    align-items: center;
    grid-template-areas:
      'checkbox prefix label suffix checked'
      'checkbox prefix description suffix checked';
    grid-template-rows: 1fr auto;
    grid-template-columns: auto auto minmax(0, 1fr) auto auto;
    padding: 0 4;
    user-select: none;
    transition: background-color 150ms ease-in-out, color 150ms ease-in-out;

    :hover,
    :active,
    :focus {
      text-decoration: none;
    }

    :has(${StyledMenuItemDescription}) {
      grid-template-rows: auto auto;

      ${StyledMenuItemLabel} {
        align-self: flex-end;
      }

      ${StyledMenuItemDescription} {
        align-self: flex-start;
      }
    }

    ${theme.typography.bodyRegularS}
    ${makeMenuItemInteractive}
    ${makeMenuItemDisabled}
    ${makeMenuItemSize}
    ${makeMenuItemBorder}
    ${makeMenuItemVariant}
  `
);

// src/components/Menu/components/MenuItemPrimitive.tsx
var MenuItemPrimitive = forwardRef6(
  (_a, ref) => {
    var _b = _a, {
      itemKey,
      children,
      disabled,
      onClick,
      readOnly,
      as,
      bordered,
      size: size2,
      selected,
      indeterminate
    } = _b, rootProps = __objRest(_b, [
      "itemKey",
      "children",
      "disabled",
      "onClick",
      "readOnly",
      "as",
      "bordered",
      "size",
      "selected",
      "indeterminate"
    ]);
    var _a2;
    const {
      onItemSelect,
      menuDisabled,
      selectionMode,
      size: menuSize,
      menuBordered,
      menuReadOnly
    } = useMenu();
    const itemSize = size2 != null ? size2 : menuSize;
    const itemDisabled = disabled != null ? disabled : menuDisabled;
    const itemBordered = bordered != null ? bordered : menuBordered;
    const itemReadOnly = (_a2 = readOnly != null ? readOnly : menuReadOnly) != null ? _a2 : selectionMode === "none" && !onClick && as !== "a" && !("href" in rootProps);
    const handleItemClick = React37.useCallback(
      (event) => {
        onItemSelect(itemKey);
        onClick == null ? void 0 : onClick(event);
      },
      [onItemSelect, onClick, itemKey]
    );
    const isSingleSelected = selectionMode === "single" && selected;
    const childNode = typeof children === "string" ? /* @__PURE__ */ React37.createElement(MenuItemLabel, null, children) : children;
    return /* @__PURE__ */ React37.createElement(
      StyledMenuItem,
      __spreadValues({
        as,
        disabled: itemDisabled,
        readOnly: itemReadOnly,
        size: itemSize,
        onClick: itemReadOnly || itemDisabled ? void 0 : handleItemClick,
        "data-selected": selected,
        "data-indeterminate": indeterminate,
        "data-disabled": itemDisabled,
        bordered: itemBordered
      }, rootProps),
      selectionMode === "multiple" && /* @__PURE__ */ React37.createElement(MenuItemCheckboxArea, null, /* @__PURE__ */ React37.createElement(Checkbox, { checked: selected, indeterminate, size: "small" })),
      childNode,
      selectionMode === "single" && /* @__PURE__ */ React37.createElement(MenuItemCheckArea, null, isSingleSelected && /* @__PURE__ */ React37.createElement(MenuItemCheckIcon, null))
    );
  }
);

// src/components/Menu/components/MenuItem.tsx
var MenuItem = forwardRef6(
  (_a, ref) => {
    var _b = _a, { itemKey, children } = _b, rootProps = __objRest(_b, ["itemKey", "children"]);
    const { selectedKeys, selectionMode } = useMenu();
    const isSelected = React38.useMemo(
      () => selectionMode !== "none" && itemKey !== void 0 && selectedKeys.includes(itemKey),
      [selectionMode, itemKey, selectedKeys]
    );
    return /* @__PURE__ */ React38.createElement(
      MenuItemPrimitive,
      __spreadValues({
        ref,
        selected: isSelected,
        itemKey,
        "data-test": itemKey ? `menu-item-${itemKey}` : "menu-item"
      }, rootProps),
      children
    );
  }
);
MenuItem.displayName = "MenuItem";

// src/components/Menu/components/MenuItemGroup.tsx
import * as React40 from "react";

// src/components/Divider/Divider.tsx
import React39 from "react";
var sizes = {
  xSmall: "1px",
  small: "2px"
};
var Divider = (_a) => {
  var _b = _a, {
    size: size2 = "small",
    orientation = "vertical",
    bg = "graphic-default"
  } = _b, props = __objRest(_b, [
    "size",
    "orientation",
    "bg"
  ]);
  const dividerStyle = {
    vertical: {
      w: sizes[size2] || sizes.small,
      h: "100%"
    },
    horizontal: {
      h: sizes[size2] || sizes.small,
      w: "100%"
    }
  };
  return /* @__PURE__ */ React39.createElement(Box_default, __spreadValues(__spreadValues({ bg }, dividerStyle[orientation]), props));
};

// src/components/Divider/Divider.decl.ts
var DividerSize = /* @__PURE__ */ ((DividerSize2) => {
  DividerSize2["X_SMALL"] = "xSmall";
  DividerSize2["SMALL"] = "small";
  return DividerSize2;
})(DividerSize || {});
var DividerOrientation = /* @__PURE__ */ ((DividerOrientation2) => {
  DividerOrientation2["VERTICAL"] = "vertical";
  DividerOrientation2["HORIZONTAL"] = "horizontal";
  return DividerOrientation2;
})(DividerOrientation || {});

// src/components/Menu/components/MenuItemGroup.tsx
var MenuItemGroup = ({ title, divider = false, children }) => {
  const { menuDisabled } = useMenu();
  return /* @__PURE__ */ React40.createElement(Box_default, { "data-test": "menu-item-group" }, title && /* @__PURE__ */ React40.createElement(
    Typography_default,
    {
      variant: "supportingMediumS",
      color: menuDisabled ? "text-disabled" : "text-placeholder",
      py: 2,
      px: 4
    },
    title
  ), divider && /* @__PURE__ */ React40.createElement(Divider, { orientation: "horizontal", size: "xSmall", color: "graphic-default", my: 2 }), /* @__PURE__ */ React40.createElement(Box_default, null, children));
};

// src/components/Menu/components/MenuItemPrefix.tsx
import React41 from "react";
var MenuItemPrefix = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React41.createElement(Box_default, __spreadProps(__spreadValues({}, boxProps), { mr: 2, gridArea: "prefix" }), children);
};

// src/components/Menu/components/MenuItemSuffix.tsx
import React42 from "react";
var MenuItemSuffix = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React42.createElement(Box_default, __spreadProps(__spreadValues({}, boxProps), { ml: 2, gridArea: "suffix" }), children);
};

// src/components/Menu/Menu.tsx
import React43, { forwardRef as forwardRef10 } from "react";

// src/components/Menu/components/StyledMenu.tsx
import styled14, { css as css7 } from "@xstyled/styled-components";
var makeMenuBorder = ({ bordered }) => {
  return css7`
    border-left: 1px solid ${bordered ? getColor("graphic-default") : "transparent"};
    border-right: 1px solid ${bordered ? getColor("graphic-default") : "transparent"};
  `;
};
var StyledMenu = styled14(Box_default)`
  user-select: none;
  text-align: left;
  ${makeMenuBorder};
`;

// src/components/Menu/Menu.tsx
function MenuComponent(_a, ref) {
  var _b = _a, {
    children,
    defaultSelectedKeys = [],
    selectedKeys,
    onItemSelected: onSelect,
    onItemDeselected: onDeselect,
    onSelectionChange,
    disabled,
    selectionMode = "none",
    size: size2 = "regular",
    bordered = false,
    readOnly
  } = _b, otherStyleProps = __objRest(_b, [
    "children",
    "defaultSelectedKeys",
    "selectedKeys",
    "onItemSelected",
    "onItemDeselected",
    "onSelectionChange",
    "disabled",
    "selectionMode",
    "size",
    "bordered",
    "readOnly"
  ]);
  return /* @__PURE__ */ React43.createElement(
    MenuProvider,
    __spreadValues({}, {
      selectedKeys,
      selectionMode,
      defaultSelectedKeys,
      onSelect,
      onDeselect,
      onSelectionChange,
      disabled,
      bordered,
      readOnly,
      size: size2
    }),
    /* @__PURE__ */ React43.createElement(
      StyledMenu,
      __spreadValues({
        "data-test": "menu",
        role: "menu",
        minWidth: 220,
        bordered,
        ref
      }, otherStyleProps),
      children
    )
  );
}
var Menu = forwardRef10(MenuComponent);

// src/components/ActionMenu/ActionMenu.tsx
var ActionMenu = ({
  items,
  trigger,
  side,
  align,
  sideOffset,
  alignOffset
}) => {
  return /* @__PURE__ */ React44.createElement(
    Dropdown,
    {
      "data-test": "action-menu",
      trigger,
      side,
      align,
      sideOffset,
      alignOffset
    },
    /* @__PURE__ */ React44.createElement(Menu, { selectionMode: "none" }, items.map((_a, index) => {
      var _b = _a, { name, prefix } = _b, menuItemProps = __objRest(_b, ["name", "prefix"]);
      return /* @__PURE__ */ React44.createElement(MenuItem, __spreadValues({ key: index }, menuItemProps), prefix && /* @__PURE__ */ React44.createElement(MenuItemPrefix, null, prefix), /* @__PURE__ */ React44.createElement(MenuItemLabel, null, name));
    }))
  );
};

// src/components/AudioPlayer/components/AudioBar/AudioBar.tsx
import React50 from "react";
import { useColor } from "@xstyled/styled-components";

// src/contexts/AudioManager/AudioManager.tsx
import React46, { useMemo as useMemo4, useRef as useRef2 } from "react";

// src/contexts/AudioManager/AudioManager.context.ts
import React45, { useContext as useContext11 } from "react";

// src/contexts/AudioManager/AudioManager.decl.ts
var defaultMangerContext = {
  play: noop,
  unregister: noop
};

// src/contexts/AudioManager/AudioManager.context.ts
var AudioManagerContext = React45.createContext(defaultMangerContext);
var useAudioManager = () => useContext11(AudioManagerContext);

// src/contexts/AudioManager/AudioManger.hooks.ts
import { useCallback as useCallback7 } from "react";
var usePlay = (currentAudio) => useCallback7(
  (audioRef) => __async(void 0, null, function* () {
    if (currentAudio.current !== audioRef) {
      if (currentAudio.current) {
        try {
          currentAudio.current.pause();
        } catch (error) {
          console.warn("Error pausing previous audio:", error);
        }
      }
      currentAudio.current = audioRef;
    }
    try {
      yield audioRef.play();
    } catch (error) {
      console.warn("Error playing audio:", error);
      currentAudio.current = null;
    }
  }),
  [currentAudio]
);
var useUnregister = (currentAudio) => useCallback7(
  (audioRef) => {
    var _a;
    if (currentAudio.current === audioRef) {
      (_a = currentAudio.current) == null ? void 0 : _a.pause();
      currentAudio.current = null;
    }
  },
  [currentAudio]
);

// src/contexts/AudioManager/AudioManager.tsx
var AudioManager = ({ children }) => {
  const currentAudio = useRef2(null);
  const play = usePlay(currentAudio);
  const unregister = useUnregister(currentAudio);
  const context = useMemo4(() => ({ play, unregister }), [play, unregister]);
  return /* @__PURE__ */ React46.createElement(AudioManagerContext.Provider, { value: context }, children);
};

// src/contexts/Audio/Audio.tsx
import React48, { useMemo as useMemo5 } from "react";

// src/contexts/Audio/Audio.context.ts
import React47, { useContext as useContext12 } from "react";
var defaultAudioContext = {
  duration: 0,
  togglePlay: () => __async(void 0, null, function* () {
  }),
  play: () => __async(void 0, null, function* () {
  }),
  pause: noop,
  isPlaying: false,
  seek: noop,
  fastForward: noop,
  rewind: noop,
  speed: 1,
  setSpeed: noop,
  error: null
};
var AudioContext = React47.createContext(defaultAudioContext);
var AudioTimeContext = React47.createContext({ currentTime: 0 });
var useAudio = () => useContext12(AudioContext);
var useAudioTime = () => useContext12(AudioTimeContext);

// src/contexts/Audio/hooks/useDuration.ts
import { useEffect as useEffect3, useState as useState4 } from "react";
function useDuration(audioRef) {
  const [duration, setDuration] = useState4(0);
  useEffect3(() => {
    const audio = audioRef.current;
    const getDuration = (event) => {
      const target = event.target;
      target.currentTime = 0;
      target.removeEventListener("timeupdate", getDuration);
      setDuration(target.duration);
    };
    const updateDuration = () => {
      if (audio.duration === Infinity || isNaN(Number(audio.duration))) {
        audio.currentTime = 1e101;
        audio.addEventListener("timeupdate", getDuration);
      } else {
        setDuration(audio.duration);
      }
    };
    audio.addEventListener("loadedmetadata", updateDuration);
    return () => {
      audio.removeEventListener("loadedmetadata", updateDuration);
      audio.removeEventListener("timeupdate", getDuration);
    };
  }, [audioRef, setDuration]);
  return duration;
}

// src/contexts/Audio/hooks/usePlayPause.ts
import { useCallback as useCallback8, useEffect as useEffect4, useState as useState5 } from "react";
function usePlayPause(audioRef) {
  const { play: managerPlay } = useAudioManager();
  const [isPlaying, setIsPlaying] = useState5(false);
  const togglePlay = useCallback8(() => __async(this, null, function* () {
    if (audioRef.current.paused) {
      yield managerPlay(audioRef.current);
    } else {
      audioRef.current.pause();
    }
  }), [audioRef, managerPlay]);
  const play = useCallback8(() => __async(this, null, function* () {
    yield managerPlay(audioRef.current);
  }), [audioRef, managerPlay]);
  const pause = useCallback8(() => __async(this, null, function* () {
    audioRef.current.pause();
  }), [audioRef]);
  useOnPlayPauseEvent(setIsPlaying, audioRef);
  return { isPlaying, togglePlay, play, pause };
}
function useOnPlayPauseEvent(setIsPlaying, audioRef) {
  useEffect4(() => {
    const pause = () => setIsPlaying(false);
    const play = () => setIsPlaying(true);
    const audioElem = audioRef.current;
    audioElem.addEventListener("pause", pause);
    audioElem.addEventListener("play", play);
    return () => {
      audioElem.removeEventListener("pause", pause);
      audioElem.removeEventListener("play", play);
    };
  }, [audioRef, setIsPlaying]);
}

// src/contexts/Audio/hooks/useAudioTime.ts
import { useCallback as useCallback9, useEffect as useEffect5, useState as useState6 } from "react";
var SKIPPING_INTERVAL = 10;
function useAudioTime2(audioRef) {
  const [currentTime, setCurrentTime] = useState6(0);
  const seek = useCallback9(
    (time) => {
      audioRef.current.currentTime = time;
      setCurrentTime(time);
    },
    [audioRef, setCurrentTime]
  );
  const fastForward = useCallback9(() => {
    seek(audioRef.current.currentTime + SKIPPING_INTERVAL);
  }, [audioRef, seek]);
  const rewind = useCallback9(() => {
    seek(audioRef.current.currentTime - SKIPPING_INTERVAL);
  }, [audioRef, seek]);
  useOnTimeUpdateEvent(audioRef, setCurrentTime);
  return { currentTime, seek, fastForward, rewind };
}
function useOnTimeUpdateEvent(audioRef, setTime) {
  useEffect5(() => {
    const audioElem = audioRef.current;
    const handleOnTimeUpdate = () => {
      setTime(audioElem.currentTime);
    };
    audioElem.addEventListener("timeupdate", handleOnTimeUpdate);
    return () => {
      audioElem.removeEventListener("timeupdate", handleOnTimeUpdate);
    };
  }, [audioRef, setTime]);
}

// src/contexts/Audio/hooks/useAudioRef.ts
import { useEffect as useEffect6, useRef as useRef3 } from "react";
function useAudioRef() {
  const audioRef = useRef3(new Audio());
  const { unregister } = useAudioManager();
  useEffect6(() => {
    const audio = audioRef.current;
    return () => unregister(audio);
  }, [unregister]);
  return audioRef;
}

// src/contexts/Audio/hooks/useSrcChanged.ts
import { useEffect as useEffect7 } from "react";
function useSrcChanged(src, audioRef, seek, setError) {
  useEffect7(() => {
    const audio = audioRef.current;
    const previousSpeed = audioRef.current.playbackRate;
    setTimeout(() => {
      audio.src = src;
      audio.playbackRate = previousSpeed;
    }, 0);
    return () => {
      audio.pause();
      setError(null);
    };
  }, [src, seek, audioRef, setError]);
}

// src/contexts/Audio/hooks/useSpeed.ts
import { useCallback as useCallback10, useState as useState7 } from "react";
var useSpeed = (audioRef) => {
  const [rate, setRate] = useState7(1);
  const setSpeed = useCallback10(
    (speed) => {
      audioRef.current.playbackRate = speed;
      setRate(speed);
    },
    [audioRef, setRate]
  );
  return { speed: rate, setSpeed };
};

// src/contexts/Audio/hooks/useAudioError.ts
import { useEffect as useEffect8, useState as useState8 } from "react";
var useAudioError = (audioRef) => {
  const [error, setError] = useState8(null);
  useEffect8(() => {
    const listener = (event) => {
      const audioElement = event.target;
      setError(audioElement.error);
    };
    const audio = audioRef.current;
    audio.addEventListener("error", listener);
    return () => {
      audio.removeEventListener("error", listener);
    };
  }, [audioRef, setError]);
  return { error, setError };
};

// src/contexts/Audio/hooks/useSetDeviceId.ts
import { useEffect as useEffect9 } from "react";
var useSetDeviceId = (audioRef, sinkId) => {
  useEffect9(() => {
    if (!sinkId) {
      return;
    }
    if (!audioRef.current.setSinkId) {
      console.warn("HTMLAudioElement, setSinkId is not supported in this browser");
      return;
    }
    audioRef.current.setSinkId(sinkId);
  }, [audioRef, sinkId]);
};

// src/contexts/Audio/Audio.tsx
function Audio2({ src, sinkId, children }) {
  const audioRef = useAudioRef();
  const duration = useDuration(audioRef);
  const { seek, rewind, fastForward, currentTime } = useAudioTime2(audioRef);
  const { isPlaying, togglePlay, play, pause } = usePlayPause(audioRef);
  const { setSpeed, speed } = useSpeed(audioRef);
  const { error, setError } = useAudioError(audioRef);
  useSrcChanged(src, audioRef, seek, setError);
  useSetDeviceId(audioRef, sinkId);
  const context = useMemo5(
    () => ({
      duration,
      isPlaying,
      play,
      pause,
      togglePlay,
      seek,
      fastForward,
      rewind,
      setSpeed,
      speed,
      error
    }),
    [
      duration,
      isPlaying,
      play,
      pause,
      togglePlay,
      seek,
      fastForward,
      rewind,
      setSpeed,
      speed,
      error
    ]
  );
  return /* @__PURE__ */ React48.createElement(AudioContext.Provider, { value: context }, /* @__PURE__ */ React48.createElement(AudioTimeContext.Provider, { value: { currentTime } }, children));
}

// src/components/AudioPlayer/AudioPlayer.utils.ts
import { PauseFilled, PlayFilled, ReplayFilled } from "@aircall/icons";

// src/components/AudioPlayer/components/PlayButton/hooks/useAudioStatus.ts
var STATUS = {
  playing: "playing",
  paused: "paused",
  ended: "ended"
};
var useAudioStatus = () => {
  const { isPlaying, duration } = useAudio();
  const { currentTime } = useAudioTime();
  if (isPlaying)
    return STATUS.playing;
  const ended = currentTime === duration && duration !== 0;
  return ended ? STATUS.ended : STATUS.paused;
};

// src/components/AudioPlayer/AudioPlayer.utils.ts
var colorsMapper = {
  green: "surface-interactive-primary",
  yellow: "surface-interactive-warning",
  default: "surface-interactive-secondary"
};
var playIconColorsMapper = {
  green: "icon-interactive-primary",
  yellow: "icon-interactive-warning",
  default: "icon-interactive-default"
};
var getIconComponent = (status) => {
  switch (status) {
    case STATUS.paused:
      return PlayFilled;
    case STATUS.playing:
      return PauseFilled;
    case STATUS.ended:
      return ReplayFilled;
    default:
      return PlayFilled;
  }
};

// src/components/AudioPlayer/utils.ts
var _getSeconds = (time) => {
  const s = Math.floor(time % 60);
  return s < 10 ? `0${s}` : `${s}`;
};
var _getMinutes = (time) => {
  const h = Math.floor(time / 3600);
  const m = Math.floor(time / 60 % 60);
  const needsZeroAppending = m < 10 && m > 0 || m === 0 && h > 0;
  return needsZeroAppending ? `0${m}` : `${m}`;
};
var _getHours = (time) => Math.floor(time / 3600);
var formatTime = (time) => {
  const result = `${_getMinutes(time)}:${_getSeconds(time)}`;
  const hours = _getHours(time);
  return hours > 0 ? `${hours}:${result}` : result;
};

// src/components/AudioPlayer/components/AudioBar/components/AudioThumb/AudioThumb.tsx
import React49, { useRef as useRef6 } from "react";

// src/components/AudioPlayer/components/AudioBar/hooks/useThumbDragging.ts
import { useCallback as useCallback11, useRef as useRef5, useState as useState9 } from "react";

// src/components/AudioPlayer/components/AudioBar/hooks/useMouseMove.ts
import { useEffect as useEffect10 } from "react";
import { useRect as useRect2 } from "@aircall/hooks";

// src/components/AudioPlayer/components/AudioBar/components/AudioThumb/utils.ts
var convertPositionToSec = (mouseXPos, { width, left }, duration) => {
  if (!width || left === void 0)
    return 0;
  const relativePos = mouseXPos - left;
  const percentage = Math.max(0, Math.min(1, relativePos / width));
  return percentage * duration;
};
var getPercentage = (value, total) => total > 0 ? value * 100 / total : 0;

// src/components/AudioPlayer/components/AudioBar/hooks/useMouseMove.ts
function useMouseMove(isDragging, mouseRelativeToThumb, containerRef) {
  const { seek, duration } = useAudio();
  const containerDim = useRect2(containerRef.current);
  useEffect10(() => {
    const handleMouseMove = (e) => {
      if (isDragging && containerDim) {
        e.preventDefault();
        const mouseX = e.clientX - mouseRelativeToThumb.current;
        const position = convertPositionToSec(mouseX, containerDim, duration);
        seek(position);
      }
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, [isDragging, mouseRelativeToThumb, containerDim, seek, duration]);
}

// src/components/AudioPlayer/components/AudioBar/hooks/useThumbMouseUp.ts
import { useEffect as useEffect11, useRef as useRef4 } from "react";
function useThumbMouseUp(setIsDragging) {
  const { play, duration } = useAudio();
  const { currentTime } = useAudioTime();
  const isEnded = useRef4();
  isEnded.current = currentTime === duration;
  useEffect11(() => {
    const handleMouseUp = () => {
      setIsDragging((isDragging) => {
        if (!isDragging)
          return isDragging;
        if (!isEnded.current)
          play();
        return false;
      });
    };
    document.addEventListener("mouseup", handleMouseUp);
    return () => document.removeEventListener("mouseup", handleMouseUp);
  }, [play, setIsDragging, isEnded]);
}

// src/components/AudioPlayer/components/AudioBar/hooks/useThumbDragging.ts
var useThumbDragging = (containerRef) => {
  const mouseRelativeToThumb = useRef5(0);
  const [isDragging, setIsDragging] = useState9(false);
  useMouseMove(isDragging, mouseRelativeToThumb, containerRef);
  useThumbMouseUp(setIsDragging);
  const { pause } = useAudio();
  const handleMouseDown = useCallback11(
    (e) => {
      if (e.button === 0) {
        pause();
        const elem = e.target;
        const { left, width } = elem.getBoundingClientRect();
        mouseRelativeToThumb.current = e.clientX - left - width / 2;
        setIsDragging(true);
      }
    },
    [pause, setIsDragging, mouseRelativeToThumb]
  );
  return { handleMouseDown };
};

// src/components/AudioPlayer/components/AudioBar/components/AudioThumb/styled.ts
import styled15, { css as css8 } from "@xstyled/styled-components";
var Thumb = styled15.div.attrs(({ value }) => ({
  style: {
    left: `calc(${value}%)`
  }
}))`
  z-index: 10;
  position: absolute;
  width: 16px;
  height: 16px;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: ew-resize;

  // Drawing the circle thumb
  &::before {
    content: '';
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 16px;
    z-index: 10;
    box-shadow: 1;
    ${({ color: color4 }) => css8`
        background-color: ${color4};
        border: 2px solid ${getColor("icon-contrast-light")};
        border-radius: ${getRadii("full")};
      `}
  }

  // Drawing the cursor thumb
  &::after {
    height: ${({ height = "100%" }) => height};
    left: 50%;
    transform: translateX(-50%);
    content: '';
    position: absolute;
    border-left: 2px solid ${getColor("graphic-neutral")};
  }
`;
var Container = styled15(Box_default)`
  :has(:focus-visible) {
    ${Thumb} {
      ${outlineStyles};
      border-radius: ${getRadii("full")};
    }
  }
`;

// src/components/AudioPlayer/components/AudioBar/components/AudioThumb/AudioThumb.tsx
function AudioThumb({ currentTime, children, height, color: color4, disabled }) {
  const containerRef = useRef6(null);
  const { duration } = useAudio();
  const { handleMouseDown } = useThumbDragging(containerRef);
  const thumbPosition = getPercentage(currentTime, duration);
  return /* @__PURE__ */ React49.createElement(
    Container,
    {
      position: "relative",
      cursor: disabled ? "none" : "pointer",
      pointerEvents: disabled ? "none" : "auto",
      ref: containerRef
    },
    /* @__PURE__ */ React49.createElement(
      Thumb,
      {
        value: thumbPosition,
        onMouseDown: handleMouseDown,
        height,
        color: duration ? color4 : "graphic-disabled",
        "data-test": "audio-thumb"
      }
    ),
    children
  );
}

// src/components/AudioPlayer/components/AudioBar/constants.ts
var FIVE_SECONDS = 5;

// src/components/AudioPlayer/components/AudioBar/styled.ts
import styled16 from "@xstyled/styled-components";
var Bar = styled16.div.attrs(
  ({ value, fillerColor, barColor }) => ({
    style: {
      backgroundImage: `linear-gradient(90deg, 
        ${fillerColor} ${value}%, ${barColor} ${value}%)`
    }
  })
)`
  width: 100%;
  height: 4px;
  border-radius: sm;
  position: relative;
  overflow: hidden;
`;
var HiddenInputRange = styled16.input`
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  clip: rect(0 0 0 0);
`;

// src/components/AudioPlayer/components/AudioBar/utils.ts
var changeCurrentTimeOnKeydown = (event, currentTime, duration, changeCurrentTime) => {
  if (event.key === "ArrowRight" || event.key === "ArrowUp") {
    changeCurrentTime(Math.min(currentTime + FIVE_SECONDS, duration));
  }
  if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
    changeCurrentTime(Math.max(currentTime - FIVE_SECONDS, 0));
  }
};

// src/components/AudioPlayer/components/AudioBar/AudioBar.tsx
var AudioBar = ({ height = "0px", color: color4 = "green", disabled }) => {
  const { duration, seek } = useAudio();
  const { currentTime } = useAudioTime();
  const computedColor = disabled ? "graphic-disabled" : colorsMapper[color4];
  const handleOnClick = (e) => {
    const { left, width } = e.currentTarget.getBoundingClientRect();
    const x5 = e.clientX - left;
    seek(x5 / width * duration);
  };
  const barColor = useColor("graphic-default");
  const fillColor = useColor(computedColor);
  return /* @__PURE__ */ React50.createElement(
    AudioThumb,
    {
      currentTime,
      height,
      color: computedColor,
      disabled: disabled || !duration
    },
    /* @__PURE__ */ React50.createElement(
      HiddenInputRange,
      {
        type: "range",
        value: currentTime,
        disabled: disabled || !duration,
        "aria-valuetext": `${formatTime(currentTime)}/${formatTime(duration)}`,
        onKeyDown: (event) => changeCurrentTimeOnKeydown(event, currentTime, duration, seek),
        step: FIVE_SECONDS,
        min: 0,
        max: duration
      }
    ),
    /* @__PURE__ */ React50.createElement(
      Bar,
      {
        barColor,
        fillerColor: fillColor,
        value: getPercentage(currentTime, duration),
        onClick: disabled ? void 0 : handleOnClick,
        "data-test": "bar"
      }
    )
  );
};

// src/components/AudioPlayer/components/AudioCurrentTime.tsx
import React51 from "react";
var AudioCurrentTime = () => {
  const { currentTime } = useAudioTime();
  return /* @__PURE__ */ React51.createElement(Typography_default, { variant: "supportingRegularS", color: currentTime ? "text-base" : "text-placeholder" }, formatTime(currentTime));
};

// src/components/AudioPlayer/components/AudioDuration.tsx
import React52 from "react";
var AudioDuration = ({ initialDuration = 0 }) => {
  const { duration } = useAudio();
  const formatedDuration = duration ? formatTime(duration) : formatTime(initialDuration);
  return /* @__PURE__ */ React52.createElement(Typography_default, { variant: "supportingRegularS", color: "text-placeholder" }, formatedDuration);
};

// src/components/AudioPlayer/components/PlayButton/PlayButton.tsx
import React54 from "react";
import { LoadingRedoUndoOutlined, PauseFilled as PauseFilled2, PlayFilled as PlayFilled2, ReplayFilled as ReplayFilled2 } from "@aircall/icons";

// src/components/IconButton/IconButton.tsx
import React53, { forwardRef as forwardRef11 } from "react";
import styled17, { getColor as getColor3, space as space3 } from "@xstyled/styled-components";
var IconContainer2 = styled17(Icon_default)`
  position: relative;
`;
var IconButtonContainer = styled17.button`
  margin: 0;
  padding: 0;
  border: none;
  position: relative;
  z-index: 0;
  cursor: pointer;
  background: none;
  border: 1.5px solid transparent;
  border-radius: 50%;
  ${space3}

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% + 8px);
    border-radius: 50%;
    height: calc(100% + 8px);
    transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
    transform: translate(-50%, -50%) scale(0.75);
    pointer-events: none;
    opacity: 0;
    z-index: -1;
  }

  &::before {
    background-color: ${({ discColor }) => getColor3(discColor != null ? discColor : "surface-interactive-default-hover")};
  }

  &:hover {
    &::before {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;

    &::before,
    &::after {
      content: none;
    }
  }

  ${outlineFocusVisible}
`;
var IconButton = forwardRef11(
  (_a, ref) => {
    var _b = _a, { disabled = false, onClick, discColor, size: size2, color: color4, component, spin } = _b, otherStyleProps = __objRest(_b, ["disabled", "onClick", "discColor", "size", "color", "component", "spin"]);
    return /* @__PURE__ */ React53.createElement(
      IconButtonContainer,
      __spreadValues({
        ref,
        onClick,
        discColor,
        disabled
      }, otherStyleProps),
      /* @__PURE__ */ React53.createElement(IconContainer2, { size: size2, component, color: color4, spin })
    );
  }
);
var IconButton_default = IconButton;

// src/components/AudioPlayer/components/PlayButton/styled.ts
import styled18, { css as css9 } from "@xstyled/styled-components";
var Button2 = styled18.button`
  position: relative;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: pointer;
  pointer-events: ${({ disabled }) => disabled ? "none" : "auto"};
  background-color: ${({ disabled, color: color4 }) => disabled ? getColor("surface-interactive-disabled") : getColor(color4)};
  border: none;

  ${outlineFocusVisible};
`;
var Transition = styled18(Flex_default)`
  position: absolute;
  pointer-events: none;
  transition: all 0.7s;
  transform: ${({ reverse }) => `rotate(${reverse ? 180 : -180}deg)`};
  opacity: 0;

  ${({ show }) => show && css9`
      transform: rotate(0);
      opacity: 1;
    `};
`;

// src/components/AudioPlayer/components/PlayButton/PlayButton.tsx
var PlayButton = ({
  color: color4 = "green",
  disabled = false,
  loading = false,
  mode = "button",
  ariaLabel,
  onClick
}) => {
  const { togglePlay, seek, duration } = useAudio();
  const status = useAudioStatus();
  const handleOnClick = () => __async(void 0, null, function* () {
    if (onClick)
      onClick(status);
    if (status === STATUS.ended)
      seek(0);
    yield togglePlay();
  });
  let buttonContents = /* @__PURE__ */ React54.createElement(React54.Fragment, null, /* @__PURE__ */ React54.createElement(Transition, { show: status === STATUS.paused, "data-test": STATUS.paused, reverse: true }, /* @__PURE__ */ React54.createElement(PlayFilled2, { color: "icon-contrast-light" })), /* @__PURE__ */ React54.createElement(Transition, { show: status === STATUS.playing, "data-test": STATUS.playing }, /* @__PURE__ */ React54.createElement(PauseFilled2, { color: "icon-contrast-light" })), /* @__PURE__ */ React54.createElement(Transition, { show: status === STATUS.ended, "data-test": STATUS.ended, reverse: true }, /* @__PURE__ */ React54.createElement(ReplayFilled2, { color: "icon-contrast-light" })));
  if (disabled) {
    buttonContents = /* @__PURE__ */ React54.createElement(Transition, { show: true, "data-test": "disabled", reverse: true }, /* @__PURE__ */ React54.createElement(PlayFilled2, { color: "icon-disabled" }));
  }
  if (loading) {
    buttonContents = /* @__PURE__ */ React54.createElement(
      Icon_default,
      {
        spin: true,
        component: LoadingRedoUndoOutlined,
        color: "icon-contrast-light",
        "data-test": "loading"
      }
    );
  }
  return mode === "icon" ? /* @__PURE__ */ React54.createElement(
    IconButton_default,
    {
      type: "button",
      "data-test": status,
      onMouseLeave: (e) => e.currentTarget.blur(),
      color: playIconColorsMapper[color4],
      component: getIconComponent(status),
      onClick: handleOnClick,
      disabled: disabled || !duration,
      "aria-label": ariaLabel
    }
  ) : /* @__PURE__ */ React54.createElement(
    Button2,
    {
      type: "button",
      onClick: handleOnClick,
      color: colorsMapper[color4],
      disabled: disabled || !duration,
      "aria-label": ariaLabel
    },
    buttonContents
  );
};

// src/components/AudioPlayer/components/QuickAudioPlayer/QuickAudioPlayer.tsx
import React55 from "react";
var QuickAudioPlayer = ({
  src,
  initialDuration,
  loading,
  color: color4 = "green",
  onPlayClick
}) => /* @__PURE__ */ React55.createElement(Audio2, { src }, /* @__PURE__ */ React55.createElement(Grid, { gridTemplateColumns: "auto 1fr", columnGap: "16px", w: "100%" }, /* @__PURE__ */ React55.createElement(PlayButton, { color: color4, loading, onClick: onPlayClick }), /* @__PURE__ */ React55.createElement(Box_default, null, /* @__PURE__ */ React55.createElement(Flex_default, { justifyContent: "space-between", pb: "8px" }, /* @__PURE__ */ React55.createElement(AudioCurrentTime, null), /* @__PURE__ */ React55.createElement(AudioDuration, { initialDuration })), /* @__PURE__ */ React55.createElement(AudioBar, { color: color4 }))));

// src/components/Avatar/Avatar.tsx
import React56, { forwardRef as forwardRef12, useState as useState10 } from "react";

// src/components/Avatar/components/StyledAvatar/StyledAvatar.tsx
import { css as css10, styled as styled19 } from "@xstyled/styled-components";

// src/components/Avatar/constant.ts
var AVATAR_VARIANT_COLORS_MAP = {
  blue: {
    color: "informative-500",
    borderColor: "informative-500"
  },
  green: {
    color: "primary-500",
    borderColor: "primary-500"
  },
  yellow: {
    color: "warning-500",
    borderColor: "warning-500"
  },
  default: {
    color: "text-secondary",
    borderColor: "graphic-neutral"
  },
  purple: {
    color: "decorative1-600",
    borderColor: "decorative1-600"
  },
  pink: {
    color: "decorative2-700",
    borderColor: "decorative2-700"
  }
};

// src/components/Avatar/constants.ts
var avatarSizes = {
  small: "24px",
  regular: "32px",
  large: "48px",
  xLarge: "64px"
};
var iconSizes = {
  small: "16px",
  regular: "16px",
  large: "24px",
  xLarge: "32px"
};
var avatarVariants = ["green", "yellow", "blue"];

// src/components/Avatar/components/StyledAvatar/StyledAvatar.tsx
var makeAvatarSize = ({ size: size2 }) => {
  var _a;
  const avatarSize = (_a = avatarSizes[size2]) != null ? _a : size2;
  return {
    width: avatarSize,
    height: avatarSize
  };
};
var makeAvatarBorderColor = ({
  disabled,
  variant: variant2,
  hasImage
}) => {
  if (hasImage) {
    return css10`
      border: 1px solid transparent;
    `;
  }
  if (disabled) {
    return css10`
      border: 1px solid ${getColor("graphic-disabled")};
    `;
  }
  return css10`
    border: 1px solid ${getColor(AVATAR_VARIANT_COLORS_MAP[variant2].borderColor)};
  `;
};
var makeAvatarColor = ({ disabled, variant: variant2 }) => {
  if (disabled) {
    return css10`
      color: ${getColor("text-disabled")};
    `;
  }
  return css10`
    color: ${getColor(AVATAR_VARIANT_COLORS_MAP[variant2].color)};
  `;
};
var StyledAvatar = styled19(Flex_default)`
  position: relative;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  user-select: none;
  font-family: default;
  border-radius: ${({ shape }) => getRadii(shape === "circle" ? "full" : "sm")};
  overflow: hidden;
  ${makeAvatarSize}
  ${makeAvatarColor}
  ${makeAvatarBorderColor}
`;

// src/components/Avatar/contexts/context.ts
import { createContext as createContext9, useContext as useContext13 } from "react";
var AvatarContext = createContext9(null);
var useAvatarContext = () => {
  return useContext13(AvatarContext);
};

// src/components/Avatar/Avatar.tsx
var Avatar = forwardRef12(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      disabled = false,
      variant: variant2 = "default",
      shape = "circle"
    } = _b, rootProps = __objRest(_b, [
      "children",
      "size",
      "disabled",
      "variant",
      "shape"
    ]);
    const [loadStatus, setLoadStatus] = useState10(0 /* Idle */);
    const hasImage = loadStatus === 2 /* Load */;
    return /* @__PURE__ */ React56.createElement(AvatarContext.Provider, { value: { size: size2, loadStatus, setLoadStatus, disabled, variant: variant2, shape } }, /* @__PURE__ */ React56.createElement(
      StyledAvatar,
      __spreadValues(__spreadProps(__spreadValues({
        "data-test": "avatar",
        hasImage,
        ref
      }, { size: size2, disabled, variant: variant2, shape }), {
        opacity: disabled && hasImage ? 0.5 : void 0
      }), rootProps),
      children
    ));
  }
);

// src/components/Avatar/components/AvatarFallback/AvatarFallback.tsx
import React57, { useEffect as useEffect12, useState as useState11 } from "react";
var AvatarFallback = ({ children, delayMs }) => {
  const [canRender, setCanRender] = useState11(delayMs === void 0);
  const { loadStatus } = useAvatarContext();
  useEffect12(() => {
    if (delayMs === void 0) {
      return;
    }
    const timerId = window.setTimeout(() => setCanRender(true), delayMs);
    return () => window.clearTimeout(timerId);
  }, [delayMs]);
  if (loadStatus === 2 /* Load */ || !canRender) {
    return null;
  }
  return /* @__PURE__ */ React57.createElement(React57.Fragment, null, children);
};

// src/components/Avatar/components/AvatarIcon/AvatarIcon.tsx
import React58, { forwardRef as forwardRef13 } from "react";
var AvatarIcon = forwardRef13(
  (_a, ref) => {
    var _b = _a, { icon, iconSize } = _b, iconProps = __objRest(_b, ["icon", "iconSize"]);
    const { size: size2, disabled, variant: variant2 } = useAvatarContext();
    return /* @__PURE__ */ React58.createElement(
      Icon_default,
      __spreadValues({
        "data-test": "avatar-icon",
        ref,
        component: icon,
        size: iconSize ? iconSize : iconSizes[size2],
        color: disabled ? "icon-disabled" : variant2 === "default" ? "icon-default" : AVATAR_VARIANT_COLORS_MAP[variant2].color
      }, iconProps)
    );
  }
);
AvatarIcon.displayName = "AvatarIcon";

// src/components/Avatar/components/AvatarImg/AvatarImg.tsx
import React59, { forwardRef as forwardRef14, useEffect as useEffect13 } from "react";
import styled20 from "@xstyled/styled-components";
var StyledImg = styled20(Box_default)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
var AvatarImg = forwardRef14(
  (_a, ref) => {
    var _b = _a, { src } = _b, imageProps = __objRest(_b, ["src"]);
    const { loadStatus, setLoadStatus } = useAvatarContext();
    useEffect13(() => {
      setLoadStatus(1 /* Progress */);
      return () => {
        setLoadStatus(0 /* Idle */);
      };
    }, [src, setLoadStatus]);
    if (loadStatus === 3 /* Fail */) {
      return null;
    }
    return /* @__PURE__ */ React59.createElement(
      StyledImg,
      __spreadProps(__spreadValues({
        as: "img",
        "data-test": "avatar-img",
        ref,
        src
      }, imageProps), {
        onLoad: () => setLoadStatus(2 /* Load */),
        onError: () => setLoadStatus(3 /* Fail */)
      })
    );
  }
);
AvatarImg.displayName = "AvatarImg";

// src/components/Avatar/components/AvatarText/AvatarText.tsx
import React60, { forwardRef as forwardRef15 } from "react";

// src/components/Avatar/utils.ts
function getInitials(name) {
  return name.toUpperCase().split(" ").slice(0, 2).map((word) => word[0]).join("");
}
function getAvatarTextChildNode({
  initials,
  name
}) {
  return initials != null ? initials : name ? getInitials(name) : void 0;
}
var computeAvatarVariant = (initials) => {
  const variantIdx = (initials.charCodeAt(0) + (initials.charCodeAt(1) || 0)) % avatarVariants.length;
  return avatarVariants[variantIdx];
};

// src/components/Avatar/components/AvatarText/AvatarText.tsx
function getTextVariant(size2) {
  switch (size2) {
    case "small":
      return "supportingRegularXS";
    case "xLarge":
      return "headingLightM";
    case "regular":
    case "large":
    default:
      return "bodyRegularM";
  }
}
var AvatarText = forwardRef15(
  (_a, ref) => {
    var _b = _a, { name, initials } = _b, textProps = __objRest(_b, ["name", "initials"]);
    const childNode = initials != null ? initials : name ? getInitials(name) : void 0;
    const { size: size2 } = useAvatarContext();
    const textVariant = getTextVariant(size2);
    return /* @__PURE__ */ React60.createElement(Typography_default, __spreadValues({ "data-test": "avatar-text", ref, variant: textVariant }, textProps), childNode);
  }
);
AvatarText.displayName = "AvatarText";

// src/components/Avatar/QuickAvatar.tsx
import * as React61 from "react";
var QuickAvatar = React61.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      icon,
      src,
      disabled = false,
      size: size2 = "regular",
      name,
      initials,
      variant: variant2,
      iconSize
    } = _b, rootProps = __objRest(_b, [
      "icon",
      "src",
      "disabled",
      "size",
      "name",
      "initials",
      "variant",
      "iconSize"
    ]);
    const childNode = getAvatarTextChildNode({ name, initials });
    const avatarVariant = variant2 != null ? variant2 : childNode ? computeAvatarVariant(childNode) : "default";
    return /* @__PURE__ */ React61.createElement(Avatar, __spreadProps(__spreadValues({ size: size2, disabled, variant: avatarVariant }, rootProps), { ref }), src && /* @__PURE__ */ React61.createElement(AvatarImg, { src, alt: "Avatar image" }), /* @__PURE__ */ React61.createElement(AvatarFallback, null, icon && /* @__PURE__ */ React61.createElement(AvatarIcon, { icon, iconSize }), childNode && !icon && /* @__PURE__ */ React61.createElement(AvatarText, { initials: childNode })));
  }
);

// src/components/Badge/Badge.tsx
import React62, { forwardRef as forwardRef17 } from "react";

// src/components/Badge/components/StyledBadgeIndicator.tsx
import styled21, { css as css11 } from "@xstyled/styled-components";

// src/utils/layout.ts
import { getInset, style as style3 } from "@xstyled/styled-components";
var offsetTop = style3({
  prop: ["offsetTop"],
  themeGet: getInset,
  css: "top"
});
var offsetRight = style3({
  prop: ["offsetRight"],
  themeGet: getInset,
  css: "right"
});

// src/components/Badge/constants.ts
var TAG_SIZES_MAP = {
  small: "13px",
  regular: "16px",
  large: "22px",
  xLarge: "28px"
};
var TAG_ICON_SIZES_MAP = {
  small: "6px",
  regular: "8px",
  large: "12px",
  xLarge: "14px"
};
var BADGE_VARIANT_COLORS_MAP = {
  primary: {
    color: "text-contrast-light",
    backgroundColor: "primary-500"
  },
  blue: {
    color: "text-contrast-light",
    backgroundColor: "informative-500"
  },
  red: {
    color: "text-contrast-light",
    backgroundColor: "critical-500"
  },
  yellow: {
    color: "text-contrast-light",
    backgroundColor: "warning-500"
  },
  grey: {
    color: "text-contrast-light",
    backgroundColor: "neutral-500"
  }
};

// src/components/Badge/components/StyledBadgeIndicator.tsx
var makeBadgeSize = ({ size: size2 }) => {
  var _a;
  const badgeSize = (_a = TAG_SIZES_MAP[size2]) != null ? _a : TAG_SIZES_MAP.regular;
  return css11`
    min-width: ${badgeSize};
    height: ${badgeSize};
  `;
};
var makeBadgeIconSize = ({ size: size2 }) => {
  var _a;
  const iconSize = (_a = TAG_ICON_SIZES_MAP[size2]) != null ? _a : TAG_ICON_SIZES_MAP.regular;
  return css11`
    svg {
      width: ${iconSize};
      height: ${iconSize};
    }
  `;
};
var makeBadgePosition = ({ hasChildren }) => {
  if (!hasChildren) {
    return;
  }
  return css11`
    position: absolute;
    transform: translate(50%, -50%);
    transform-origin: 100% 0%;
  `;
};
var makeBadgeVariant = ({
  theme,
  badgeBg,
  badgeColor,
  variant: variant2
}) => {
  if (badgeBg) {
    const bgColor = getColor(badgeBg)({ theme });
    return css11({
      backgroundColor: badgeBg,
      color: badgeColor || textColor(bgColor, "text-contrast-light", "text-contrast-dark")
    });
  }
  return css11(variant2 && BADGE_VARIANT_COLORS_MAP[variant2] || BADGE_VARIANT_COLORS_MAP.primary);
};
var StyledBadgeIndicator = styled21(Box_default)`
  visibility: ${({ visible }) => visible ? "visible" : "hidden"};
  border-radius: full;
  border: 2px solid white;
  overflow: hidden;
  ${makeBadgePosition}
  ${makeBadgeSize}
  ${makeBadgeIconSize}
  ${makeBadgeVariant}
  ${offsetTop}
  ${offsetRight}
`;

// src/components/Badge/components/StyledBadgeIndicatorContent.ts
import { styled as styled22 } from "@xstyled/styled-components";
var StyledBadgeIndicatorContent = styled22.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

// src/components/Badge/Badge.tsx
var Badge = forwardRef17(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      variant: variant2 = "primary",
      color: color4,
      bg,
      icon,
      visible = true,
      offsetTop: offsetTop2 = 0,
      offsetRight: offsetRight2 = 0
    } = _b, remainingStyleProps = __objRest(_b, [
      "children",
      "size",
      "variant",
      "color",
      "bg",
      "icon",
      "visible",
      "offsetTop",
      "offsetRight"
    ]);
    return /* @__PURE__ */ React62.createElement(Flex_default, { display: "inline-flex", position: "relative", "data-test": "badge-container", ref }, children, /* @__PURE__ */ React62.createElement(
      StyledBadgeIndicator,
      __spreadValues(__spreadValues({
        "data-test": "badge-indicator",
        badgeBg: bg,
        badgeColor: color4,
        hasChildren: !!children,
        visible
      }, { size: size2, variant: variant2, offsetTop: offsetTop2, offsetRight: offsetRight2 }), remainingStyleProps),
      /* @__PURE__ */ React62.createElement(StyledBadgeIndicatorContent, null, icon)
    ));
  }
);
Badge.displayName = "Badge";

// src/components/Banner/components/BannerIcon.tsx
import React69 from "react";

// src/components/Notification/components/NotificationSuffix.ts
import styled24 from "@xstyled/styled-components";

// src/components/Spacer/Spacer.tsx
import React63, { forwardRef as forwardRef18 } from "react";
import styled23, { css as css12 } from "@xstyled/styled-components";

// src/components/Spacer/utils.ts
var shouldForwardProp3 = (prop, defaultValidationFn) => !["direction"].includes(prop) && defaultValidationFn(prop);

// src/components/Spacer/Spacer.tsx
var Container2 = styled23(Flex_default).withConfig({ shouldForwardProp: shouldForwardProp3 })`
  vertical-align: top;
  ${({ reverse, direction }) => {
  const flexDirection = direction === "vertical" ? "column" : "row";
  return css12`
      flex-direction: ${reverse ? `${flexDirection}-reverse` : flexDirection};
    `;
}}
`;
var Spacer = forwardRef18(
  (_a, ref) => {
    var _b = _a, {
      children,
      alignItems,
      justifyContent,
      flexWrap,
      space: space6 = "xxxs",
      direction = "horizontal",
      reverse = false,
      fluid,
      w,
      itemsSized = "auto"
    } = _b, otherStyleProps = __objRest(_b, [
      "children",
      "alignItems",
      "justifyContent",
      "flexWrap",
      "space",
      "direction",
      "reverse",
      "fluid",
      "w",
      "itemsSized"
    ]);
    const validChildren = React63.Children.toArray(children).filter(Boolean);
    return /* @__PURE__ */ React63.createElement(
      Container2,
      __spreadValues({
        display: "inline-flex",
        ref,
        direction,
        alignItems,
        justifyContent,
        flexWrap,
        w: w != null ? w : fluid ? "100%" : void 0,
        reverse,
        gap: space6
      }, otherStyleProps),
      validChildren.map((child, childIdx) => /* @__PURE__ */ React63.createElement(Box_default, { key: childIdx, flex: itemsSized === "evenly-sized" ? "1 1 0" : void 0 }, child))
    );
  }
);
Spacer.displayName = "Spacer";

// src/components/Notification/components/NotificationSuffix.ts
var NotificationSuffix = styled24(Spacer).attrs({
  space: 2
})``;
NotificationSuffix.defaultProps = {
  "data-test": "notification-suffix"
};

// src/components/Notification/components/NotificationButton.tsx
import React64 from "react";
var NotificationButton = (_a) => {
  var _b = _a, {
    children,
    mode = "link",
    variant: variant2 = "secondary"
  } = _b, otherButtonProps = __objRest(_b, [
    "children",
    "mode",
    "variant"
  ]);
  return /* @__PURE__ */ React64.createElement(Button, __spreadValues(__spreadValues({ size: "xSmall" }, { mode, variant: variant2 }), otherButtonProps), children);
};

// src/components/Notification/components/NotificationHeading.ts
import { styled as styled25 } from "@xstyled/styled-components";
var NotificationHeading = styled25(Typography_default).attrs({
  color: "text-base",
  textAlign: "left",
  variant: "bodyMediumS"
})``;
NotificationHeading.defaultProps = {
  "data-test": "notification-heading"
};

// src/components/Notification/components/NotificationParagraph.ts
import { styled as styled26 } from "@xstyled/styled-components";
var NotificationParagraph = styled26(Typography_default).attrs({
  color: "text-base",
  textAlign: "left",
  variant: "supportingRegularS"
})``;
NotificationParagraph.defaultProps = {
  "data-test": "notification-paragraph"
};

// src/components/Notification/components/NotificationIcon.tsx
import React67 from "react";
import { styled as styled27 } from "@xstyled/styled-components";

// src/components/Notification/constants.tsx
import * as React65 from "react";
import {
  CloseCircleFilled,
  InformationFilled,
  TickCircleFilled,
  WarningFilled
} from "@aircall/icons";
var notificationIcons = {
  success: () => /* @__PURE__ */ React65.createElement(Icon_default, { component: TickCircleFilled }),
  info: () => /* @__PURE__ */ React65.createElement(Icon_default, { component: InformationFilled }),
  warning: () => /* @__PURE__ */ React65.createElement(Icon_default, { component: WarningFilled }),
  critical: () => /* @__PURE__ */ React65.createElement(Icon_default, { component: CloseCircleFilled })
};

// src/components/Notification/contexts/NotificationContext.ts
import * as React66 from "react";
var NotificationContext = React66.createContext(null);
var useNotificationContext = () => {
  return React66.useContext(NotificationContext);
};

// src/components/Notification/components/NotificationIcon.tsx
var StyledIcon = styled27(Box_default).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop)
}).attrs(({ icon, variant: variant2 }) => {
  const IconComponent2 = notificationIcons[variant2];
  const iconNode = icon && (typeof icon === "boolean" ? /* @__PURE__ */ React67.createElement(IconComponent2, null) : icon);
  return {
    children: iconNode
  };
})``;
var NotificationIcon = (_a) => {
  var _b = _a, {
    icon = true,
    alignSelf: alignSelf2 = "center"
  } = _b, iconProps = __objRest(_b, [
    "icon",
    "alignSelf"
  ]);
  const { variant: variant2 } = useNotificationContext();
  return /* @__PURE__ */ React67.createElement(
    StyledIcon,
    __spreadProps(__spreadValues({
      "data-test": "notification-icon"
    }, iconProps), {
      icon,
      variant: variant2,
      alignSelf: alignSelf2
    })
  );
};

// src/components/Notification/components/NotificationRoot.tsx
import React68 from "react";
import styled28 from "@xstyled/styled-components";

// src/components/Notification/components/utils.ts
import { css as css13 } from "@xstyled/styled-components";
var makeNotificationVariant = ({ variant: variant2 }) => {
  return css13`
    background-color: ${getColor(`surface-${variant2}`)};

    ${StyledIcon} svg {
      color: ${getColor(`icon-${variant2}`)};
    }

    ${NotificationSuffix} {
      svg {
        color: ${getColor("icon-contrast-dark")};
      }
    }
  `;
};

// src/components/Notification/components/NotificationRoot.tsx
var StyledRootContainer = styled28(Flex_default).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop)
})`
  padding: 4;
  user-select: none;
  align-items: center;
  ${makeNotificationVariant}
`;
var NotificationRoot = (_a) => {
  var _b = _a, {
    variant: variant2,
    children,
    "data-test": dataTest = "notification-root"
  } = _b, rootProps = __objRest(_b, [
    "variant",
    "children",
    "data-test"
  ]);
  return /* @__PURE__ */ React68.createElement(NotificationContext.Provider, { value: { variant: variant2 } }, /* @__PURE__ */ React68.createElement(StyledRootContainer, __spreadValues({ variant: variant2, "data-test": dataTest }, rootProps), children));
};

// src/components/Notification/Notification.tsx
var Notification = {
  Root: NotificationRoot,
  Icon: NotificationIcon,
  Heading: NotificationHeading,
  Paragraph: NotificationParagraph,
  Suffix: NotificationSuffix,
  Button: NotificationButton
};

// src/components/Banner/components/BannerIcon.tsx
var BannerIcon = (props) => {
  return /* @__PURE__ */ React69.createElement(Notification.Icon, __spreadValues({ gridArea: "icon", mr: 2, "data-test": "banner-icon" }, props));
};

// src/components/Banner/components/BannerHeading.tsx
import styled29 from "@xstyled/styled-components";
var BannerHeading = styled29(NotificationHeading)`
  grid-area: heading;
`;
BannerHeading.defaultProps = {
  "data-test": "banner-heading"
};

// src/components/Banner/components/BannerParagraph.tsx
import { styled as styled30 } from "@xstyled/styled-components";
var BannerParagraph = styled30(NotificationParagraph)`
  grid-area: paragraph;
`;
BannerParagraph.defaultProps = {
  "data-test": "banner-paragraph"
};

// src/components/Banner/components/BannerSuffix.tsx
import styled31 from "@xstyled/styled-components";
var BannerSuffix = styled31(Notification.Suffix)`
  grid-area: suffix;
`;

// src/components/Banner/components/BannerButton.tsx
var { Button: Button3 } = Notification;
var BannerButton = Button3;

// src/components/Banner/components/Banner.tsx
import React70 from "react";
import styled32, { css as css14, getSpace as getSpace2 } from "@xstyled/styled-components";
var BannerRoot = styled32(Notification.Root)`
  ${({ inline }) => inline ? css14`
          border-radius: lg;
        ` : ""}
  width: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    'icon heading suffix'
    '. paragraph suffix';
  padding: ${getSpace2("s")};
`;
var Banner = (_a) => {
  var _b = _a, { variant: variant2 } = _b, rest = __objRest(_b, ["variant"]);
  return /* @__PURE__ */ React70.createElement(BannerRoot, __spreadValues({ variant: variant2, "data-test": `banner-${variant2}` }, rest));
};

// src/components/Banner/contexts/BannerContext.tsx
import { createContext as createContext11, useContext as useContext15 } from "react";
var BannerContext = createContext11(null);
var useBanner = () => {
  return useContext15(BannerContext);
};

// src/components/Banner/components/BannerManager/BannerManager.tsx
import * as React73 from "react";
import uniqueId from "lodash.uniqueid";
import { usePubSub } from "@aircall/hooks";

// src/internal/InternalPortal.tsx
import * as React71 from "react";
import { createPortal } from "react-dom";
var InternalPortal = ({
  children,
  container = ((_a) => (_a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a.body)()
}) => {
  const [isMounted, setIsMounted] = React71.useState(false);
  React71.useEffect(() => {
    setIsMounted(true);
  }, []);
  const containerNode = typeof container === "function" ? container() : container;
  return /* @__PURE__ */ React71.createElement(React71.Fragment, null, containerNode && isMounted && createPortal(children, containerNode));
};

// src/components/Banner/constants.ts
var TOPICS = {
  SHOW_BANNER: "SHOW_BANNER",
  REMOVE_BANNER: "REMOVE_BANNER"
};

// src/components/Banner/components/BannerList/BannerList.tsx
import * as React72 from "react";
import { AnimatePresence as AnimatePresence2, motion as motion3 } from "framer-motion";
var bannerVariant = {
  show: { height: "auto" },
  hide: { height: 0 }
};
var bannerTransition = { type: "tween", duration: 0.3 };
var AnimateBanner = ({ banner }) => {
  const { removeBanner } = useBanner();
  const _a = banner, { icon, variant: variant2, heading, paragraph, actions } = _a, bannerProps = __objRest(_a, ["icon", "variant", "heading", "paragraph", "actions"]);
  const handleDismiss = React72.useCallback(() => {
    removeBanner(banner.id);
  }, [removeBanner, banner.id]);
  const onActionClick = React72.useCallback(
    (handleClick) => {
      return () => {
        handleClick(handleDismiss);
      };
    },
    [handleDismiss]
  );
  return /* @__PURE__ */ React72.createElement(
    motion3.div,
    {
      layout: true,
      style: { overflow: "hidden" },
      initial: "hide",
      animate: "show",
      exit: "hide",
      variants: bannerVariant,
      transition: bannerTransition
    },
    /* @__PURE__ */ React72.createElement(Banner, __spreadValues({ variant: variant2 }, bannerProps), icon && /* @__PURE__ */ React72.createElement(BannerIcon, { icon }), /* @__PURE__ */ React72.createElement(BannerHeading, null, heading), paragraph && /* @__PURE__ */ React72.createElement(BannerParagraph, null, paragraph), actions && actions.length > 0 && /* @__PURE__ */ React72.createElement(BannerSuffix, null, actions.map((_b, actionIdx) => {
      var _c = _b, { onClick, variant: variant3, mode, children } = _c, otherActionProps = __objRest(_c, ["onClick", "variant", "mode", "children"]);
      return /* @__PURE__ */ React72.createElement(
        BannerButton,
        __spreadValues({
          key: actionIdx,
          "data-test": `banner-action-${actionIdx}`,
          onClick: onActionClick(onClick),
          variant: variant3,
          mode
        }, otherActionProps),
        children
      );
    })))
  );
};
var BannerList = () => {
  const { banners: banners2 } = useBanner();
  return /* @__PURE__ */ React72.createElement(Box_default, { "data-test": "banner-list", position: "relative" }, /* @__PURE__ */ React72.createElement(AnimatePresence2, null, banners2.map((banner) => /* @__PURE__ */ React72.createElement(AnimateBanner, { key: banner.id, banner }))));
};

// src/components/Banner/components/BannerManager/BannerManager.tsx
var BannerManager = ({
  children,
  container = ((_a) => (_a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a.body)()
}) => {
  const [banners2, setBanners] = React73.useState([]);
  const removeBanner = React73.useCallback(
    (id) => setBanners((prevBanners) => prevBanners.filter((t) => t.id !== id)),
    []
  );
  const showBanner = React73.useCallback(
    (t) => {
      const banner = __spreadValues({ id: uniqueId() }, t);
      const cleanup = () => removeBanner(banner.id);
      setBanners((prevBanners) => {
        if (prevBanners.some(({ id }) => id === banner.id)) {
          return prevBanners;
        }
        return [banner, ...prevBanners];
      });
      return cleanup;
    },
    [removeBanner]
  );
  usePubSub(TOPICS.SHOW_BANNER, showBanner);
  usePubSub(TOPICS.REMOVE_BANNER, removeBanner);
  const containerNode = typeof container === "function" ? container() : container;
  return /* @__PURE__ */ React73.createElement(BannerContext.Provider, { value: { banners: banners2, showBanner, removeBanner } }, /* @__PURE__ */ React73.createElement(React73.Fragment, null, children, /* @__PURE__ */ React73.createElement(InternalPortal, { container }, /* @__PURE__ */ React73.createElement(BannerList, null))));
};

// src/components/Banner/pubsub.ts
import PubSub from "pubsub-js";
var banners = {
  showBanner: (banner) => {
    PubSub.publish(TOPICS.SHOW_BANNER, banner);
  },
  removeBanner: (id) => {
    PubSub.publish(TOPICS.REMOVE_BANNER, id);
  }
};

// src/components/ComboBox/ComboBox.tsx
import React75, { useCallback as useCallback15 } from "react";

// src/components/ComboBox/ComboBoxProvider.tsx
import React74, { useCallback as useCallback14, useMemo as useMemo6 } from "react";
var ComboBoxContext = React74.createContext(null);
var useComboBox = () => {
  return React74.useContext(ComboBoxContext);
};
var ComboBoxProvider = ({
  disabled,
  children
}) => {
  const { selectedKeys, setSelectedKeys, selectionMode } = useMenu();
  const { open, setOpen } = usePopoverContext();
  const removeAll = useCallback14(() => {
    setSelectedKeys([]);
  }, [setSelectedKeys]);
  const removeKey = useCallback14(
    (key) => {
      const nextKeys = selectedKeys.filter((k) => k !== key);
      setSelectedKeys(nextKeys);
    },
    [selectedKeys, setSelectedKeys]
  );
  const onItemClicked = useCallback14(() => {
    if (selectionMode === "single") {
      setOpen(false);
    }
  }, [selectionMode, setOpen]);
  const value = useMemo6(
    () => ({
      onItemClicked,
      open,
      setOpen,
      selectedKeys,
      removeAll,
      removeKey,
      setSelectedKeys,
      disabled
    }),
    [onItemClicked, open, removeAll, removeKey, selectedKeys, setOpen, setSelectedKeys, disabled]
  );
  return /* @__PURE__ */ React74.createElement(ComboBoxContext.Provider, { value }, children);
};

// src/components/ComboBox/ComboBox.tsx
function ComboBox(_a) {
  var _b = _a, {
    children,
    selectionMode,
    size: size2 = "regular",
    onOpen,
    onClose,
    disabled = false,
    open,
    defaultOpen
  } = _b, props = __objRest(_b, [
    "children",
    "selectionMode",
    "size",
    "onOpen",
    "onClose",
    "disabled",
    "open",
    "defaultOpen"
  ]);
  const onOpenChange = useCallback15(
    (open2) => {
      if (open2) {
        onOpen == null ? void 0 : onOpen();
      } else {
        onClose == null ? void 0 : onClose();
      }
    },
    [onClose, onOpen]
  );
  return /* @__PURE__ */ React75.createElement(MenuProvider, __spreadValues({ selectionMode, size: size2 }, props), /* @__PURE__ */ React75.createElement(Popover.Root, { onOpenChange, open, defaultOpen }, /* @__PURE__ */ React75.createElement(ComboBoxProvider, { disabled }, children)));
}

// src/components/ComboBox/components/ComboBoxTrigger.tsx
import React76 from "react";
var ComboBoxTrigger = function Trigger(props) {
  const { toggleOpen } = usePopoverContext();
  const { disabled } = useComboBox();
  return /* @__PURE__ */ React76.createElement(Popover.Trigger, __spreadProps(__spreadValues({}, props), { onClick: disabled ? void 0 : toggleOpen }));
};

// src/components/ComboBox/components/ComboBoxContent.tsx
import React77 from "react";
var ComboBoxContent = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React77.createElement(
    Popover.Content,
    __spreadValues({
      flexDirection: "column",
      takeViewportHeight: true,
      align: "start",
      side: "bottom",
      sideOffset: 8,
      boxShadow: 1,
      overflow: "hidden",
      borderRadius: "sm",
      bg: "surface-interactive-default",
      takeTriggerWidth: true
    }, props),
    children
  );
};

// src/components/ComboBox/components/ComboBoxItem.tsx
import * as React78 from "react";
var ComboBoxItem = React78.forwardRef(
  (_a, ref) => {
    var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
    const { onItemClicked } = useComboBox();
    return /* @__PURE__ */ React78.createElement(MenuItem, __spreadValues({ ref, onClick: composeEventHandlers(onItemClicked, onClick) }, props));
  }
);

// src/components/ComboBox/components/ComboBoxMenu.tsx
import React79 from "react";
var ComboBoxMenu = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React79.createElement(StyledMenu, __spreadValues({ minWidth: "unset", overflowY: "auto" }, props), children);
};

// src/components/CounterBadge/CounterBadge.tsx
import React80, { forwardRef as forwardRef20 } from "react";

// src/components/CounterBadge/components/StyledCounterBadgeIndicator.tsx
import styled33, { css as css15 } from "@xstyled/styled-components";

// src/components/CounterBadge/constants.ts
var counterBadgeSize = {
  small: {
    minWidth: 16,
    height: 16,
    maxWidth: 24
  },
  regular: {
    minWidth: 20,
    height: 20,
    maxWidth: 32
  },
  large: {
    minWidth: 24,
    height: 24,
    maxWidth: 32
  }
};
var counterBadgeTypographyVariant = {
  small: "supportingMediumXS",
  regular: "supportingMediumS",
  large: "supportingMediumS"
};
var counterBadgeTypographyPadding = {
  small: "4px",
  regular: "8px",
  large: "8px"
};
var COUNTER_BADGE_VARIANT_COLORS_MAP = {
  primary: {
    color: "text-contrast-light",
    backgroundColor: "primary-500"
  },
  red: {
    color: "text-contrast-light",
    backgroundColor: "critical-500"
  },
  black: {
    color: "text-contrast-light",
    backgroundColor: "neutral-1000"
  }
};

// src/components/CounterBadge/components/StyledCounterBadgeIndicator.tsx
var makeBadgeSize2 = ({ size: size2 }) => {
  const { minWidth, maxWidth, height } = counterBadgeSize[size2];
  return {
    minWidth,
    maxWidth,
    height,
    borderRadius: height / 2
  };
};
var makeBadgePosition2 = ({
  hasChildren
}) => {
  if (!hasChildren) {
    return;
  }
  return css15`
    position: absolute;
    transform: translate(50%, -50%);
    transform-origin: 100% 0%;
  `;
};
var makeBadgeVariant2 = ({
  theme,
  badgeBg,
  badgeColor,
  variant: variant2
}) => {
  if (badgeBg) {
    const bgColor = getColor(badgeBg)({ theme });
    return css15({
      backgroundColor: badgeBg,
      color: badgeColor || textColor(bgColor, "text-contrast-light", "text-contrast-dark")
    });
  }
  return css15(
    variant2 && COUNTER_BADGE_VARIANT_COLORS_MAP[variant2] || COUNTER_BADGE_VARIANT_COLORS_MAP.red
  );
};
var StyledCounterBadgeIndicator = styled33(Box_default)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${makeBadgePosition2}
  ${makeBadgeSize2}
  ${makeBadgeVariant2}
  ${offsetTop}
  ${offsetRight}
`;

// src/components/CounterBadge/CounterBadge.tsx
var CounterBadge = forwardRef20(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      variant: variant2 = "red",
      bg,
      color: color4,
      count,
      maxCount = 99,
      offsetTop: offsetTop2 = 0,
      offsetRight: offsetRight2 = 0,
      showEmptyBubble = false
    } = _b, otherStyleProps = __objRest(_b, [
      "children",
      "size",
      "variant",
      "bg",
      "color",
      "count",
      "maxCount",
      "offsetTop",
      "offsetRight",
      "showEmptyBubble"
    ]);
    if (count === 0) {
      return /* @__PURE__ */ React80.createElement(React80.Fragment, null, children);
    }
    return /* @__PURE__ */ React80.createElement(Flex_default, { display: "inline-flex", position: "relative", "data-test": "counter-badge-container", ref }, children, /* @__PURE__ */ React80.createElement(
      StyledCounterBadgeIndicator,
      __spreadValues(__spreadProps(__spreadValues({
        size: size2,
        hasChildren: !!children,
        badgeColor: color4,
        badgeBg: bg,
        variant: variant2
      }, { offsetTop: offsetTop2, offsetRight: offsetRight2 }), {
        "data-test": "counter-badge-indicator"
      }), otherStyleProps),
      !showEmptyBubble && /* @__PURE__ */ React80.createElement(
        Typography_default,
        {
          variant: counterBadgeTypographyVariant[size2],
          px: count >= 10 ? counterBadgeTypographyPadding[size2] : 0,
          userSelect: "none"
        },
        count <= maxCount ? count : `${maxCount}+`
      )
    ));
  }
);
CounterBadge.displayName = "CounterBadge";

// src/components/DatePicker/DatePicker.tsx
import React87 from "react";
import { useControllableState as useControllableState5 } from "@aircall/hooks";

// src/components/DatePicker/Calendar.tsx
import React85, { useRef as useRef7 } from "react";
import styled37, { css as css18, getColor as getColor6 } from "@xstyled/styled-components";
import { isAfter as isAfter4, isBefore as isBefore4, isSameMonth as isSameMonth2, subMonths } from "date-fns";

// src/components/DatePicker/ArrowButton.tsx
import React81 from "react";
import styled34, { getColor as getColor4 } from "@xstyled/styled-components";
import { ChevronLeftOutlined, ChevronRightOutlined } from "@aircall/icons";

// src/components/DatePicker/DatePicker.hook.ts
import { useContext as useContext16 } from "react";

// src/components/DatePicker/DatePickerContext.ts
import { createContext as createContext12 } from "react";
var DatePickerContext = createContext12({});

// src/components/DatePicker/DatePicker.hook.ts
var useDatePickerState = () => useContext16(DatePickerContext);

// src/components/DatePicker/ArrowButton.tsx
var StyledButton2 = styled34.button`
  position: absolute;
  z-index: 1;
  overflow: hidden;
  top: 6px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${getColor4("graphic-interactive-default")};
  background-color: ${getColor4("surface-interactive-default")};
  cursor: pointer;
  ${({ arrowDirection, displaced }) => arrowDirection === "prev" ? `left: ${displaced + 4}px;` : `right: ${displaced + 4}px`};
  &:hover {
    background-color: ${getColor4("surface-interactive-default-hover")};
  }
`;
function ArrowButton({ direction, displaced = 8 }) {
  const { navigate } = useDatePickerState();
  return /* @__PURE__ */ React81.createElement(
    StyledButton2,
    {
      arrowDirection: direction,
      displaced,
      onClick: () => navigate(direction),
      "data-test": `datepicker-${direction}`
    },
    direction === "prev" ? /* @__PURE__ */ React81.createElement(ChevronLeftOutlined, { size: "15px", color: "icon-interactive-default" }) : /* @__PURE__ */ React81.createElement(ChevronRightOutlined, { size: "15px", color: "icon-interactive-default" })
  );
}

// src/components/DatePicker/Month.tsx
import React84 from "react";
import styled36, { css as css17 } from "@xstyled/styled-components";
import { addDays as addDays2, eachWeekOfInterval, endOfMonth as endOfMonth3 } from "date-fns";

// src/utils/date/get_initial_month.utility.ts
import { add, endOfMonth, isAfter, isBefore, startOfMonth } from "date-fns";
var getInitialMonth = ({
  numberOfMonths,
  initialDate,
  calendarDirection,
  minDate,
  maxDate
}) => {
  let date = initialDate;
  if (maxDate && isAfter(initialDate, endOfMonth(maxDate))) {
    date = maxDate;
  }
  if (minDate && isBefore(initialDate, startOfMonth(minDate))) {
    date = minDate;
  }
  if (numberOfMonths === 1 || calendarDirection === "past") {
    return startOfMonth(date);
  }
  return startOfMonth(add(date, { months: numberOfMonths - 1 }));
};

// src/utils/date/get_initial_months.utility.ts
import { add as add2, endOfMonth as endOfMonth2, isAfter as isAfter2, isBefore as isBefore2, startOfMonth as startOfMonth2, sub } from "date-fns";
var months = (numberOfMonths) => [-1, ...Array(numberOfMonths + 1).keys()];
var getInitialMonths = ({
  numberOfMonths,
  initialDate,
  calendarDirection,
  minDate,
  maxDate
}) => {
  let date = initialDate;
  if (maxDate && isAfter2(initialDate, endOfMonth2(maxDate))) {
    date = maxDate;
  }
  if (minDate && isBefore2(initialDate, startOfMonth2(minDate))) {
    date = minDate;
  }
  if (calendarDirection === "past") {
    return months(numberOfMonths).map((val) => startOfMonth2(sub(date, { months: val }))).reverse();
  }
  return months(numberOfMonths).map((val) => startOfMonth2(add2(date, { months: val })));
};

// src/utils/date/formatting.utility.ts
import { format } from "date-fns";
var monthFormat = (date) => format(date, "MMMM");
var longDate = (date) => format(date, "PPP");
var getWeekdayName = (date, locale = "en-US") => {
  const l = locale.toLocaleLowerCase().includes("pt") ? "PT" : locale;
  return new Intl.DateTimeFormat(l, { weekday: "short" }).format(date);
};
function getMonthYearLocale(date, locale = "en-US") {
  const formatter = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "long"
  });
  return formatter.format(date);
}

// src/components/DatePicker/Week.tsx
import React83 from "react";
import { addDays, isSameMonth } from "date-fns";

// src/components/DatePicker/Day.tsx
import React82 from "react";
import styled35, { css as css16, getColor as getColor5 } from "@xstyled/styled-components";
import { format as format2, isAfter as isAfter3, isBefore as isBefore3, isSameDay } from "date-fns";
var DayContainer = styled35.td`
  ${({ theme }) => css16`
      ${theme.typography.bodyMediumS}
    `}
  opacity: 1;
`;
var Day = styled35.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: sm;
  ${({ daySize }) => css16`
    width: ${daySize}px;
    height: ${daySize}px;
  `}
  color: ${getColor5("text-base")};
  background-color: surface-default;
  border: none;
  cursor: default;
  ${({ isInMonth, disabled }) => isInMonth && !disabled && css16`
      cursor: pointer;
    `}

  &:hover {
    ${({ disabled }) => !disabled && css16`
        background-color: ${getColor5("surface-interactive-default-hover")};
      `}
  }
  ${({ isBetweenDates }) => isBetweenDates && css16`
      background: ${getColor5("surface-interactive-default-active")} !important;
      color: ${getColor5("text-interactive-primary")} !important;
    `}
  ${({ isBookendDate }) => isBookendDate && css16`
      background: ${getColor5("surface-interactive-primary")} !important;
      color: ${getColor5("text-inverted")} !important;
      &:hover {
        background: ${getColor5("surface-interactive-primary-hover")} !important;
      }
    `}
  ${({ today }) => today && css16`
      outline-offset: 1px;
      outline: 1px solid ${getColor5("graphic-interactive-primary-active")};
    `}
  ${({ disabled }) => disabled && css16`
      color: ${getColor5("text-disabled")} !important;
      cursor: default;
    `}
`;
var datepickerDayAriaLabels = {
  start: "Picked starting date.",
  end: "Picked ending date.",
  highlight: "Highlighted dates",
  disabled: "This date is disabled"
};
function getAriaLabel(isStart, isEnd, isBetweenDates, disabled) {
  if (isStart) {
    return datepickerDayAriaLabels.start;
  }
  if (isEnd) {
    return datepickerDayAriaLabels.end;
  }
  if (isBetweenDates) {
    return datepickerDayAriaLabels.highlight;
  }
  if (disabled) {
    return datepickerDayAriaLabels.disabled;
  }
  return "";
}
function checkIsBetweenDates(startDate, hoveredDate, endDate, day) {
  return !!(startDate && isAfter3(day, startDate) && (hoveredDate && (isBefore3(day, hoveredDate) || isSameDay(day, hoveredDate)) && !endDate || endDate && isBefore3(day, endDate)));
}
function DatePickerDay({ day, isInMonth }) {
  const {
    setHoveredDate,
    clickOnDay,
    disabledDay,
    startDate,
    endDate,
    hoveredDate,
    singleDate,
    daySize
  } = useDatePickerState();
  const isStart = !!(startDate && isSameDay(day, startDate));
  const isEnd = !!(endDate && isSameDay(day, endDate));
  const disabled = !!(disabledDay == null ? void 0 : disabledDay(day));
  const isBookendDate = isStart || isEnd;
  const isToday = isSameDay(day, /* @__PURE__ */ new Date());
  const isBetweenDates = checkIsBetweenDates(startDate, hoveredDate, endDate, day);
  return /* @__PURE__ */ React82.createElement(
    DayContainer,
    {
      disabled,
      onClick: disabled ? void 0 : () => {
        clickOnDay(day);
      }
    },
    isInMonth && /* @__PURE__ */ React82.createElement(
      Day,
      {
        type: "button",
        isInMonth,
        "aria-label": getAriaLabel(isStart, isEnd, isBetweenDates, disabled),
        title: longDate(day),
        daySize,
        disabled,
        today: isToday,
        isBetweenDates: !singleDate && isBetweenDates,
        onMouseEnter: disabled ? void 0 : () => setHoveredDate(day),
        isBookendDate
      },
      format2(day, "d")
    )
  );
}

// src/components/DatePicker/Week.tsx
function Week({ weekStart, month }) {
  return /* @__PURE__ */ React83.createElement("tr", null, [...Array(7).keys()].map((_, index) => {
    const day = addDays(weekStart, index);
    const isInMonth = isSameMonth(day, month);
    return /* @__PURE__ */ React83.createElement(DatePickerDay, { day, key: `${day.getTime()}-day`, isInMonth });
  }));
}

// src/components/DatePicker/Month.tsx
var Table = styled36.table`
  border-spacing: 4px;
`;
var MonthContainer = styled36(Box_default)`
  display: inline-block;
  padding: 0 ${({ paddingX }) => paddingX}px;
  ${({ isVisible, transition }) => !isVisible && !transition && css17`
      visibility: hidden !important;
    `}
  ${({ firstMonth, transition }) => firstMonth && transition !== "prev" && css17`
      position: absolute !important;
      z-index: -1 !important;
      opacity: 0 !important;
      pointer-events: none !important;
      visibility: hidden !important;
    `}
  ${({ transition, monthSize, firstMonth }) => firstMonth && transition === "prev" && css17`
      position: absolute !important;
      left: -${monthSize + 4}px;
    `}
  ${({ lastVisible, transition, firstVisible }) => (lastVisible && transition === "prev" || firstVisible && transition === "next") && css17`
      opacity: 0;
      transition: opacity 200ms;
    `}
  ${({ lastMonth, transition, firstMonth }) => (lastMonth && transition !== "next" || firstMonth && transition === "next") && css17`
      display: none !important;
    `}
`;
function Month({ month, paddingX, index, monthSize, isVisible }) {
  const { transition, currentMonths, locale } = useDatePickerState();
  const weeks = eachWeekOfInterval({ start: month, end: endOfMonth3(month) }, { weekStartsOn: 1 });
  return /* @__PURE__ */ React84.createElement(
    MonthContainer,
    {
      "data-test": monthFormat(month),
      w: "fit-content",
      firstMonth: index === 0,
      paddingX,
      transition,
      monthSize,
      isVisible,
      firstVisible: index === 1,
      lastVisible: index === currentMonths.length - 2,
      lastMonth: index === currentMonths.length - 1
    },
    /* @__PURE__ */ React84.createElement(Flex_default, { paddingTop: "xxs", paddingBottom: "s", justifyContent: "center" }, /* @__PURE__ */ React84.createElement(Typography_default, { variant: "headingBoldS", color: "text-base" }, getMonthYearLocale(month, locale))),
    /* @__PURE__ */ React84.createElement(Table, null, /* @__PURE__ */ React84.createElement("thead", null, /* @__PURE__ */ React84.createElement("tr", null, [...Array(7).keys()].map((_, dayIndex) => {
      const day = addDays2(weeks[0], dayIndex);
      const translatedDay = getWeekdayName(day, locale);
      return /* @__PURE__ */ React84.createElement("th", { key: `${day}-header` }, /* @__PURE__ */ React84.createElement(Typography_default, { color: "text-disabled", pb: "xxs", textAlign: "center" }, translatedDay));
    }))), /* @__PURE__ */ React84.createElement("tbody", null, weeks.map((week) => /* @__PURE__ */ React84.createElement(Week, { key: `${week}-week`, weekStart: week, month }))))
  );
}

// src/components/DatePicker/Calendar.tsx
var MonthsContainer = styled37(Box_default)`
  z-index: 0 !important;
  width: ${({ width }) => width}px;
  text-align: left !important;
  transform: ${({ transition, monthSize }) => css18`
      translateX(${transition === "next" && "-"}${transition && monthSize}px)
    `};
  transition: transform ${({ transitionTime, transition }) => transition ? transitionTime : 0}ms;
  white-space: nowrap;
`;
var OuterContainer = styled37(Box_default)`
  background-color: ${getColor6("surface-default")};
  transition: height ${({ transitionTime }) => transitionTime}ms;
`;
var MONTH_CONTAINER_PADDING_X = 8;
var CALENDAR_CONTAINER_HEIGHT = "312px";
function DatePickerCalendar({
  maxDate,
  minDate,
  numberOfMonths,
  "data-test": dataTest
}) {
  const { currentMonth, transition, currentMonths, transitionTime, daySize } = useDatePickerState();
  const monthsContainer = useRef7(null);
  const monthSize = (
    // the width of 7 days including left border and right border
    7 * (daySize + 2) + // 8 spacing border
    8 * 4 + // left padding and right padding
    MONTH_CONTAINER_PADDING_X * 2
  );
  const outerContainerWidth = numberOfMonths * monthSize;
  const sliderContainerWidth = (numberOfMonths + 1) * monthSize;
  const showNext = maxDate ? !(isAfter4(currentMonth, maxDate) || isSameMonth2(currentMonth, maxDate)) : true;
  const showPrev = minDate ? !isBefore4(subMonths(currentMonth, numberOfMonths - 1), minDate) : true;
  return /* @__PURE__ */ React85.createElement(
    OuterContainer,
    {
      overflow: "hidden",
      w: outerContainerWidth,
      h: CALENDAR_CONTAINER_HEIGHT,
      position: "relative",
      backgroundColor: "white",
      transitionTime,
      "data-test": dataTest
    },
    showPrev && /* @__PURE__ */ React85.createElement(ArrowButton, { direction: "prev", displaced: MONTH_CONTAINER_PADDING_X }),
    showNext && /* @__PURE__ */ React85.createElement(ArrowButton, { direction: "next", displaced: MONTH_CONTAINER_PADDING_X }),
    /* @__PURE__ */ React85.createElement(
      MonthsContainer,
      {
        "data-test": transition ? `datepicker-transition-${transition}` : "datepicker-month-container",
        ref: monthsContainer,
        width: sliderContainerWidth,
        transition,
        transitionTime,
        monthSize
      },
      currentMonths.map((month, index) => /* @__PURE__ */ React85.createElement(
        Month,
        {
          paddingX: MONTH_CONTAINER_PADDING_X,
          index,
          isVisible: index > 0 && index < currentMonths.length - 1,
          monthSize,
          key: `${month}-month`,
          month
        }
      ))
    )
  );
}

// src/components/DatePicker/DatePickerProvider.tsx
import React86, { useCallback as useCallback16, useEffect as useEffect15, useMemo as useMemo7, useRef as useRef8, useState as useState14 } from "react";
import { addMonths, endOfMonth as endOfMonth4, isAfter as isAfter5, isBefore as isBefore5, startOfMonth as startOfMonth3, sub as sub2 } from "date-fns";
function DatePickerProvider({
  children,
  numberOfMonths,
  initialDate,
  calendarDirection,
  minDate,
  maxDate,
  onChange,
  value,
  transitionTime,
  isDateDisabled,
  daySize,
  mode = "range",
  locale
}) {
  var _a, _b;
  const timeoutRef = useRef8();
  const [hoveredDate, setHoveredDate] = useState14(null);
  const [currentMonth, setCurrentMonth] = useState14(
    () => getInitialMonth({ numberOfMonths, initialDate, calendarDirection, minDate, maxDate })
  );
  const [transition, setTransition] = useState14();
  const [currentMonths, setCurrentMonths] = useState14(
    () => getInitialMonths({ numberOfMonths, initialDate, calendarDirection, minDate, maxDate })
  );
  const startDate = (_a = value == null ? void 0 : value.startDate) != null ? _a : null;
  const endDate = (_b = value == null ? void 0 : value.endDate) != null ? _b : null;
  const updateMonths = useCallback16(
    (month) => {
      const monthsPlaceholder = [-1, ...Array(numberOfMonths + 1).keys()].map((val) => startOfMonth3(sub2(month, { months: val }))).reverse();
      setCurrentMonths(monthsPlaceholder);
      setTransition(void 0);
    },
    [numberOfMonths]
  );
  const isSingleDate = mode === "single";
  const memoizedContextValue = useMemo7(() => {
    const navigate = (direction) => {
      setCurrentMonth(addMonths(currentMonth, direction === "next" ? 1 : -1));
      setTransition(direction);
    };
    const clickOnDay = (date) => {
      if (isSingleDate) {
        onChange({ startDate: date, endDate: null });
        return;
      }
      const bothDatesSelected = startDate && endDate;
      const startDateSelectedOnly = startDate && !endDate;
      if (!startDate || bothDatesSelected || startDateSelectedOnly && isBefore5(date, startDate)) {
        onChange({ startDate: date, endDate: null });
      } else {
        onChange({ startDate, endDate: date });
      }
    };
    const disabledDay = (day) => !!(isDateDisabled(day) || minDate && isBefore5(day, startOfMonth3(minDate)) || maxDate && isAfter5(day, endOfMonth4(maxDate)));
    return {
      initialized: true,
      hoveredDate,
      setHoveredDate,
      currentMonth,
      setCurrentMonth,
      currentMonths,
      setCurrentMonths,
      transition,
      setTransition,
      navigate,
      clickOnDay,
      startDate,
      endDate,
      mode,
      transitionTime,
      disabledDay,
      daySize,
      locale,
      singleDate: isSingleDate
    };
  }, [
    currentMonth,
    currentMonths,
    daySize,
    isDateDisabled,
    endDate,
    hoveredDate,
    maxDate,
    minDate,
    onChange,
    mode,
    startDate,
    transition,
    transitionTime,
    locale,
    isSingleDate
  ]);
  useEffect15(() => {
    const timeout = window.setTimeout(() => {
      updateMonths(currentMonth);
    }, transitionTime);
    timeoutRef.current = timeout;
  }, [numberOfMonths, currentMonth, transitionTime, updateMonths]);
  useEffect15(() => clearTimeout(timeoutRef.current), []);
  return /* @__PURE__ */ React86.createElement(DatePickerContext.Provider, { value: memoizedContextValue }, children);
}

// src/components/DatePicker/DatePicker.tsx
var DAY_SIZE = 32;
function DatePicker({
  numberOfMonths = 1,
  initialDate = /* @__PURE__ */ new Date(),
  locale = "en-US",
  value,
  defaultValue,
  onChange,
  maxDate,
  minDate,
  mode = "range",
  calendarDirection = "past",
  transitionTime = 200,
  isDateDisabled = () => false,
  "data-test": dataTest
}) {
  const [datesValue, setDatesValue] = useControllableState5({
    prop: value,
    defaultProp: defaultValue,
    onChange
  });
  return /* @__PURE__ */ React87.createElement(
    DatePickerProvider,
    {
      onChange: setDatesValue,
      initialDate,
      calendarDirection,
      value: datesValue,
      mode,
      transitionTime,
      isDateDisabled,
      daySize: DAY_SIZE,
      numberOfMonths,
      minDate,
      maxDate,
      locale
    },
    /* @__PURE__ */ React87.createElement(
      DatePickerCalendar,
      {
        numberOfMonths,
        minDate,
        maxDate,
        "data-test": dataTest
      }
    )
  );
}

// src/components/Drawer/Drawer.tsx
import React102 from "react";
import styled47 from "@xstyled/styled-components";

// src/components/Modal/components/ModalBody.tsx
import * as React92 from "react";
import { styled as styled41 } from "@xstyled/styled-components";

// src/components/List/List.tsx
import * as React88 from "react";
import styled38, { th as th2 } from "@xstyled/styled-components";
var StyledListRoot = styled38(Box_default)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ fluid }) => fluid ? "100%" : "fit-content"};
  background-color: background-02;
  overflow: hidden;
  border: 1px solid ${th2.color("graphic-default")};
  border-radius: sm;
`;
var List = ({
  children,
  fluid,
  "data-test": dataTest = "list-root"
}) => {
  return /* @__PURE__ */ React88.createElement(StyledListRoot, { fluid, "data-test": dataTest }, children);
};

// src/components/List/components/ListView/ListView.tsx
import * as React89 from "react";
import styled39, { maxHeight } from "@xstyled/styled-components";
import { useComposedRefs as useComposedRefs4 } from "@aircall/hooks";

// src/components/List/utils/scroll.utils.ts
function isScrollAtBottom(element) {
  return element.scrollHeight - element.scrollTop === element.clientHeight;
}
function isScrollAtTop(element) {
  return element.scrollTop === 0;
}

// src/components/List/components/ListView/ListView.tsx
var StyledListView = styled39.ul`
  ${maxHeight}
  padding: 0;
  margin: 0;
  overflow: auto;
  list-style-type: none;
  transition: 500ms box-shadow;
  ${({ hasBottomShadow, hasTopShadow }) => {
  const shadows2 = [
    ...hasTopShadow ? [`inset 0 19px 20px -31px grey`] : [],
    ...hasBottomShadow ? [`inset 0 -19px 20px -31px grey`] : []
  ];
  return `box-shadow: ${shadows2.join(",")};`;
}}
`;
function ListViewBase(_a, ref) {
  var _b = _a, { children, "data-test": dataTest = "list-view" } = _b, rest = __objRest(_b, ["children", "data-test"]);
  const localRef = React89.useRef(null);
  const combinedRef = useComposedRefs4(localRef, ref);
  const [hasBottomShadow, setBottomShadow] = React89.useState(false);
  const [hasTopShadow, setTopShadow] = React89.useState(false);
  const setScrollShadow = React89.useCallback((el) => {
    const atBottom = isScrollAtBottom(el);
    const atTop = isScrollAtTop(el);
    setBottomShadow(!atBottom);
    setTopShadow(!atTop);
  }, []);
  React89.useEffect(() => {
    setScrollShadow(localRef.current);
  }, [localRef, setScrollShadow]);
  const handleScroll = React89.useCallback(
    (event) => {
      setScrollShadow(event.currentTarget);
    },
    [setScrollShadow]
  );
  return /* @__PURE__ */ React89.createElement(
    StyledListView,
    __spreadProps(__spreadValues({}, rest), {
      ref: combinedRef,
      onScroll: handleScroll,
      hasBottomShadow,
      hasTopShadow,
      "data-test": dataTest
    }),
    children
  );
}
var ListView = React89.forwardRef(ListViewBase);

// src/components/List/components/ListItem/ListItem.tsx
import * as React90 from "react";
import styled40 from "@xstyled/styled-components";
var StyledListItem = styled40(Box_default).attrs({ as: "li" })`
  border-bottom: 1px solid ${getColor("graphic-default")};
  color: ${getColor("text-base")};

  &:last-child {
    border-bottom: none;
  }
`;
function ListItem(_a) {
  var _b = _a, {
    children,
    "data-test": dataTest = "list-item"
  } = _b, rest = __objRest(_b, [
    "children",
    "data-test"
  ]);
  return /* @__PURE__ */ React90.createElement(StyledListItem, __spreadValues({ "data-test": dataTest }, rest), children);
}

// src/components/List/components/ListFooter/ListFooter.tsx
import * as React91 from "react";
function ListFooter({
  children,
  "data-test": dataTest = "list-sticky-footer"
}) {
  return /* @__PURE__ */ React91.createElement(
    Box_default,
    {
      "data-test": dataTest,
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderTopColor: "graphic-default"
    },
    children
  );
}

// src/components/Modal/components/ModalBody.tsx
var StyledModalBody = styled41(Box_default)`
  flex: 1;
  overflow-y: auto;
  transition: box-shadow 0.1s ease-in-out;

  ${({ hasBottomShadow, hasTopShadow }) => {
  const shadows2 = [
    ...hasTopShadow ? ["inset 0px 10px 20px rgba(0, 0, 0, 0.07)"] : [],
    ...hasBottomShadow ? ["inset 0px -8px 15px rgba(0, 0, 0, 0.07)"] : []
  ];
  return `box-shadow: ${shadows2.join(",") || "none"};`;
}}

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
var ModalBody = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  const localRef = React92.useRef(null);
  const [hasBottomShadow, setBottomShadow] = React92.useState(false);
  const [hasTopShadow, setTopShadow] = React92.useState(false);
  const setScrollShadow = React92.useCallback((el) => {
    const atBottom = isScrollAtBottom(el);
    const atTop = isScrollAtTop(el);
    setBottomShadow(!atBottom);
    setTopShadow(!atTop);
  }, []);
  React92.useEffect(() => {
    if (localRef.current) {
      setScrollShadow(localRef.current);
    }
  }, [localRef, setScrollShadow]);
  const handleScroll = React92.useCallback(
    (e) => {
      setScrollShadow(e.currentTarget);
    },
    [setScrollShadow]
  );
  return /* @__PURE__ */ React92.createElement(
    StyledModalBody,
    __spreadValues({
      ref: localRef,
      p: 5,
      minHeight: "100px",
      "data-test": "modal-body",
      hasBottomShadow,
      hasTopShadow,
      onScroll: handleScroll
    }, boxProps),
    children
  );
};

// src/components/Modal/components/ModalClose.tsx
import * as React94 from "react";
import { CloseOutlined } from "@aircall/icons";

// src/components/Modal/contexts/ModalContext.ts
import * as React93 from "react";
var ModalContext = React93.createContext({
  onHide: noop
});
var useModalContext = () => React93.useContext(ModalContext);

// src/components/Modal/components/ModalClose.tsx
function ModalClose({ className }) {
  const { onHide } = useModalContext();
  return /* @__PURE__ */ React94.createElement(Box_default, { ml: "auto", px: 3, py: 2, className }, /* @__PURE__ */ React94.createElement(
    Button,
    {
      "data-test": "modal-close-icon",
      size: "small",
      variant: "secondary",
      mode: "ghost",
      shape: "circle",
      onClick: onHide
    },
    /* @__PURE__ */ React94.createElement(CloseOutlined, null)
  ));
}

// src/components/Modal/components/ModalFooter.tsx
import * as React95 from "react";
import { styled as styled42 } from "@xstyled/styled-components";
var StyledModalFooter = styled42(Flex_default)`
  position: sticky;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 2 3;
`;
var ModalFooter = (_a) => {
  var _b = _a, {
    children,
    "data-test": dataTest = "modal-footer"
  } = _b, flexProps = __objRest(_b, [
    "children",
    "data-test"
  ]);
  return /* @__PURE__ */ React95.createElement(StyledModalFooter, __spreadValues({ "data-test": dataTest }, flexProps), children);
};

// src/components/Modal/components/ModalHeader.tsx
import * as React96 from "react";
import { styled as styled43 } from "@xstyled/styled-components";
var StyledModalHeader = styled43(Flex_default)`
  position: sticky;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: space-between;
  padding-left: 5;
`;
var ModalHeader = (_a) => {
  var _b = _a, {
    closeButton = true,
    children,
    "data-test": dataTest = "modal-header"
  } = _b, restProps = __objRest(_b, [
    "closeButton",
    "children",
    "data-test"
  ]);
  return /* @__PURE__ */ React96.createElement(StyledModalHeader, __spreadValues({ "data-test": dataTest }, restProps), /* @__PURE__ */ React96.createElement(Box_default, null, children), closeButton && /* @__PURE__ */ React96.createElement(ModalClose, null));
};

// src/components/Modal/components/ModalTitle.tsx
import React97 from "react";
var ModalTitle = (props) => {
  return /* @__PURE__ */ React97.createElement(Typography_default, __spreadValues({ variant: "headingBoldXS", "data-test": "modal-title" }, props));
};

// src/components/Modal/components/ModalDialog.tsx
import * as React101 from "react";
import styled45, { css as css19, getSize, getSpace as getSpace3 } from "@xstyled/styled-components";

// src/components/Modal/constants.ts
var modal = {
  sizes: {
    xSmall: {
      w: "100%",
      maxWidth: "320px"
    },
    small: {
      w: "100%",
      maxWidth: "520px"
    },
    regular: {
      w: "100%",
      maxWidth: "670px"
    },
    large: {
      w: "100%",
      maxWidth: "1000px"
    },
    full: {
      w: "100%",
      h: "100vh"
    }
  }
};

// src/components/Modal/components/Modal.tsx
import React100 from "react";
import styled44, { getColor as getColor7 } from "@xstyled/styled-components";
import { AnimatePresence as AnimatePresence3 } from "framer-motion";
import { useCloseOnEscape as useCloseOnEscape2 } from "@aircall/hooks";

// src/components/FocusTrap/FocusTrap.tsx
import React98, { useEffect as useEffect18, useRef as useRef11 } from "react";
var FOCUSABLE_TRIGGER_SELECTORS = [
  "a[href]",
  "button",
  "select",
  '[tabindex]:not([tabindex="-1"])'
];
var FOCUSABLE_SELECTORS = [
  "a[href]",
  "button",
  "textarea",
  'input[type="text"]',
  'input[type="radio"]',
  'input[type="checkbox"]',
  "select",
  '[tabindex]:not([tabindex="-1"])'
];
var focusTrapStack = /* @__PURE__ */ new Set();
function isFocusable(element) {
  if (!element)
    return false;
  const isMatchingSelector = element.matches(FOCUSABLE_SELECTORS.join(","));
  const isVisible = !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  return isMatchingSelector && isVisible;
}
var FocusTrap = (props) => {
  const { children, active, onClose, autofocus } = props;
  const focusRef = useRef11(null);
  const nodeToRestore = useRef11(null);
  useEffect18(() => {
    const handleMouseDown = (event) => {
      if (!active) {
        const focusableSelectorsString = FOCUSABLE_TRIGGER_SELECTORS.join(",");
        const focusableElement = event.target.closest(focusableSelectorsString);
        if (focusableElement) {
          nodeToRestore.current = focusableElement;
        }
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [active]);
  useEffect18(() => {
    const element = focusRef.current;
    if (!active || !element)
      return;
    focusTrapStack.add(element);
    return () => {
      focusTrapStack.delete(element);
    };
  }, [active]);
  useEffect18(() => {
    if (!active && nodeToRestore.current) {
      nodeToRestore.current.focus();
    }
  }, [active]);
  useEffect18(() => {
    if (!active || !focusRef.current)
      return;
    const element = focusRef.current;
    const getFocusableElements = (container) => {
      return Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS.join(","))).filter(
        (node) => container.contains(node)
      );
    };
    const trapFocus = (event) => {
      if (focusTrapStack.size === 0 || [...focusTrapStack].pop() !== element)
        return;
      const focusable = getFocusableElements(element);
      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.key === "Tab") {
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
      if (event.key === "Escape") {
        onClose == null ? void 0 : onClose();
      }
    };
    const focusFirstElement = () => {
      if (!autofocus)
        return;
      const allFocusableElements = getFocusableElements(element);
      const hasExistingFocus = allFocusableElements.some((element2) => {
        return element2 === document.activeElement || element2.hasAttribute("autofocus");
      });
      if (hasExistingFocus) {
        return;
      }
      const firstFocusable = allFocusableElements[0];
      if (firstFocusable) {
        if (isFocusable(document.activeElement)) {
          nodeToRestore.current = document.activeElement;
        }
        firstFocusable.focus({ preventScroll: true });
      }
    };
    focusFirstElement();
    document.addEventListener("keydown", trapFocus);
    return () => {
      document.removeEventListener("keydown", trapFocus);
    };
  }, [active, onClose, autofocus]);
  return /* @__PURE__ */ React98.createElement("div", { ref: focusRef }, children);
};
var FocusTrap_default = FocusTrap;

// src/components/Modal/hooks.ts
import * as React99 from "react";

// src/styles/InjectGlobalStyle.ts
import { createGlobalStyle } from "@xstyled/styled-components";
import { normalize } from "styled-normalize";
var BODY_OVERFLOW_STOP_CLASS_NAME = "__body-overflow-stop";
var InjectGlobalStyle = createGlobalStyle`
  ${normalize}

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: default;
    ${({ theme }) => theme.typography.bodyRegularS};
    color: ${getColor("text-base")};
  }

  body.${BODY_OVERFLOW_STOP_CLASS_NAME} {
    overflow: hidden;
  }

  a {
    color: primary-500;
    background-color: transparent;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    display: block;
    line-height: 0;
  }
`;

// src/components/Modal/hooks.ts
var useUpdateBodyClassName = (show) => {
  React99.useEffect(() => {
    if (show) {
      document.body.classList.add(BODY_OVERFLOW_STOP_CLASS_NAME);
    } else {
      document.body.classList.remove(BODY_OVERFLOW_STOP_CLASS_NAME);
    }
  }, [show]);
};

// src/components/Modal/components/Modal.tsx
var containerAnimation = {
  enter: {
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.25,
      duration: 0.25
    }
  }
};
var ModalContainer = styled44(MotionBox).attrs({
  variants: containerAnimation,
  initial: "exit",
  animate: "enter",
  exit: "exit"
})`
  position: fixed;
  inset: 0;
  overflow: auto;
`;
var ModalBackdrop = styled44.div`
  position: absolute;
  z-index: 0;
  inset: 0;
  background-color: ${getColor7("surface-overlay")};
`;
var Modal = ({
  onHide,
  portalContainer = document.body,
  children,
  show,
  zIndex,
  rootClose = true,
  focusOptions,
  "data-test": dataTest
}) => {
  useCloseOnEscape2(show, onHide);
  useUpdateBodyClassName(show);
  return /* @__PURE__ */ React100.createElement(ModalContext.Provider, { value: { onHide } }, /* @__PURE__ */ React100.createElement(Portal, { containerRef: { current: portalContainer }, zIndex }, /* @__PURE__ */ React100.createElement(FocusTrap_default, __spreadValues({ active: show, autofocus: true }, focusOptions), /* @__PURE__ */ React100.createElement(AnimatePresence3, { "data-test": "animatePresence" }, show && /* @__PURE__ */ React100.createElement(ModalContainer, { "data-test": dataTest }, /* @__PURE__ */ React100.createElement(
    ModalBackdrop,
    {
      "data-test": "modal-backdrop",
      onClick: !rootClose ? void 0 : onHide
    }
  ), children)))));
};

// src/components/Modal/components/ModalDialog.tsx
var dialogAnimation = {
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    y: 100,
    opacity: 0,
    transition: {
      duration: 0.25
    }
  }
};
var ModalDialogWrapper = styled45(Box_default)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // Prevents scrollbars from showing when ModalDialogContent exit animation runs
  overflow: hidden;
`;
var ModalDialogContent = styled45(MotionBox).attrs({
  variants: dialogAnimation
})`
  display: flex;
  flex-direction: column;
  max-height: ${({ maxHeight: maxHeight2 }) => {
  if (maxHeight2) {
    return css19`
        ${getSize(maxHeight2)}
      `;
  }
  return css19`calc(100vh - (${getSpace3("xxxl")} * 2))`;
}};
  background-color: surface-default;
`;
var ModalDialog = (_a) => {
  var _b = _a, {
    children,
    show,
    onHide,
    portalContainer,
    rootClose,
    "data-test": dataTest,
    zIndex = 1e3,
    size: size2 = "regular"
  } = _b, rest = __objRest(_b, [
    "children",
    "show",
    "onHide",
    "portalContainer",
    "rootClose",
    "data-test",
    "zIndex",
    "size"
  ]);
  return /* @__PURE__ */ React101.createElement(
    Modal,
    {
      zIndex,
      show,
      onHide,
      portalContainer,
      rootClose,
      "data-test": dataTest
    },
    /* @__PURE__ */ React101.createElement(ModalDialogWrapper, { px: { _: "2", md: "4" } }, /* @__PURE__ */ React101.createElement(
      ModalDialogContent,
      __spreadValues(__spreadValues({
        "data-test": "modal-dialog-content",
        overflow: "hidden",
        borderRadius: "lg",
        zIndex: 1
      }, modal.sizes[size2]), rest),
      children
    ))
  );
};

// src/components/Drawer/components/StyledDrawer.tsx
import styled46, { css as css20, getColor as getColor8 } from "@xstyled/styled-components";
var calculateHorizontalPlacement = (placement) => {
  if (placement === "start") {
    return css20`
      left: 0;
    `;
  }
  if (placement === "end") {
    return css20`
      right: 0;
    `;
  }
  return css20`
    left: 0;
    right: 0;
    margin: auto;
  `;
};
var calculateVerticalPlacement = (placement) => {
  if (placement === "start") {
    return css20`
      top: 0;
    `;
  }
  if (placement === "end") {
    return css20`
      bottom: 0;
    `;
  }
  return css20`
    top: 0;
    bottom: 0;
    margin: auto;
  `;
};
var makePlacement = ({ side, placement = "center" }) => {
  if (side === "bottom") {
    return calculateHorizontalPlacement(placement);
  }
  return calculateVerticalPlacement(placement);
};
var makeSide = ({ side }) => {
  const positions = {
    left: "left: 0;",
    right: "right: 0;",
    bottom: "bottom: 0;"
  };
  return css20`
    ${positions[side]}
  `;
};
var StyledDrawer = styled46(Flex_default)`
  background-color: ${getColor8("surface-default")};
  overflow: hidden;
  flex-direction: column;
  z-index: 1;
  position: absolute;
  ${makeSide}
  ${makePlacement}
`;

// src/components/Drawer/Drawer.tsx
var dialogAnimation2 = {
  left: {
    enter: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.25
      }
    },
    exit: {
      x: -100,
      opacity: 0,
      transition: {
        duration: 0.25
      }
    }
  },
  right: {
    enter: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.25
      }
    },
    exit: {
      x: 100,
      opacity: 0,
      transition: {
        duration: 0.25
      }
    }
  },
  bottom: {
    enter: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.25
      }
    },
    exit: {
      y: 100,
      opacity: 0,
      transition: {
        duration: 0.25
      }
    }
  }
};
var DrawerWrapper = styled47(MotionBox)`
  height: 100%;
`;
var Drawer = (_a) => {
  var _b = _a, {
    side = "right",
    placement,
    children,
    show,
    onHide,
    portalContainer,
    rootClose,
    "data-test": dataTest = "drawer-container",
    w = "480px",
    h = "100%",
    zIndex = 1e3
  } = _b, contentProps = __objRest(_b, [
    "side",
    "placement",
    "children",
    "show",
    "onHide",
    "portalContainer",
    "rootClose",
    "data-test",
    "w",
    "h",
    "zIndex"
  ]);
  return /* @__PURE__ */ React102.createElement(
    Modal,
    {
      show,
      onHide,
      portalContainer,
      "data-test": dataTest,
      rootClose,
      zIndex
    },
    /* @__PURE__ */ React102.createElement(DrawerWrapper, { variants: dialogAnimation2[side] }, /* @__PURE__ */ React102.createElement(
      StyledDrawer,
      __spreadValues({
        "data-test": "drawer-dialog-content",
        w,
        h,
        side,
        placement
      }, contentProps),
      children
    ))
  );
};
var DrawerHeader = (props) => /* @__PURE__ */ React102.createElement(ModalHeader, __spreadValues({ "data-test": "drawer-header" }, props));
var DrawerTitle = (props) => /* @__PURE__ */ React102.createElement(ModalTitle, __spreadValues({ "data-test": "drawer-title" }, props));
var DrawerClose = ModalClose;

// src/components/Drawer/DrawerBody.tsx
import * as React103 from "react";
import styled48 from "@xstyled/styled-components";
var StyledBody = styled48(ModalBody)`
  box-shadow: none;
`;
var DrawerBody = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React103.createElement(StyledBody, __spreadValues({ p: 5, minHeight: "100px", "data-test": "drawer-body" }, boxProps), children);
};

// src/components/Drawer/DrawerFooter.tsx
import * as React104 from "react";
import { styled as styled49 } from "@xstyled/styled-components";
var StyledDrawerFooter = styled49(Flex_default)`
  padding: 2 4;
`;
var DrawerFooter = (_a) => {
  var _b = _a, { children } = _b, flexProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React104.createElement(StyledDrawerFooter, __spreadValues({ "data-test": "drawer-footer" }, flexProps), children);
};

// src/components/FlagIcon/FlagIcon.tsx
import React106, { forwardRef as forwardRef22 } from "react";
import loadable from "@loadable/component";

// src/components/Skeleton/Skeleton.tsx
import React105 from "react";
import styled50 from "@xstyled/styled-components";

// src/components/Skeleton/utils.ts
import { css as css21, keyframes as keyframes3, th as th3 } from "@xstyled/styled-components";
var shimmer = keyframes3`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
`;
var wave = keyframes3`
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
`;
var ANIMATION_DELAY = "0.2s";
var makeSkeletonShape = ({ shape }) => {
  if (shape === "squircle") {
    return css21`
      clip-path: url(#svgPath);
    `;
  }
  return css21`
    border-radius: ${shape === "circle" ? "50%" : shape === "squareRounded" ? "default" : void 0};
  `;
};
var makeSkeletonAnimation = ({
  animation,
  animationDelay,
  mode
}) => css21`
  animation: ${animation === "shimmer" ? shimmer : "none"} 1.5s ease-in-out infinite;
  animation-delay: ${animation === "shimmer" && animationDelay ? ANIMATION_DELAY : void 0};

  &:after {
    display: ${animation === "wave" ? "block" : "none"};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: ${animation === "wave" ? wave : "none"} 1.5s ease-in-out infinite;
    animation-delay: ${animation === "wave" && animationDelay ? ANIMATION_DELAY : void 0};
    background-image: linear-gradient(
      90deg,
      transparent,
      ${th3.color(
  mode == "dark" ? "surface-secondary-contrast-dark-alpha" : "surface-secondary-alpha"
)},
      transparent
    );
  }
`;
var shouldForwardProp4 = (prop, defaultValidationFn) => !["shape"].includes(prop) && defaultValidationFn(prop);

// src/components/Skeleton/Skeleton.tsx
var SkeletonComponent = styled50(Box_default).withConfig({ shouldForwardProp: shouldForwardProp4 })`
  ${makeSkeletonShape}
  ${makeSkeletonAnimation}
  position: relative;
  overflow: hidden;
`;
var Skeleton = (_a) => {
  var _b = _a, {
    shape = "squareRounded",
    animation = "wave",
    mode = "auto"
  } = _b, otherProps = __objRest(_b, [
    "shape",
    "animation",
    "mode"
  ]);
  const backgroundColor2 = mode === "dark" ? "surface-primary-contrast-dark-alpha" : "surface-primary-alpha";
  return /* @__PURE__ */ React105.createElement(
    SkeletonComponent,
    __spreadValues({
      backgroundColor: backgroundColor2,
      shape,
      animation
    }, otherProps)
  );
};

// src/components/FlagIcon/styled.ts
import styled51 from "@xstyled/styled-components";
import { color as color3, opacity as opacity2, space as space4 } from "@xstyled/system";
var shouldForwardProp5 = (prop, defaultValidationFn) => !["size"].includes(prop) && defaultValidationFn(prop);
var IconContainer3 = styled51(Box_default).withConfig({
  shouldForwardProp: shouldForwardProp5
})`
  line-height: 0;
  ${space4};
  > svg {
    ${size};
    ${color3};
    ${opacity2};
  }
`;

// src/components/FlagIcon/utils.ts
var COUNTRY_ISO_MAPPING = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AN: "ANT",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BA: "BIH",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "XKX",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
var getFlagComponent = (countryCode) => {
  var _a;
  const countryCodeISO3 = COUNTRY_ISO_MAPPING[(_a = countryCode == null ? void 0 : countryCode.toUpperCase()) != null ? _a : ""];
  const ISO3 = countryCodeISO3 || "USA";
  return `Flag${ISO3.charAt(0).toUpperCase()}${ISO3.slice(1).toLowerCase()}`;
};

// src/components/FlagIcon/FlagIcon.tsx
var FlagsImports = {
  FlagAbw: () => import("@aircall/icons/FlagAbw.mjs"),
  FlagAfg: () => import("@aircall/icons/FlagAfg.mjs"),
  FlagAgo: () => import("@aircall/icons/FlagAgo.mjs"),
  FlagAia: () => import("@aircall/icons/FlagAia.mjs"),
  FlagAla: () => import("@aircall/icons/FlagAla.mjs"),
  FlagAlb: () => import("@aircall/icons/FlagAlb.mjs"),
  FlagAnd: () => import("@aircall/icons/FlagAnd.mjs"),
  FlagAnt: () => import("@aircall/icons/FlagAnt.mjs"),
  FlagAre: () => import("@aircall/icons/FlagAre.mjs"),
  FlagArg: () => import("@aircall/icons/FlagArg.mjs"),
  FlagArm: () => import("@aircall/icons/FlagArm.mjs"),
  FlagAsm: () => import("@aircall/icons/FlagAsm.mjs"),
  FlagAta: () => import("@aircall/icons/FlagAta.mjs"),
  FlagAtf: () => import("@aircall/icons/FlagAtf.mjs"),
  FlagAtg: () => import("@aircall/icons/FlagAtg.mjs"),
  FlagAus: () => import("@aircall/icons/FlagAus.mjs"),
  FlagAut: () => import("@aircall/icons/FlagAut.mjs"),
  FlagAze: () => import("@aircall/icons/FlagAze.mjs"),
  FlagBdi: () => import("@aircall/icons/FlagBdi.mjs"),
  FlagBel: () => import("@aircall/icons/FlagBel.mjs"),
  FlagBen: () => import("@aircall/icons/FlagBen.mjs"),
  FlagBes: () => import("@aircall/icons/FlagBes.mjs"),
  FlagBfa: () => import("@aircall/icons/FlagBfa.mjs"),
  FlagBgd: () => import("@aircall/icons/FlagBgd.mjs"),
  FlagBgr: () => import("@aircall/icons/FlagBgr.mjs"),
  FlagBhr: () => import("@aircall/icons/FlagBhr.mjs"),
  FlagBhs: () => import("@aircall/icons/FlagBhs.mjs"),
  FlagBih: () => import("@aircall/icons/FlagBih.mjs"),
  FlagBlm: () => import("@aircall/icons/FlagBlm.mjs"),
  FlagBlr: () => import("@aircall/icons/FlagBlr.mjs"),
  FlagBlz: () => import("@aircall/icons/FlagBlz.mjs"),
  FlagBmu: () => import("@aircall/icons/FlagBmu.mjs"),
  FlagBol: () => import("@aircall/icons/FlagBol.mjs"),
  FlagBra: () => import("@aircall/icons/FlagBra.mjs"),
  FlagBrb: () => import("@aircall/icons/FlagBrb.mjs"),
  FlagBrn: () => import("@aircall/icons/FlagBrn.mjs"),
  FlagBtn: () => import("@aircall/icons/FlagBtn.mjs"),
  FlagBvt: () => import("@aircall/icons/FlagBvt.mjs"),
  FlagBwa: () => import("@aircall/icons/FlagBwa.mjs"),
  FlagCaf: () => import("@aircall/icons/FlagCaf.mjs"),
  FlagCan: () => import("@aircall/icons/FlagCan.mjs"),
  FlagCck: () => import("@aircall/icons/FlagCck.mjs"),
  FlagChe: () => import("@aircall/icons/FlagChe.mjs"),
  FlagChl: () => import("@aircall/icons/FlagChl.mjs"),
  FlagChn: () => import("@aircall/icons/FlagChn.mjs"),
  FlagCiv: () => import("@aircall/icons/FlagCiv.mjs"),
  FlagCmr: () => import("@aircall/icons/FlagCmr.mjs"),
  FlagCod: () => import("@aircall/icons/FlagCod.mjs"),
  FlagCog: () => import("@aircall/icons/FlagCog.mjs"),
  FlagCok: () => import("@aircall/icons/FlagCok.mjs"),
  FlagCol: () => import("@aircall/icons/FlagCol.mjs"),
  FlagCom: () => import("@aircall/icons/FlagCom.mjs"),
  FlagCpv: () => import("@aircall/icons/FlagCpv.mjs"),
  FlagCri: () => import("@aircall/icons/FlagCri.mjs"),
  FlagCub: () => import("@aircall/icons/FlagCub.mjs"),
  FlagCuw: () => import("@aircall/icons/FlagCuw.mjs"),
  FlagCxr: () => import("@aircall/icons/FlagCxr.mjs"),
  FlagCym: () => import("@aircall/icons/FlagCym.mjs"),
  FlagCyp: () => import("@aircall/icons/FlagCyp.mjs"),
  FlagCze: () => import("@aircall/icons/FlagCze.mjs"),
  FlagDeu: () => import("@aircall/icons/FlagDeu.mjs"),
  FlagDji: () => import("@aircall/icons/FlagDji.mjs"),
  FlagDma: () => import("@aircall/icons/FlagDma.mjs"),
  FlagDnk: () => import("@aircall/icons/FlagDnk.mjs"),
  FlagDom: () => import("@aircall/icons/FlagDom.mjs"),
  FlagDza: () => import("@aircall/icons/FlagDza.mjs"),
  FlagEcu: () => import("@aircall/icons/FlagEcu.mjs"),
  FlagEgy: () => import("@aircall/icons/FlagEgy.mjs"),
  FlagEri: () => import("@aircall/icons/FlagEri.mjs"),
  FlagEsh: () => import("@aircall/icons/FlagEsh.mjs"),
  FlagEsp: () => import("@aircall/icons/FlagEsp.mjs"),
  FlagEst: () => import("@aircall/icons/FlagEst.mjs"),
  FlagEth: () => import("@aircall/icons/FlagEth.mjs"),
  FlagFin: () => import("@aircall/icons/FlagFin.mjs"),
  FlagFji: () => import("@aircall/icons/FlagFji.mjs"),
  FlagFlk: () => import("@aircall/icons/FlagFlk.mjs"),
  FlagFra: () => import("@aircall/icons/FlagFra.mjs"),
  FlagFro: () => import("@aircall/icons/FlagFro.mjs"),
  FlagFsm: () => import("@aircall/icons/FlagFsm.mjs"),
  FlagGab: () => import("@aircall/icons/FlagGab.mjs"),
  FlagGbEng: () => import("@aircall/icons/FlagGbEng.mjs"),
  FlagGbNir: () => import("@aircall/icons/FlagGbNir.mjs"),
  FlagGbSct: () => import("@aircall/icons/FlagGbSct.mjs"),
  FlagGbWls: () => import("@aircall/icons/FlagGbWls.mjs"),
  FlagGbr: () => import("@aircall/icons/FlagGbr.mjs"),
  FlagGeo: () => import("@aircall/icons/FlagGeo.mjs"),
  FlagGer: () => import("@aircall/icons/FlagGer.mjs"),
  FlagGgy: () => import("@aircall/icons/FlagGgy.mjs"),
  FlagGha: () => import("@aircall/icons/FlagGha.mjs"),
  FlagGib: () => import("@aircall/icons/FlagGib.mjs"),
  FlagGin: () => import("@aircall/icons/FlagGin.mjs"),
  FlagGlp: () => import("@aircall/icons/FlagGlp.mjs"),
  FlagGmb: () => import("@aircall/icons/FlagGmb.mjs"),
  FlagGnb: () => import("@aircall/icons/FlagGnb.mjs"),
  FlagGnq: () => import("@aircall/icons/FlagGnq.mjs"),
  FlagGrc: () => import("@aircall/icons/FlagGrc.mjs"),
  FlagGrd: () => import("@aircall/icons/FlagGrd.mjs"),
  FlagGrl: () => import("@aircall/icons/FlagGrl.mjs"),
  FlagGtm: () => import("@aircall/icons/FlagGtm.mjs"),
  FlagGuf: () => import("@aircall/icons/FlagGuf.mjs"),
  FlagGum: () => import("@aircall/icons/FlagGum.mjs"),
  FlagGuy: () => import("@aircall/icons/FlagGuy.mjs"),
  FlagHkg: () => import("@aircall/icons/FlagHkg.mjs"),
  FlagHmd: () => import("@aircall/icons/FlagHmd.mjs"),
  FlagHnd: () => import("@aircall/icons/FlagHnd.mjs"),
  FlagHrv: () => import("@aircall/icons/FlagHrv.mjs"),
  FlagHti: () => import("@aircall/icons/FlagHti.mjs"),
  FlagHun: () => import("@aircall/icons/FlagHun.mjs"),
  FlagIdn: () => import("@aircall/icons/FlagIdn.mjs"),
  FlagImn: () => import("@aircall/icons/FlagImn.mjs"),
  FlagInd: () => import("@aircall/icons/FlagInd.mjs"),
  FlagIot: () => import("@aircall/icons/FlagIot.mjs"),
  FlagIrl: () => import("@aircall/icons/FlagIrl.mjs"),
  FlagIrn: () => import("@aircall/icons/FlagIrn.mjs"),
  FlagIrq: () => import("@aircall/icons/FlagIrq.mjs"),
  FlagIsl: () => import("@aircall/icons/FlagIsl.mjs"),
  FlagIsr: () => import("@aircall/icons/FlagIsr.mjs"),
  FlagIta: () => import("@aircall/icons/FlagIta.mjs"),
  FlagJam: () => import("@aircall/icons/FlagJam.mjs"),
  FlagJey: () => import("@aircall/icons/FlagJey.mjs"),
  FlagJor: () => import("@aircall/icons/FlagJor.mjs"),
  FlagJpn: () => import("@aircall/icons/FlagJpn.mjs"),
  FlagKaz: () => import("@aircall/icons/FlagKaz.mjs"),
  FlagKen: () => import("@aircall/icons/FlagKen.mjs"),
  FlagKgz: () => import("@aircall/icons/FlagKgz.mjs"),
  FlagKhm: () => import("@aircall/icons/FlagKhm.mjs"),
  FlagKir: () => import("@aircall/icons/FlagKir.mjs"),
  FlagKna: () => import("@aircall/icons/FlagKna.mjs"),
  FlagKor: () => import("@aircall/icons/FlagKor.mjs"),
  FlagKwt: () => import("@aircall/icons/FlagKwt.mjs"),
  FlagLao: () => import("@aircall/icons/FlagLao.mjs"),
  FlagLbn: () => import("@aircall/icons/FlagLbn.mjs"),
  FlagLbr: () => import("@aircall/icons/FlagLbr.mjs"),
  FlagLby: () => import("@aircall/icons/FlagLby.mjs"),
  FlagLca: () => import("@aircall/icons/FlagLca.mjs"),
  FlagLie: () => import("@aircall/icons/FlagLie.mjs"),
  FlagLka: () => import("@aircall/icons/FlagLka.mjs"),
  FlagLso: () => import("@aircall/icons/FlagLso.mjs"),
  FlagLtu: () => import("@aircall/icons/FlagLtu.mjs"),
  FlagLux: () => import("@aircall/icons/FlagLux.mjs"),
  FlagLva: () => import("@aircall/icons/FlagLva.mjs"),
  FlagMac: () => import("@aircall/icons/FlagMac.mjs"),
  FlagMaf: () => import("@aircall/icons/FlagMaf.mjs"),
  FlagMar: () => import("@aircall/icons/FlagMar.mjs"),
  FlagMco: () => import("@aircall/icons/FlagMco.mjs"),
  FlagMda: () => import("@aircall/icons/FlagMda.mjs"),
  FlagMdg: () => import("@aircall/icons/FlagMdg.mjs"),
  FlagMdv: () => import("@aircall/icons/FlagMdv.mjs"),
  FlagMex: () => import("@aircall/icons/FlagMex.mjs"),
  FlagMhl: () => import("@aircall/icons/FlagMhl.mjs"),
  FlagMkd: () => import("@aircall/icons/FlagMkd.mjs"),
  FlagMli: () => import("@aircall/icons/FlagMli.mjs"),
  FlagMlt: () => import("@aircall/icons/FlagMlt.mjs"),
  FlagMmr: () => import("@aircall/icons/FlagMmr.mjs"),
  FlagMne: () => import("@aircall/icons/FlagMne.mjs"),
  FlagMng: () => import("@aircall/icons/FlagMng.mjs"),
  FlagMnp: () => import("@aircall/icons/FlagMnp.mjs"),
  FlagMoz: () => import("@aircall/icons/FlagMoz.mjs"),
  FlagMrt: () => import("@aircall/icons/FlagMrt.mjs"),
  FlagMsr: () => import("@aircall/icons/FlagMsr.mjs"),
  FlagMtq: () => import("@aircall/icons/FlagMtq.mjs"),
  FlagMus: () => import("@aircall/icons/FlagMus.mjs"),
  FlagMwi: () => import("@aircall/icons/FlagMwi.mjs"),
  FlagMys: () => import("@aircall/icons/FlagMys.mjs"),
  FlagMyt: () => import("@aircall/icons/FlagMyt.mjs"),
  FlagNam: () => import("@aircall/icons/FlagNam.mjs"),
  FlagNcl: () => import("@aircall/icons/FlagNcl.mjs"),
  FlagNer: () => import("@aircall/icons/FlagNer.mjs"),
  FlagNfk: () => import("@aircall/icons/FlagNfk.mjs"),
  FlagNga: () => import("@aircall/icons/FlagNga.mjs"),
  FlagNic: () => import("@aircall/icons/FlagNic.mjs"),
  FlagNiu: () => import("@aircall/icons/FlagNiu.mjs"),
  FlagNld: () => import("@aircall/icons/FlagNld.mjs"),
  FlagNor: () => import("@aircall/icons/FlagNor.mjs"),
  FlagNpl: () => import("@aircall/icons/FlagNpl.mjs"),
  FlagNru: () => import("@aircall/icons/FlagNru.mjs"),
  FlagNzl: () => import("@aircall/icons/FlagNzl.mjs"),
  FlagOmn: () => import("@aircall/icons/FlagOmn.mjs"),
  FlagPak: () => import("@aircall/icons/FlagPak.mjs"),
  FlagPan: () => import("@aircall/icons/FlagPan.mjs"),
  FlagPcn: () => import("@aircall/icons/FlagPcn.mjs"),
  FlagPer: () => import("@aircall/icons/FlagPer.mjs"),
  FlagPhl: () => import("@aircall/icons/FlagPhl.mjs"),
  FlagPlw: () => import("@aircall/icons/FlagPlw.mjs"),
  FlagPng: () => import("@aircall/icons/FlagPng.mjs"),
  FlagPol: () => import("@aircall/icons/FlagPol.mjs"),
  FlagPri: () => import("@aircall/icons/FlagPri.mjs"),
  FlagPrk: () => import("@aircall/icons/FlagPrk.mjs"),
  FlagPrt: () => import("@aircall/icons/FlagPrt.mjs"),
  FlagPry: () => import("@aircall/icons/FlagPry.mjs"),
  FlagPse: () => import("@aircall/icons/FlagPse.mjs"),
  FlagPyf: () => import("@aircall/icons/FlagPyf.mjs"),
  FlagQat: () => import("@aircall/icons/FlagQat.mjs"),
  FlagReu: () => import("@aircall/icons/FlagReu.mjs"),
  FlagRou: () => import("@aircall/icons/FlagRou.mjs"),
  FlagRus: () => import("@aircall/icons/FlagRus.mjs"),
  FlagRwa: () => import("@aircall/icons/FlagRwa.mjs"),
  FlagSau: () => import("@aircall/icons/FlagSau.mjs"),
  FlagSdn: () => import("@aircall/icons/FlagSdn.mjs"),
  FlagSen: () => import("@aircall/icons/FlagSen.mjs"),
  FlagSgp: () => import("@aircall/icons/FlagSgp.mjs"),
  FlagSgs: () => import("@aircall/icons/FlagSgs.mjs"),
  FlagShn: () => import("@aircall/icons/FlagShn.mjs"),
  FlagSjm: () => import("@aircall/icons/FlagSjm.mjs"),
  FlagSlb: () => import("@aircall/icons/FlagSlb.mjs"),
  FlagSle: () => import("@aircall/icons/FlagSle.mjs"),
  FlagSlv: () => import("@aircall/icons/FlagSlv.mjs"),
  FlagSmr: () => import("@aircall/icons/FlagSmr.mjs"),
  FlagSom: () => import("@aircall/icons/FlagSom.mjs"),
  FlagSpa: () => import("@aircall/icons/FlagSpa.mjs"),
  FlagSpm: () => import("@aircall/icons/FlagSpm.mjs"),
  FlagSrb: () => import("@aircall/icons/FlagSrb.mjs"),
  FlagSsd: () => import("@aircall/icons/FlagSsd.mjs"),
  FlagStp: () => import("@aircall/icons/FlagStp.mjs"),
  FlagSur: () => import("@aircall/icons/FlagSur.mjs"),
  FlagSvk: () => import("@aircall/icons/FlagSvk.mjs"),
  FlagSvn: () => import("@aircall/icons/FlagSvn.mjs"),
  FlagSwe: () => import("@aircall/icons/FlagSwe.mjs"),
  FlagSwz: () => import("@aircall/icons/FlagSwz.mjs"),
  FlagSxm: () => import("@aircall/icons/FlagSxm.mjs"),
  FlagSyc: () => import("@aircall/icons/FlagSyc.mjs"),
  FlagSyr: () => import("@aircall/icons/FlagSyr.mjs"),
  FlagTca: () => import("@aircall/icons/FlagTca.mjs"),
  FlagTcd: () => import("@aircall/icons/FlagTcd.mjs"),
  FlagTgo: () => import("@aircall/icons/FlagTgo.mjs"),
  FlagTha: () => import("@aircall/icons/FlagTha.mjs"),
  FlagTjk: () => import("@aircall/icons/FlagTjk.mjs"),
  FlagTkl: () => import("@aircall/icons/FlagTkl.mjs"),
  FlagTkm: () => import("@aircall/icons/FlagTkm.mjs"),
  FlagTls: () => import("@aircall/icons/FlagTls.mjs"),
  FlagTon: () => import("@aircall/icons/FlagTon.mjs"),
  FlagTto: () => import("@aircall/icons/FlagTto.mjs"),
  FlagTun: () => import("@aircall/icons/FlagTun.mjs"),
  FlagTur: () => import("@aircall/icons/FlagTur.mjs"),
  FlagTuv: () => import("@aircall/icons/FlagTuv.mjs"),
  FlagTwn: () => import("@aircall/icons/FlagTwn.mjs"),
  FlagTza: () => import("@aircall/icons/FlagTza.mjs"),
  FlagUga: () => import("@aircall/icons/FlagUga.mjs"),
  FlagUkr: () => import("@aircall/icons/FlagUkr.mjs"),
  FlagUmi: () => import("@aircall/icons/FlagUmi.mjs"),
  FlagUry: () => import("@aircall/icons/FlagUry.mjs"),
  FlagUsa: () => import("@aircall/icons/FlagUsa.mjs"),
  FlagUzb: () => import("@aircall/icons/FlagUzb.mjs"),
  FlagVat: () => import("@aircall/icons/FlagVat.mjs"),
  FlagVct: () => import("@aircall/icons/FlagVct.mjs"),
  FlagVen: () => import("@aircall/icons/FlagVen.mjs"),
  FlagVgb: () => import("@aircall/icons/FlagVgb.mjs"),
  FlagVir: () => import("@aircall/icons/FlagVir.mjs"),
  FlagVnm: () => import("@aircall/icons/FlagVnm.mjs"),
  FlagVut: () => import("@aircall/icons/FlagVut.mjs"),
  FlagWlf: () => import("@aircall/icons/FlagWlf.mjs"),
  FlagWsm: () => import("@aircall/icons/FlagWsm.mjs"),
  FlagXkx: () => import("@aircall/icons/FlagXkx.mjs"),
  FlagYem: () => import("@aircall/icons/FlagYem.mjs"),
  FlagZaf: () => import("@aircall/icons/FlagZaf.mjs"),
  FlagZmb: () => import("@aircall/icons/FlagZmb.mjs"),
  FlagZwe: () => import("@aircall/icons/FlagZwe.mjs")
};
var IconComponent = loadable(
  ({ component }) => {
    return FlagsImports[component]();
  },
  {
    cacheKey: (props) => props.component
  }
);
var FlagIcon = forwardRef22(
  (_a, ref) => {
    var _b = _a, { countryCode, size: size2 = "24px" } = _b, otherStyleProps = __objRest(_b, ["countryCode", "size"]);
    const flagComponentName = getFlagComponent(countryCode);
    return /* @__PURE__ */ React106.createElement(IconContainer3, __spreadValues({ ref, size: size2 }, otherStyleProps), /* @__PURE__ */ React106.createElement(
      IconComponent,
      {
        component: flagComponentName,
        fallback: /* @__PURE__ */ React106.createElement(Skeleton, { w: size2, h: size2, shape: "squircle" })
      }
    ));
  }
);

// src/components/Gauge/Gauge.tsx
import * as React107 from "react";
import styled52 from "@xstyled/styled-components";
var GaugeItem = styled52(Box_default)`
  transition: background-color 0.2s ease-in-out;
`;
var Gauge = React107.forwardRef(({ value, gauges = 8 }, ref) => {
  const arr = Array.from({ length: gauges }, (_, index) => index);
  return /* @__PURE__ */ React107.createElement(Grid, { ref, w: "100%", columnGap: "12px", gridTemplateColumns: "8", "data-test": "input-gauge" }, arr.map((_, index) => /* @__PURE__ */ React107.createElement(
    GaugeItem,
    {
      key: index,
      borderRadius: "sm",
      display: "block",
      h: "12px",
      backgroundColor: index < value ? "graphic-primary" : "graphic-default"
    }
  )));
});
var Gauge_default = Gauge;

// src/components/Pagination/Pagination.tsx
import * as React118 from "react";
import { useControllableState as useControllableState6 } from "@aircall/hooks";
import { ChevronLeftOutlined as ChevronLeftOutlined2, ChevronRightOutlined as ChevronRightOutlined2 } from "@aircall/icons";

// src/components/Select/Select.tsx
import React117, { forwardRef as forwardRef25, useEffect as useEffect21, useState as useState17 } from "react";
import { useLatest } from "@aircall/hooks";

// src/components/Select/components/SelectContent.tsx
import * as React109 from "react";

// src/components/Select/constants.ts
var selectSizesHeight = {
  small: "40px",
  regular: "48px",
  large: "56px"
};
var searchableDropdownMinHeight = {
  small: "80px",
  regular: "96px",
  large: "112px"
};

// src/components/Select/context.tsx
import * as React108 from "react";
var SelectContext = React108.createContext(null);
var useSelect = () => React108.useContext(SelectContext);
var SelectProvider = ({
  size: size2,
  validationStatus,
  selectionMode,
  disabled,
  loading,
  loadingText,
  noOptionsLabel,
  getOptionLabel = (option) => option.label,
  getOptionValue = (option) => option.value,
  renderOption,
  children
}) => {
  const { selectedKeys } = useMenu();
  return /* @__PURE__ */ React108.createElement(
    SelectContext.Provider,
    {
      value: {
        componentSize: size2,
        componentStatus: validationStatus,
        selectedKeys,
        selectionMode,
        disabled,
        loading,
        loadingText,
        noOptionsLabel,
        getOptionLabel,
        getOptionValue,
        renderOption
      }
    },
    children
  );
};

// src/components/Select/components/SelectContent.tsx
var SelectContent = (_a) => {
  var _b = _a, {
    children,
    searchable,
    takeTriggerWidth = true
  } = _b, popoverContent = __objRest(_b, [
    "children",
    "searchable",
    "takeTriggerWidth"
  ]);
  const { componentSize } = useSelect();
  return /* @__PURE__ */ React109.createElement(
    Popover.Content,
    __spreadProps(__spreadValues({}, popoverContent), {
      flexDirection: "column",
      sideOffset: 8,
      boxShadow: 1,
      overflow: "hidden",
      borderRadius: "sm",
      bg: "surface-interactive-default",
      takeTriggerWidth,
      takeViewportHeight: true,
      minWidth: takeTriggerWidth ? "fit-content" : 220,
      minHeight: searchable ? searchableDropdownMinHeight[componentSize] : void 0,
      closeOnInsideClick: false,
      closeOnOutsideClick: true
    }),
    children
  );
};

// src/components/Select/components/SelectMenu.tsx
import React111, { useCallback as useCallback19 } from "react";

// src/components/Select/utils.ts
function isGroupOption(element) {
  return element.options !== void 0;
}

// src/components/Select/components/Loading.tsx
import React110 from "react";
import { LoadingRedoUndoOutlined as LoadingRedoUndoOutlined2 } from "@aircall/icons";

// src/components/Select/components/styled.ts
import styled53, { css as css22 } from "@xstyled/styled-components";
var makeTriggerContainerStyle = ({
  validationStatus,
  triggerSize
}) => {
  return css22`
    outline: 0;
    height: ${selectSizesHeight[triggerSize]};
  `;
};
var makeTriggerStates = ({
  validationStatus,
  disabled,
  triggerSize
}) => {
  const hasError = validationStatus === "error";
  if (disabled) {
    return css22`
      background-color: ${getColor("surface-disabled")};
      border-color: ${getColor("graphic-disabled")};
      color: ${getColor("text-disabled")};
    `;
  }
  if (hasError) {
    return css22`
      border-color: ${getColor("graphic-interactive-critical")};
    `;
  }
  return css22`
    :not(:disabled) {
      :hover {
        border-color: ${getColor("graphic-interactive-default-hover")};
      }

      :focus {
        border-color: ${getColor("graphic-interactive-default-active")};
      }
    }
  `;
};
var makeDisabledTriggerContainerStyle = ({ disabled }) => {
  if (!disabled)
    return;
  return css22`
    cursor: 'not-allowed';
    /* prevent all clicks event, and the dropdown menu won't open */
    pointer-events: none;
    background-color: input-deemphasized;
  `;
};
var TriggerContainer = styled53(Grid).attrs(() => ({
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  gap: "xxs",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "graphic-interactive-default",
  backgroundColor: "surface-default",
  cursor: "pointer",
  borderRadius: "sm",
  px: "s"
})).withConfig({
  shouldForwardProp: (prop, defaultValidator) => defaultValidator(prop)
})`
  text-align: left;
  ${makeTriggerContainerStyle}
  ${makeTriggerStates}
  ${makeDisabledTriggerContainerStyle}
`;
var EmptyShell = styled53(Flex_default)`
  ${({ theme }) => theme.typography.bodyMediumS};
  position: relative;
  align-items: center;
  height: 48px;
  padding: 3 4;
  color: ${getColor("text-default")};
  user-select: none;
  background-color: input-background-01;
  transition: default;
`;

// src/components/Select/components/Loading.tsx
var Loading = ({ loadingText }) => {
  return /* @__PURE__ */ React110.createElement(EmptyShell, null, /* @__PURE__ */ React110.createElement(Icon_default, { spin: true, component: LoadingRedoUndoOutlined2, color: "icon-primary", size: "16px", mr: 2 }), loadingText);
};

// src/components/Select/components/SelectMenu.tsx
var SelectMenu = ({ options, "data-test": dataTest }) => {
  const { getOptionValue, loading, loadingText, noOptionsLabel } = useSelect();
  return /* @__PURE__ */ React111.createElement(
    StyledMenu,
    {
      "data-test": dataTest,
      minWidth: "unset",
      overflowY: "auto",
      py: 2
    },
    loading ? /* @__PURE__ */ React111.createElement(Loading, { loadingText }) : options.length === 0 ? /* @__PURE__ */ React111.createElement(EmptyShell, null, noOptionsLabel) : options.map(
      (option, optionIdx) => isGroupOption(option) ? /* @__PURE__ */ React111.createElement(
        SelectMenuGroup,
        {
          key: `option-group-${optionIdx}`,
          option,
          optionIdx
        }
      ) : /* @__PURE__ */ React111.createElement(SelectMenuItem, { key: getOptionValue(option), option })
    )
  );
};
var SelectMenuGroup = ({ option, optionIdx }) => {
  const { options, label } = option;
  const divider = optionIdx !== 0 && !label;
  return /* @__PURE__ */ React111.createElement(MenuItemGroup, { title: label, divider }, options.map((item) => /* @__PURE__ */ React111.createElement(SelectMenuItem, { key: item.value, option: item })));
};
var SelectMenuItem = ({ option }) => {
  const { toggleOpen } = usePopoverContext();
  const { getOptionLabel, getOptionValue, renderOption, selectionMode } = useSelect();
  const { prefix, suffix, disabled = false } = option;
  const itemKey = getOptionValue(option);
  const optionElement = renderOption ? renderOption(option) : getOptionLabel(option);
  const onItemClick = useCallback19(() => {
    selectionMode === "single" && toggleOpen();
  }, [toggleOpen, selectionMode]);
  return /* @__PURE__ */ React111.createElement(
    MenuItem,
    {
      itemKey,
      "data-test": `select-option-item-${itemKey}`,
      onClick: onItemClick,
      disabled
    },
    prefix && /* @__PURE__ */ React111.createElement(MenuItemPrefix, null, prefix),
    /* @__PURE__ */ React111.createElement(MenuItemLabel, null, optionElement),
    suffix && /* @__PURE__ */ React111.createElement(MenuItemSuffix, null, suffix)
  );
};

// src/components/Select/components/SelectSearch.tsx
import * as React113 from "react";
import { useEffect as useEffect20, useRef as useRef12 } from "react";

// src/components/Select/components/SelectInput.tsx
import * as React112 from "react";
import { useCallback as useCallback20 } from "react";
import styled54 from "@xstyled/styled-components";
import { CloseOutlined as CloseOutlined2, SearchOutlined } from "@aircall/icons";

// src/components/TextInput/constants.ts
var TEXT_INPUT_SIZES = {
  xSmall: "32px",
  small: "40px",
  regular: "48px",
  large: "56px"
};

// src/components/Select/components/SelectInput.tsx
var CustomInput = styled54.input`
  border: none;
  outline: none;
  min-width: 0px;
  flex: 1;
  display: inline-block;
  width: 100%;
`;
var SearchInput = ({ onChange, value, size: size2 = "regular", inputRef }) => {
  const handleClear = useCallback20(() => {
    onChange("");
  }, [onChange]);
  return /* @__PURE__ */ React112.createElement(
    Flex_default,
    {
      h: TEXT_INPUT_SIZES[size2],
      display: "inline-flex",
      alignItems: "center",
      w: "100%",
      boxSizing: "border-box",
      p: "xxxs"
    },
    /* @__PURE__ */ React112.createElement("span", null, /* @__PURE__ */ React112.createElement(Icon_default, { component: SearchOutlined, color: "icon-default", ml: "xxs" })),
    /* @__PURE__ */ React112.createElement(
      CustomInput,
      {
        ref: inputRef,
        "data-test": "select-search-input",
        "aria-label": "Search",
        value,
        onChange: (event) => onChange(event.target.value)
      }
    ),
    value && /* @__PURE__ */ React112.createElement("span", null, /* @__PURE__ */ React112.createElement(
      Button,
      {
        "data-test": "text-field-clear-button",
        type: "button",
        shape: "circle",
        mode: "ghost",
        size: "xSmall",
        onClick: handleClear
      },
      /* @__PURE__ */ React112.createElement(CloseOutlined2, { color: "icon-default" })
    ))
  );
};

// src/components/Select/components/SelectSearch.tsx
var SelectSearch = ({ onChange, size: size2, value }) => {
  const ref = useRef12(null);
  const { side } = usePopoverPlacement();
  const { open } = usePopoverContext();
  const handleChange = (value2) => {
    onChange == null ? void 0 : onChange(value2);
  };
  useEffect20(() => {
    if (open && (ref == null ? void 0 : ref.current)) {
      ref.current.focus();
    }
  }, [open]);
  return /* @__PURE__ */ React113.createElement(Box_default, { order: side === "bottom" ? -1 : 1 }, side === "top" && /* @__PURE__ */ React113.createElement(Divider, { color: "graphic-default", orientation: "horizontal", h: "1px" }), /* @__PURE__ */ React113.createElement(SearchInput, { value, onChange: handleChange, size: size2, inputRef: ref }), side === "bottom" && /* @__PURE__ */ React113.createElement(Divider, { color: "graphic-default", orientation: "horizontal", h: "1px" }));
};

// src/components/Select/components/SelectTrigger.tsx
import * as React114 from "react";
var SelectTrigger = React114.forwardRef(
  (_a, ref) => {
    var triggerProps = __objRest(_a, []);
    const context = usePopoverContext();
    return /* @__PURE__ */ React114.createElement(Popover.Trigger, __spreadProps(__spreadValues({}, triggerProps), { ref, onClick: context.toggleOpen }));
  }
);

// src/components/Select/components/SelectTriggerButton.tsx
import React116, { useMemo as useMemo8 } from "react";
import { ChevronDownOutlined as ChevronDownOutlined2 } from "@aircall/icons";

// src/components/Select/components/ValueContainer.tsx
import React115 from "react";
var ValueContainer = ({ selectedLabels }) => {
  if (selectedLabels.every((label) => typeof label === "string")) {
    return /* @__PURE__ */ React115.createElement(
      Typography_default,
      {
        color: "text-base",
        "data-test": "select-value-container",
        variant: "bodyRegularS",
        ellipsis: true
      },
      selectedLabels.join(",")
    );
  }
  return /* @__PURE__ */ React115.createElement(Spacer, { space: 1 }, selectedLabels);
};

// src/components/Select/components/SelectTriggerButton.tsx
var SelectTriggerButton = React116.forwardRef(
  (_a, ref) => {
    var _b = _a, { placeholder, options } = _b, triggerButtonProps = __objRest(_b, ["placeholder", "options"]);
    const {
      selectedKeys,
      disabled,
      componentSize,
      componentStatus,
      getOptionLabel,
      getOptionValue
    } = useSelect();
    const selectedLabels = useMemo8(
      () => options.filter(
        (option) => isGroupOption(option) ? false : selectedKeys.includes(getOptionValue(option))
      ).map(getOptionLabel),
      [options, selectedKeys, getOptionLabel, getOptionValue]
    );
    return /* @__PURE__ */ React116.createElement(
      TriggerContainer,
      __spreadValues({
        triggerSize: componentSize,
        validationStatus: componentStatus,
        disabled,
        ref
      }, triggerButtonProps),
      selectedKeys.length === 0 ? /* @__PURE__ */ React116.createElement(Typography_default, { color: disabled ? "text-disabled" : "text-placeholder" }, placeholder) : /* @__PURE__ */ React116.createElement(ValueContainer, { selectedLabels }),
      /* @__PURE__ */ React116.createElement(Icon_default, { color: disabled ? "icon-disabled" : "icon-default", component: ChevronDownOutlined2 })
    );
  }
);

// src/components/Select/Select.tsx
var BaseSelect = ({
  options,
  size: size2 = "regular",
  selectionMode = "single",
  defaultSelectedKeys = [],
  selectedKeys,
  onItemSelected: onSelect,
  onItemDeselected: onDeselect,
  onSelectionChange,
  side = "bottom",
  align = "start",
  disabled = false,
  placeholder,
  validationStatus,
  getOptionLabel,
  getOptionValue,
  renderOption,
  trigger,
  w = "100%",
  loading,
  loadingText = "Loading results",
  noOptionsLabel = "No options",
  searchable = false,
  "data-test": dataTest,
  onBlur,
  takeTriggerWidth,
  takeViewportHeight,
  open,
  defaultOpen = false,
  searchOptions
}, ref) => {
  const [searchText, setSearchText] = useState17(void 0);
  const [innerOptions, setInnerOptions] = useState17(options);
  const searchOptionsRef = useLatest(searchOptions);
  const { componentSize, componentStatus } = useForm({ size: size2, validationStatus });
  const selectTrigger = trigger != null ? trigger : /* @__PURE__ */ React117.createElement(SelectTriggerButton, { placeholder, options, w });
  const triggerTestId = dataTest || "select-trigger-container";
  const menuTestId = dataTest ? `${dataTest}-dropdown-menu` : "select-dropdown-menu";
  const contentTestId = dataTest ? `${dataTest}-content` : "select-dropdown-container";
  useEffect21(() => {
    if (searchText === void 0 || !(searchOptionsRef == null ? void 0 : searchOptionsRef.current))
      return;
    const filter = () => __async(void 0, null, function* () {
      const filteredOptions = yield searchOptionsRef.current(searchText);
      setInnerOptions(filteredOptions);
    });
    filter();
  }, [searchText, searchOptionsRef]);
  useEffect21(() => {
    setInnerOptions(options);
  }, [options]);
  return /* @__PURE__ */ React117.createElement(
    MenuProvider,
    {
      selectionMode,
      size: componentSize,
      selectedKeys,
      defaultSelectedKeys,
      onSelect,
      onDeselect,
      onSelectionChange,
      disabled
    },
    /* @__PURE__ */ React117.createElement(
      SelectProvider,
      {
        size: componentSize,
        validationStatus: componentStatus,
        selectionMode,
        loading,
        loadingText,
        disabled,
        noOptionsLabel,
        getOptionLabel,
        getOptionValue,
        renderOption
      },
      /* @__PURE__ */ React117.createElement(Popover.Root, { open, defaultOpen }, /* @__PURE__ */ React117.createElement(SelectTrigger, { tabIndex: 0, "data-test": triggerTestId, onBlur, ref }, selectTrigger), /* @__PURE__ */ React117.createElement(
        SelectContent,
        __spreadProps(__spreadValues({}, { align, side, searchable, takeTriggerWidth, takeViewportHeight }), {
          "data-test": contentTestId
        }),
        searchable && /* @__PURE__ */ React117.createElement(SelectSearch, { onChange: setSearchText, size: size2, value: searchText }),
        /* @__PURE__ */ React117.createElement(SelectMenu, { options: innerOptions, "data-test": menuTestId })
      ))
    )
  );
};
var Select = forwardRef25(BaseSelect);

// src/components/Pagination/constants.ts
var PAGE_SIZE_OPTIONS = [
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 200, label: "200" }
];
var ELLIPSIS_MARKER = void 0;
var INITIAL_PAGE = 1;

// src/components/Pagination/pagesBuilder.ts
var buildPages = (totalPages, activePage, ellipsisMarker) => {
  if (totalPages <= 6) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (activePage <= 4) {
      return [1, 2, 3, 4, 5, ellipsisMarker, totalPages];
    } else if (activePage >= 5 && activePage <= totalPages - 4) {
      return [
        1,
        ellipsisMarker,
        activePage - 1,
        activePage,
        activePage + 1,
        ellipsisMarker,
        totalPages
      ];
    } else if (activePage >= totalPages - 3) {
      return [
        1,
        ellipsisMarker,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      ];
    } else {
      throw new Error("Unhandled pagination criteria");
    }
  }
};

// src/components/Pagination/Pagination.tsx
var Pagination = (_a) => {
  var _b = _a, {
    activePage: activePageProp,
    defaultActivePage = INITIAL_PAGE,
    onPageChange,
    recordsTotalCount,
    pageSizeOptions = PAGE_SIZE_OPTIONS,
    pageSize: pageSizeProp,
    defaultPageSize = pageSizeOptions[0].value,
    hidePageSizeOptions = false,
    onPageSizeChange
  } = _b, styleProps = __objRest(_b, [
    "activePage",
    "defaultActivePage",
    "onPageChange",
    "recordsTotalCount",
    "pageSizeOptions",
    "pageSize",
    "defaultPageSize",
    "hidePageSizeOptions",
    "onPageSizeChange"
  ]);
  const [pageSize = defaultPageSize, setPageSize] = useControllableState6({
    prop: pageSizeProp,
    defaultProp: defaultPageSize,
    onChange: onPageSizeChange
  });
  const [activePage = defaultActivePage, setActivePage] = useControllableState6({
    prop: activePageProp,
    defaultProp: defaultActivePage,
    onChange: onPageChange
  });
  const incrementPage = React118.useCallback(() => {
    setActivePage(activePage + 1);
  }, [setActivePage, activePage]);
  const decrementPage = React118.useCallback(() => {
    setActivePage(activePage - 1);
  }, [setActivePage, activePage]);
  const totalPages = Math.ceil(recordsTotalCount / pageSize);
  const pages = React118.useMemo(
    () => buildPages(totalPages, activePage, ELLIPSIS_MARKER),
    [activePage, totalPages]
  );
  return /* @__PURE__ */ React118.createElement(Spacer, __spreadValues({ space: "s", justifyContent: "flex-end", fluid: true }, styleProps), !hidePageSizeOptions ? /* @__PURE__ */ React118.createElement(
    Select,
    {
      options: pageSizeOptions,
      side: "bottom",
      align: "start",
      selectionMode: "single",
      selectedKeys: [pageSize],
      takeTriggerWidth: true,
      onSelectionChange: (selectedKeys) => setPageSize(selectedKeys[0]),
      size: "small"
    }
  ) : null, /* @__PURE__ */ React118.createElement(Spacer, { space: 1, justifyContent: "flex-end", fluid: true }, /* @__PURE__ */ React118.createElement(
    Button,
    {
      size: "small",
      onClick: decrementPage,
      disabled: activePage === 1,
      "data-test": "pagination-left",
      variant: "secondary",
      mode: "ghost"
    },
    /* @__PURE__ */ React118.createElement(ChevronLeftOutlined2, null)
  ), pages.map(
    (page, index) => page !== ELLIPSIS_MARKER ? /* @__PURE__ */ React118.createElement(
      Button,
      {
        size: "small",
        key: page,
        "data-test": `pagination-page-${page}`,
        variant: "secondary",
        mode: activePage === page ? "fill" : "outline",
        onClick: () => setActivePage(page)
      },
      page
    ) : /* @__PURE__ */ React118.createElement(
      Button,
      {
        key: `ellipsis${index}`,
        variant: "secondary",
        mode: "ghost",
        size: "small",
        readOnly: true,
        tabIndex: -1
      },
      "..."
    )
  ), /* @__PURE__ */ React118.createElement(
    Button,
    {
      onClick: incrementPage,
      disabled: activePage === totalPages,
      "data-test": "pagination-right",
      size: "small",
      variant: "secondary",
      mode: "ghost"
    },
    /* @__PURE__ */ React118.createElement(ChevronRightOutlined2, null)
  )));
};

// src/components/PasswordInput/PasswordInput.tsx
import React122, { forwardRef as forwardRef27, useState as useState18 } from "react";

// src/components/TextInput/TextInput.tsx
import React120, { forwardRef as forwardRef26 } from "react";
import { useComposedRefs as useComposedRefs5 } from "@aircall/hooks";

// src/components/TextField/TextField.tsx
import React119 from "react";
import { CloseOutlined as CloseOutlined3 } from "@aircall/icons";

// src/components/TextField/components/TextFieldPrefix.ts
import styled55 from "@xstyled/styled-components";
var TextFieldPrefix = styled55.span``;

// src/components/TextField/components/TextFieldRoot.ts
import styled57 from "@xstyled/styled-components";

// src/components/TextField/utils.ts
import { css as css23 } from "@xstyled/styled-components";
var makeTextField = () => css23`
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  font-family: inherit;
  appearance: none;
  box-sizing: border-box;
  transition: default;
  border: none;
  outline: none;
  border-radius: 0;
  padding: 0;
  margin: 0;
  background: 0 0;
  color: inherit;
  caret-color: ${getColor("text-base")};

  ::placeholder {
    color: ${getColor("text-placeholder")};
  }
`;
var makeTextFieldValidationStatus = ({
  validationStatus
}) => {
  if (validationStatus !== "error") {
    return;
  }
  return css23`
    border-color: ${getColor("graphic-interactive-critical")};

    input {
      caret-color: ${getColor("text-critical")};
    }

    :not(:has(:disabled)) {
      :hover {
        border-color: ${getColor("graphic-interactive-critical-hover")};
      }

      :focus-within,
      :focus {
        border-color: ${getColor("graphic-interactive-critical-active")};
      }
    }
  `;
};
var makeDefaultField = css23`
  ${makeTextField}
`;
var makeListVariantStyle = ({ variant: variant2 }) => variant2 === "list" && css23`
    border: none;
    border-radius: 0px;
    border-bottom: 1px solid ${getColor("graphic-interactive-default")};

    :not(:has(:disabled)) {
      :hover {
        border-bottom-color: ${getColor("graphic-interactive-default-hover")};
      }

      :focus-within,
      :focus {
        border-bottom-color: ${getColor("graphic-interactive-default-active")};
      }
    }
  `;

// src/components/TextField/components/TextFieldSuffix.ts
import styled56 from "@xstyled/styled-components";
var TextFieldSuffix = styled56.span`
  display: flex;
  align-items: center;
  gap: 1;
`;

// src/components/TextField/components/TextFieldRoot.ts
var TextFieldRoot = styled57(Box_default)`
  display: inline-flex;
  position: relative;
  width: 100%;
  min-width: 0;
  gap: 2;
  background-color: ${getColor("surface-default")};
  border: 1px solid ${getColor("graphic-interactive-default")};
  color: ${getColor("text-base")};
  border-radius: sm;

  input,
  textarea {
    ${({ theme }) => theme.typography.bodyRegularS};
  }

  ${makeListVariantStyle}

  :has(input) {
    padding-left: 4;
    padding-right: 4;
    align-items: center;
  }

  :has(${TextFieldSuffix}) {
    padding-right: 2;
  }

  :has(:disabled) {
    background-color: ${getColor("surface-disabled")};
    border-color: ${getColor("graphic-disabled")};
    color: ${getColor("text-disabled")};
  }

  :not(:has(:disabled)) {
    :hover {
      border-color: ${getColor("graphic-interactive-default-hover")};
    }

    :focus-within,
    :focus {
      border-color: ${getColor("graphic-interactive-default-active")};
    }
  }

  ${makeTextFieldValidationStatus}
`;

// src/components/TextField/TextField.tsx
function TextField(_a) {
  var _b = _a, {
    onClear,
    icon: Icon2,
    children,
    disabled,
    triggerFocus,
    variant: variant2,
    suffix
  } = _b, otherProps = __objRest(_b, [
    "onClear",
    "icon",
    "children",
    "disabled",
    "triggerFocus",
    "variant",
    "suffix"
  ]);
  const containerRef = React119.useRef(null);
  const iconColor = disabled ? "icon-disabled" : "icon-default";
  const hasClearButton = !!onClear;
  const hasSuffix = hasClearButton || !!suffix;
  const onInputClick = (e) => {
    var _a2;
    if ((_a2 = containerRef.current) == null ? void 0 : _a2.contains(e.target)) {
      triggerFocus == null ? void 0 : triggerFocus();
    }
  };
  const handleClear = (e) => {
    e.stopPropagation();
    onClear == null ? void 0 : onClear();
  };
  return /* @__PURE__ */ React119.createElement(TextFieldRoot, __spreadValues({ ref: containerRef, onClick: onInputClick, variant: variant2 }, otherProps), Icon2 && /* @__PURE__ */ React119.createElement(TextFieldPrefix, null, /* @__PURE__ */ React119.createElement(Icon2, { color: iconColor })), children, hasSuffix && /* @__PURE__ */ React119.createElement(TextFieldSuffix, null, suffix, hasClearButton && /* @__PURE__ */ React119.createElement(
    Button,
    {
      "data-test": "text-field-clear-button",
      type: "button",
      shape: "circle",
      mode: "ghost",
      size: "xSmall",
      onClick: handleClear,
      disabled
    },
    /* @__PURE__ */ React119.createElement(CloseOutlined3, { color: iconColor })
  )));
}
var TextField_default = TextField;

// src/components/TextField/hooks/useTextField/useTextField.ts
var useTextField = ({ validationStatus, id, size: size2 }) => {
  const { componentStatus, componentId, componentSize, error } = useForm({
    id,
    validationStatus,
    size: size2
  });
  return {
    componentSize,
    componentStatus,
    componentId,
    error
  };
};

// src/components/TextInput/components/StyledInput.ts
import styled58 from "@xstyled/styled-components";
var StyledInput = styled58.input`
  ${makeTextField}
`;

// src/components/TextInput/TextInput.tsx
var TextInput = forwardRef26((props, forwardedRef) => {
  const _a = props, {
    id,
    icon,
    size: size2,
    validationStatus,
    onClear,
    variant: variant2 = "input",
    type = "text",
    disabled,
    suffix,
    // this attribute is purely for storybook purposes
    "data-pseudo": dataPseudo
  } = _a, inputProps = __objRest(_a, [
    "id",
    "icon",
    "size",
    "validationStatus",
    "onClear",
    "variant",
    "type",
    "disabled",
    "suffix",
    "data-pseudo"
  ]);
  const innerRef = React120.useRef(null);
  const composedRef = useComposedRefs5(forwardedRef, innerRef);
  const { componentStatus, componentId, componentSize, error } = useTextField({
    id,
    validationStatus,
    icon,
    size: size2,
    onClear,
    disabled
  });
  return /* @__PURE__ */ React120.createElement(
    TextField_default,
    __spreadProps(__spreadValues({}, {
      icon,
      onClear,
      suffix,
      error,
      disabled,
      validationStatus: componentStatus,
      triggerFocus: () => {
        var _a2;
        return (_a2 = innerRef == null ? void 0 : innerRef.current) == null ? void 0 : _a2.focus();
      },
      variant: variant2,
      "data-pseudo": dataPseudo
    }), {
      h: TEXT_INPUT_SIZES[componentSize] || TEXT_INPUT_SIZES.regular
    }),
    /* @__PURE__ */ React120.createElement(
      StyledInput,
      __spreadValues({
        ref: composedRef,
        id: componentId,
        type,
        disabled
      }, inputProps)
    )
  );
});

// src/components/PasswordInput/components/PasswordIcon.tsx
import React121 from "react";
import { VisibleOffOutlined, VisibleOnOutlined } from "@aircall/icons";
function PasswordIcon(_a) {
  var _b = _a, { visible, onClick } = _b, props = __objRest(_b, ["visible", "onClick"]);
  const iconProps = { color: "icon-base" };
  return /* @__PURE__ */ React121.createElement(Button, __spreadProps(__spreadValues({}, props), { type: "button", shape: "circle", mode: "ghost", size: "xSmall", onClick }), visible ? /* @__PURE__ */ React121.createElement(VisibleOnOutlined, __spreadValues({}, iconProps)) : /* @__PURE__ */ React121.createElement(VisibleOffOutlined, __spreadValues({}, iconProps)));
}

// src/components/PasswordInput/PasswordInput.tsx
var PasswordInput = forwardRef27((props, ref) => {
  const {
    disabled,
    visibilityButtonAriaLabel,
    // this attribute is purely for storybook purposes
    "data-pseudo": dataPseudo
  } = props;
  const [typeState, setType] = useState18("password");
  function toggleType() {
    setType((t) => t === "password" ? "text" : "password");
  }
  const forcePasswordType = !!disabled;
  const type = forcePasswordType ? "password" : typeState;
  const visible = type === "text";
  return /* @__PURE__ */ React122.createElement(
    TextInput,
    __spreadProps(__spreadValues({
      ref
    }, props), {
      "data-pseudo": dataPseudo,
      type,
      disabled,
      suffix: /* @__PURE__ */ React122.createElement(
        PasswordIcon,
        {
          "aria-label": visibilityButtonAriaLabel,
          disabled,
          onClick: toggleType,
          visible,
          "data-test": "text-field-visibility-button"
        }
      )
    })
  );
});

// src/components/Radio/Radio.tsx
import React124, { forwardRef as forwardRef28 } from "react";

// src/components/Radio/components/RadioLabel.tsx
import { styled as styled59 } from "@xstyled/styled-components";
var RadioLabel = styled59(Typography_default).attrs({
  as: "span",
  "data-test": "radio-label"
})`
  grid-area: label;
  align-self: center;
  user-select: none;
`;
RadioLabel.displayName = "RadioLabel";

// src/components/Radio/components/StyledRadioContainer.tsx
import styled60, { css as css24 } from "@xstyled/styled-components";

// src/components/Radio/constants.ts
var RADIO_SIZES = {
  small: "16px",
  regular: "24px",
  large: "32px"
};
var RADIO_INDICATOR_SIZES = {
  small: "8px",
  regular: "12px",
  large: "16px"
};

// src/components/Radio/components/StyledRadioContainer.tsx
var makeRadioSize = ({ size: size2 }) => {
  const radioSize = RADIO_SIZES[size2];
  return css24`
    height: ${radioSize};
    width: ${radioSize};
  `;
};
var StyledRadioContainer = styled60.div`
  position: relative;
  display: block;
  box-sizing: border-box;
  border: 1.5px solid transparent;
  ${makeRadioSize}
  transition: border-color 300ms;
  flex-shrink: 0;
  user-select: none;
  border-radius: full;

  input {
    opacity: 0;
  }

  &&:has(input:focus-visible) {
    ${outlineStyles}
  }

  &&:has(input:focus:not(:focus-visible)) {
    outline-color: transparent;
  }
`;

// src/components/Radio/components/StyledRadioIndicator.tsx
import styled61, { css as css25 } from "@xstyled/styled-components";
var makeRadioIndicatorSize = ({ size: size2, checked }) => {
  if (!checked) {
    return null;
  }
  const indicatorSize = RADIO_INDICATOR_SIZES[size2];
  return css25`
    height: ${indicatorSize};
    width: ${indicatorSize};
  `;
};
var StyledRadioIndicator = styled61.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  &:after {
    display: block;
    content: '';
    border-radius: full;
    transform: scale(0);
    transition: background 300ms, transform 150ms;
    transform-origin: center;
    ${makeRadioIndicatorSize}
    ${({ checked }) => checked && "transform: scale(1);"}
  }
`;

// src/components/Radio/components/StyledRadioLayout.tsx
import styled63, { css as css26, getColor as getColor9 } from "@xstyled/styled-components";

// src/components/Radio/components/RadioDescription.tsx
import { styled as styled62 } from "@xstyled/styled-components";
var RadioDescription = styled62(Typography_default).attrs({
  as: "span",
  "data-test": "radio-description"
})`
  grid-area: description;
  margin-top: 2;

  user-select: none;
`;
RadioDescription.displayName = "RadioDescription";

// src/components/Radio/components/StyledRadioLayout.tsx
var makeRadioTypography = ({
  size: size2,
  disabled,
  theme
}) => {
  return css26`
    ${RadioLabel} {
      ${size2 === "small" ? theme.typography.bodyRegularS : theme.typography.bodyRegularM};
      color: ${getColor9(disabled ? "text-disabled" : "text-base")};
    }

    ${RadioDescription} {
      ${theme.typography.supportingRegularS};
      color: ${getColor9(disabled ? "text-disabled" : "text-secondary")};
    }
  `;
};
var makeRadioColor = ({
  checked,
  disabled,
  readOnly,
  error
}) => {
  if (disabled) {
    return css26`
      ${StyledRadioContainer} {
        background-color: ${getColor9("surface-disabled")};
        border-color: ${getColor9("graphic-disabled")};
      }

      ${StyledRadioIndicator}::after {
        background-color: ${getColor9("surface-interactive-disabled")};
      }
    `;
  }
  if (error) {
    return css26`
      ${StyledRadioContainer} {
        border-color: ${getColor9("graphic-interactive-critical")};
      }

      ${StyledRadioIndicator}::after {
        background-color: ${getColor9("surface-interactive-critical")};
      }

      ${!readOnly && css26`
        &:hover {
          ${StyledRadioContainer} {
            border-color: ${getColor9("graphic-interactive-critical-hover")};
            background-color: ${getColor9("surface-interactive-critical-ghost-hover")};
          }

          ${StyledRadioIndicator}::after {
            background-color: ${getColor9("surface-interactive-critical-hover")};
          }
        }

        &:active {
          ${StyledRadioContainer} {
            border-color: ${getColor9("graphic-interactive-critical-active")};
          }

          ${StyledRadioIndicator}::after {
            background-color: ${getColor9("surface-interactive-critical-active")};
          }
        }
      `}
    `;
  }
  if (checked) {
    return css26`
      ${StyledRadioContainer} {
        border-color: ${getColor9("graphic-interactive-primary")};
      }

      ${StyledRadioIndicator}::after {
        background-color: ${getColor9("graphic-interactive-primary")};
      }

      ${!readOnly && css26`
        &:hover {
          ${StyledRadioContainer} {
            border-color: ${getColor9("graphic-interactive-primary-hover")};
          }

          ${StyledRadioIndicator}::after {
            background-color: ${getColor9("graphic-interactive-primary-hover")};
          }
        }

        &:active {
          ${StyledRadioContainer} {
            border-color: ${getColor9("graphic-interactive-primary-active")};
          }

          ${StyledRadioIndicator}:after {
            background-color: ${getColor9("graphic-interactive-primary-active")};
          }
        }
      `}
    `;
  }
  return css26`
    ${StyledRadioContainer} {
      background-color: ${getColor9("graphic-interactive-primary-ghost")};
      border-color: ${getColor9("graphic-interactive-default")};
    }

    ${!readOnly && css26`
      &:hover {
        ${StyledRadioContainer} {
          background-color: ${getColor9("graphic-interactive-primary-ghost-hover")};
          border-color: ${getColor9("graphic-interactive-default-hover")};
        }
      }

      &:active {
        ${StyledRadioContainer} {
          background-color: ${getColor9("graphic-interactive-primary-ghost-active")};
          border-color: ${getColor9("graphic-interactive-default-active")};
        }
      }
    `}
  `;
};
var StyledRadioLayout = styled63(Grid)`
  display: inline-grid;
  grid-template-areas:
    'icon label'
    '. description';
  grid-template-rows: 1fr auto;
  justify-content: flex-start;
  align-items: center;
  :not(:has(> *:only-child)) {
    ${({ size: size2 }) => css26`
      column-gap: ${size2 === "small" ? 2 : 4};
    `}
  }

  &,
  input {
    cursor: ${({ disabled, readOnly }) => disabled || readOnly ? void 0 : "pointer"};
  }

  ${makeRadioTypography}
  ${makeRadioColor}
`;

// src/components/Radio/hooks/useRadio.ts
import { useCallback as useCallback22 } from "react";
import { useControllableState as useControllableState7, useId } from "@aircall/hooks";

// src/components/Radio/contexts/RadioGroupContext.ts
import React123 from "react";
var RadioGroupContext = React123.createContext(null);
var useRadioGroupContext = () => React123.useContext(RadioGroupContext);

// src/components/Radio/hooks/useRadio.ts
function useRadio(props = {}) {
  var _a, _b, _c;
  const {
    defaultChecked = false,
    checked: checkedProp,
    disabled: disabledProp,
    readOnly: readOnlyProp,
    size: sizeProps,
    validationStatus,
    onChange: onChangeProp,
    name,
    value,
    id: idProp
  } = props;
  const radioGroupProps = useRadioGroupContext();
  const uuid = `radio-${useId()}`;
  const { componentId, componentSize, error } = useForm({
    validationStatus,
    size: sizeProps,
    id: uuid
  });
  const id = idProp != null ? idProp : componentId;
  const [checked = defaultChecked, setChecked] = useControllableState7({
    prop: (checkedProp != null ? checkedProp : radioGroupProps) ? (radioGroupProps == null ? void 0 : radioGroupProps.checkedValue) === value : void 0,
    defaultProp: defaultChecked
  });
  const size2 = (_a = sizeProps != null ? sizeProps : radioGroupProps == null ? void 0 : radioGroupProps.size) != null ? _a : componentSize;
  const readOnly = (_b = readOnlyProp != null ? readOnlyProp : radioGroupProps == null ? void 0 : radioGroupProps.readOnly) != null ? _b : false;
  const disabled = (_c = disabledProp != null ? disabledProp : radioGroupProps == null ? void 0 : radioGroupProps.disabled) != null ? _c : false;
  const invalid = !!error;
  const onChange = composeEventHandlers(onChangeProp, radioGroupProps == null ? void 0 : radioGroupProps.onChange);
  const handleChange = useCallback22(
    (event) => {
      if (readOnly || disabled) {
        event.preventDefault();
        return;
      }
      setChecked(event.target.checked);
      onChange == null ? void 0 : onChange(event);
    },
    [disabled, readOnly, onChange, setChecked]
  );
  const getInputProps = useCallback22(
    () => ({
      value,
      id,
      name,
      checked,
      disabled,
      onChange: handleChange,
      "aria-checked": checked,
      "aria-disabled": disabled,
      "aria-hidden": true
    }),
    [checked, disabled, value, id, name, handleChange]
  );
  const getLayoutProps = useCallback22(
    () => ({
      id,
      size: size2,
      invalid,
      disabled,
      readOnly,
      checked
    }),
    [id, checked, disabled, invalid, readOnly, size2]
  );
  return {
    name,
    getLayoutProps,
    getInputProps
  };
}

// src/components/Radio/Radio.tsx
var Radio = forwardRef28(
  (_a, ref) => {
    var _b = _a, { children, "data-test": dataTest } = _b, useRadioProps = __objRest(_b, ["children", "data-test"]);
    const { getLayoutProps, getInputProps } = useRadio(useRadioProps);
    const { id, disabled, size: size2, checked, invalid, readOnly } = getLayoutProps();
    const childNode = typeof children === "string" ? /* @__PURE__ */ React124.createElement(RadioLabel, null, children) : children;
    return /* @__PURE__ */ React124.createElement(
      StyledRadioLayout,
      __spreadValues({
        as: "label",
        htmlFor: id,
        error: invalid,
        "data-test": dataTest
      }, { checked, size: size2, disabled, readOnly }),
      /* @__PURE__ */ React124.createElement(StyledRadioContainer, __spreadValues({}, { size: size2 }), /* @__PURE__ */ React124.createElement("input", __spreadValues({ ref, "data-test": "radio", type: "radio" }, getInputProps())), /* @__PURE__ */ React124.createElement(StyledRadioIndicator, __spreadValues({}, { size: size2, checked }))),
      childNode
    );
  }
);
Radio.displayName = "Radio";

// src/components/Radio/RadioGroup.tsx
import React125, { forwardRef as forwardRef29, useCallback as useCallback23 } from "react";
import { useControllableState as useControllableState8 } from "@aircall/hooks";
var RadioGroup = forwardRef29(
  (_a, ref) => {
    var _b = _a, {
      children,
      defaultValue,
      value: checkedProp,
      readOnly,
      disabled,
      validationStatus,
      onChange,
      size: size2,
      space: space6 = "l"
    } = _b, spacerProps = __objRest(_b, [
      "children",
      "defaultValue",
      "value",
      "readOnly",
      "disabled",
      "validationStatus",
      "onChange",
      "size",
      "space"
    ]);
    const formContext = useFormContext();
    const formItemContext = useFormItemContext();
    const [checked = defaultValue, setChecked] = useControllableState8({
      prop: checkedProp,
      defaultProp: defaultValue,
      onChange
    });
    const radioSize = size2 || (formContext == null ? void 0 : formContext.size) || "regular";
    const inputStatus = validationStatus || (formItemContext == null ? void 0 : formItemContext.validationStatus);
    const handleOnChange = useCallback23(
      (event) => {
        setChecked(event.target.value);
      },
      [setChecked]
    );
    return /* @__PURE__ */ React125.createElement(
      RadioGroupContext.Provider,
      {
        value: {
          checkedValue: checked,
          onChange: handleOnChange,
          size: radioSize,
          readOnly,
          disabled,
          validationStatus: inputStatus
        }
      },
      /* @__PURE__ */ React125.createElement(Spacer, __spreadValues({ ref, space: space6, "data-test": "radio-group" }, spacerProps), children)
    );
  }
);
RadioGroup.displayName = "RadioGroup";

// src/components/SegmentedControl/hooks/useSegmentedControlSelection.ts
import { useCallback as useCallback24, useMemo as useMemo10 } from "react";
import { useControllableState as useControllableState9 } from "@aircall/hooks";
function useSegmentedControlSelection(selectionMode, controlledSelectedOptions, onSelectionChange, defaultSelectedOptions) {
  const [selectedOptions = [], setSelectedOptions] = useControllableState9({
    prop: controlledSelectedOptions,
    defaultProp: defaultSelectedOptions,
    onChange: onSelectionChange
  });
  const selectedOptionsSet = useMemo10(() => {
    return new Set(selectedOptions);
  }, [selectedOptions]);
  const isOptionSelected = useCallback24(
    (value) => selectedOptionsSet.has(value),
    [selectedOptionsSet]
  );
  const onChangeOptionHandler = useCallback24(
    (value) => {
      if (selectionMode === "single") {
        if (isOptionSelected(value)) {
          return;
        }
        const nextSelectedKeys2 = [value];
        setSelectedOptions(nextSelectedKeys2);
        return;
      }
      if (isOptionSelected(value)) {
        const nextSelectedKeys2 = selectedOptions.filter((option) => option !== value);
        setSelectedOptions(nextSelectedKeys2);
        return;
      }
      const nextSelectedKeys = [...selectedOptions, value];
      setSelectedOptions(nextSelectedKeys);
    },
    [isOptionSelected, selectedOptions, selectionMode, setSelectedOptions]
  );
  const useHandleOptionsReturn = useMemo10(
    () => ({
      isOptionSelected,
      onChangeOptionHandler
    }),
    [isOptionSelected, onChangeOptionHandler]
  );
  return useHandleOptionsReturn;
}

// src/components/SegmentedControl/SegmentedControl.tsx
import React129, { Children as Children3, useEffect as useEffect22, useRef as useRef13, useState as useState19 } from "react";

// src/components/SegmentedControl/components/SelectedOptionBackground.tsx
import React128 from "react";

// src/components/SegmentedControl/contexts/SegmentedControlContext.ts
import * as React126 from "react";
var SegmentedControlContext = React126.createContext(
  null
);
var useSegmentedControl = () => {
  const context = React126.useContext(SegmentedControlContext);
  if (!context) {
    throw new Error("useSegmentedControl must be used within a SegmentedControlProvider");
  }
  return context;
};

// src/components/SegmentedControl/contexts/SegmentedControlProvider.tsx
import * as React127 from "react";
var SegmentedControlProvider = ({
  variant: variant2,
  selectionMode,
  selectedOptions,
  onSelectionChange,
  fluid,
  defaultSelectedOptions,
  size: size2,
  children
}) => {
  const { onChangeOptionHandler, isOptionSelected } = useSegmentedControlSelection(
    selectionMode,
    selectedOptions,
    onSelectionChange,
    defaultSelectedOptions
  );
  const value = React127.useMemo(
    () => ({
      variant: variant2,
      selectionMode,
      onSelectOption: onChangeOptionHandler,
      isOptionSelected,
      fluid: Boolean(fluid),
      size: size2
    }),
    [variant2, selectionMode, onChangeOptionHandler, isOptionSelected, fluid, size2]
  );
  return /* @__PURE__ */ React127.createElement(SegmentedControlContext.Provider, { value }, children);
};

// src/components/SegmentedControl/components/SelectedOptionBackground.styled.ts
import { css as css28, getColor as getColor11, styled as styled65 } from "@xstyled/styled-components";

// src/components/SegmentedControl/components/SegmentedControlOption.styled.ts
import { css as css27, getColor as getColor10, getSpace as getSpace4, styled as styled64 } from "@xstyled/styled-components";
function getButtonVariant({ variant: variant2 }) {
  if (variant2 === "primary") {
    return css27`
      background-color: ${getColor10("surface-interactive-primary-ghost")};

      &:hover {
        background-color: ${getColor10("surface-interactive-primary-ghost-hover")};
      }

      &:active {
        background-color: ${getColor10("surface-interactive-primary-ghost-active")};
      }

      &:focus:not(:active):not(:hover),
      &:focus-visible:not(:active):not(:hover) {
        background-color: ${getColor10("surface-interactive-primary-ghost")};
      }

      &[aria-pressed='true'] {
        color: ${getColor10("text-contrast-light")};
        background-color: ${getColor10("surface-interactive-primary")};

        svg {
          color: ${getColor10("icon-contrast-light")};
        }

        &:hover:not(:focus) {
          background-color: ${getColor10("surface-interactive-primary-hover")};
        }

        &:active {
          background-color: ${getColor10("surface-interactive-primary-active")};
        }

        &:focus:not(:active):not(:hover),
        &:focus-visible:not(:active):not(:hover) {
          background-color: ${getColor10("surface-interactive-primary")};
        }
      }
    `;
  }
  return css27`
    background-color: ${getColor10("surface-interactive-secondary-ghost")};

    &:hover {
      background-color: ${getColor10("surface-interactive-secondary-ghost-hover")};
    }

    &:active {
      background-color: ${getColor10("surface-interactive-secondary-ghost-active")};
    }

    &:focus:not(:active):not(:hover),
    &:focus-visible:not(:active):not(:hover) {
      background-color: ${getColor10("surface-interactive-secondary-ghost")};
    }

    &[aria-pressed='true'] {
      color: ${getColor10("text-contrast-light")};
      background-color: ${getColor10("surface-interactive-secondary")};

      svg {
        color: ${getColor10("icon-contrast-light")};
      }

      &:hover:not(:focus) {
        background-color: ${getColor10("surface-interactive-secondary-hover")};
      }

      &:active {
        background-color: ${getColor10("surface-interactive-secondary-active")};
      }

      &:focus:not(:active):not(:hover),
      &:focus-visible:not(:active):not(:hover) {
        background-color: ${getColor10("surface-interactive-secondary")};
      }
    }
  `;
}
function getButtonBackground({ selectionMode }) {
  if (selectionMode === "single") {
    return css27`
      transition: color 300ms ease;

      svg {
        transition: color 300ms ease;
      }

      &[aria-pressed='true'] {
        background-color: transparent;

        &:hover,
        &:active,
        &&:focus {
          background-color: transparent;
        }
      }
    `;
  }
}
var BUTTON_MIN_BLOCK_SIZE = {
  small: "24px",
  regular: "32px",
  large: "40px"
};
var SegmentedControlOptionButton = styled64.button`
  cursor: pointer;
  min-block-size: ${({ size: size2 }) => BUTTON_MIN_BLOCK_SIZE[size2]};
  color: ${getColor10("text-base")};
  outline-offset: ${getSpace4("xxxs")};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${getSpace4("xxxs")};
  border-radius: ${getRadii("full")};
  flex: 1;
  inline-size: ${({ fluid }) => fluid ? "100%" : "auto"};
  position: relative;

  transition: background-color 300ms ease, color 300ms ease;

  svg {
    color: ${getColor10("icon-default")};
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
    background-color: ${getColor10("surface-interactive-primary-ghost")};
    color: ${getColor10("text-disabled")};

    svg {
      color: ${getColor10("icon-disabled")};
    }

    &[aria-pressed='true'] {
      background-color: ${getColor10("surface-interactive-disabled")};
    }
  }

  /**
   * Need to go last to override any other styles
   */
  ${getButtonVariant}
  ${getButtonBackground}

  @media (prefers-reduced-motion) {
    transition: none;
  }
`;

// src/components/SegmentedControl/components/SelectedOptionBackground.styled.ts
function getBackgroundVariant({ variant: variant2 }) {
  if (variant2 === "primary") {
    return css28`
      background-color: ${getColor11("surface-interactive-primary")};
    `;
  }
  return css28`
    background-color: ${getColor11("surface-interactive-secondary")};
  `;
}
var Background = styled65(Box_default)`
  inset-block-start: 50%;
  inset-inline-start: ${({ offsetLeft }) => offsetLeft}px;
  block-size: 100%;
  block-size: ${({ offsetHeight }) => offsetHeight}px;
  inline-size: ${({ offsetWidth }) => offsetWidth}px;
  transform: translateY(-50%);
  transition-property: inset-inline-start, inline-size;
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  border-radius: ${getRadii("full")};
  ${getBackgroundVariant};

  &:has(~ ${SegmentedControlOptionButton}:disabled) {
    background-color: transparent;
  }

  @media (prefers-reduced-motion) {
    transition: none;
  }
`;

// src/components/SegmentedControl/components/SelectedOptionBackground.tsx
function SelectedOptionBackground({
  offsetLeft,
  offsetWidth,
  offsetHeight
}) {
  const { selectionMode, variant: variant2 } = useSegmentedControl();
  if (selectionMode === "multiple" || !offsetLeft || !offsetWidth || !offsetHeight) {
    return null;
  }
  return /* @__PURE__ */ React128.createElement(
    Background,
    {
      "data-test": "selected-option-background",
      variant: variant2,
      position: "absolute",
      offsetLeft,
      offsetWidth,
      offsetHeight
    }
  );
}

// src/components/SegmentedControl/SegmentedControl.styled.ts
import { styled as styled66 } from "@xstyled/styled-components";
var Options = styled66(Flex_default)`
  white-space: nowrap;
`;

// src/components/SegmentedControl/SegmentedControl.tsx
function SegmentedControl({
  ariaLabel,
  selectionMode = "single",
  selectedOptions,
  defaultSelectedOptions,
  variant: variant2 = "primary",
  size: size2 = "regular",
  onSelectionChange,
  fluid = false,
  ariaLabelledby,
  children
}) {
  const optionRefs = useRef13([]);
  const [optionOffsetWidth, setOptionOffsetWidth] = useState19();
  const [optionOffsetLeft, setOptionOffsetLeft] = useState19();
  const [optionOffsetHeight, setOptionOffsetHeight] = useState19();
  useEffect22(() => {
    function updateSelectedItemOffset() {
      const selectedItem = optionRefs.current.find(
        (item) => (item == null ? void 0 : item.getAttribute("aria-pressed")) === "true"
      );
      if (selectedItem) {
        setOptionOffsetLeft(selectedItem.offsetLeft - 0.5);
        setOptionOffsetWidth(selectedItem.offsetWidth);
        setOptionOffsetHeight(selectedItem.offsetHeight);
      }
    }
    updateSelectedItemOffset();
    window.addEventListener("resize", updateSelectedItemOffset);
    return () => window.removeEventListener("resize", updateSelectedItemOffset);
  }, [selectedOptions]);
  return /* @__PURE__ */ React129.createElement(
    SegmentedControlProvider,
    {
      selectionMode,
      variant: variant2,
      selectedOptions,
      onSelectionChange,
      defaultSelectedOptions,
      fluid,
      size: size2
    },
    /* @__PURE__ */ React129.createElement(
      Options,
      {
        "aria-labelledby": ariaLabelledby,
        "aria-label": ariaLabel,
        role: "group",
        "aria-live": "polite",
        p: "xxxs",
        border: "1px solid",
        backgroundColor: "surface-default",
        borderColor: "graphic-default",
        borderRadius: "full",
        gap: "xxxs",
        w: fluid ? "100%" : "auto",
        position: "relative"
      },
      /* @__PURE__ */ React129.createElement(
        SelectedOptionBackground,
        {
          offsetWidth: optionOffsetWidth,
          offsetLeft: optionOffsetLeft,
          offsetHeight: optionOffsetHeight
        }
      ),
      Children3.map(children, (child, index) => {
        return React129.cloneElement(child, {
          ref: (node) => {
            if (node) {
              optionRefs.current[index] = node;
            }
            return node;
          }
        });
      })
    )
  );
}

// src/components/SegmentedControl/components/SegmentedControlOption.tsx
import React131, { forwardRef as forwardRef30, useImperativeHandle, useRef as useRef14 } from "react";

// src/components/SegmentedControl/components/SegmentedControlOptionLabel.tsx
import React130 from "react";
function SegmentedControlOptionLabel({ children }) {
  return /* @__PURE__ */ React130.createElement(Typography_default, { variant: "bodyMediumS", pl: "xxxs", pr: "xxs", as: "span", margin: "0" }, children);
}

// src/components/SegmentedControl/components/SegmentedControlOption.tsx
var SegmentedControlOption = forwardRef30(function SegmentedControlOptionBase({
  value,
  disabled,
  children,
  onClick,
  onMouseEnter,
  onMouseLeave
}, ref) {
  const localRef = useRef14(null);
  useImperativeHandle(ref, () => localRef.current, []);
  const { variant: variant2, isOptionSelected, fluid, onSelectOption, selectionMode, size: size2 } = useSegmentedControl();
  const onSelectOptionHandler = React131.useCallback(() => {
    onSelectOption(value);
  }, [value, onSelectOption]);
  return /* @__PURE__ */ React131.createElement(
    SegmentedControlOptionButton,
    {
      ref: localRef,
      selectionMode,
      type: "button",
      variant: variant2,
      fluid,
      disabled,
      "aria-pressed": isOptionSelected(value),
      size: size2,
      onClick: composeEventHandlers(onClick, onSelectOptionHandler),
      onMouseEnter,
      onMouseLeave
    },
    typeof children === "string" ? /* @__PURE__ */ React131.createElement(SegmentedControlOptionLabel, null, children) : children
  );
});
SegmentedControlOption.displayName = "SegmentedControlOption";

// src/components/SegmentedControl/components/SegmentedControlSeparator.tsx
import React132, { forwardRef as forwardRef31 } from "react";
var SegmentedControlSeparator = forwardRef31(
  function SegmentedControlSeparatorBase(_, ref) {
    return /* @__PURE__ */ React132.createElement(Box_default, { ref, display: "contents" }, /* @__PURE__ */ React132.createElement(Divider, { backgroundColor: "graphic-default", size: "xSmall", flexShrink: 0 }));
  }
);

// src/components/SegmentedControl/components/SegmentedControlOptionPrefix.tsx
import React133 from "react";
import styled67 from "@xstyled/styled-components";
import { getSpace as getSpace5 } from "@xstyled/system";
var Container3 = styled67(Box_default)`
  padding-inline: ${getSpace5(0.5)};
  flex-shrink: 0;
  max-block-size: 32px;

  svg {
    inline-size: 20px;
    block-size: 20px;
  }
`;
function SegmentedControlOptionPrefix({ children }) {
  return /* @__PURE__ */ React133.createElement(Container3, null, children);
}

// src/components/SegmentedControl/components/SegmentedControlOptionSuffix.tsx
import React134 from "react";
import styled68 from "@xstyled/styled-components";
import { getSpace as getSpace6 } from "@xstyled/system";
var Container4 = styled68(Box_default)`
  padding-inline: ${getSpace6(0.5)};
  flex-shrink: 0;
  max-block-size: 32px;

  svg {
    inline-size: 20px;
    block-size: 20px;
  }
`;
function SegmentedControlOptionSuffix({ children }) {
  return /* @__PURE__ */ React134.createElement(Container4, null, children);
}

// src/components/SegmentedControl/components/SegmentedControlOptionTag.tsx
import React138 from "react";
import styled71 from "@xstyled/styled-components";

// src/components/Tag/Tag.tsx
import React136, { forwardRef as forwardRef32 } from "react";
import styled69 from "@xstyled/styled-components";

// src/components/Tag/components/TagLabel.tsx
import React135 from "react";

// src/components/Tag/context/TagContext.ts
import { createContext as createContext16, useContext as useContext20 } from "react";
var TagContext = createContext16(null);
var useTagContext = () => {
  return useContext20(TagContext);
};

// src/components/Tag/components/TagLabel.tsx
var TagLabel = (_a) => {
  var _b = _a, { children, color: color4 } = _b, typographyProps = __objRest(_b, ["children", "color"]);
  const { size: size2 } = useTagContext();
  return /* @__PURE__ */ React135.createElement(
    Typography_default,
    __spreadProps(__spreadValues({
      as: "span",
      ellipsis: true,
      color: color4
    }, typographyProps), {
      variant: size2 === "xSmall" || size2 === "small" ? "supportingMediumS" : "bodyMediumS"
    }),
    children
  );
};

// src/components/Tag/utils.ts
import { css as css29, getColor as getColor12 } from "@xstyled/styled-components";

// src/components/Tag/constants.ts
var TAG_SIZES_MAP2 = {
  xSmall: "16px",
  small: "24px",
  regular: "26px",
  large: "34px"
};
var TAG_ICON_SIZES_MAP2 = {
  xSmall: "12px",
  small: "12px",
  regular: "16px",
  large: "16px"
};
var TAG_VARIANT_COLORS_MAP = {
  blue: {
    color: "informative-700",
    backgroundColor: "informative-100"
  },
  darkBlue: {
    color: "text-contrast-light",
    backgroundColor: "informative-700"
  },
  red: {
    color: "critical-700",
    backgroundColor: "critical-100"
  },
  darkRed: {
    color: "text-contrast-light",
    backgroundColor: "critical-700"
  },
  yellow: {
    color: "warning-800",
    backgroundColor: "warning-100"
  },
  darkYellow: {
    color: "text-contrast-light",
    backgroundColor: "warning-700"
  },
  grey: {
    color: "neutral-400",
    backgroundColor: "neutral-200"
  },
  darkGrey: {
    color: "text-contrast-light",
    backgroundColor: "neutral-500"
  },
  white: {
    color: "neutral-400",
    backgroundColor: "neutral-0"
  },
  secondary: {
    color: "text-contrast-light",
    backgroundColor: "secondary-500"
  },
  darkSecondary: {
    color: "text-contrast-light",
    backgroundColor: "secondary-700"
  },
  lightSecondary: {
    color: "secondary-700",
    backgroundColor: "secondary-100"
  },
  primary: {
    color: "text-contrast-light",
    backgroundColor: "primary-500"
  },
  darkPrimary: {
    color: "text-contrast-light",
    backgroundColor: "primary-700"
  },
  lightPrimary: {
    color: "primary-700",
    backgroundColor: "primary-100"
  },
  purple: {
    color: "decorative1-700",
    backgroundColor: "decorative1-100"
  },
  darkPurple: {
    color: "text-contrast-light",
    backgroundColor: "decorative1-700"
  },
  green: {
    color: "success-500",
    backgroundColor: "success-100"
  },
  darkGreen: {
    color: "text-contrast-light",
    backgroundColor: "success-700"
  },
  pink: {
    color: "decorative2-800",
    backgroundColor: "decorative2-300"
  }
};

// src/components/Tag/utils.ts
var makeTagVariant = ({
  theme,
  tagBg,
  tagColor,
  tagVariant
}) => {
  if (tagBg) {
    const bgColor = getColor12(tagBg)({ theme });
    return css29({
      backgroundColor: tagBg,
      color: tagColor || textColor(bgColor, "text-contrast-light", "text-contrast-dark")
    });
  }
  return css29(tagVariant && TAG_VARIANT_COLORS_MAP[tagVariant] || TAG_VARIANT_COLORS_MAP.white);
};
var makeTagMode = ({ tagVariant, tagMode }) => {
  if (tagMode === "outline")
    return css29`
      border: 1px solid ${getColor12(TAG_VARIANT_COLORS_MAP[tagVariant].color)};
      background: transparent;
    `;
  return css29``;
};
var makeTagSize = ({ tagSize }) => {
  const height = TAG_SIZES_MAP2[tagSize] || TAG_SIZES_MAP2.regular;
  return css29({
    height
  });
};
var shouldForwardProp6 = (prop) => !["tagSize", "tagBg", "tagColor", "tagVariant"].includes(prop);

// src/components/Tag/Tag.tsx
var Container5 = styled69(Flex_default).withConfig({ shouldForwardProp: shouldForwardProp6 })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2;
  border-radius: full;
  padding-left: 2;
  padding-right: 2;
  ${makeTagVariant}
  ${makeTagSize}
  ${makeTagMode}
`;
var Tag = forwardRef32(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      onClick,
      variant: variant2,
      color: color4,
      bg,
      minWidth,
      maxW,
      maxWidth,
      mode = "fill"
    } = _b, remainingStyleProps = __objRest(_b, [
      "children",
      "size",
      "onClick",
      "variant",
      "color",
      "bg",
      "minWidth",
      "maxW",
      "maxWidth",
      "mode"
    ]);
    const sizes2 = { maxWidth: maxWidth || maxW || "100%", minWidth: minWidth || 32 };
    const childNode = typeof children === "string" ? /* @__PURE__ */ React136.createElement(TagLabel, __spreadValues({}, sizes2), children.trim()) : children;
    return /* @__PURE__ */ React136.createElement(TagContext.Provider, { value: { size: size2 } }, /* @__PURE__ */ React136.createElement(
      Container5,
      __spreadValues(__spreadValues({
        "data-test": "tag",
        ref,
        onClick,
        cursor: onClick ? "pointer" : "default",
        tagSize: size2,
        tagVariant: variant2,
        tagColor: color4,
        tagBg: bg,
        tagMode: mode
      }, remainingStyleProps), sizes2),
      childNode
    ));
  }
);
Tag.displayName = "Tag";

// src/components/Tag/components/TagDeleteIcon.tsx
import React137, { useCallback as useCallback25 } from "react";
import styled70 from "@xstyled/styled-components";
import { CloseOutlined as CloseOutlined4 } from "@aircall/icons";
var StyledIconButton = styled70(IconButton_default)`
  color: inherit;
`;
var TagDeleteIcon = ({
  icon = CloseOutlined4,
  onClick,
  color: color4,
  "data-test": dataTest,
  "aria-label": ariaLabel,
  discColor = "graphic-interactive-default-hover"
}) => {
  const { size: size2 } = useTagContext();
  const height = TAG_ICON_SIZES_MAP2[size2] || TAG_ICON_SIZES_MAP2.regular;
  const IconComponent2 = useCallback25(
    () => /* @__PURE__ */ React137.createElement(Icon_default, { component: icon, size: height, color: color4, "aria-hidden": "true" }),
    [icon, height, color4]
  );
  if (onClick) {
    return /* @__PURE__ */ React137.createElement(
      StyledIconButton,
      {
        component: IconComponent2,
        type: "button",
        "data-test": dataTest,
        "aria-label": ariaLabel,
        onClick,
        size: height,
        discColor
      }
    );
  }
  return /* @__PURE__ */ React137.createElement(Box_default, { "data-test": dataTest, "aria-label": ariaLabel }, /* @__PURE__ */ React137.createElement(IconComponent2, null));
};

// src/components/SegmentedControl/components/SegmentedControlOptionTag.tsx
var Container6 = styled71(Tag)`
  pointer-events: none;
  block-size: 24px;
`;
function SegmentedControlOptionTag(_a) {
  var _b = _a, {
    children
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React138.createElement(Container6, __spreadProps(__spreadValues({}, props), { size: "small", forwardedAs: "span" }), children);
}

// src/components/SidenavDropdown/SidenavDropdown.tsx
import React148, { useId as useId2 } from "react";
import { ChevronRightOutlined as ChevronRightOutlined3 } from "@aircall/icons";

// src/components/SidenavItem/SidenavItem.tsx
import React145 from "react";
import { LockedFilled } from "@aircall/icons";

// src/components/Tooltip/Tooltip.tsx
import React144, { cloneElement as cloneElement2, forwardRef as forwardRef33, useRef as useRef15 } from "react";
import { useComposedRefs as useComposedRefs6 } from "@aircall/hooks";

// src/components/Tooltip/components/TooltipContent.tsx
import * as React141 from "react";

// src/components/Tooltip/contexts/TooltipContext.ts
import * as React139 from "react";
var TooltipContext = React139.createContext(null);
var useTooltip = () => React139.useContext(TooltipContext);

// src/components/Tooltip/components/TooltipArrow.tsx
import * as React140 from "react";
import styled72 from "@xstyled/styled-components";
var StyledArrow = styled72(Box_default)`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid ${({ color: color4 }) => getColor(color4)};
`;
var TooltipArrow = ({ color: color4 }) => {
  return /* @__PURE__ */ React140.createElement(Popover.Arrow, { offset: 12 }, /* @__PURE__ */ React140.createElement(StyledArrow, { color: color4 }));
};

// src/components/Tooltip/components/TooltipContent.tsx
var TooltipContent = (_a) => {
  var _b = _a, { children, mode } = _b, popoverContent = __objRest(_b, ["children", "mode"]);
  const { cancelClose, close } = useTooltip();
  const tooltipColor = mode === "auto" ? "surface-inverted" : "surface-contrast-secondary";
  return /* @__PURE__ */ React141.createElement(
    Popover.Content,
    __spreadValues({
      "data-test": "tooltip-content",
      backgroundColor: tooltipColor,
      color: "text-inverted",
      borderRadius: "sm",
      p: 2,
      boxShadow: 1,
      sideOffset: 8,
      onMouseEnter: cancelClose,
      onMouseLeave: close
    }, popoverContent),
    children,
    /* @__PURE__ */ React141.createElement(TooltipArrow, { color: tooltipColor })
  );
};

// src/components/Tooltip/components/TooltipRoot.tsx
import * as React142 from "react";
import debounce from "lodash.debounce";
import { useControllableState as useControllableState10 } from "@aircall/hooks";
var TooltipRoot = (_a) => {
  var _b = _a, {
    children,
    mouseEnterDelay,
    mouseLeaveDelay,
    open: openProp,
    onVisibilityChange
  } = _b, popoverProps = __objRest(_b, [
    "children",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "open",
    "onVisibilityChange"
  ]);
  const [open, setIsOpen] = useControllableState10({
    prop: openProp,
    defaultProp: false,
    onChange: onVisibilityChange
  });
  const closeHandler = React142.useMemo(
    () => debounce(() => {
      setIsOpen(false);
    }, mouseLeaveDelay),
    [setIsOpen, mouseLeaveDelay]
  );
  const openHandler = React142.useMemo(
    () => debounce(() => {
      setIsOpen(true);
    }, mouseEnterDelay),
    [mouseEnterDelay, setIsOpen]
  );
  const handleOpen = React142.useCallback(() => {
    closeHandler.cancel();
    openHandler();
  }, [openHandler, closeHandler]);
  const handleClose = React142.useCallback(() => {
    openHandler.cancel();
    closeHandler();
  }, [openHandler, closeHandler]);
  return /* @__PURE__ */ React142.createElement(
    TooltipContext.Provider,
    {
      value: {
        open: handleOpen,
        close: handleClose,
        cancelClose: closeHandler.cancel
      }
    },
    /* @__PURE__ */ React142.createElement(Popover.Root, __spreadProps(__spreadValues({}, popoverProps), { open, "data-test": "tooltip" }), children)
  );
};

// src/components/Tooltip/components/TooltipTrigger.tsx
import * as React143 from "react";
var TooltipTrigger = (_a) => {
  var _b = _a, {
    onMouseEnter,
    onMouseLeave
  } = _b, triggerProps = __objRest(_b, [
    "onMouseEnter",
    "onMouseLeave"
  ]);
  const { open, close } = useTooltip();
  return /* @__PURE__ */ React143.createElement(
    Popover.Trigger,
    __spreadProps(__spreadValues({}, triggerProps), {
      onMouseEnter: composeEventHandlers(onMouseEnter, open),
      onMouseLeave: composeEventHandlers(onMouseLeave, close)
    })
  );
};

// src/components/Tooltip/Tooltip.tsx
var Tooltip = forwardRef33(
  (_a, ref) => {
    var _b = _a, {
      title,
      content,
      side = "top",
      align = "center",
      mouseEnterDelay = 0,
      mouseLeaveDelay = 100,
      maxW = "250px",
      visible,
      children,
      onVisibilityChange,
      arrowPointsAtCenter = false,
      onClick,
      disabled,
      mode = "auto"
    } = _b, popoverContent = __objRest(_b, [
      "title",
      "content",
      "side",
      "align",
      "mouseEnterDelay",
      "mouseLeaveDelay",
      "maxW",
      "visible",
      "children",
      "onVisibilityChange",
      "arrowPointsAtCenter",
      "onClick",
      "disabled",
      "mode"
    ]);
    var _a2;
    const child = React144.Children.only(children);
    const localTriggerRef = useRef15();
    const composedRefs = useComposedRefs6(child.ref, ref, localTriggerRef);
    if (disabled)
      return React144.cloneElement(child, { ref: composedRefs });
    let portalContainerRef = void 0;
    const triggerOwnerWindow = (localTriggerRef == null ? void 0 : localTriggerRef.current) ? (localTriggerRef == null ? void 0 : localTriggerRef.current).ownerDocument.defaultView : null;
    if (triggerOwnerWindow && triggerOwnerWindow !== window) {
      portalContainerRef = { current: triggerOwnerWindow.document.body };
    }
    const textColor2 = mode === "auto" ? "text-inverted" : "text-contrast-dark";
    return /* @__PURE__ */ React144.createElement(TooltipRoot, __spreadValues({}, { open: visible, mouseEnterDelay, mouseLeaveDelay, onVisibilityChange }), /* @__PURE__ */ React144.createElement(TooltipTrigger, null, cloneElement2(child, {
      ref: composedRefs,
      onClick: composeEventHandlers((_a2 = child.props) == null ? void 0 : _a2.onClick, onClick)
    })), title || content ? /* @__PURE__ */ React144.createElement(
      TooltipContent,
      __spreadValues({}, __spreadValues({
        side,
        align,
        maxW,
        arrowPointsAtCenter,
        portalContainerRef,
        mode
      }, popoverContent)),
      title ? /* @__PURE__ */ React144.createElement(Typography_default, { color: textColor2, "data-test": "tooltip-title" }, title) : content
    ) : null);
  }
);

// src/components/SidenavItem/SidenavItem.styled.ts
import { css as css30, styled as styled73 } from "@xstyled/styled-components";
var Badge2 = styled73(Box_default)`
  position: absolute;
  inset-block-start: -4px;
  inset-inline-end: -4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var ExpandedContent = styled73(Flex_default)`
  position: absolute;
  pointer-events: none;
  opacity: 0;
  padding-inline-end: 8px;
  text-align: left;

  ${({ expanded }) => expanded && css30`
      position: relative;
      opacity: 1;
      transition: opacity 0.4s 0.3s ease;
    `}
`;
var commonHoverActiveStyles = css30`
  &:hover {
    background-color: ${getColor("surface-interactive-secondary-ghost-hover")};
    text-decoration: none;
    color: ${getColor("text-interactive-secondary")};

    ${ExpandedContent} {
      color: ${getColor("text-interactive-secondary")};
    }
  }

  &:active,
  &[aria-expanded='true'] {
    background-color: ${getColor("surface-interactive-secondary-ghost-active")};

    ${ExpandedContent} {
      color: ${getColor("text-interactive-secondary")};
    }
  }
`;
var activeStyles = css30`
  &,
  &[aria-expanded='true'] {
    background-color: ${getColor("surface-interactive-secondary")};

    ${ExpandedContent} {
      color: ${getColor("text-contrast-light")};
    }
  }
`;
var containerStatusStyles = ({
  active,
  disabled
}) => {
  if (disabled) {
    return css30`
      background-color: transparent;
      color: ${getColor("text-disabled")};

      ${ExpandedContent} {
        color: ${getColor("text-disabled")};
      }

      pointer-events: none;

      ${active === true && css30`
        background-color: ${getColor("surface-interactive-disabled")};
      `}

      ${active === "current-page" && css30`
        &[aria-current='page'] {
          background-color: ${getColor("surface-interactive-disabled")};
        }
      `}
    `;
  }
  return css30`
    ${active === true && css30`
      ${activeStyles}
    `}

    ${active === "current-page" && css30`
      &[aria-current='page'] {
        ${activeStyles}
      }
    `}

    ${commonHoverActiveStyles}
  `;
};
var Container7 = styled73(Flex_default).withConfig({
  shouldForwardProp: (prop, defaultValidationFn) => defaultValidationFn(prop)
})`
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s ease, width 0.3s ease;
  height: 48px;
  width: 48px;
  padding-inline: 8px;
  padding-block: 8px;
  border: none;

  ${ExpandedContent} {
    color: ${getColor("text-interactive-secondary")};
  }

  ${outlineFocusVisible}

  ${containerStatusStyles}

  ${({ expanded }) => expanded && css30`
      width: 224px;
    `}

  ${({ restricted }) => restricted && css30`
      ${Badge2} {
        border-radius: ${getRadii("full")};
        background-color: ${getColor("text-disabled")};
        padding: 2px;
      }
    `}

  @media (prefers-reduced-motion) {
    transition: none;

    ${ExpandedContent} {
      transition: none;
    }
  }
`;

// src/components/SidenavItem/SidenavItem.tsx
var SidenavItem = forwardRef6(
  (_a, ref) => {
    var _b = _a, {
      indicator,
      title,
      tooltip,
      disabledTooltip = false,
      badge,
      active,
      expanded,
      disabled,
      restricted,
      onClick,
      "data-test": dataTest,
      component = "button",
      to,
      suffix,
      className
    } = _b, rest = __objRest(_b, [
      "indicator",
      "title",
      "tooltip",
      "disabledTooltip",
      "badge",
      "active",
      "expanded",
      "disabled",
      "restricted",
      "onClick",
      "data-test",
      "component",
      "to",
      "suffix",
      "className"
    ]);
    const badgeContainer = restricted || badge ? /* @__PURE__ */ React145.createElement(Badge2, null, restricted ? /* @__PURE__ */ React145.createElement(LockedFilled, { "aria-hidden": "true", size: 12, color: "icon-inverted" }) : badge) : null;
    const content = /* @__PURE__ */ React145.createElement(
      Flex_default,
      {
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
        minWidth: "32px",
        minHeight: "32px",
        position: "relative"
      },
      indicator,
      badgeContainer
    );
    return /* @__PURE__ */ React145.createElement(
      Container7,
      __spreadValues({
        ref,
        as: component,
        href: component === "a" && to ? to : void 0,
        to: component !== "a" ? to : void 0,
        type: component === "button" ? "button" : void 0,
        "data-test": dataTest,
        onClick: !disabled ? onClick : void 0,
        gap: "xxs",
        borderRadius: "full",
        alignItems: "center",
        active,
        expanded,
        disabled,
        restricted,
        className
      }, rest),
      !expanded && !disabledTooltip ? /* @__PURE__ */ React145.createElement(Tooltip, { title: tooltip, mouseEnterDelay: 500, mouseLeaveDelay: 0, side: "right" }, content) : content,
      /* @__PURE__ */ React145.createElement(ExpandedContent, { minWidth: "0", gap: "xxxs", alignItems: "center", flex: "1", expanded }, title, suffix)
    );
  }
);

// src/components/SidenavItem/components/SidenavItemIndicator.tsx
import React146 from "react";
function SidenavItemIndicator(_a) {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ React146.createElement(
    Flex_default,
    __spreadValues({
      h: "32px",
      w: "32px",
      borderRadius: "full",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "surface-contrast-secondary",
      className
    }, props),
    children
  );
}

// src/components/SidenavItem/components/SidenavItemTitle.tsx
import React147 from "react";
import styled74 from "@xstyled/styled-components";
var Container8 = styled74(Typography_default)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
`;
function SidenavItemTitle(_a) {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ React147.createElement(Container8, __spreadProps(__spreadValues({ className }, props), { variant: "bodySemiboldS" }), children);
}

// src/components/SidenavDropdown/SidenavDropdown.tsx
var SidenavItemTrigger = forwardRef6(
  (props, ref) => {
    const { open } = useDropdownContext();
    return /* @__PURE__ */ React148.createElement(
      SidenavItem,
      __spreadProps(__spreadValues({
        ref
      }, props), {
        disabledTooltip: open,
        "aria-expanded": open ? "true" : "false"
      })
    );
  }
);
function SidenavDropdown(_a) {
  var _b = _a, {
    children,
    title,
    className
  } = _b, rest = __objRest(_b, [
    "children",
    "title",
    "className"
  ]);
  const containerId = useId2();
  const triggerSuffix = /* @__PURE__ */ React148.createElement(Flex_default, { ml: "auto", alignItems: "center", justifyContent: "center", h: "24px", w: "24px", flexShrink: 0 }, /* @__PURE__ */ React148.createElement(ChevronRightOutlined3, { size: 16, "aria-hidden": "true" }));
  return /* @__PURE__ */ React148.createElement(
    Dropdown,
    {
      trigger: /* @__PURE__ */ React148.createElement(
        SidenavItemTrigger,
        __spreadProps(__spreadValues({}, rest), {
          suffix: triggerSuffix,
          title,
          "aria-controls": containerId
        })
      ),
      side: "right",
      align: "start",
      minWidth: "192px",
      takeViewportHeight: true
    },
    /* @__PURE__ */ React148.createElement(Flex_default, { flexDirection: "column", w: "100%", id: containerId, className }, children)
  );
}

// src/components/SidenavDropdown/components/SidenavDropdownItem.tsx
import React149 from "react";

// src/components/SidenavDropdown/components/SidenavDropdownItem.styled.ts
import styled75, { css as css31, getColor as getColor13, getSpace as getSpace7 } from "@xstyled/styled-components";
var Container9 = styled75.button`
  ${outlineFocusVisible}
  background-color: transparent;
  border: none;
  transition: background-color 300ms ease;
  display: flex;
  align-items: center;
  height: 42px;
  flex-shrink: 0;
  padding: 0;
  padding-inline: ${getSpace7("s")};
  padding-block: ${getSpace7("xs")};
  gap: ${getSpace7("xxs")};
  cursor: pointer;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 14px;
    width: 2px;
    background-color: transparent;
    transition: background-color 300ms ease;
    border-start-end-radius: 2px;
    border-end-end-radius: 2px;
  }

  :hover,
  :active,
  :focus {
    text-decoration: none;
  }

  :hover {
    background-color: #eff4f6;

    &::before {
      background-color: ${getColor13("surface-interactive-secondary-hover")};
    }
  }

  :active {
    background-color: #e2e7ea;

    &::before {
      background-color: ${getColor13("graphic-interactive-secondary-active")};
    }
  }

  :disabled {
    pointer-events: none;
  }

  :disabled,
  :disabled * {
    color: ${getColor13("text-disabled")};

    &::before {
      background-color: transparent;
    }
  }

  ${({ active }) => active === true && css31`
      &&,
      && * {
        color: ${getColor13("text-interactive-primary")};
      }

      pointer-events: none;

      &&::before {
        background-color: ${getColor13("graphic-interactive-primary")};
      }
    `}

  ${({ active }) => active === "current-page" && css31`
      &&[aria-current='page'] {
        &&,
        && * {
          color: ${getColor13("text-interactive-primary")};
        }

        pointer-events: none;

        &&::before {
          background-color: ${getColor13("graphic-interactive-primary")};
        }
      }
    `}

  @media (prefers-reduced-motion) {
    transition: none;

    &::before {
      transition: none;
    }
  }
`;

// src/components/SidenavDropdown/components/SidenavDropdownItem.tsx
function SidenavDropdownItem(_a) {
  var _b = _a, {
    active,
    children,
    onClick,
    component = "button",
    to,
    className,
    disabled
  } = _b, rest = __objRest(_b, [
    "active",
    "children",
    "onClick",
    "component",
    "to",
    "className",
    "disabled"
  ]);
  const { toggleOpen } = useDropdownContext();
  return /* @__PURE__ */ React149.createElement(
    Container9,
    __spreadValues({
      as: component,
      href: component === "a" && to ? to : void 0,
      to: component !== "a" ? to : void 0,
      type: component === "button" ? "button" : void 0,
      onClick: (event) => {
        onClick == null ? void 0 : onClick(event);
        toggleOpen();
      },
      className,
      active,
      disabled: disabled || active
    }, rest),
    children
  );
}

// src/components/SidenavDropdown/components/SidenavDropdownItemLabel.tsx
import React150 from "react";
function SidenavDropdownItemLabel({ children, className }) {
  return /* @__PURE__ */ React150.createElement(Typography_default, { variant: "bodySemiboldS", color: "text-base", as: "span", className }, children);
}

// src/components/SidenavDropdown/components/SidenavDropdownSeparator.tsx
import React151 from "react";
function SidenavDropdownSeparator() {
  return /* @__PURE__ */ React151.createElement(
    Divider,
    {
      orientation: "horizontal",
      backgroundColor: "graphic-default",
      size: "xSmall",
      flexShrink: 0
    }
  );
}

// src/components/Slider/Slider.tsx
import React152, { forwardRef as forwardRef34 } from "react";
import styled76, { th as th4 } from "@xstyled/styled-components";
var SliderRange = styled76.input`
  appearance: none;
  width: 100%;
  height: 4px;
  background-color: graphic-default;
  border-radius: 16px;
  outline: none;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 24px;
    height: 24px;
    background-color: graphic-primary;
    border: 4px solid ${th4.color("neutral-0")};
    box-shadow: ${th4.shadow(1)};
    border-radius: 50%;
    cursor: pointer;
  }
`;
var Slider = forwardRef34(
  ({ id, min, max, value, onChange, defaultValue }, ref) => /* @__PURE__ */ React152.createElement(
    SliderRange,
    {
      ref,
      type: "range",
      min,
      max,
      value,
      defaultValue,
      id,
      onChange: (e) => onChange(e.target.value, e)
    }
  )
);

// src/components/Squircle/Squircle.tsx
import React153, { forwardRef as forwardRef35 } from "react";
var Squircle = forwardRef35((_props, ref) => {
  return /* @__PURE__ */ React153.createElement(
    "svg",
    {
      ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      style: {
        display: "block",
        width: 0,
        height: 0
      }
    },
    /* @__PURE__ */ React153.createElement("defs", null, /* @__PURE__ */ React153.createElement("clipPath", { id: "svgPath", clipPathUnits: "objectBoundingBox", transform: "scale(0.01, 0.01)" }, /* @__PURE__ */ React153.createElement(
      "path",
      {
        id: "squircle",
        d: "m 78.831044,5.798472 c 4.81983,1.8730797 8.656314,5.078731 11.616304,9.229462 1.710259,2.39826 3.022328,4.962988 3.989926,7.528069 0.339092,0.898925 0.611267,1.734992 0.822933,2.487591 0.128659,0.457463 0.209358,0.789755 0.242215,0.948817 1.810168,7.521542 2.575736,15.656565 2.465189,24.043417 0.107264,8.054549 -0.721352,16.32087 -2.557537,24.040925 -0.039,0.186495 -0.11966,0.518794 -0.248267,0.976263 -0.211578,0.752606 -0.483665,1.588682 -0.822671,2.487615 -0.967354,2.565102 -2.279258,5.129853 -3.989474,7.528133 -2.960102,4.151029 -6.797177,7.356843 -11.611444,9.227224 -5.827534,2.31576 -16.436446,3.571875 -28.746653,3.681886 C 38.042142,97.870939 27.196322,96.56006 21.26748,94.298621 16.446841,92.425597 12.609904,89.219788 9.6497582,85.06877 7.9395212,82.6705 6.6275352,80.10576 5.6600587,77.540668 5.3210099,76.64174 5.0488795,75.805669 4.8372576,75.053066 4.7086242,74.595599 4.6279453,74.263304 4.5970194,74.112077 2.7055611,66.536823 1.9207205,58.433075 2.0323569,49.963193 1.9250644,41.906233 2.753082,33.640869 4.5889314,25.922209 4.6279451,25.735717 4.7086242,25.403422 4.8372576,24.945956 5.0488795,24.193353 5.3210099,23.357282 5.6600587,22.458355 6.6275352,19.893262 7.9395212,17.328522 9.6497582,14.930252 12.609904,10.779233 16.446841,7.5734249 21.27292,5.6983053 27.196903,3.4387398 38.043912,2.1279881 50.008319,2.0221243 62.048719,2.1288092 72.841786,3.4563161 78.831044,5.798472 Z"
      }
    )))
  );
});
var Squircle_default = Squircle;

// src/components/Tab/components/TabContainer.tsx
import React154, { forwardRef as forwardRef36, memo, useCallback as useCallback27, useState as useState20 } from "react";

// src/utils/invariant.ts
var IS_PROD_ENV = false;
var invariant = function(condition, errMsg) {
  if (!IS_PROD_ENV && errMsg === void 0) {
    throw new Error("Invariant requires an error message argument.");
  }
  if (!condition) {
    const finalErrorMessage = IS_PROD_ENV || errMsg === void 0 ? "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings." : `Invariant Violation: ${errMsg}`;
    throw new Error(finalErrorMessage);
  }
};

// src/components/Tab/context.ts
import { createContext as createContext18 } from "react";
var TabContext = createContext18({
  activeTabId: void 0,
  onTabClick: noop
});

// src/components/Tab/components/TabContainer.tsx
var TabContainer = memo(
  forwardRef36(
    (_a, ref) => {
      var _b = _a, { defaultActiveTabId, activeTabId, onChange, children } = _b, styleProps = __objRest(_b, ["defaultActiveTabId", "activeTabId", "onChange", "children"]);
      const controlled = typeof activeTabId !== "undefined";
      const uncontrolled = typeof defaultActiveTabId !== "undefined";
      invariant(
        !(controlled && uncontrolled),
        "Tab component can be either controlled or uncontrolled at a time: use either 'defaultActiveTabId' or 'activeTabId'."
      );
      const [internalActiveTabId, setInternalActiveTabId] = useState20(defaultActiveTabId);
      const handleTabClick = useCallback27(
        (clickedTab) => {
          setInternalActiveTabId(clickedTab);
          onChange == null ? void 0 : onChange(clickedTab);
        },
        [setInternalActiveTabId, onChange]
      );
      return /* @__PURE__ */ React154.createElement(
        TabContext.Provider,
        {
          value: { activeTabId: activeTabId != null ? activeTabId : internalActiveTabId, onTabClick: handleTabClick }
        },
        /* @__PURE__ */ React154.createElement(
          Flex_default,
          __spreadValues({
            ref,
            h: "100%",
            alignItems: "stretch",
            flexDirection: "column",
            "data-test": "tab-container"
          }, styleProps),
          children
        )
      );
    }
  )
);
TabContainer.displayName = "Tab.Container";

// src/components/Tab/components/TabContent.tsx
import React156, { forwardRef as forwardRef38, memo as memo3 } from "react";
import styled77 from "@xstyled/styled-components";
import { useChildrenValidation as useChildrenValidation3 } from "@aircall/hooks";

// src/components/Tab/components/TabItem.tsx
import React155, { forwardRef as forwardRef37, memo as memo2, useContext as useContext22 } from "react";
import { AnimatePresence as AnimatePresence4 } from "framer-motion";

// src/components/Tab/components/constants.ts
var TAB_ITEM_IS_FOCUSABLE = void 0;
var TAB_ITEM_IS_NOT_FOCUSABLE = -1;
var TAB_MENU_ITEM_ID = (id) => `tab-menu-item-${id}`;
var TAB_ITEM_ID = (id) => `tab-item-${id}`;

// src/components/Tab/components/TabItem.tsx
var animationVariants2 = {
  entry: {
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.25
    }
  }
};
var TabItem = memo2(
  forwardRef37((_a, ref) => {
    var _b = _a, { id, children } = _b, styleProps = __objRest(_b, ["id", "children"]);
    const { activeTabId } = useContext22(TabContext);
    const isActive = activeTabId === id;
    return /* @__PURE__ */ React155.createElement(AnimatePresence4, null, isActive && /* @__PURE__ */ React155.createElement(
      MotionBox,
      __spreadProps(__spreadValues({
        position: "absolute",
        "z-index": 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        overflow: "auto",
        padding: "l",
        bg: "neutral-100",
        ref,
        variants: animationVariants2,
        initial: "exit",
        animate: "entry",
        exit: "exit",
        "data-test": TAB_ITEM_ID(id)
      }, styleProps), {
        role: "tabpanel",
        id: TAB_ITEM_ID(id),
        "aria-labelledby": TAB_MENU_ITEM_ID(id)
      }),
      children
    ));
  })
);
TabItem.displayName = "Tab.Item";

// src/components/Tab/components/TabContent.tsx
var TabContentWrapper = styled77.div`
  position: relative;
  width: 100%;
  height: 100%;
  flex-shrink: 1;
`;
var TabContent = memo3(
  forwardRef38((_a, ref) => {
    var _b = _a, { children } = _b, styleProps = __objRest(_b, ["children"]);
    useChildrenValidation3(children, "TabContent", TabItem);
    return /* @__PURE__ */ React156.createElement(TabContentWrapper, __spreadProps(__spreadValues({}, styleProps), { "data-test": "tab-content", ref }), children);
  })
);
TabContent.displayName = "TabContent";

// src/components/Tab/components/TabMenu.tsx
import React158, { Children as Children4, forwardRef as forwardRef40, memo as memo5, useRef as useRef16 } from "react";
import { useChildrenValidation as useChildrenValidation4 } from "@aircall/hooks";

// src/components/Tab/components/TabMenuItem.tsx
import React157, { forwardRef as forwardRef39, memo as memo4, useCallback as useCallback28, useContext as useContext23 } from "react";
import styled78, { css as css32, getColor as getColor14, th as th5 } from "@xstyled/styled-components";
var TabMenuItemWrapper = styled78(Flex_default).attrs({
  py: "s"
})`
  position: relative;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${() => css32`
      ${th5("typography.bodyMediumM")}
    `};
  transition: font-weight 0.25s ease;
  color: text-base;
  background-color: transparent;
  border: none;
  z-index: 0;

  ${outlineFocusVisible};

  /*
   * Makes it possible to show the outline on top of the content
   */
  &&:focus-visible {
    z-index: 1;
  }

  /*
   * Reverts z-index back to 0 when the element is focused
   * but the outline is not supposed to be shown
   */
  &&:focus:not(:focus-visible) {
    z-index: 0;
  }

  ${({ isActive }) => !isActive && css32`
      &:hover {
        &::after {
          opacity: 1;
          background-color: ${getColor14("graphic-interactive-default-hover")};
        }
      }
    `}

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    opacity: ${({ isActive }) => isActive ? 1 : 0};
    transition: opacity 0.25s ease;
    border-radius: 2px;
    z-index: -1;
    ${({ activeTabColor }) => activeTabColor && css32`
        background-color: ${activeTabColor};
      `};
  }
`;
var TabMenuItem = memo4(
  forwardRef39(
    (_a, ref) => {
      var _b = _a, { children, activeTabColor = "graphic-interactive-default-active", id } = _b, styleProps = __objRest(_b, ["children", "activeTabColor", "id"]);
      const { activeTabId, onTabClick } = useContext23(TabContext);
      const isActive = activeTabId === id;
      const handleClick = useCallback28(() => {
        onTabClick(id);
      }, [onTabClick, id]);
      return /* @__PURE__ */ React157.createElement(
        TabMenuItemWrapper,
        __spreadProps(__spreadValues({
          ref,
          isActive,
          onClick: handleClick,
          activeTabColor: isActive ? activeTabColor : void 0,
          "data-test": TAB_MENU_ITEM_ID(id)
        }, styleProps), {
          id: TAB_MENU_ITEM_ID(id),
          as: "button",
          type: "button",
          role: "tab",
          "aria-controls": TAB_ITEM_ID(id),
          tabIndex: isActive ? TAB_ITEM_IS_FOCUSABLE : TAB_ITEM_IS_NOT_FOCUSABLE,
          "aria-selected": isActive ? "true" : "false"
        }),
        children
      );
    }
  )
);
TabMenuItem.displayName = "TabMenuItem";

// src/components/Tab/components/utils.ts
var handleTabMenuItemFocus = (event, itemsRef) => {
  var _a, _b;
  const focusedItemIndex = itemsRef.current.findIndex((item) => {
    return item === document.activeElement;
  });
  const lastItemIndex = itemsRef.current.length - 1;
  if (event.key === "ArrowRight" || event.key === "ArrowDown") {
    preventDefaultEvent();
    if (focusedItemIndex < 0) {
      return;
    }
    const nextItem = (_a = itemsRef.current) == null ? void 0 : _a[calculateNextFocusedItemIndex()];
    if (nextItem) {
      nextItem.focus();
    }
  } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
    preventDefaultEvent();
    const previousItem = (_b = itemsRef.current) == null ? void 0 : _b[calculatePreviousFocusedItemIndex()];
    if (previousItem) {
      previousItem.focus();
    }
  }
  function preventDefaultEvent() {
    event.stopPropagation();
    event.preventDefault();
  }
  function calculateNextFocusedItemIndex() {
    const newIndex = focusedItemIndex + 1;
    return newIndex > lastItemIndex ? 0 : newIndex;
  }
  function calculatePreviousFocusedItemIndex() {
    const newIndex = focusedItemIndex - 1;
    return newIndex < 0 ? lastItemIndex : newIndex;
  }
};

// src/components/Tab/components/TabMenu.tsx
var TabMenu = memo5(
  forwardRef40(
    (_a, ref) => {
      var _b = _a, { children, variant: variant2 = "auto", space: space6 = "s" } = _b, styleProps = __objRest(_b, ["children", "variant", "space"]);
      useChildrenValidation4(children, "TabMenu", TabMenuItem);
      const itemsRef = useRef16([]);
      return /* @__PURE__ */ React158.createElement(
        Box_default,
        __spreadProps(__spreadValues({
          ref
        }, styleProps), {
          role: "tablist",
          onKeyDown: (event) => handleTabMenuItemFocus(event, itemsRef)
        }),
        /* @__PURE__ */ React158.createElement(Spacer, { space: space6, fluid: true, itemsSized: variant2, "data-test": "tab-menu" }, Children4.map(children, (child, index) => {
          return child && React158.cloneElement(child, {
            ref: (node) => {
              itemsRef.current[index] = node;
              return node;
            }
          });
        }))
      );
    }
  )
);
TabMenu.displayName = "TabMenu";

// src/components/Table/components/ActionBar/ActionBar.tsx
import React159, { useCallback as useCallback31, useEffect as useEffect24 } from "react";

// src/components/Table/components/ActionBar/hooks/useElementEdgeInView.ts
import { useCallback as useCallback29, useLayoutEffect as useLayoutEffect2, useState as useState21 } from "react";
var useElementEdgeInView = (elementEdge, element, scrollableContainer) => {
  const isElementInView = useCallback29(() => {
    const containerPosition = element == null ? void 0 : element.getBoundingClientRect();
    const scrollableContainerPosition = scrollableContainer == null ? void 0 : scrollableContainer.getBoundingClientRect();
    if (!containerPosition) {
      return false;
    }
    switch (elementEdge) {
      case "bottom" /* Bottom */:
        return containerPosition.bottom >= 0 && containerPosition.bottom <= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.bottom) || window.innerHeight || document.documentElement.clientHeight) && containerPosition.bottom >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.top) || 0);
      case "top" /* Top */:
        return containerPosition.top >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.top) || 0);
      case "left" /* Left */:
        return containerPosition.left >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.left) || 0);
      case "right" /* Right */:
        return containerPosition.right >= 0 && containerPosition.right <= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.width) || window.innerWidth || document.documentElement.clientWidth) && containerPosition.right >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.right) || 0);
      default:
        return true;
    }
  }, [element, elementEdge, scrollableContainer]);
  const [elementInView, setElementInView] = useState21();
  useLayoutEffect2(() => {
    setElementInView(isElementInView());
    const handleScrollPositionChange = () => {
      setElementInView(isElementInView());
    };
    window.addEventListener("resize", handleScrollPositionChange);
    scrollableContainer == null ? void 0 : scrollableContainer.addEventListener("scroll", handleScrollPositionChange);
    return () => {
      window.removeEventListener("resize", handleScrollPositionChange);
      scrollableContainer == null ? void 0 : scrollableContainer.removeEventListener("scroll", handleScrollPositionChange);
    };
  }, [element, scrollableContainer, isElementInView]);
  return elementInView;
};

// src/components/Table/components/ActionBar/hooks/useElementPosition.ts
import { useCallback as useCallback30, useEffect as useEffect23, useState as useState22 } from "react";
var useElementPosition = (element) => {
  const getElementPosition = useCallback30(() => {
    const pos = (element == null ? void 0 : element.getBoundingClientRect()) || { width: 0, left: 0 };
    return {
      width: pos.width,
      left: pos.left
    };
  }, [element]);
  const [position, setPosition] = useState22(getElementPosition());
  const handleWindowResize = useCallback30(() => {
    setPosition(getElementPosition());
  }, [setPosition, getElementPosition]);
  useEffect23(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);
  useEffect23(() => {
    setPosition(getElementPosition());
  }, [element, setPosition, getElementPosition]);
  return position;
};

// src/components/Table/components/ActionBar/styled.ts
import styled79, { css as css33 } from "@xstyled/styled-components";
var StyledActionBarContainer = styled79(Flex_default).withConfig({
  shouldForwardProp: (prop, defaultShouldForwardProp) => defaultShouldForwardProp(prop)
})`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: background-02;
  z-index: 2;
  position: sticky;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 3 4;
  box-sizing: border-box;

  ${({ elementBottomEdgeInView, left, width }) => !elementBottomEdgeInView && css33`
      position: fixed;
      border-right: 1px solid;
      border-right-color: border-base;
      border-left: 1px solid;
      border-left-color: border-base;
      bottom: 0;
      left: ${left}px;
      width: ${width}px;
      box-shadow: 3;
    `}
`;

// src/components/Table/components/ActionBar/ActionBar.tsx
var ActionBar = ({
  nonVerticallyScrollingParent,
  actions,
  selectedRows,
  verticalScrollingParent,
  cancelBtnText = "Cancel",
  selectedItemsText = "selected items",
  onCancel,
  onStickyChange
}) => {
  const elementBottomEdgeInView = useElementEdgeInView(
    "bottom" /* Bottom */,
    nonVerticallyScrollingParent.current,
    verticalScrollingParent.current
  );
  const { left, width } = useElementPosition(nonVerticallyScrollingParent.current);
  const styleProps = __spreadValues({}, elementBottomEdgeInView === false ? {
    left,
    width
  } : {});
  const renderSecondActionIfNeeded = useCallback31(() => {
    if (actions && Array.isArray(actions) && actions.length === 2) {
      const secondAction = actions[1];
      const ActionRenderer = secondAction.renderer;
      return ActionRenderer ? /* @__PURE__ */ React159.createElement(ActionRenderer, { rowsData: selectedRows }) : /* @__PURE__ */ React159.createElement(
        Button,
        {
          size: "small",
          mode: "outline",
          onClick: (event) => secondAction.onExecute(selectedRows, event)
        },
        secondAction.label
      );
    }
    return null;
  }, [actions, selectedRows]);
  const renderFirstActionIfNeeded = useCallback31(() => {
    if (actions && Array.isArray(actions) && actions.length <= 2) {
      const firstAction = actions[0];
      const ActionRenderer = firstAction.renderer;
      return ActionRenderer ? /* @__PURE__ */ React159.createElement(ActionRenderer, { rowsData: selectedRows }) : /* @__PURE__ */ React159.createElement(
        Button,
        {
          mode: "fill",
          size: "small",
          onClick: (event) => firstAction.onExecute(selectedRows, event)
        },
        firstAction.label
      );
    }
    return null;
  }, [actions, selectedRows]);
  const renderMultipleActionsIfNeeded = useCallback31(
    () => actions && (Array.isArray(actions) && actions.length > 2 || typeof actions === "function") && /* @__PURE__ */ React159.createElement(Box_default, { marginLeft: "s" }, typeof actions === "function" ? actions(selectedRows) : /* @__PURE__ */ React159.createElement(Dropdown, { trigger: /* @__PURE__ */ React159.createElement(DropdownButton, null, "Actions"), align: "end" }, /* @__PURE__ */ React159.createElement(Menu, { selectionMode: "none" }, actions.map((action) => {
      const ActionRenderer = action.renderer;
      return ActionRenderer ? /* @__PURE__ */ React159.createElement(ActionRenderer, { key: action.label, rowsData: selectedRows }) : /* @__PURE__ */ React159.createElement(
        MenuItem,
        {
          key: action.label,
          onClick: (event) => action.onExecute(selectedRows, event)
        },
        action.label
      );
    })))),
    [actions, selectedRows]
  );
  useEffect24(() => {
    onStickyChange == null ? void 0 : onStickyChange(!!elementBottomEdgeInView);
  }, [elementBottomEdgeInView, onStickyChange]);
  return /* @__PURE__ */ React159.createElement(StyledActionBarContainer, __spreadValues({ elementBottomEdgeInView: !!elementBottomEdgeInView }, styleProps), /* @__PURE__ */ React159.createElement(Flex_default, { alignItems: "center" }, /* @__PURE__ */ React159.createElement(CounterBadge, { count: Object.keys(selectedRows).length, size: "large", bg: "primary-500" }), /* @__PURE__ */ React159.createElement(Typography_default, { ml: 2, color: "black" }, selectedItemsText)), /* @__PURE__ */ React159.createElement(Spacer, { space: "s", alignItems: "center" }, /* @__PURE__ */ React159.createElement(Button, { size: "small", variant: "secondary", mode: "link", onClick: onCancel }, cancelBtnText), /* @__PURE__ */ React159.createElement(Spacer, { space: "s", alignItems: "center" }, renderSecondActionIfNeeded(), renderFirstActionIfNeeded(), renderMultipleActionsIfNeeded())));
};

// src/components/Table/components/Table/Table.tsx
import React172 from "react";

// src/components/Table/Table.decl.ts
var StickTo = /* @__PURE__ */ ((StickTo2) => {
  StickTo2["Left"] = "left";
  StickTo2["Right"] = "right";
  return StickTo2;
})(StickTo || {});
var RowActionType = /* @__PURE__ */ ((RowActionType2) => {
  RowActionType2["Inline"] = "Inline";
  RowActionType2["Dropdown"] = "Dropdown";
  return RowActionType2;
})(RowActionType || {});
var ColumnTextAlign = /* @__PURE__ */ ((ColumnTextAlign2) => {
  ColumnTextAlign2["Left"] = "left";
  ColumnTextAlign2["Center"] = "center";
  ColumnTextAlign2["Right"] = "right";
  return ColumnTextAlign2;
})(ColumnTextAlign || {});

// src/components/Table/components/TableRoot/TableRoot.tsx
import React160, { useRef as useRef17 } from "react";

// src/components/Table/hooks/useHorizontalScrollAtEnd.ts
import { useCallback as useCallback32, useEffect as useEffect25, useState as useState23 } from "react";
var useHorizontalScrollAtEnd = (stickTo, scrollableContainer, contentLoading) => {
  const isHorizontalScrollAtEnd = useCallback32(() => {
    if (scrollableContainer) {
      if (stickTo === "left" /* Left */) {
        return scrollableContainer.scrollLeft === 0;
      } else {
        return scrollableContainer.scrollLeft + scrollableContainer.offsetWidth >= scrollableContainer.scrollWidth;
      }
    }
    return void 0;
  }, [stickTo, scrollableContainer]);
  const [scrollAtEnd, setScrollAtEnd] = useState23(true);
  useEffect25(() => {
    setScrollAtEnd(isHorizontalScrollAtEnd());
    const handleScrollPositionChange = () => {
      setScrollAtEnd(isHorizontalScrollAtEnd());
    };
    window.addEventListener("resize", handleScrollPositionChange);
    scrollableContainer == null ? void 0 : scrollableContainer.addEventListener("scroll", handleScrollPositionChange);
    return () => {
      window.removeEventListener("resize", handleScrollPositionChange);
      scrollableContainer == null ? void 0 : scrollableContainer.removeEventListener("scroll", handleScrollPositionChange);
    };
  }, [stickTo, scrollableContainer, contentLoading, isHorizontalScrollAtEnd]);
  return scrollAtEnd;
};

// src/components/Table/hooks/useSelectionHelper/useSelectionHelper.ts
import { useCallback as useCallback33, useEffect as useEffect26, useState as useState24 } from "react";
function useSelectionHelper(selectMode, rowsData, recordAttributeIdentifier, onSelectionChange) {
  const [selectedRows, setSelectedRows] = useState24({});
  const selectedCount = Object.keys(selectedRows).length;
  const columnSelected = rowsData.length && rowsData.every((node) => !!selectedRows[node[recordAttributeIdentifier]]);
  const clearSelection = useCallback33(() => {
    setSelectedRows({});
  }, [setSelectedRows]);
  const toggleRecord = useCallback33(
    (record, rowSelected) => {
      setSelectedRows((oldSelectedRows) => {
        var _a;
        if (rowSelected) {
          return __spreadProps(__spreadValues({}, oldSelectedRows), { [record[recordAttributeIdentifier]]: record });
        } else {
          const _b = oldSelectedRows, { [_a = record[recordAttributeIdentifier]]: recordToDelete } = _b, newSelectedRows = __objRest(_b, [__restKey(_a)]);
          return newSelectedRows;
        }
      });
    },
    [recordAttributeIdentifier]
  );
  const toggleAllRecordsFromCurrentPage = useCallback33(
    (checked) => {
      setSelectedRows((oldSelectedRows) => {
        const newSelectedRows = __spreadValues({}, oldSelectedRows);
        rowsData.forEach((node) => {
          if (checked) {
            newSelectedRows[node[recordAttributeIdentifier]] = node;
          } else {
            delete newSelectedRows[node[recordAttributeIdentifier]];
          }
        });
        return newSelectedRows;
      });
    },
    [recordAttributeIdentifier, rowsData]
  );
  useEffect26(() => {
    selectMode && clearSelection();
  }, [selectMode, clearSelection]);
  useEffect26(
    () => onSelectionChange == null ? void 0 : onSelectionChange(Object.values(selectedRows), selectedCount),
    [onSelectionChange, selectedRows, selectedCount, rowsData]
  );
  return {
    selectedRows,
    columnSelected,
    selectedCount,
    toggleRecord,
    toggleAllRecordsFromCurrentPage,
    clearSelection
  };
}

// src/components/Table/components/TableRoot/context.ts
import { createContext as createContext19 } from "react";
var TableRootContext = createContext19({
  horizontallyScrollableContainerRef: void 0,
  loading: false,
  recordAttributeIdentifier: "id",
  scrollAtEnd: {
    ["left" /* Left */]: void 0,
    ["right" /* Right */]: void 0
  }
});

// src/components/Table/components/TableRoot/styled.ts
import styled80 from "@xstyled/styled-components";
var TableWrapper = styled80(Box_default)`
  width: 100%;
  overflow-x: auto;
  border: 1px solid;
  border-color: graphic-default;
  border-radius: sm;
  background-color: surface-interactive-default;
`;

// src/components/Table/components/TableRoot/TableRoot.tsx
var TableRoot = (_a) => {
  var _b = _a, {
    loading,
    recordAttributeIdentifier = "id",
    children
  } = _b, styleProps = __objRest(_b, [
    "loading",
    "recordAttributeIdentifier",
    "children"
  ]);
  const tableWrapperRef = useRef17();
  const isScrollAtLeftEnd = useHorizontalScrollAtEnd("left" /* Left */, tableWrapperRef == null ? void 0 : tableWrapperRef.current);
  const isScrollAtRightEnd = useHorizontalScrollAtEnd("right" /* Right */, tableWrapperRef == null ? void 0 : tableWrapperRef.current);
  return /* @__PURE__ */ React160.createElement(TableWrapper, __spreadValues({ ref: tableWrapperRef }, styleProps), /* @__PURE__ */ React160.createElement(
    TableRootContext.Provider,
    {
      value: {
        horizontallyScrollableContainerRef: tableWrapperRef,
        loading,
        recordAttributeIdentifier,
        scrollAtEnd: {
          ["left" /* Left */]: isScrollAtLeftEnd,
          ["right" /* Right */]: isScrollAtRightEnd
        }
      }
    },
    children
  ));
};

// src/components/Table/components/Table/TableInner.tsx
import React171, {
  useCallback as useCallback35,
  useContext as useContext27,
  useImperativeHandle as useImperativeHandle2,
  useMemo as useMemo13,
  useState as useState25
} from "react";

// src/components/Table/components/NoDataMessage/NoDataMessage.tsx
import * as React161 from "react";
var NoDataMessage = ({ message }) => /* @__PURE__ */ React161.createElement(Box_default, { as: "tr", position: "relative" }, /* @__PURE__ */ React161.createElement("td", { colSpan: 9999 }, /* @__PURE__ */ React161.createElement(Box_default, { p: "m" }, ["string", "undefined"].indexOf(typeof message) >= 0 ? /* @__PURE__ */ React161.createElement(Typography_default, { textAlign: "center", variant: "bodyMediumS", color: "text-base" }, message || "No records available for this category or filter criteria") : message)));

// src/components/Table/components/Row/Row.tsx
import React167, { useCallback as useCallback34, useContext as useContext25 } from "react";
import get from "lodash.get";

// src/components/Table/components/InlineActions/InlineActions.tsx
import * as React164 from "react";
import { MenuVerticalFilled } from "@aircall/icons";

// src/components/Table/components/InlineActions/InlineActionsList.tsx
import React163 from "react";

// src/components/Table/components/InlineActions/InlineAction.tsx
import React162 from "react";
import styled81 from "@xstyled/styled-components";
var IconButtonContainer2 = styled81(Flex_default).attrs({
  justifyContent: "center",
  alignItems: "center"
})`
  box-sizing: border-box;
  cursor: pointer;
  height: 40px;
  width: 40px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
  }
`;
var InlineAction = ({
  action,
  rowData
}) => {
  const ActionRenderer = action.renderer;
  return ActionRenderer || action.icon ? /* @__PURE__ */ React162.createElement(IconButtonContainer2, { onClick: (event) => action.onExecute(rowData, event), title: action.label }, ActionRenderer ? /* @__PURE__ */ React162.createElement(ActionRenderer, { rowData }) : /* @__PURE__ */ React162.createElement(IconButton_default, { component: action.icon, size: 16, discColor: "input-background-02" })) : /* @__PURE__ */ React162.createElement(Button, { mode: "link", size: "small", onClick: (event) => action.onExecute(rowData, event) }, action.label);
};

// src/components/Table/components/InlineActions/InlineActionsList.tsx
var InlineActionsList = ({
  actions,
  rowData
}) => {
  return /* @__PURE__ */ React163.createElement(Flex_default, null, actions.map((action, index) => /* @__PURE__ */ React163.createElement(InlineAction, { action, key: index, rowData })));
};

// src/components/Table/components/InlineActions/InlineActions.tsx
var InlineActions = ({
  data,
  actionsType,
  actions
}) => {
  if (actionsType === "Dropdown" /* Dropdown */) {
    return /* @__PURE__ */ React164.createElement(React164.Fragment, null, /* @__PURE__ */ React164.createElement(
      Dropdown,
      {
        onVisibilityChange: (flyoutVisibility) => {
          if (flyoutVisibility) {
            if (typeof actions === "function") {
              actions(data);
            }
          }
        },
        trigger: /* @__PURE__ */ React164.createElement(
          Button,
          {
            mode: "ghost",
            variant: "secondary",
            size: "xSmall",
            shape: "circle",
            "data-test": "table-action-dropdown-button"
          },
          /* @__PURE__ */ React164.createElement(MenuVerticalFilled, null)
        ),
        align: "end"
      },
      typeof actions === "function" ? actions(data) : /* @__PURE__ */ React164.createElement(Menu, { selectionMode: "none" }, actions.map((action, index) => {
        const ActionRenderer = action.renderer;
        return ActionRenderer ? /* @__PURE__ */ React164.createElement(ActionRenderer, { key: index, rowData: data }) : /* @__PURE__ */ React164.createElement(MenuItem, { key: action.label, onClick: (event) => action.onExecute(data, event) }, action.label);
      }))
    ));
  } else if (typeof actions === "function") {
    return actions(data);
  }
  return /* @__PURE__ */ React164.createElement(InlineActionsList, { actions, rowData: data });
};

// src/components/Table/components/TableData/TableData.tsx
import * as React165 from "react";

// src/components/Table/components/TableData/styled.ts
import styled82, { css as css34 } from "@xstyled/styled-components";
var computeStickyStyle = ({ selected, stickTo, scrolledToEdge }) => {
  if (!stickTo) {
    return;
  }
  return css34(__spreadValues(__spreadValues({
    position: "sticky",
    zIndex: 0,
    backgroundColor: selected ? (
      /* FIXME */
      "primary-100"
    ) : "surface-interactive-default"
  }, stickTo === "left" /* Left */ ? { left: 0 } : { right: 0 }), scrolledToEdge === false ? stickTo === "left" /* Left */ ? { borderRight: "1px solid", borderRightColor: "graphic-default" } : { borderLeft: "1px solid", borderLeftColor: "graphic-default" } : void 0));
};
var StyledTableData = styled82(Box_default).withConfig({
  shouldForwardProp: (prop, defaultShouldForwardProp) => defaultShouldForwardProp(prop)
}).attrs({ as: "td" })`
    display: table-cell;
    padding: 0 4;
    height: 40px;
    border-bottom: 1px solid;
    border-bottom-color: graphic-default;
    white-space: nowrap;
    ${computeStickyStyle}

    label {
      margin-bottom: 0;
    }
  `;

// src/components/Table/components/TableData/TableData.tsx
var TableData = (_a) => {
  var _b = _a, {
    children,
    stickTo,
    textAlign = "left" /* Left */
  } = _b, otherProps = __objRest(_b, [
    "children",
    "stickTo",
    "textAlign"
  ]);
  const { scrollAtEnd } = React165.useContext(TableRootContext);
  const stylingProps = __spreadValues({}, stickTo ? { stickTo, scrolledToEdge: scrollAtEnd[stickTo] } : {});
  return /* @__PURE__ */ React165.createElement(StyledTableData, __spreadValues(__spreadValues({}, stylingProps), otherProps), /* @__PURE__ */ React165.createElement(Flex_default, { justifyContent: textAlign }, children));
};

// src/components/Table/components/TextCell/TextCell.tsx
import React166 from "react";
var TextCell = (_a) => {
  var _b = _a, {
    children,
    textAlign = "left",
    disabled = false
  } = _b, otherProps = __objRest(_b, [
    "children",
    "textAlign",
    "disabled"
  ]);
  return /* @__PURE__ */ React166.createElement(
    Typography_default,
    __spreadProps(__spreadValues({
      variant: "bodyMediumS",
      textAlign
    }, otherProps), {
      color: disabled ? "text-disabled" : "text-base"
    }),
    children
  );
};

// src/components/Table/components/Row/styled.ts
import styled83, { css as css35 } from "@xstyled/styled-components";
var TableRow = styled83(Box_default).withConfig({
  shouldForwardProp: (prop, defaultShouldForwardProp) => defaultShouldForwardProp(prop)
}).attrs({ as: "tr" })(
  ({ disabled, clickable }) => css35`
    display: table-row;
    ${computeRowBackground}
    ${disabled && css35`
      pointer-events: none;
      color: text-disabled;
      cursor: default;
    `}
    ${clickable && css35`
      cursor: pointer;
    `}
  `
);
var computeRowBackground = ({ selected }) => {
  if (selected) {
    return css35`
      /* FIXME */
      background-color: primary-100;
    `;
  }
  return css35`
    background-color: surface-interactive-default;
    &:hover,
    &:hover td {
      background-color: surface-interactive-default-hover;
    }
  `;
};
var ActionsTableData = styled83(TableData)`
  padding: 0 1;
  width: 40px;
`;

// src/components/Table/components/Row/Row.tsx
var Row = ({
  data,
  columns,
  actions,
  actionsType,
  disabled,
  selectable,
  selectDisabled,
  selected = false,
  onSelectChange,
  onClick
}) => {
  const { loading, recordAttributeIdentifier } = useContext25(TableRootContext);
  const hasActions = typeof actions === "function" || !!(actions && actions.length);
  const renderCell = useCallback34(
    (col, data2, index) => {
      const value = get(data2, col.id);
      if (col.renderer) {
        return col.renderer(data2, value, index);
      }
      return /* @__PURE__ */ React167.createElement(TextCell, { disabled }, value);
    },
    [disabled]
  );
  const handleRowClick = useCallback34(
    (event) => {
      var _a;
      const currentSelection = (_a = window.getSelection()) == null ? void 0 : _a.toString();
      if (!currentSelection) {
        onClick == null ? void 0 : onClick(data, event);
      }
    },
    [onClick, data]
  );
  const preventRowClick = useCallback34((evt) => {
    evt.stopPropagation();
  }, []);
  return /* @__PURE__ */ React167.createElement(
    TableRow,
    {
      key: data[recordAttributeIdentifier],
      selected,
      disabled,
      clickable: !!onClick,
      onClick: handleRowClick
    },
    selectable && /* @__PURE__ */ React167.createElement(TableData, { stickTo: "left" /* Left */, selected, w: "48px", onClick: preventRowClick }, /* @__PURE__ */ React167.createElement(
      Checkbox,
      {
        checked: selected,
        disabled: selectDisabled || disabled,
        onChange: (checked) => onSelectChange(data, checked),
        size: "small"
      }
    )),
    columns.map((column, index) => /* @__PURE__ */ React167.createElement(TableData, { key: column.id, selected, textAlign: column.textAlign }, loading ? /* @__PURE__ */ React167.createElement(Box_default, { flex: 1 }, /* @__PURE__ */ React167.createElement(Skeleton, null)) : renderCell(column, data, index))),
    hasActions && /* @__PURE__ */ React167.createElement(ActionsTableData, { stickTo: "right" /* Right */, selected, onClick: preventRowClick }, loading ? /* @__PURE__ */ React167.createElement(Skeleton, null) : /* @__PURE__ */ React167.createElement(InlineActions, { data, actions, actionsType }))
  );
};
var MemoizedRow = React167.memo(Row);

// src/components/Table/components/TableHeaders/TableHeaders.tsx
import React170 from "react";

// src/components/Table/components/TableHeader/TableHeader.tsx
import * as React168 from "react";

// src/components/Table/components/TableHeader/styled.ts
import styled84, { css as css36 } from "@xstyled/styled-components";
var computeStickyStyle2 = ({ stickTo, scrolledToEdge }) => {
  if (!stickTo) {
    return;
  }
  return css36(__spreadValues(__spreadValues({
    position: "sticky",
    zIndex: 0
  }, stickTo === "left" /* Left */ ? { left: 0 } : { right: 0 }), scrolledToEdge === false ? stickTo === "left" /* Left */ ? { borderRight: "1px solid", borderRightColor: "graphic-default" } : { borderLeft: "1px solid", borderLeftColor: "graphic-default" } : void 0));
};
var StyledHeader = styled84.th`
  display: table-cell;
  padding: 0 4;
  height: 40px;
  text-align: left;
  border-bottom: 1px solid;
  background-color: surface-interactive-default;
  border-bottom-color: graphic-default;
  white-space: nowrap;
  ${computeStickyStyle2}
`;

// src/components/Table/components/TableHeader/TableHeader.tsx
var TableHeader = (_a) => {
  var _b = _a, {
    children,
    stickTo,
    textAlign = "left" /* Left */
  } = _b, restProps = __objRest(_b, [
    "children",
    "stickTo",
    "textAlign"
  ]);
  const { scrollAtEnd } = React168.useContext(TableRootContext);
  const stylingProps = __spreadValues({}, stickTo ? { stickTo, scrolledToEdge: scrollAtEnd[stickTo] } : {});
  return /* @__PURE__ */ React168.createElement(StyledHeader, __spreadValues(__spreadValues({}, stylingProps), restProps), /* @__PURE__ */ React168.createElement(Flex_default, { justifyContent: textAlign }, children));
};

// src/components/Table/components/TableHeaders/OrderArrow.tsx
import * as React169 from "react";
import { ArrowUpFilled, ArrowDownFilled } from "@aircall/icons";

// src/components/Table/constants.ts
var OrderDirection = /* @__PURE__ */ ((OrderDirection2) => {
  OrderDirection2["Asc"] = "ASC";
  OrderDirection2["Desc"] = "DESC";
  return OrderDirection2;
})(OrderDirection || {});
var DEFAULT_PAGE_SIZE = 50;

// src/components/Table/components/TableHeaders/OrderArrow.tsx
var OrderArrow = ({ orderDirection, active = false }) => {
  return /* @__PURE__ */ React169.createElement(
    Icon_default,
    {
      ml: "xxxs",
      component: orderDirection === "DESC" /* Desc */ || !active ? ArrowDownFilled : ArrowUpFilled,
      size: 14,
      color: active ? "icon-interactive-default-active" : "graphic-interactive-default"
    }
  );
};

// src/components/Table/components/TableHeaders/styled.ts
import styled85, { css as css37 } from "@xstyled/styled-components";
var ActionsHeader = styled85(TableHeader)(
  ({ theme: { space: space6 } }) => css37`
    padding: 0 ${space6.xxs}px;
  `
);

// src/components/Table/components/TableHeaders/TableHeaders.tsx
var TableHeaders = ({
  selectable,
  hasActions,
  selectColumnDisabled,
  selectColumnChecked,
  columns,
  order: order2,
  onSelectionChange,
  onOrderChange
}) => /* @__PURE__ */ React170.createElement(
  Box_default,
  {
    as: "thead",
    display: "table-header-group",
    top: 0,
    zIndex: 1,
    position: "sticky",
    backgroundColor: "surface-interactive-default"
  },
  /* @__PURE__ */ React170.createElement(TableRow, null, selectable && /* @__PURE__ */ React170.createElement(TableHeader, { stickTo: "left" /* Left */ }, /* @__PURE__ */ React170.createElement(
    Checkbox,
    {
      checked: !!selectColumnChecked,
      disabled: selectColumnDisabled,
      onChange: onSelectionChange,
      size: "small"
    }
  )), columns.map((column, index) => {
    const isSortingDisabledExplicitly = column.sortable === false;
    const columnSortable = !!order2 && !!onOrderChange && !isSortingDisabledExplicitly;
    const isSorting = columnSortable && (order2 == null ? void 0 : order2.field) === column.id;
    return /* @__PURE__ */ React170.createElement(TableHeader, { key: index, textAlign: column.textAlign }, /* @__PURE__ */ React170.createElement(
      Flex_default,
      {
        onClick: () => columnSortable && (onOrderChange == null ? void 0 : onOrderChange(column.id)),
        cursor: columnSortable ? "pointer" : "default",
        alignItems: "center"
      },
      /* @__PURE__ */ React170.createElement(
        Typography_default,
        {
          variant: "supportingSemiboldS",
          ellipsis: true,
          color: isSorting ? "text-highlight" : "text-placeholder"
        },
        column.label
      ),
      columnSortable && /* @__PURE__ */ React170.createElement(OrderArrow, { active: isSorting, orderDirection: order2 == null ? void 0 : order2.direction })
    ));
  }), hasActions && /* @__PURE__ */ React170.createElement(ActionsHeader, { stickTo: "right" /* Right */ }))
);
var MemoizedTableHeaders = React170.memo(TableHeaders);

// src/components/Table/components/Table/styled.ts
import styled86 from "@xstyled/styled-components";
var StyledTable = styled86(Box_default).attrs({ as: "table" })`
  display: table;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  tr:last-of-type > td {
    border-bottom: none;
  }
`;

// src/components/Table/components/Table/TableInner.tsx
var Table2 = ({
  data,
  columns,
  footer,
  disableRow,
  noDataMessage,
  verticalScrollingParent,
  pageSize = 50,
  order: order2,
  rowActions,
  rowActionsType = "Dropdown" /* Dropdown */,
  bulkActions,
  unselectableRowCondition,
  hideActionBar,
  onRowClick,
  onOrderChange,
  onSelectionChange
}, ref) => {
  const { horizontallyScrollableContainerRef, loading, recordAttributeIdentifier } = useContext27(TableRootContext);
  const [actionBarPositionSticky, setActionBarPositionSticky] = useState25();
  const rowsData = useMemo13(
    () => loading ? new Array(pageSize).fill({}) : data,
    [data, loading, pageSize]
  );
  const rowsSelectable = useMemo13(() => !!(bulkActions && bulkActions.length), [bulkActions]);
  const {
    selectedRows,
    columnSelected,
    selectedCount,
    toggleRecord,
    toggleAllRecordsFromCurrentPage,
    clearSelection
  } = useSelectionHelper(
    rowsSelectable,
    rowsData,
    recordAttributeIdentifier,
    rowsSelectable ? onSelectionChange : void 0
  );
  useImperativeHandle2(ref, () => ({
    clearSelection
  }));
  const handleStickyChange = useCallback35((stuck) => {
    setActionBarPositionSticky(stuck);
  }, []);
  const hasActions = typeof rowActions === "function" || !!(rowActions && rowActions.length);
  const tableHasNoData = !loading && rowsData.length === 0;
  const needSpaceForActionBar = selectedCount && !actionBarPositionSticky && !hideActionBar;
  return /* @__PURE__ */ React171.createElement(React171.Fragment, null, /* @__PURE__ */ React171.createElement(StyledTable, { pb: needSpaceForActionBar ? 8 : 0 }, /* @__PURE__ */ React171.createElement(
    MemoizedTableHeaders,
    {
      onSelectionChange: toggleAllRecordsFromCurrentPage,
      selectColumnDisabled: !!unselectableRowCondition || !!disableRow,
      selectColumnChecked: !!columnSelected,
      columns,
      onOrderChange,
      selectable: rowsSelectable,
      hasActions: hasActions && !selectedCount,
      order: order2
    }
  ), /* @__PURE__ */ React171.createElement(Box_default, { as: "tbody", display: "table-row-group" }, rowsData.map((record, index) => {
    var _a, _b;
    return /* @__PURE__ */ React171.createElement(
      MemoizedRow,
      {
        key: (_a = record[recordAttributeIdentifier]) != null ? _a : index,
        data: record,
        columns,
        actions: selectedCount > 0 ? void 0 : rowActions,
        actionsType: rowActionsType,
        disabled: typeof disableRow === "function" ? disableRow(record) : disableRow,
        onClick: onRowClick,
        selectable: rowsSelectable,
        selectDisabled: (_b = unselectableRowCondition == null ? void 0 : unselectableRowCondition(record)) != null ? _b : false,
        onSelectChange: toggleRecord,
        selected: !!selectedRows[record[recordAttributeIdentifier]]
      }
    );
  })), tableHasNoData && /* @__PURE__ */ React171.createElement(Box_default, { as: "tfoot", display: "table-footer-group" }, /* @__PURE__ */ React171.createElement(NoDataMessage, { message: noDataMessage })), footer), selectedCount > 0 && !hideActionBar && /* @__PURE__ */ React171.createElement(
    ActionBar,
    {
      actions: bulkActions,
      nonVerticallyScrollingParent: horizontallyScrollableContainerRef,
      verticalScrollingParent,
      onStickyChange: handleStickyChange,
      onCancel: clearSelection,
      selectedRows: Object.values(selectedRows)
    }
  ));
};
var TableInner = React171.forwardRef(Table2);

// src/components/Table/components/Table/Table.tsx
var WrappedTable = (_a, ref) => {
  var _b = _a, {
    data,
    columns,
    loading = false,
    disableRow,
    noDataMessage,
    verticalScrollingParent,
    pageSize = 50,
    recordAttributeIdentifier = "id",
    order: order2,
    rowActions,
    rowActionsType = "Dropdown" /* Dropdown */,
    bulkActions,
    unselectableRowCondition,
    hideActionBar,
    onRowClick,
    onOrderChange,
    onSelectionChange,
    footer
  } = _b, styleProps = __objRest(_b, [
    "data",
    "columns",
    "loading",
    "disableRow",
    "noDataMessage",
    "verticalScrollingParent",
    "pageSize",
    "recordAttributeIdentifier",
    "order",
    "rowActions",
    "rowActionsType",
    "bulkActions",
    "unselectableRowCondition",
    "hideActionBar",
    "onRowClick",
    "onOrderChange",
    "onSelectionChange",
    "footer"
  ]);
  return /* @__PURE__ */ React172.createElement(
    TableRoot,
    __spreadValues({
      loading,
      recordAttributeIdentifier
    }, styleProps),
    /* @__PURE__ */ React172.createElement(
      TableInner,
      {
        ref,
        data,
        columns,
        disableRow,
        noDataMessage,
        verticalScrollingParent,
        pageSize,
        order: order2,
        rowActions,
        rowActionsType,
        bulkActions,
        unselectableRowCondition,
        hideActionBar,
        onRowClick,
        onOrderChange,
        onSelectionChange,
        footer
      }
    )
  );
};
var Table3 = React172.forwardRef(WrappedTable);

// src/components/TabToggle/TabToggle.tsx
import React173, { forwardRef as forwardRef41, memo as memo6, useCallback as useCallback36 } from "react";
import { useControllableState as useControllableState11 } from "@aircall/hooks";

// src/components/TabToggle/components/StyledTabToggleButton.ts
import { css as css38, styled as styled87 } from "@xstyled/styled-components";

// src/components/TabToggle/constants.ts
var TAB_TOGGLE_SIZES = {
  small: {
    height: "40px",
    padding: "0px 16px"
  },
  regular: {
    height: "48px",
    padding: "0px 24px"
  },
  large: {
    height: "56px",
    padding: "0px 32px"
  }
};

// src/components/TabToggle/components/StyledTabToggleButton.ts
var makeButtonVariant2 = ({
  disabled,
  type,
  readOnly,
  checked
}) => {
  if (disabled) {
    return css38`
      background-color: ${getColor("surface-interactive-disabled")};
      border-color: ${getColor("graphic-disabled")};
      color: ${getColor("text-disabled")};
    `;
  }
  if (!checked) {
    return css38`
      background-color: ${getColor("surface-interactive-default")};
      border-color: ${getColor("graphic-interactive-default")};
      color: ${getColor("text-base")};

      ${!readOnly && css38`
        :hover {
          background-color: ${getColor("surface-interactive-default-hover")};
          border-color: ${getColor("graphic-interactive-default-hover")};
        }

        :focus-within,
        :active {
          background-color: ${getColor("surface-interactive-default-active")};
          border-color: ${getColor("graphic-interactive-default-active")};
        }
      `}
    `;
  }
  if (type === "unchecked") {
    return css38`
      background-color: ${getColor("surface-interactive-critical")};
      border-color: ${getColor("graphic-interactive-critical")};
      color: ${getColor("text-contrast-light")};

      ${!readOnly && css38`
        :hover {
          background-color: ${getColor("surface-interactive-critical-hover")};
          border-color: ${getColor("graphic-interactive-critical-hover")};
        }

        :focus-within,
        :active {
          background-color: ${getColor("surface-interactive-critical-active")};
          border-color: ${getColor("graphic-interactive-critical-active")};
        }
      `}
    `;
  }
  return css38`
    background-color: ${getColor("surface-interactive-primary")};
    border-color: ${getColor("graphic-interactive-primary")};
    color: ${getColor("text-contrast-light")};
    ${!readOnly && css38`
      :hover {
        background-color: ${getColor("surface-interactive-primary-hover")};
        border-color: ${getColor("graphic-interactive-primary-hover")};
      }

      :focus-within,
      :active {
        background-color: ${getColor("surface-interactive-primary-active")};
        border-color: ${getColor("graphic-interactive-primary-active")};
      }
    `}
  `;
};
var makeTabToggleBlockSize = ({ size: size2 }) => {
  const tabToggleSize = TAB_TOGGLE_SIZES[size2];
  return css38`
    height: ${tabToggleSize.height};
    padding: ${tabToggleSize.padding};
  `;
};
var StyledTabToggleButton = styled87(Flex_default)`
  align-items: center;
  justify-content: center;
  cursor: ${({ readOnly, disabled }) => disabled ? "not-allowed" : readOnly ? "normal" : "pointer"};
  border: 1px solid transparent;
  ${({ theme }) => theme.typography.bodyMediumM};
  transition: default;

  ${makeButtonVariant2}
  ${makeTabToggleBlockSize}

  &:first-of-type {
    flex: 1;
    border-radius: sm 0 0 sm;
    border-right: none;
  }

  &:last-of-type {
    flex: 1;
    border-radius: 0 sm sm 0;
    border-left: none;
  }
`;

// src/components/TabToggle/components/StyledTabToggleContainer.ts
import { styled as styled88 } from "@xstyled/styled-components";
var StyledTabToggleContainer = styled88.label`
  display: flex;
  align-items: center;
  user-select: none;

  input {
    display: none;
  }
`;

// src/components/TabToggle/TabToggle.tsx
var TabToggle = memo6(
  forwardRef41(
    (_a, ref) => {
      var _b = _a, {
        checked: checkedProp,
        defaultChecked = false,
        disabled = false,
        readOnly = false,
        size: size2,
        onChange,
        name,
        id,
        checkedLabel,
        uncheckedLabel,
        "data-test": dataTest = "tab-toggle"
      } = _b, otherStyleProps = __objRest(_b, [
        "checked",
        "defaultChecked",
        "disabled",
        "readOnly",
        "size",
        "onChange",
        "name",
        "id",
        "checkedLabel",
        "uncheckedLabel",
        "data-test"
      ]);
      const formContext = useFormContext();
      const inputSize = size2 || (formContext == null ? void 0 : formContext.size) || "regular";
      const [checked = defaultChecked, setChecked] = useControllableState11({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange
      });
      const handleChange = useCallback36(
        (event) => {
          if (disabled || readOnly) {
            return;
          }
          const { checked: checked2 } = event.target;
          setChecked(checked2);
        },
        [disabled, readOnly, setChecked]
      );
      return /* @__PURE__ */ React173.createElement(StyledTabToggleContainer, __spreadProps(__spreadValues({ htmlFor: id }, otherStyleProps), { "data-test": dataTest }), /* @__PURE__ */ React173.createElement(
        StyledTabToggleButton,
        {
          size: inputSize,
          checked,
          type: "checked",
          "data-test": `${dataTest}-checked`,
          disabled,
          readOnly
        },
        checkedLabel
      ), /* @__PURE__ */ React173.createElement(
        StyledTabToggleButton,
        {
          size: inputSize,
          checked: !checked,
          type: "unchecked",
          "data-test": `${dataTest}-unchecked`,
          disabled,
          readOnly
        },
        uncheckedLabel
      ), /* @__PURE__ */ React173.createElement(
        "input",
        {
          ref,
          id,
          name,
          type: "checkbox",
          "data-test": `${dataTest}-checkbox`,
          checked,
          disabled,
          onChange: handleChange
        }
      ));
    }
  )
);
TabToggle.displayName = "TabToggle";

// src/components/Textarea/Textarea.tsx
import React174, { forwardRef as forwardRef42 } from "react";
import { useComposedRefs as useComposedRefs7 } from "@aircall/hooks";

// src/components/Textarea/components/StyledTextarea.ts
import styled89 from "@xstyled/styled-components";
var StyledTextarea = styled89.textarea`
  ${makeTextField}
  resize: ${({ resizable }) => resizable ? "vertical" : "none"};
  padding: 4;

  & + ${TextFieldSuffix} {
    position: absolute;
    right: 2;
    top: 2;
  }
`;

// src/components/Textarea/Textarea.tsx
var Textarea = forwardRef42((props, forwardedRef) => {
  const _a = props, {
    id,
    validationStatus,
    resizable = false,
    onClear,
    // this attribute is purely for storybook purposes
    "data-pseudo": dataPseudo
  } = _a, textareaProps = __objRest(_a, [
    "id",
    "validationStatus",
    "resizable",
    "onClear",
    "data-pseudo"
  ]);
  const innerRef = React174.useRef(null);
  const composedRef = useComposedRefs7(forwardedRef, innerRef);
  const { componentStatus, componentId, error } = useTextField({
    id,
    validationStatus,
    onClear
  });
  return /* @__PURE__ */ React174.createElement(
    TextField_default,
    {
      error,
      onClear,
      triggerFocus: () => {
        var _a2;
        return (_a2 = innerRef == null ? void 0 : innerRef.current) == null ? void 0 : _a2.focus();
      },
      validationStatus: componentStatus,
      minHeight: 108,
      "data-pseudo": dataPseudo
    },
    /* @__PURE__ */ React174.createElement(
      StyledTextarea,
      __spreadValues({
        ref: composedRef,
        "data-test": "textarea",
        resizable,
        id: componentId
      }, textareaProps)
    )
  );
});
var Textarea_default = Textarea;

// src/components/Toast/components/Toast.tsx
import * as React175 from "react";
import styled91, { css as css39 } from "@xstyled/styled-components";

// src/components/Toast/components/ToastMessage.tsx
import { styled as styled90 } from "@xstyled/styled-components";
var ToastMessage = styled90(Notification.Heading).attrs({ "data-test": "toast-message" })`
  flex: 1;
`;

// src/components/Toast/components/Toast.tsx
var ToastRoot = styled91(Notification.Root)`
  ${({ takeContainerWidth }) => css39`
    box-shadow: 5;
    border-radius: lg;
    margin-bottom: 2;
    gap: 2;
    max-width: ${takeContainerWidth ? "auto" : "calc(100vw - 24px * 2)"};
    min-height: 40px;
    width: ${takeContainerWidth ? "100%" : "344px"};
  `}
`;
var Toast = (_a) => {
  var _b = _a, { variant: variant2, children } = _b, rest = __objRest(_b, ["variant", "children"]);
  const childNode = typeof children === "string" ? /* @__PURE__ */ React175.createElement(ToastMessage, null, children) : children;
  return /* @__PURE__ */ React175.createElement(ToastRoot, __spreadValues({ variant: variant2, "data-test": `toast-${variant2}` }, rest), childNode);
};

// src/components/Toast/components/ToastButton.tsx
var { Button: Button4 } = Notification;
var ToastButton = Button4;

// src/components/Toast/components/ToastIcon.tsx
import * as React176 from "react";
var ToastIcon = (props) => {
  return /* @__PURE__ */ React176.createElement(Notification.Icon, __spreadValues({ "data-test": "toast-icon" }, props));
};

// src/components/Toast/components/ToastCloseIcon.tsx
import React177, { useCallback as useCallback37 } from "react";
import styled92, { css as css40, keyframes as keyframes4 } from "@xstyled/styled-components";
import { CloseOutlined as CloseOutlined5 } from "@aircall/icons";
var progress = keyframes4`
  from {
    stroke-dashoffset: -82px;
  }

  to {
    stroke-dashoffset: -164px;
  }
`;
var SVGContainer = styled92.svg`
  overflow: visible;
  position: absolute;
  transform: rotate(-90deg);
`;
var IndicatorCircle = styled92.circle`
  fill: transparent;
  stroke-dasharray: 82px;
  stroke-width: 1px;
  stroke: currentColor;
  opacity: 0.4;
  stroke-dashoffset: 0;
  transition: stroke 0.2s ease-in-out;

  ${SVGContainer}:hover & {
    opacity: 1;
  }

  ${SVGContainer}:active & {
    fill: rgb(255, 255, 255, 0.1);
  }
`;
var ProgressCircle = styled92.circle(
  ({ dismissIn }) => css40`
    fill: transparent;
    stroke-dasharray: 82px;
    stroke-width: 1px;
    animation-delay: 0.5s;
    animation-name: ${progress};
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    animation-duration: ${dismissIn}ms;
    stroke: currentColor;
    stroke-dashoffset: ${dismissIn === 0 ? "-164px" : "-82px"};
    stroke-linecap: round;
  `
);
function CloseIcon({ dismissIn = 0 }) {
  return /* @__PURE__ */ React177.createElement(
    Flex_default,
    {
      position: "relative",
      "data-test": "toast-close",
      cursor: "pointer",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      w: 24,
      h: 24,
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React177.createElement(SVGContainer, { width: "24", height: "24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React177.createElement(IndicatorCircle, { r: "9", cx: "12", cy: "12" }), /* @__PURE__ */ React177.createElement(ProgressCircle, { dismissIn, r: "9", cx: "12", cy: "12" })),
    /* @__PURE__ */ React177.createElement(CloseOutlined5, { size: 12 })
  );
}
var ToastCloseIcon = ({
  onClick,
  dismissIn = 0,
  "aria-label": ariaLabel
}) => {
  const closeIcon = useCallback37(() => /* @__PURE__ */ React177.createElement(CloseIcon, { dismissIn }), [dismissIn]);
  return /* @__PURE__ */ React177.createElement(
    IconButton_default,
    {
      type: "button",
      "aria-label": ariaLabel,
      component: closeIcon,
      size: 24,
      onClick
    }
  );
};

// src/components/Toast/components/ToastManager/ToastManager.tsx
import * as React179 from "react";
import uniqueId2 from "lodash.uniqueid";
import { usePubSub as usePubSub2 } from "@aircall/hooks";

// src/components/Toast/constants.ts
var TOPICS2 = {
  SHOW_TOAST: "SHOW_TOAST",
  REMOVE_TOAST: "REMOVE_TOAST",
  SHOW_BANNER: "SHOW_BANNER",
  REMOVE_BANNER: "REMOVE_BANNER"
};

// src/components/Toast/contexts/ToastContext.tsx
import { createContext as createContext20, useContext as useContext28 } from "react";
var ToastContext = createContext20(null);
var useToast = () => {
  return useContext28(ToastContext);
};
var ToastConfigContext = createContext20(null);
var useToastConfig = () => {
  return useContext28(ToastConfigContext);
};

// src/components/Toast/utils.ts
var isDismissable = (dismissIn = 0) => Number.isFinite(dismissIn) && dismissIn > 0;

// src/components/Toast/components/ToastList/ToastList.tsx
import React178, { useCallback as useCallback38 } from "react";
import { AnimatePresence as AnimatePresence5, motion as motion4 } from "framer-motion";
var AnimatedToast = ({ toast }) => {
  const { takeContainerWidth } = useToastConfig();
  const { removeToast } = useToast();
  const _a = toast, { id, icon, variant: variant2, message, action, onClick, dismissIn, customComponent } = _a, toastProps = __objRest(_a, ["id", "icon", "variant", "message", "action", "onClick", "dismissIn", "customComponent"]);
  const handleDismiss = useCallback38(() => {
    removeToast(id);
  }, [removeToast, id]);
  const onBodyClicked = useCallback38(() => {
    onClick == null ? void 0 : onClick(handleDismiss);
  }, [onClick, handleDismiss]);
  const onActionClick = useCallback38(
    (handleClick) => {
      return () => {
        handleClick(handleDismiss);
      };
    },
    [handleDismiss]
  );
  return /* @__PURE__ */ React178.createElement(
    motion4.div,
    {
      key: toast.id,
      layout: true,
      initial: "hide",
      animate: "show",
      exit: "hide",
      transition: { ease: [0, 0, 0, 1], duration: 0.3 },
      variants: {
        hide: { opacity: 0, y: -50 },
        show: { opacity: 1, y: 0 }
      }
    },
    /* @__PURE__ */ React178.createElement(
      Toast,
      __spreadValues({
        onClick: onBodyClicked,
        cursor: onClick && "pointer",
        variant: variant2,
        takeContainerWidth
      }, toastProps),
      customComponent ? customComponent(handleDismiss, dismissIn) : null,
      icon && /* @__PURE__ */ React178.createElement(ToastIcon, { icon }),
      message && /* @__PURE__ */ React178.createElement(ToastMessage, null, message),
      action ? /* @__PURE__ */ React178.createElement(ToastButton, { onClick: onActionClick(action.onClick), mode: action.mode }, action.children) : !customComponent ? /* @__PURE__ */ React178.createElement(ToastCloseIcon, { onClick: handleDismiss, dismissIn }) : null
    )
  );
};
var ToastList = () => {
  const { takeContainerWidth, position } = useToastConfig();
  const { toasts: toasts2 } = useToast();
  return /* @__PURE__ */ React178.createElement(
    Box_default,
    {
      "data-test": "toast-list",
      position,
      top: 2,
      left: takeContainerWidth ? 2 : "auto",
      right: 2,
      zIndex: 1009
    },
    /* @__PURE__ */ React178.createElement(AnimatePresence5, null, toasts2.map((toast) => /* @__PURE__ */ React178.createElement(AnimatedToast, { key: toast.id, toast })))
  );
};

// src/components/Toast/components/ToastManager/ToastManager.tsx
var ToastManager = ({
  children,
  container = ((_a) => (_a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a.body)(),
  takeContainerWidth = false,
  position = "fixed"
}) => {
  const [toasts2, setToasts] = React179.useState([]);
  const removeToast = React179.useCallback(
    (id) => setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id)),
    []
  );
  const showToast = React179.useCallback(
    (t) => {
      const toast = __spreadValues({ dismissIn: 0, id: uniqueId2() }, t);
      const cleanup = () => removeToast(toast.id);
      setToasts((prevToasts) => {
        if (prevToasts.some(({ id }) => id === toast.id)) {
          return prevToasts;
        }
        return [...prevToasts, toast];
      });
      if (isDismissable(toast.dismissIn)) {
        const timeoutIdx = window.setTimeout(() => {
          cleanup();
          window.clearTimeout(timeoutIdx);
        }, toast.dismissIn);
      }
      return cleanup;
    },
    [removeToast]
  );
  usePubSub2(TOPICS2.SHOW_TOAST, showToast);
  usePubSub2(TOPICS2.REMOVE_TOAST, removeToast);
  return /* @__PURE__ */ React179.createElement(ToastConfigContext.Provider, { value: { takeContainerWidth, position } }, /* @__PURE__ */ React179.createElement(ToastContext.Provider, { value: { toasts: toasts2, showToast, removeToast } }, /* @__PURE__ */ React179.createElement(React179.Fragment, null, children, /* @__PURE__ */ React179.createElement(InternalPortal, { container }, /* @__PURE__ */ React179.createElement(ToastList, null)))));
};

// src/components/Toast/pubsub.ts
import PubSub2 from "pubsub-js";
var toasts = {
  showToast: (toast) => {
    PubSub2.publish(TOPICS2.SHOW_TOAST, toast);
  },
  removeToast: (id) => {
    PubSub2.publish(TOPICS2.REMOVE_TOAST, id);
  }
};

// src/components/Toggle/Toggle.tsx
import * as React180 from "react";
import { useControllableState as useControllableState12 } from "@aircall/hooks";

// src/components/Toggle/components/StyledToggleContainer.tsx
import styled93 from "@xstyled/styled-components";

// src/components/Toggle/constants.ts
var toggle = {
  sizes: {
    small: {
      width: "40px",
      height: "24px",
      padding: "4px"
    },
    regular: {
      width: "40px",
      height: "24px",
      padding: "4px"
    },
    large: {
      width: "48px",
      height: "32px",
      padding: "4px"
    }
  },
  circleSizes: {
    small: {
      width: "16px",
      height: "16px"
    },
    regular: {
      width: "16px",
      height: "16px"
    },
    large: {
      width: "24px",
      height: "24px"
    }
  }
};

// src/components/Toggle/components/StyledToggleContainer.tsx
var toggleStyles = ({ size: size2, checked }) => {
  const toggleSize = toggle.sizes[size2];
  const circleSize = toggle.circleSizes[size2];
  return __spreadProps(__spreadValues({}, toggleSize), {
    borderRadius: "100px",
    "::after": __spreadProps(__spreadValues({}, circleSize), {
      left: checked ? `calc(100% - ${circleSize.width} - ${toggleSize.padding})` : toggleSize.padding
    })
  });
};
var StyledToggleContainer = styled93(Flex_default)`
  position: relative;
  display: block;
  user-select: none;
  border: 1.5px solid transparent;
  ${toggleStyles}
  transition: background 300ms ease-in-out;

  input {
    opacity: 0;
  }

  &::after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    border-radius: ${getRadii("full")};
    transition: left 230ms ease-in-out;
  }

  &&:has(input:focus-visible) {
    ${outlineStyles}
  }

  &&:has(input:focus:not(:focus-visible)) {
    outline-color: transparent;
  }
`;

// src/components/Toggle/components/StyledToggleLayout.tsx
import styled96, { css as css41, getColor as getColor15 } from "@xstyled/styled-components";

// src/components/Toggle/components/ToggleDescription.tsx
import { styled as styled94 } from "@xstyled/styled-components";
var ToggleDescription = styled94(Typography_default).attrs({
  as: "span",
  "data-test": "toggle-description"
})`
  grid-area: description;
  margin-top: 2;
  user-select: none;
`;
ToggleDescription.displayName = "ToggleDescription";

// src/components/Toggle/components/ToggleLabel.tsx
import { styled as styled95 } from "@xstyled/styled-components";
var ToggleLabel = styled95(Typography_default).attrs({
  as: "span",
  "data-test": "toggle-label"
})`
  grid-area: label;
  align-self: center;
  user-select: none;
`;
ToggleLabel.displayName = "ToggleLabel";

// src/components/Toggle/components/StyledToggleLayout.tsx
var makeToggleTypography = ({
  size: size2,
  disabled,
  theme
}) => {
  return css41`
    ${ToggleLabel} {
      ${size2 === "small" ? theme.typography.bodyRegularS : theme.typography.bodyRegularM};
      color: ${getColor15(disabled ? "text-disabled" : "text-base")};
    }

    ${ToggleDescription} {
      ${theme.typography.supportingRegularS};
      color: ${getColor15(disabled ? "text-disabled" : "text-secondary")};
    }
  `;
};
var makeToggleColor = ({
  checked,
  disabled,
  error
}) => {
  if (disabled) {
    return css41`
      ${StyledToggleContainer} {
        background-color: ${getColor15("surface-interactive-disabled")};
        border-color: ${getColor15("graphic-disabled")};

        :after {
          background-color: ${getColor15("icon-disabled")};
        }
      }
    `;
  }
  if (error) {
    if (checked) {
      return css41`
        ${StyledToggleContainer} {
          background-color: ${getColor15("surface-interactive-critical")};

          :after {
            background-color: ${getColor15("icon-contrast-light")};
          }
        }

        :hover {
          ${StyledToggleContainer} {
            background-color: ${getColor15("surface-interactive-critical-hover")};
          }
        }

        :active {
          ${StyledToggleContainer} {
            background-color: ${getColor15("surface-interactive-critical-active")};
          }
        }
      `;
    }
    return css41`
      ${StyledToggleContainer} {
        background-color: ${getColor15("surface-critical")};

        :after {
          background-color: ${getColor15("icon-contrast-light")};
        }
      }
    `;
  }
  if (checked) {
    return css41`
      ${StyledToggleContainer} {
        background-color: ${getColor15("surface-interactive-primary")};

        :after {
          background-color: ${getColor15("icon-contrast-light")};
        }
      }

      :hover {
        ${StyledToggleContainer} {
          background-color: ${getColor15("surface-interactive-primary-hover")};
        }
      }

      :active {
        ${StyledToggleContainer} {
          background-color: ${getColor15("surface-interactive-primary-active")};
        }
      }
    `;
  }
  return css41`
    ${StyledToggleContainer} {
      background-color: ${getColor15("graphic-interactive-default")};

      :after {
        background-color: ${getColor15("icon-contrast-light")};
      }
    }

    :hover {
      ${StyledToggleContainer} {
        background-color: ${getColor15("graphic-interactive-default-hover")};
      }
    }

    :active {
      ${StyledToggleContainer} {
        background-color: ${getColor15("graphic-interactive-default-active")};
      }
    }
  `;
};
var makeToggleSide = ({ side }) => {
  if (side === "right") {
    return css41`
      grid-template-areas:
        'label icon'
        'description .';
      grid-template-rows: auto 1fr;
    `;
  }
  return css41`
    grid-template-areas:
      'icon label'
      '. description';
    grid-template-rows: 1fr auto;
  `;
};
var StyledToggleLayout = styled96(Grid)`
  display: inline-grid;
  justify-content: flex-start;
  align-items: center;
  pointer-events: ${({ readOnly }) => readOnly ? "none" : "all"};

  :not(:has(> *:only-child)) {
    ${({ size: size2 }) => css41`
      column-gap: ${size2 === "small" ? 2 : 4};
    `}
  }

  &,
  input {
    cursor: ${({ disabled, readOnly }) => disabled || readOnly ? void 0 : "pointer"};
  }

  ${makeToggleSide}
  ${makeToggleTypography}
  ${makeToggleColor}
`;

// src/components/Toggle/Toggle.tsx
var Toggle = React180.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      name,
      id,
      size: size2,
      side = "left",
      checked: checkedProp,
      defaultChecked = false,
      disabled = false,
      readOnly = false,
      autoFocus = false,
      onChange,
      validationStatus,
      children
    } = _b, otherStyleProps = __objRest(_b, [
      "name",
      "id",
      "size",
      "side",
      "checked",
      "defaultChecked",
      "disabled",
      "readOnly",
      "autoFocus",
      "onChange",
      "validationStatus",
      "children"
    ]);
    const { componentSize, error } = useForm({ validationStatus, id, size: size2 });
    const [checked = defaultChecked, setChecked] = useControllableState12({
      prop: checkedProp,
      defaultProp: defaultChecked,
      onChange
    });
    const handleOnChange = React180.useCallback(
      (event) => {
        if (!disabled) {
          const { checked: checked2 } = event.target;
          setChecked(checked2);
        }
      },
      [disabled, setChecked]
    );
    const childNode = typeof children === "string" ? /* @__PURE__ */ React180.createElement(ToggleLabel, null, children) : children;
    return /* @__PURE__ */ React180.createElement(
      StyledToggleLayout,
      __spreadValues({
        as: "label"
      }, { checked, disabled, readOnly, error, size: componentSize, side }),
      /* @__PURE__ */ React180.createElement(StyledToggleContainer, { checked, size: componentSize }, /* @__PURE__ */ React180.createElement(
        "input",
        __spreadProps(__spreadValues(__spreadValues({
          "data-test": "toggle",
          type: "checkbox",
          role: "switch"
        }, { ref, autoFocus, checked, disabled, name }), otherStyleProps), {
          onChange: handleOnChange
        })
      )),
      childNode
    );
  }
);
Toggle.displayName = "Toggle";

// src/components/Tree/Tree.tsx
import * as React195 from "react";

// src/components/Tree/components/TreeGroupItem.tsx
import * as React189 from "react";
import { ChevronDownOutlined as ChevronDownOutlined3, ChevronRightOutlined as ChevronRightOutlined4 } from "@aircall/icons";

// src/components/Tree/contexts/TreeExpandContext.ts
import * as React181 from "react";
var TreeExpandContext = React181.createContext({});
var useTreeExpand = () => {
  return React181.useContext(TreeExpandContext);
};

// src/components/Tree/components/TreeItem.tsx
import * as React183 from "react";
import { styled as styled97, th as th6 } from "@xstyled/styled-components";

// src/components/Tree/contexts/TreeContext.ts
import * as React182 from "react";
var TreeContext = React182.createContext({});
var useTree = () => {
  return React182.useContext(TreeContext);
};

// src/components/Tree/utils/tree.ts
function isNodeWithChildren(node) {
  return node.children !== void 0;
}
function findParentNodeById(id, nodes) {
  let foundNode;
  const findParentNode = (node) => {
    if (isNodeWithChildren(node)) {
      node.children.forEach((child) => {
        if (child.id === id) {
          foundNode = node;
          return;
        }
        if (isNodeWithChildren(child)) {
          findParentNode(child);
        }
      });
    }
  };
  nodes.forEach(findParentNode);
  return foundNode;
}
function findNodeById(id, nodes) {
  let foundNode;
  const findNode = (node) => {
    if (node.id === id) {
      foundNode = node;
      return;
    }
    if (isNodeWithChildren(node) && node.children) {
      node.children.forEach(findNode);
    }
  };
  nodes.forEach(findNode);
  return foundNode;
}

// src/components/Tree/components/TreeItem.tsx
var StyledTreeItem = styled97(MenuItemPrimitive)`
  padding-left: calc(${({ level, theme }) => level * theme.space[4]}px + ${th6.space(4)});
`;
var TreeItem = React183.forwardRef(
  (_a, ref) => {
    var _b = _a, { level = 0, itemKey, children, onClick, as = "div" } = _b, rootProps = __objRest(_b, ["level", "itemKey", "children", "onClick", "as"]);
    const { selectedKeys } = useMenu();
    const { nodes } = useTree();
    const isSelected = React183.useMemo(() => {
      const node = findNodeById(itemKey, nodes);
      return !node ? false : selectedKeys.includes(node.id);
    }, [itemKey, nodes, selectedKeys]);
    const isindeterminate = React183.useMemo(() => {
      const node = findNodeById(itemKey, nodes);
      if (!node || !isNodeWithChildren(node)) {
        return false;
      }
      const isSomeChildSelected = node.children.some((child) => selectedKeys.includes(child.id));
      return isSomeChildSelected && !selectedKeys.includes(node.id);
    }, [itemKey, nodes, selectedKeys]);
    return /* @__PURE__ */ React183.createElement(
      StyledTreeItem,
      __spreadValues({
        forwardedAs: as,
        ref,
        selected: isSelected,
        indeterminate: isindeterminate,
        itemKey,
        level,
        "data-test": itemKey ? `tree-item-${itemKey}` : "tree-item"
      }, rootProps),
      children
    );
  }
);
TreeItem.displayName = "TreeItem";

// src/components/Tree/components/TreeNodeItem.tsx
import * as React188 from "react";

// src/components/Tree/components/TreeItemDescription.tsx
import * as React184 from "react";
var TreeItemDescription = (props) => {
  return /* @__PURE__ */ React184.createElement(MenuItemDescription, __spreadValues({}, props));
};
TreeItemDescription.displayName = "TreeItemDescription";

// src/components/Tree/components/TreeItemLabel.tsx
import * as React185 from "react";
var TreeItemLabel = (props) => {
  return /* @__PURE__ */ React185.createElement(MenuItemLabel, __spreadValues({}, props));
};
TreeItemLabel.displayName = "TreeItemLabel";

// src/components/Tree/components/TreeItemPrefix.tsx
import * as React186 from "react";
var TreeItemPrefix = (props) => {
  return /* @__PURE__ */ React186.createElement(MenuItemPrefix, __spreadValues({}, props));
};
TreeItemPrefix.displayName = "TreeItemPrefix";

// src/components/Tree/components/TreeItemSuffix.tsx
import * as React187 from "react";
var TreeItemSuffix = (props) => {
  return /* @__PURE__ */ React187.createElement(MenuItemSuffix, __spreadValues({}, props));
};
TreeItemSuffix.displayName = "TreeItemSuffix";

// src/components/Tree/components/TreeNodeItem.tsx
var TreeNodeItem = ({ node, level = 0 }) => {
  if (isNodeWithChildren(node)) {
    return /* @__PURE__ */ React188.createElement(TreeGroupItem, { node, level });
  }
  return /* @__PURE__ */ React188.createElement(TreeItem, { key: node.id, itemKey: node.id, level }, node.prefix && /* @__PURE__ */ React188.createElement(TreeItemPrefix, null, node.prefix), /* @__PURE__ */ React188.createElement(TreeItemLabel, null, node.label), node.description && /* @__PURE__ */ React188.createElement(TreeItemDescription, null, node.description), node.suffix && /* @__PURE__ */ React188.createElement(TreeItemSuffix, null, node.label));
};

// src/components/Tree/components/TreeGroupItem.tsx
var TreeGroupItem = ({
  node,
  level = 0
}) => {
  var _a;
  const { expandedKeys, expand } = useTreeExpand();
  const expanded = expandedKeys == null ? void 0 : expandedKeys.includes(node.id);
  const handleToggle = React189.useCallback(
    (e) => {
      e.stopPropagation();
      expand(
        expanded ? expandedKeys == null ? void 0 : expandedKeys.filter((key) => key !== node.id) : [...expandedKeys || [], node.id]
      );
    },
    [expand, expanded, expandedKeys, node.id]
  );
  return /* @__PURE__ */ React189.createElement(React189.Fragment, null, /* @__PURE__ */ React189.createElement(TreeItem, { itemKey: node.id, "data-expanded": expanded, level }, node.prefix && /* @__PURE__ */ React189.createElement(MenuItemPrefix, null, node.prefix), /* @__PURE__ */ React189.createElement(MenuItemLabel, null, node.label), node.children && /* @__PURE__ */ React189.createElement(MenuItemSuffix, null, /* @__PURE__ */ React189.createElement(
    Button,
    {
      variant: "secondary",
      mode: "ghost",
      size: "xSmall",
      shape: "circle",
      onClick: handleToggle
    },
    expanded ? /* @__PURE__ */ React189.createElement(ChevronDownOutlined3, null) : /* @__PURE__ */ React189.createElement(ChevronRightOutlined4, null)
  ))), expanded && ((_a = node.children) == null ? void 0 : _a.map((child) => /* @__PURE__ */ React189.createElement(TreeNodeItem, { key: child.id, node: child, level: level + 1 }))));
};
TreeGroupItem.displayName = "TreeGroupItem";

// src/components/Tree/components/TreeMenu.tsx
import * as React190 from "react";
var TreeMenu = () => {
  const { nodes } = useTree();
  const { menuBordered } = useMenu();
  return /* @__PURE__ */ React190.createElement(StyledMenu, { minWidth: "unset", overflowY: "auto", bordered: menuBordered }, nodes.map((node) => /* @__PURE__ */ React190.createElement(TreeNodeItem, { key: node.id, node })));
};
TreeMenu.displayName = "TreeMenu";

// src/components/Tree/components/TreePrimitive.tsx
import * as React194 from "react";

// src/components/Tree/contexts/TreeProvider.tsx
import * as React193 from "react";

// src/components/Tree/hooks/useTreeSelection.ts
import * as React191 from "react";

// src/components/Tree/utils/selection.ts
var unique = (arr) => Array.from(new Set(arr));
var getChildrenIds = (node) => node.children.map((child) => child.id);
var calculateSelectedKeys = ({
  key,
  nodes,
  selectionMode,
  selectedKeys,
  node
}) => {
  if (selectionMode === "single") {
    const nextSelectedKeys2 = selectedKeys.includes(key) ? [] : [key];
    return unique(nextSelectedKeys2);
  }
  if (isNodeWithChildren(node)) {
    return unique([...selectedKeys, key, ...getChildrenIds(node)]);
  }
  const parentNode = findParentNodeById(key, nodes);
  const nextSelectedKeys = [...selectedKeys, key];
  const allChildrenSelected = parentNode == null ? void 0 : parentNode.children.every(
    (child) => nextSelectedKeys.includes(child.id)
  );
  return unique(
    allChildrenSelected && parentNode ? nextSelectedKeys.concat(parentNode.id) : nextSelectedKeys
  );
};
var calculateUnselectedKeys = ({
  key,
  nodes,
  selectionMode,
  selectedKeys,
  node
}) => {
  if (selectionMode === "single") {
    return [];
  }
  if (isNodeWithChildren(node)) {
    const nextSelectedKeys2 = selectedKeys.filter((k) => ![key, ...getChildrenIds(node)].includes(k));
    return unique(nextSelectedKeys2);
  }
  const parentNode = findParentNodeById(key, nodes);
  const keysToBeRemoved = parentNode ? [parentNode.id, key] : [key];
  const nextSelectedKeys = selectedKeys.filter((k) => !keysToBeRemoved.includes(k));
  return unique(nextSelectedKeys);
};

// src/components/Tree/hooks/useTreeSelection.ts
var useTreeSelection = ({
  selectionMode = "single",
  nodes,
  selectedKeys: controlledSelectedKeys,
  defaultSelectedKeys = [],
  disabled,
  onSelect,
  onDeselect,
  onSelectionChange
}) => {
  const { selectedKeys, setSelectedKeys } = useMenuSelection({
    selectedKeys: controlledSelectedKeys,
    selectionMode,
    onSelectionChange,
    defaultSelectedKeys,
    disabled
  });
  const onItemSelect = React191.useCallback(
    (key) => {
      if (disabled || selectionMode === "none") {
        return;
      }
      const node = findNodeById(key, nodes);
      if (!node) {
        return;
      }
      const wasSelected = selectedKeys.includes(key);
      if (!wasSelected) {
        const nextSelectedKeys2 = calculateSelectedKeys({
          key,
          nodes,
          selectionMode,
          selectedKeys,
          node
        });
        onSelect == null ? void 0 : onSelect(key, nextSelectedKeys2);
        return setSelectedKeys(nextSelectedKeys2);
      }
      const nextSelectedKeys = calculateUnselectedKeys({
        key,
        nodes,
        selectionMode,
        selectedKeys,
        node
      });
      onDeselect == null ? void 0 : onDeselect(key, nextSelectedKeys);
      setSelectedKeys(nextSelectedKeys);
    },
    [disabled, nodes, onDeselect, onSelect, selectedKeys, selectionMode, setSelectedKeys]
  );
  return {
    onItemSelect,
    menuDisabled: disabled,
    selectedKeys,
    selectionMode,
    setSelectedKeys
  };
};

// src/components/Tree/contexts/TreeExpandProvider.tsx
import * as React192 from "react";
import { useControllableState as useControllableState13 } from "@aircall/hooks";
var TreeExpandProvider = ({
  expandedKeys: controlledExpandedKeys,
  defaultExpandedKeys,
  onExpandChange,
  children
}) => {
  const [expandedKeys, expand] = useControllableState13({
    prop: controlledExpandedKeys,
    defaultProp: defaultExpandedKeys,
    onChange: onExpandChange
  });
  return /* @__PURE__ */ React192.createElement(TreeExpandContext.Provider, { value: { expandedKeys, expand } }, children);
};

// src/components/Tree/contexts/TreeProvider.tsx
var TreeProvider = ({
  nodes,
  selectionMode,
  size: size2,
  bordered = false,
  readOnly,
  selectedKeys: controlledSelectedKeys,
  defaultSelectedKeys = [],
  expandedKeys,
  defaultExpandedKeys,
  onExpandChange,
  onSelect,
  onDeselect,
  onSelectionChange,
  disabled,
  children
}) => {
  const { menuDisabled, onItemSelect, selectedKeys, setSelectedKeys } = useTreeSelection({
    nodes,
    selectedKeys: controlledSelectedKeys,
    selectionMode,
    defaultSelectedKeys,
    onSelect,
    onDeselect,
    onSelectionChange,
    disabled
  });
  const value = React193.useMemo(
    () => ({
      selectionMode,
      menuDisabled,
      menuBordered: bordered,
      menuReadOnly: readOnly,
      onItemSelect,
      selectedKeys,
      size: size2,
      setSelectedKeys
    }),
    [
      bordered,
      menuDisabled,
      onItemSelect,
      readOnly,
      selectedKeys,
      selectionMode,
      setSelectedKeys,
      size2
    ]
  );
  return /* @__PURE__ */ React193.createElement(TreeContext.Provider, { value: { nodes } }, /* @__PURE__ */ React193.createElement(TreeExpandProvider, __spreadValues({}, { expandedKeys, defaultExpandedKeys, onExpandChange }), /* @__PURE__ */ React193.createElement(MenuContext.Provider, { value }, children)));
};

// src/components/Tree/components/TreePrimitive.tsx
var TreePrimitive = (_a) => {
  var _b = _a, {
    selectionMode = "multiple",
    size: size2 = "regular",
    onItemSelected: onSelect,
    onItemDeselected: onDeselect,
    bordered = false,
    children
  } = _b, otherProps = __objRest(_b, [
    "selectionMode",
    "size",
    "onItemSelected",
    "onItemDeselected",
    "bordered",
    "children"
  ]);
  return /* @__PURE__ */ React194.createElement(
    TreeProvider,
    __spreadValues({}, __spreadValues({
      selectionMode,
      size: size2,
      onSelect,
      onDeselect
    }, otherProps)),
    children
  );
};
TreePrimitive.displayName = "TreePrimitive";

// src/components/Tree/Tree.tsx
var Tree = (props) => {
  return /* @__PURE__ */ React195.createElement(TreePrimitive, __spreadValues({}, props), /* @__PURE__ */ React195.createElement(TreeMenu, null));
};

// src/components/TreeSelect/TreeSelect.tsx
import * as React199 from "react";

// src/components/TreeSelect/components/TreeSelectTrigger.tsx
import React196 from "react";
var TreeSelectTrigger = (props) => {
  const { toggleOpen } = usePopoverContext();
  return /* @__PURE__ */ React196.createElement(Popover.Trigger, __spreadProps(__spreadValues({}, props), { onClick: toggleOpen }));
};
TreeSelectTrigger.displayName = "TreeSelectTrigger";

// src/components/TreeSelect/components/TreeSelectContent.tsx
import React197 from "react";
var TreeSelectContent = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React197.createElement(
    Popover.Content,
    __spreadValues({
      flexDirection: "column",
      takeViewportHeight: true,
      align: "start",
      side: "bottom",
      sideOffset: 8,
      boxShadow: 1,
      overflow: "hidden",
      borderRadius: "sm",
      bg: "surface-interactive-default"
    }, props),
    children
  );
};
TreeSelectContent.displayName = "TreeSelectContent";

// src/components/TreeSelect/components/TreeSelectRoot.tsx
import * as React198 from "react";
var TreeSelectRoot = (_a) => {
  var _b = _a, {
    children,
    defaultOpen,
    open,
    onOpenChange
  } = _b, otherProps = __objRest(_b, [
    "children",
    "defaultOpen",
    "open",
    "onOpenChange"
  ]);
  return /* @__PURE__ */ React198.createElement(TreePrimitive, __spreadValues({}, otherProps), /* @__PURE__ */ React198.createElement(Popover.Root, __spreadValues({}, { open, defaultOpen, onOpenChange }), children));
};
TreeSelectRoot.displayName = "TreeSelectRoot";

// src/components/TreeSelect/TreeSelect.tsx
var TreeSelect = (_a) => {
  var _b = _a, {
    trigger,
    selectionMode = "multiple",
    size: size2 = "regular"
  } = _b, treeProps = __objRest(_b, [
    "trigger",
    "selectionMode",
    "size"
  ]);
  return /* @__PURE__ */ React199.createElement(TreeSelectRoot, __spreadValues(__spreadValues({}, { selectionMode, size: size2 }), treeProps), /* @__PURE__ */ React199.createElement(TreeSelectTrigger, null, trigger), /* @__PURE__ */ React199.createElement(TreeSelectContent, null, /* @__PURE__ */ React199.createElement(TreeMenu, null)));
};
TreeSelect.displayName = "TreeSelect";

// src/components/WhatsAppTemplatePreview/WhatsAppTemplatePreview.tsx
import React209 from "react";
import { ImageFilled, NotesFilled } from "@aircall/icons";

// src/components/TextContentFormatter/TextContentFormatter.tsx
import React206 from "react";

// src/components/TextContentFormatter/utils/formatLinksText.tsx
import React200, { Fragment as Fragment7 } from "react";
var urlRegex = /(https?:\/\/[^\s!@#$%^&*()+=\[\]{};:'",<>?\\|`~]+(?:\.[^\s!@#$%^&*()+=\[\]{};:'",<>?\\|`~]+)+)/g;
var formatLinksText = (text) => {
  let parts = [];
  if (!text) {
    parts = [text];
  }
  try {
    parts = text.split(urlRegex);
  } catch (e) {
    parts = [text];
  }
  return /* @__PURE__ */ React200.createElement(React200.Fragment, null, parts.map((part, index) => {
    if (urlRegex.test(part)) {
      try {
        const url = new URL(part);
        if (url.username || url.password) {
          return /* @__PURE__ */ React200.createElement(Fragment7, { key: index }, part);
        }
        return /* @__PURE__ */ React200.createElement(Link_default, { key: index, href: url.href, target: "_blank", rel: "noopener noreferrer" }, part);
      } catch (e) {
        return /* @__PURE__ */ React200.createElement(Fragment7, { key: index }, part);
      }
    }
    return /* @__PURE__ */ React200.createElement(Fragment7, { key: index }, part);
  }));
};

// src/components/TextContentFormatter/utils/formatWhatsAppText.tsx
import React205 from "react";

// src/components/TextContentFormatter/components/Blockquote.tsx
import React201 from "react";
var BlockQuote = ({ children }) => /* @__PURE__ */ React201.createElement(
  Box_default,
  {
    pl: "xs",
    borderRadius: "xs",
    py: "xxs",
    borderLeft: "3px solid",
    borderColor: "graphic-default-interactive",
    bg: "surface-disabled",
    color: "text-disabled"
  },
  children
);

// src/components/TextContentFormatter/components/BulletListItem.tsx
import React202 from "react";
var BulletListItem = ({
  text,
  next
}) => {
  const content = text.replace(/^[-*]\s/, "");
  return /* @__PURE__ */ React202.createElement(Flex_default, { alignItems: "center", gap: "xxxs", margin: "xxxs" }, /* @__PURE__ */ React202.createElement(Typography_default, { as: "span", minWidth: "14px" }, "\u2022"), /* @__PURE__ */ React202.createElement("div", null, next(content)));
};

// src/components/TextContentFormatter/components/CodeBlock.tsx
import React203 from "react";
var CodeBlock = ({ content }) => /* @__PURE__ */ React203.createElement(
  Typography_default,
  {
    as: "pre",
    bg: "surface-disabled",
    p: "s",
    m: 0,
    borderRadius: "sm",
    whiteSpace: "pre-wrap",
    variant: "bodyRegularS"
  },
  /* @__PURE__ */ React203.createElement(Typography_default, { as: "code", variant: "supportingMediumS" }, content.join("\n"))
);

// src/components/TextContentFormatter/components/NumberedListItem.tsx
import React204 from "react";
var NumberedListItem = ({
  text,
  index,
  next
}) => {
  var _a;
  const number = (_a = text.match(/^\d+\./)) == null ? void 0 : _a[0];
  const content = text.replace(/^\d+\.\s/, "");
  return /* @__PURE__ */ React204.createElement(Flex_default, { key: `numbered-${index}`, alignItems: "center", gap: "xxxs", margin: "xxxs" }, /* @__PURE__ */ React204.createElement(Typography_default, { as: "span", minWidth: "14px" }, number), /* @__PURE__ */ React204.createElement("div", null, next(content)));
};

// src/components/TextContentFormatter/utils/formatWhatsAppText.tsx
var formatInlineText = (text, options) => {
  const parts = text.split(/(\*[^*]+\*|_[^_]+_|~[^~]+~|`[^`]+`)/g);
  const textFormatter = options.email ? formatLinksText : (text2) => text2;
  return parts.map((part, i) => {
    if (!part)
      return null;
    if (/^\*[^*]+\*$/.test(part)) {
      return /* @__PURE__ */ React205.createElement("strong", { key: i }, textFormatter(part.slice(1, -1)));
    }
    if (/^_[^_]+_$/.test(part)) {
      return /* @__PURE__ */ React205.createElement("em", { key: i }, textFormatter(part.slice(1, -1)));
    }
    if (/^~[^~]+~$/.test(part)) {
      return /* @__PURE__ */ React205.createElement("del", { key: i }, textFormatter(part.slice(1, -1)));
    }
    if (/^`[^`]+`$/.test(part)) {
      return /* @__PURE__ */ React205.createElement(
        Typography_default,
        {
          as: "code",
          key: i,
          bg: "surface-disabled",
          px: 1,
          py: 0.5,
          borderRadius: "xs",
          fontSize: "11px"
        },
        textFormatter(part.slice(1, -1))
      );
    }
    return /* @__PURE__ */ React205.createElement("span", { key: i }, textFormatter(part));
  });
};
var formatWhatsAppText = (text, options = { email: true }) => {
  const { email } = options;
  const lines = text.split("\n");
  let inCodeBlock = false;
  let codeBlockContent = [];
  const formattedLines = [];
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    if (line.trim() === "```") {
      if (inCodeBlock) {
        formattedLines.push(/* @__PURE__ */ React205.createElement(CodeBlock, { key: `code-block-${i}`, content: codeBlockContent }));
        codeBlockContent = [];
        inCodeBlock = false;
      } else {
        inCodeBlock = true;
      }
      continue;
    }
    if (inCodeBlock) {
      codeBlockContent.push(line);
      continue;
    }
    if (!line.trim()) {
      formattedLines.push(/* @__PURE__ */ React205.createElement("br", { key: `empty-${i}` }));
      continue;
    }
    if (line.startsWith("> ")) {
      formattedLines.push(
        /* @__PURE__ */ React205.createElement(BlockQuote, { key: `quote-${i}` }, formatInlineText(line.slice(2), { email }))
      );
      continue;
    }
    if (/^\d+\.\s/.test(line)) {
      formattedLines.push(/* @__PURE__ */ React205.createElement(NumberedListItem, { next: formatWhatsAppText, text: line, index: i }));
      continue;
    }
    if (/^[-*]\s/.test(line)) {
      formattedLines.push(
        /* @__PURE__ */ React205.createElement(BulletListItem, { key: `bullet-${i}`, text: line, next: formatWhatsAppText })
      );
      continue;
    }
    formattedLines.push(/* @__PURE__ */ React205.createElement("div", { key: `line-${i}` }, formatInlineText(line, { email })));
  }
  if (inCodeBlock && codeBlockContent.length > 0) {
    formattedLines.push(
      /* @__PURE__ */ React205.createElement(CodeBlock, { key: `unclosed-code-${lines.length}`, content: codeBlockContent })
    );
  }
  return formattedLines;
};

// src/components/TextContentFormatter/TextContentFormatter.tsx
var TextContentFormatter = React206.memo(({ text, options }) => {
  if (!text) {
    return "";
  }
  options = options != null ? options : {
    whatsapp: false,
    email: true
  };
  if (options.whatsapp) {
    return /* @__PURE__ */ React206.createElement(React206.Fragment, null, formatWhatsAppText(text, { email: options.email }));
  }
  return /* @__PURE__ */ React206.createElement(React206.Fragment, null, formatLinksText(text));
});

// src/components/WhatsAppTemplatePreview/components/MediaPreview.tsx
import React208, { memo as memo7, useState as useState27 } from "react";
import styled98 from "@xstyled/styled-components";

// src/components/WhatsAppTemplatePreview/constants.ts
var MEDIA_PREVIEW_SIZE = {
  list: "70%",
  bubble: "284px"
};

// src/components/WhatsAppTemplatePreview/components/MediaPlaceholder.tsx
import React207 from "react";
var MediaPlaceholder = () => /* @__PURE__ */ React207.createElement(
  "svg",
  {
    "data-test": "media-placeholder",
    width: "296",
    height: "167",
    viewBox: "0 0 296 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React207.createElement("rect", { width: "296", height: "166.5", fill: "white" }),
  /* @__PURE__ */ React207.createElement("g", { opacity: "0.05" }, /* @__PURE__ */ React207.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M78.8335 82.9997C78.8335 44.7973 109.795 13.833 148 13.833C186.203 13.833 217.167 44.7947 217.167 82.9997C217.167 121.202 186.205 152.166 148 152.166C109.798 152.166 78.8335 121.205 78.8335 82.9997ZM85.7505 82.9999C85.7505 117.385 113.618 145.25 148 145.25C182.385 145.25 210.25 117.382 210.25 82.9999C210.25 48.615 182.383 20.7499 148 20.7499C113.616 20.7499 85.7505 48.6173 85.7505 82.9999ZM121.346 61.2364L143.109 82.9994L121.346 104.762C118.085 108.023 122.976 112.914 126.237 109.653L148 87.8902L169.763 109.653C173.023 112.914 177.914 108.023 174.653 104.762L152.891 82.9994L174.653 61.2364C177.914 57.9759 173.023 53.0851 169.763 56.3456L148 78.1085L126.237 56.3456C122.976 53.0851 118.085 57.9759 121.346 61.2364Z",
      fill: "#6B6B6B"
    }
  ))
);

// src/components/WhatsAppTemplatePreview/components/MediaPreview.tsx
var Image = styled98.img`
  border-radius: ${getRadii("default")};
  object-fit: cover;
  max-width: ${(props) => props.mode === "list" ? MEDIA_PREVIEW_SIZE.list : MEDIA_PREVIEW_SIZE.bubble};
`;
var Video = styled98.video`
  border-radius: ${getRadii("default")};
  object-fit: cover;
  max-width: ${(props) => props.mode === "list" ? MEDIA_PREVIEW_SIZE.list : MEDIA_PREVIEW_SIZE.bubble};
`;
var MediaPreview = memo7(({ mode, header }) => {
  const [imageError, setImageError] = useState27(false);
  if (!header.url) {
    return /* @__PURE__ */ React208.createElement(MediaPlaceholder, null);
  }
  const fileName = header.url.split("/").pop() || "";
  switch (header.format) {
    case "IMAGE":
      if (imageError) {
        return /* @__PURE__ */ React208.createElement(MediaPlaceholder, null);
      }
      return /* @__PURE__ */ React208.createElement(Image, { src: header.url, alt: fileName, mode, onError: () => setImageError(true) });
    case "VIDEO":
      return /* @__PURE__ */ React208.createElement(Video, { controls: true, mode }, /* @__PURE__ */ React208.createElement("source", { src: header.url }));
    case "DOCUMENT":
      return /* @__PURE__ */ React208.createElement(Flex_default, { gap: "xxxs" }, /* @__PURE__ */ React208.createElement(Link_default, { href: header.url, target: "_blank", rel: "noopener noreferrer" }, "Download"));
    default:
      return null;
  }
});

// src/components/WhatsAppTemplatePreview/hooks/useShowMore.ts
import { useCallback as useCallback43, useEffect as useEffect27, useRef as useRef18, useState as useState28 } from "react";
var useShowMore = (isOpen) => {
  const [shouldShowMore, setShouldShowMore] = useState28(false);
  const [hasShowMore, setHasShowMore] = useState28(false);
  const textRef = useRef18(null);
  const onToggleShowMore = useCallback43(
    () => setShouldShowMore(!shouldShowMore),
    [setShouldShowMore, shouldShowMore]
  );
  useEffect27(() => {
    var _a, _b;
    if (isOpen) {
      setHasShowMore(((_a = textRef.current) == null ? void 0 : _a.scrollHeight) !== ((_b = textRef.current) == null ? void 0 : _b.clientHeight));
    } else {
      setShouldShowMore(false);
    }
  }, [isOpen]);
  return {
    hasShowMore,
    shouldShowMore,
    textRef,
    onToggleShowMore
  };
};

// src/components/WhatsAppTemplatePreview/utils/fillPlaceholders.ts
var fillPlaceholders = (text, examples, noCurlyBraces = false) => {
  if (!text) {
    return "";
  }
  return text.replace(/{{(\d+)}}/g, (_, index) => {
    var _a;
    const example = (_a = examples[+index - 1]) != null ? _a : "";
    return example ? `${noCurlyBraces ? example : `{${example}}`}` : `${noCurlyBraces ? `example_${index}` : `{example_${index}}`}`;
  });
};

// src/components/WhatsAppTemplatePreview/WhatsAppTemplatePreview.tsx
var Header = ({
  mode,
  header,
  hideCurlyBracesAroundPlaceholders = false
}) => {
  if (mode === "list") {
    return /* @__PURE__ */ React209.createElement(React209.Fragment, null, header && header.type === "text" && header.textExample && /* @__PURE__ */ React209.createElement(
      Typography_default,
      {
        "data-test": "whatsapp-template-preview-header-text",
        variant: "bodyRegularS",
        color: "text-base",
        fontWeight: "semibold"
      },
      /* @__PURE__ */ React209.createElement(
        TextContentFormatter,
        {
          text: fillPlaceholders(
            header.text,
            header.textExample,
            !hideCurlyBracesAroundPlaceholders
          ),
          options: { whatsapp: true, email: true }
        }
      )
    ), header && header.type === "media" && /* @__PURE__ */ React209.createElement(
      Flex_default,
      {
        "data-test": "whatsapp-template-preview-header-media",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "xxxs",
        w: "100%"
      },
      header.format === "DOCUMENT" ? /* @__PURE__ */ React209.createElement(NotesFilled, { size: 16, color: "icon-default" }) : /* @__PURE__ */ React209.createElement(ImageFilled, { size: 16, color: "icon-default" }),
      /* @__PURE__ */ React209.createElement(Flex_default, { alignItems: "center", justifyContent: "center" }, /* @__PURE__ */ React209.createElement(MediaPreview, { mode, header }))
    ));
  }
  return /* @__PURE__ */ React209.createElement(React209.Fragment, null, header && header.type === "text" && /* @__PURE__ */ React209.createElement(Box_default, { "data-test": "whatsapp-template-preview-header-text" }, /* @__PURE__ */ React209.createElement(Typography_default, { variant: "bodyRegularS", color: "text-base", fontWeight: "semibold" }, /* @__PURE__ */ React209.createElement(TextContentFormatter, { text: header.text, options: { whatsapp: true, email: true } }))), header && header.type === "media" && /* @__PURE__ */ React209.createElement(Box_default, { "data-test": "whatsapp-template-preview-header-media" }, /* @__PURE__ */ React209.createElement(MediaPreview, { mode, header })));
};
var Body = ({
  mode,
  body,
  labels,
  hideCurlyBracesAroundPlaceholders = false
}) => {
  var _a;
  const { hasShowMore, shouldShowMore, textRef, onToggleShowMore } = useShowMore(true);
  const showMoreButton = /* @__PURE__ */ React209.createElement(
    Button,
    {
      "data-test": "show-more-button",
      variant: "primary",
      mode: "link",
      size: "xSmall",
      onClick: (e) => {
        e.stopPropagation();
        onToggleShowMore();
      }
    },
    /* @__PURE__ */ React209.createElement(Typography_default, { variant: "supportingMediumS" }, shouldShowMore ? labels.showLess : labels.showMore)
  );
  if (mode === "list") {
    return /* @__PURE__ */ React209.createElement(
      Flex_default,
      {
        "data-test": "whatsapp-template-preview-body",
        flexDirection: "column",
        gap: "xxxs",
        alignItems: "flex-start"
      },
      /* @__PURE__ */ React209.createElement(
        Typography_default,
        {
          ref: textRef,
          variant: "bodyRegularS",
          color: "text-base",
          ellipsis: shouldShowMore ? void 0 : 7
        },
        /* @__PURE__ */ React209.createElement(
          TextContentFormatter,
          {
            text: fillPlaceholders(
              body.text,
              (_a = body.textExample) != null ? _a : [],
              !hideCurlyBracesAroundPlaceholders
            ),
            options: { whatsapp: true, email: true }
          }
        )
      ),
      hasShowMore && showMoreButton
    );
  }
  return /* @__PURE__ */ React209.createElement(
    Flex_default,
    {
      "data-test": "whatsapp-template-preview-body",
      flexDirection: "column",
      gap: "xxxs",
      alignItems: "flex-start"
    },
    /* @__PURE__ */ React209.createElement(
      Typography_default,
      {
        variant: "bodyRegularS",
        color: "text-base",
        ref: textRef,
        ellipsis: shouldShowMore ? void 0 : 7
      },
      /* @__PURE__ */ React209.createElement(TextContentFormatter, { text: body.text, options: { whatsapp: true, email: true } })
    ),
    hasShowMore && showMoreButton
  );
};
var Footer = ({
  mode,
  footer
}) => {
  if (mode === "list") {
    return /* @__PURE__ */ React209.createElement(Typography_default, { as: "div", variant: "supportingRegularS", color: "text-secondary" }, /* @__PURE__ */ React209.createElement(TextContentFormatter, { text: footer.text, options: { whatsapp: true, email: true } }));
  }
  return /* @__PURE__ */ React209.createElement(Box_default, { "data-test": "whatsapp-template-preview-footer" }, /* @__PURE__ */ React209.createElement(Typography_default, { as: "div", variant: "supportingRegularS", color: "text-secondary" }, /* @__PURE__ */ React209.createElement(TextContentFormatter, { text: footer.text, options: { whatsapp: true, email: true } })));
};
var TemplateButtons = ({
  mode,
  buttons
}) => {
  return (
    /**
     * For now buttons are only cosmetic. They do nothing in AW.
     */
    /* @__PURE__ */ React209.createElement(Box_default, { w: "100%", "data-test": "whatsapp-template-preview-buttons" }, buttons.map((button, index) => /* @__PURE__ */ React209.createElement(
      Flex_default,
      {
        key: index,
        flexDirection: "column",
        w: "100%",
        alignItems: "center",
        "data-test": "whatsapp-template-preview-button",
        borderTop: "1px solid",
        borderBottom: mode === "bubble" && index === buttons.length - 1 ? "1px solid" : "",
        borderColor: mode === "list" ? "surface-default" : "graphic-default",
        py: 3,
        px: 2
      },
      /* @__PURE__ */ React209.createElement(Typography_default, { color: "text-base", variant: "bodyMediumS" }, button.text)
    )))
  );
};
var WhatsAppTemplatePreview = ({
  mode = "list",
  header,
  body,
  footer,
  buttons,
  labels,
  hideCurlyBracesAroundPlaceholders = false
}) => {
  if (mode === "list") {
    return /* @__PURE__ */ React209.createElement(
      Flex_default,
      {
        "data-test": "whatsapp-template-preview-list-item",
        gap: "xs",
        flexDirection: "column",
        alignItems: "flex-start",
        alignSelf: "stretch",
        borderRadius: "default",
        border: "1px solid",
        borderColor: "surface-background",
        bg: "surface-background"
      },
      /* @__PURE__ */ React209.createElement(Flex_default, { flexDirection: "column", p: "xxs" }, header && /* @__PURE__ */ React209.createElement(Header, { mode, header }), body && /* @__PURE__ */ React209.createElement(Body, { labels, mode, body }), footer && /* @__PURE__ */ React209.createElement(Footer, { mode, footer })),
      buttons && buttons.length > 0 && /* @__PURE__ */ React209.createElement(TemplateButtons, { mode, buttons })
    );
  }
  return /* @__PURE__ */ React209.createElement(Flex_default, { "data-test": "whatsapp-template-preview-bubble", flexDirection: "column" }, /* @__PURE__ */ React209.createElement(Flex_default, { px: 3, pb: 3, flexDirection: "column", gap: "xs" }, header && /* @__PURE__ */ React209.createElement(
    Header,
    {
      hideCurlyBracesAroundPlaceholders,
      mode,
      header
    }
  ), body && /* @__PURE__ */ React209.createElement(
    Body,
    {
      hideCurlyBracesAroundPlaceholders,
      labels,
      mode,
      body
    }
  ), footer && /* @__PURE__ */ React209.createElement(Footer, { mode, footer })), buttons && buttons.length > 0 && /* @__PURE__ */ React209.createElement(TemplateButtons, { mode, buttons }));
};

// src/styles/animation.ts
var timingFunctions = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var transitionProperties = {
  default: [
    "background-color",
    "border-color",
    "color",
    "fill",
    "stroke",
    "opacity",
    "box-shadow",
    "transform"
  ],
  colors: ["background-color", "border-color", "color", "fill", "stroke"],
  opacity: ["opacity"],
  shadow: ["box-shadow"],
  transform: ["transform"]
};
var transitions = Object.keys(transitionProperties).reduce(
  (obj, key) => {
    obj[key] = transitionProperties[key].map((property) => `${property} ${timingFunctions["ease-in-out"]} 150ms`).join(",");
    return obj;
  },
  {}
);
var animations = {
  spin: "x-spin 1s linear infinite",
  ping: "x-ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
  pulse: "x-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  bounce: "x-bounce 1s infinite"
};

// src/styles/color.ts
var colorPalette = {
  "primary-900": "#002B20",
  "primary-800": "#004736",
  "primary-700": "#006B51",
  "primary-600": "#008F6D",
  "primary-500": "#00b388",
  "primary-300": "#66D1B8",
  "primary-100": "#C9EDE4",
  "primary-50": "#F1FAF8",
  "neutral-1000": "#000000",
  "neutral-800": "#121212",
  "neutral-700": "#232323",
  "neutral-600": "#2E2E2E",
  "neutral-500": "#383838",
  "neutral-400": "#6B6B6B",
  "neutral-300": "#A0A0A0",
  "neutral-200": "#E0E0E0",
  "neutral-100": "#F7F7F7",
  "neutral-0": "#FFFFFF",
  "secondary-900": "#0B1F28",
  "secondary-800": "#253942",
  "secondary-700": "#3E525B",
  "secondary-600": "#586C75",
  "secondary-500": "#71858E",
  "secondary-400": "#8A9EA7",
  "secondary-300": "#A8B7BE",
  "secondary-200": "#C5CFD3",
  "secondary-100": "#E2E7E4",
  "secondary-50": "#EEF4F6",
  "informative-800": "#0D3260",
  "informative-700": "#144B90",
  "informative-600": "#2766B5",
  "informative-500": "#307FE2",
  "informative-300": "#83B2EE",
  "informative-100": "#D3E2F6",
  "success-800": "#002B24",
  "success-700": "#004036",
  "success-500": "#006C5B",
  "success-300": "#66A79D",
  "success-100": "#C9DFDB",
  "warning-800": "#8F6401",
  "warning-700": "#D69702",
  "warning-600": "#E1AB29",
  "warning-500": "#FCBB26",
  "warning-300": "#FEE4A8",
  "warning-100": "#FCF3DF",
  "critical-950": "#2B0700",
  "critical-900": "#570F00",
  "critical-800": "#7C1600",
  "critical-700": "#BB2100",
  "critical-600": "#E14220",
  "critical-500": "#FF5C39",
  "critical-300": "#FF9D88",
  "critical-100": "#FCDBD4",
  "critical-50": "#FDEDE9",
  "decorative1-800": "#312A5B",
  "decorative1-700": "#493F89",
  "decorative1-600": "#6254B6",
  "decorative1-300": "#AFA5EF",
  "decorative1-100": "#E4E1FA",
  "decorative2-800": "#9A0D2B",
  "decorative2-700": "#EB5E7C",
  "decorative2-600": "#FFA0B5",
  "decorative2-300": "#FFDAE2",
  "decorative2-100": "#FFECF0"
};
var getColor16 = getColor;
var lightColorTokens = {
  // Text
  "text-highlight": getColor16("neutral-800"),
  "text-base": getColor16("neutral-600"),
  "text-secondary": getColor16("neutral-400"),
  "text-placeholder": getColor16("neutral-300"),
  "text-disabled": getColor16("neutral-300"),
  "text-info": getColor16("informative-500"),
  "text-success": getColor16("success-800"),
  "text-warning": getColor16("warning-800"),
  "text-critical": getColor16("critical-800"),
  "text-inverted": getColor16("neutral-0"),
  "text-contrast-light": getColor16("neutral-0"),
  "text-contrast-dark": getColor16("neutral-600"),
  "text-contrast-light-highlight": getColor16("text-contrast-light"),
  "text-contrast-light-base": getColor16("neutral-100"),
  "text-contrast-light-secondary": getColor16("neutral-200"),
  "text-contrast-critical": getColor16("critical-500"),
  "text-interactive-neutral": getColor16("neutral-400"),
  "text-interactive-neutral-hover": getColor16("neutral-500"),
  "text-interactive-neutral-active": getColor16("neutral-700"),
  "text-interactive-primary": getColor16("primary-600"),
  "text-interactive-primary-hover": getColor16("primary-700"),
  "text-interactive-primary-active": getColor16("primary-800"),
  "text-interactive-primary-ghost": getColor16("text-interactive-primary"),
  "text-interactive-informative": getColor16("informative-500"),
  "text-interactive-informative-hover": getColor16("informative-700"),
  "text-interactive-informative-active": getColor16("informative-800"),
  "text-interactive-informative-ghost": getColor16("text-interactive-informative"),
  "text-interactive-secondary": getColor16("secondary-700"),
  "text-interactive-secondary-hover": getColor16("secondary-800"),
  "text-interactive-secondary-active": getColor16("secondary-900"),
  "text-interactive-secondary-ghost": getColor16("text-interactive-secondary"),
  "text-interactive-critical": getColor16("critical-700"),
  "text-interactive-critical-hover": getColor16("critical-800"),
  "text-interactive-critical-active": getColor16("critical-900"),
  "text-interactive-critical-ghost": getColor16("text-interactive-critical"),
  "text-interactive-warning": getColor16("warning-500"),
  "text-interactive-warning-hover": getColor16("warning-700"),
  "text-interactive-warning-active": getColor16("warning-800"),
  "text-interactive-warning-ghost": getColor16("text-interactive-warning"),
  "text-interactive-contrast-light": getColor16("secondary-100"),
  "text-interactive-contrast-light-hover": getColor16("secondary-200"),
  "text-interactive-contrast-light-active": getColor16("secondary-300"),
  // End Text
  // Surface
  "surface-background": getColor16("neutral-100"),
  "surface-default": getColor16("neutral-0"),
  "surface-default-contrast-alpha": getColor16("white-a70"),
  "surface-overlay": "rgba(0, 0, 0, 0.5)",
  "surface-disabled": getColor16("neutral-100"),
  "surface-info": getColor16("informative-100"),
  "surface-success": getColor16("success-100"),
  "surface-warning": getColor16("warning-100"),
  "surface-critical": getColor16("critical-100"),
  "surface-critical-light": getColor16("critical-50"),
  "surface-inverted": getColor16("neutral-1000"),
  "surface-contrast-light": getColor16("neutral-1000"),
  "surface-contrast-light-alpha": getColor16("white-a10"),
  "surface-contrast-dark-alpha": getColor16("black-a80"),
  "surface-contrast-secondary": getColor16("neutral-0"),
  "surface-interactive-default": getColor16("neutral-0"),
  "surface-interactive-default-hover": getColor16("neutral-100"),
  "surface-interactive-default-active": getColor16("primary-50"),
  "surface-interactive-primary": getColor16("primary-600"),
  "surface-interactive-primary-hover": getColor16("primary-700"),
  "surface-interactive-primary-active": getColor16("primary-800"),
  "surface-interactive-secondary": getColor16("secondary-700"),
  "surface-interactive-secondary-hover": getColor16("secondary-800"),
  "surface-interactive-secondary-active": getColor16("secondary-900"),
  "surface-interactive-neutral": getColor16("neutral-200"),
  "surface-interactive-neutral-hover": getColor16("neutral-300"),
  "surface-interactive-neutral-active": getColor16("neutral-400"),
  "surface-interactive-informative": getColor16("informative-500"),
  "surface-interactive-informative-hover": getColor16("informative-700"),
  "surface-interactive-informative-active": getColor16("informative-800"),
  "surface-interactive-warning": getColor16("warning-500"),
  "surface-interactive-warning-hover": getColor16("warning-700"),
  "surface-interactive-warning-active": getColor16("warning-800"),
  "surface-interactive-critical": getColor16("critical-700"),
  "surface-interactive-critical-hover": getColor16("critical-800"),
  "surface-interactive-critical-active": getColor16("critical-900"),
  "surface-interactive-primary-ghost": "transparent",
  "surface-interactive-primary-ghost-hover": getColor16("neutral-100"),
  "surface-interactive-primary-ghost-active": getColor16("primary-50"),
  "surface-interactive-informative-ghost": "transparent",
  "surface-interactive-informative-ghost-hover": getColor16("neutral-100"),
  "surface-interactive-informative-ghost-active": getColor16("informative-50"),
  "surface-interactive-secondary-ghost": "transparent",
  "surface-interactive-secondary-ghost-hover": getColor16("secondary-50"),
  "surface-interactive-secondary-ghost-active": getColor16("secondary-100"),
  "surface-interactive-warning-ghost": "transparent",
  "surface-interactive-warning-ghost-hover": getColor16("warning-100"),
  "surface-interactive-warning-ghost-active": getColor16("warning-300"),
  "surface-interactive-critical-ghost": "transparent",
  "surface-interactive-critical-ghost-hover": getColor16("critical-100"),
  "surface-interactive-critical-ghost-active": getColor16("critical-300"),
  "surface-interactive-disabled": getColor16("neutral-200"),
  "surface-interactive-contrast-light-alpha": getColor16("white-a20"),
  "surface-interactive-contrast-light-alpha-hover": getColor16("white-a40"),
  "surface-interactive-contrast-light-alpha-active": getColor16("neutral-0"),
  // End Surface
  // Graphic
  "graphic-default": getColor16("neutral-200"),
  "graphic-neutral": getColor16("neutral-300"),
  "graphic-primary": getColor16("primary-300"),
  "graphic-primary-strong": getColor16("primary-500"),
  "graphic-informative": getColor16("informative-300"),
  "graphic-informative-strong": getColor16("informative-500"),
  "graphic-info": getColor16("informative-300"),
  "graphic-info-strong": getColor16("informative-500"),
  "graphic-success": getColor16("success-300"),
  "graphic-success-strong": getColor16("success-500"),
  "graphic-warning": getColor16("warning-300"),
  "graphic-warning-strong": getColor16("warning-500"),
  "graphic-critical": getColor16("critical-300"),
  "graphic-critical-strong": getColor16("critical-500"),
  "graphic-disabled": getColor16("neutral-200"),
  "graphic-disabled-strong": getColor16("neutral-400"),
  "graphic-inverted": getColor16("neutral-800"),
  "graphic-contrast-dark": getColor16("neutral-800"),
  "graphic-contrast-light": getColor16("neutral-0"),
  "graphic-interactive-default": getColor16("neutral-200"),
  "graphic-interactive-default-hover": getColor16("neutral-300"),
  "graphic-interactive-default-active": getColor16("neutral-400"),
  "graphic-interactive-primary": getColor16("primary-600"),
  "graphic-interactive-primary-hover": getColor16("primary-700"),
  "graphic-interactive-primary-active": getColor16("primary-800"),
  "graphic-interactive-informative": getColor16("informative-500"),
  "graphic-interactive-informative-hover": getColor16("informative-700"),
  "graphic-interactive-informative-active": getColor16("informative-800"),
  "graphic-interactive-secondary": getColor16("secondary-700"),
  "graphic-interactive-secondary-hover": getColor16("secondary-800"),
  "graphic-interactive-secondary-active": getColor16("secondary-900"),
  "graphic-interactive-critical": getColor16("critical-700"),
  "graphic-interactive-critical-hover": getColor16("critical-800"),
  "graphic-interactive-critical-active": getColor16("critical-900"),
  "graphic-interactive-warning": getColor16("warning-500"),
  "graphic-interactive-warning-hover": getColor16("warning-700"),
  "graphic-interactive-warning-active": getColor16("warning-800"),
  "graphic-interactive-primary-ghost": "transparent",
  "graphic-interactive-primary-hover-ghost": getColor16("neutral-100"),
  "graphic-interactive-primary-active-ghost": getColor16("neutral-200"),
  "graphic-interactive-informative-ghost": "transparent",
  "graphic-interactive-informative-hover-ghost": getColor16("neutral-100"),
  "graphic-interactive-informative-active-ghost": getColor16("neutral-200"),
  "graphic-interactive-critical-ghost": "transparent",
  "graphic-interactive-critical-hover-ghost": getColor16("critical-100"),
  "graphic-interactive-critical-active-ghost": getColor16("critical-300"),
  "graphic-interactive-secondary-ghost": "transparent",
  "graphic-interactive-secondary-hover-ghost": getColor16("secondary-50"),
  "graphic-interactive-secondary-active-ghost": getColor16("secondary-100"),
  "graphic-interactive-contrast-light-alpha": getColor16("white-a10"),
  "graphic-interactive-contrast-light-alpha-hover": getColor16("white-a20"),
  "graphic-interactive-contrast-light-alpha-active": getColor16("neutral-0"),
  // End Graphic
  // Icon
  "icon-default": getColor16("neutral-400"),
  "icon-highlight": getColor16("neutral-800"),
  "icon-base": getColor16("neutral-600"),
  "icon-primary": getColor16("primary-500"),
  "icon-secondary": getColor16("secondary-300"),
  "icon-disabled": getColor16("neutral-300"),
  "icon-info": getColor16("informative-500"),
  "icon-success": getColor16("success-500"),
  "icon-warning": getColor16("warning-700"),
  "icon-critical": getColor16("critical-700"),
  "icon-inverted": getColor16("neutral-0"),
  "icon-secondary-inverted": getColor16("secondary-700"),
  "icon-contrast-secondary": getColor16("secondary-700"),
  "icon-contrast-light": getColor16("neutral-0"),
  "icon-contrast-dark": getColor16("neutral-800"),
  "icon-interactive-default": getColor16("neutral-400"),
  "icon-interactive-default-hover": getColor16("neutral-500"),
  "icon-interactive-default-active": getColor16("neutral-700"),
  "icon-interactive-primary": getColor16("primary-600"),
  "icon-interactive-primary-hover": getColor16("primary-700"),
  "icon-interactive-primary-active": getColor16("primary-800"),
  "icon-interactive-informative": getColor16("informative-500"),
  "icon-interactive-informative-hover": getColor16("informative-700"),
  "icon-interactive-informative-active": getColor16("informative-800"),
  "icon-interactive-secondary": getColor16("secondary-700"),
  "icon-interactive-secondary-hover": getColor16("secondary-800"),
  "icon-interactive-secondary-active": getColor16("secondary-900"),
  "icon-interactive-critical": getColor16("critical-700"),
  "icon-interactive-critical-hover": getColor16("critical-800"),
  "icon-interactive-critical-active": getColor16("critical-900"),
  "icon-interactive-warning": getColor16("warning-500"),
  "icon-interactive-warning-hover": getColor16("warning-700"),
  "icon-interactive-warning-active": getColor16("warning-800"),
  "icon-interactive-contrast": getColor16("secondary-100"),
  "icon-interactive-contrast-hover": getColor16("secondary-200"),
  "icon-interactive-contrast-active": getColor16("secondary-300"),
  // End Icon
  // Call type
  "call-assigned": getColor16("primary-700"),
  "call-answered": getColor16("primary-500"),
  "call-missed": getColor16("critical-500"),
  "call-callback": getColor16("informative-500"),
  "call-abandoned": getColor16("neutral-400"),
  "call-voicemail": getColor16("warning-500"),
  // End Call type
  "surface-primary-alpha": "rgba(0, 0, 0, 0.11)",
  "surface-secondary-alpha": "rgba(0, 0, 0, 0.04)",
  "surface-primary-contrast-dark-alpha": "rgba(255, 255, 255, 0.11)",
  "surface-secondary-contrast-dark-alpha": "rgba(255, 255, 255, 0.04)"
};
var darkColorTokens = {
  // Text
  "text-highlight": getColor16("neutral-0"),
  "text-base": getColor16("neutral-100"),
  "text-secondary": getColor16("neutral-200"),
  "text-placeholder": getColor16("neutral-300"),
  "text-disabled": getColor16("neutral-300"),
  "text-info": getColor16("informative-500"),
  "text-success": getColor16("success-500"),
  "text-warning": getColor16("warning-500"),
  "text-critical": getColor16("critical-500"),
  "text-inverted": getColor16("neutral-800"),
  "text-contrast-light": getColor16("neutral-0"),
  "text-contrast-dark": getColor16("neutral-800"),
  "text-contrast-critical": getColor16("critical-500"),
  "text-interactive-neutral": getColor16("neutral-300"),
  "text-interactive-neutral-hover": getColor16("neutral-200"),
  "text-interactive-neutral-active": getColor16("neutral-100"),
  "text-interactive-primary": getColor16("primary-500"),
  "text-interactive-primary-hover": getColor16("primary-300"),
  "text-interactive-primary-active": getColor16("primary-100"),
  "text-interactive-primary-ghost": getColor16("text-interactive-primary"),
  "text-interactive-informative": getColor16("informative-500"),
  "text-interactive-informative-hover": getColor16("informative-500"),
  "text-interactive-informative-active": getColor16("informative-300"),
  "text-interactive-informative-ghost": getColor16("text-interactive-informative"),
  "text-interactive-secondary": getColor16("neutral-100"),
  "text-interactive-secondary-hover": getColor16("secondary-200"),
  "text-interactive-secondary-active": getColor16("secondary-100"),
  "text-interactive-secondary-ghost": getColor16("text-interactive-secondary"),
  "text-interactive-critical": getColor16("critical-700"),
  "text-interactive-critical-hover": getColor16("critical-500"),
  "text-interactive-critical-active": getColor16("critical-300"),
  "text-interactive-critical-ghost": getColor16("text-interactive-critical"),
  "text-interactive-warning": getColor16("warning-500"),
  "text-interactive-warning-hover": getColor16("warning-700"),
  "text-interactive-warning-active": getColor16("warning-800"),
  "text-interactive-warning-ghost": getColor16("text-interactive-warning"),
  // End Text
  // Surface
  "surface-background": getColor16("neutral-800"),
  "surface-default": getColor16("neutral-600"),
  "surface-default-alpha": getColor16("neutral-0"),
  "surface-default-contrast-alpha": getColor16("black-a80"),
  "surface-overlay": "rgba(0, 0, 0, 0.5)",
  "surface-disabled": getColor16("neutral-800"),
  "surface-info": getColor16("informative-700"),
  "surface-success": getColor16("success-700"),
  "surface-warning": getColor16("warning-800"),
  "surface-critical": getColor16("critical-800"),
  "surface-critical-light": getColor16("critical-800"),
  "surface-inverted": getColor16("neutral-0"),
  "surface-contrast-secondary": getColor16("neutral-0"),
  "surface-interactive-default": getColor16("neutral-600"),
  "surface-interactive-default-hover": getColor16("neutral-500"),
  "surface-interactive-default-active": getColor16("primary-900"),
  "surface-interactive-primary": getColor16("primary-600"),
  "surface-interactive-primary-hover": getColor16("primary-700"),
  "surface-interactive-primary-active": getColor16("primary-800"),
  "surface-interactive-secondary": getColor16("secondary-500"),
  "surface-interactive-secondary-hover": getColor16("secondary-600"),
  "surface-interactive-secondary-active": getColor16("secondary-100"),
  "surface-interactive-neutral": getColor16("neutral-200"),
  "surface-interactive-neutral-hover": getColor16("neutral-300"),
  "surface-interactive-neutral-active": getColor16("neutral-400"),
  "surface-interactive-informative": getColor16("informative-500"),
  "surface-interactive-informative-hover": getColor16("informative-600"),
  "surface-interactive-informative-active": getColor16("informative-300"),
  "surface-interactive-warning": getColor16("warning-500"),
  "surface-interactive-warning-hover": getColor16("warning-600"),
  "surface-interactive-warning-active": getColor16("warning-300"),
  "surface-interactive-critical": getColor16("critical-500"),
  "surface-interactive-critical-hover": getColor16("critical-700"),
  "surface-interactive-critical-active": getColor16("critical-800"),
  "surface-interactive-primary-ghost": "transparent",
  "surface-interactive-primary-ghost-hover": getColor16("neutral-600"),
  "surface-interactive-primary-ghost-active": getColor16("primary-900"),
  "surface-interactive-informative-ghost": "transparent",
  "surface-interactive-informative-ghost-hover": getColor16("neutral-600"),
  "surface-interactive-informative-ghost-active": getColor16("informative-800"),
  "surface-interactive-secondary-ghost": "transparent",
  "surface-interactive-secondary-ghost-hover": getColor16("secondary-800"),
  "surface-interactive-secondary-ghost-active": getColor16("secondary-700"),
  "surface-interactive-warning-ghost": "transparent",
  "surface-interactive-warning-ghost-hover": getColor16("warning-800"),
  "surface-interactive-warning-ghost-active": getColor16("warning-700"),
  "surface-interactive-critical-ghost": "transparent",
  "surface-interactive-critical-ghost-hover": getColor16("critical-900"),
  "surface-interactive-critical-ghost-active": getColor16("critical-950"),
  "surface-interactive-disabled": getColor16("neutral-500"),
  // End Surface
  // Graphic
  "graphic-default": getColor16("neutral-500"),
  "graphic-neutral": getColor16("neutral-300"),
  "graphic-primary": getColor16("primary-300"),
  "graphic-primary-strong": getColor16("primary-500"),
  "graphic-info": getColor16("informative-300"),
  "graphic-info-strong": getColor16("informative-500"),
  "graphic-success": getColor16("success-300"),
  "graphic-success-strong": getColor16("success-500"),
  "graphic-warning": getColor16("warning-300"),
  "graphic-warning-strong": getColor16("warning-500"),
  "graphic-critical": getColor16("critical-300"),
  "graphic-critical-strong": getColor16("critical-500"),
  "graphic-disabled": getColor16("neutral-500"),
  "graphic-disabled-strong": getColor16("neutral-400"),
  "graphic-inverted": getColor16("neutral-0 "),
  "graphic-contrast-dark": getColor16("neutral-800"),
  "graphic-contrast-light": getColor16("neutral-0"),
  "graphic-interactive-default": getColor16("neutral-400"),
  "graphic-interactive-default-hover": getColor16("neutral-300"),
  "graphic-interactive-default-active": getColor16("neutral-200"),
  "graphic-interactive-primary": getColor16("primary-500"),
  "graphic-interactive-primary-hover": getColor16("primary-300"),
  "graphic-interactive-primary-active": getColor16("primary-100"),
  "graphic-interactive-informative": getColor16("informative-500"),
  "graphic-interactive-informative-hover": getColor16("informative-600"),
  "graphic-interactive-informative-active": getColor16("informative-300"),
  "graphic-interactive-secondary": getColor16("secondary-500"),
  "graphic-interactive-secondary-hover": getColor16("secondary-600"),
  "graphic-interactive-secondary-active": getColor16("secondary-300"),
  "graphic-interactive-critical": getColor16("critical-500"),
  "graphic-interactive-critical-hover": getColor16("critical-700"),
  "graphic-interactive-critical-active": getColor16("critical-800"),
  "graphic-interactive-warning": getColor16("warning-500"),
  "graphic-interactive-warning-hover": getColor16("warning-600"),
  "graphic-interactive-warning-active": getColor16("warning-300"),
  "graphic-interactive-primary-ghost": "transparent",
  "graphic-interactive-primary-hover-ghost": getColor16("neutral-600"),
  "graphic-interactive-primary-active-ghost": getColor16("primary-900"),
  "graphic-interactive-informative-ghost": "transparent",
  "graphic-interactive-informative-hover-ghost": getColor16("neutral-600"),
  "graphic-interactive-informative-active-ghost": getColor16("informative-800"),
  "graphic-interactive-secondary-ghost": "transparent",
  "graphic-interactive-secondary-hover-ghost": getColor16("secondary-800"),
  "graphic-interactive-secondary-active-ghost": getColor16("secondary-700"),
  "graphic-interactive-critical-ghost": "transparent",
  "graphic-interactive-critical-hover-ghost": getColor16("critical-100"),
  "graphic-interactive-critical-active-ghost": getColor16("critical-300"),
  // End Graphic
  // Icon
  "icon-default": getColor16("neutral-200"),
  "icon-highlight": getColor16("neutral-0"),
  "icon-base": getColor16("neutral-200"),
  "icon-primary": getColor16("primary-500"),
  "icon-secondary": getColor16("secondary-700"),
  "icon-disabled": getColor16("neutral-400"),
  "icon-info": getColor16("informative-500"),
  "icon-success": getColor16("success-500"),
  "icon-warning": getColor16("warning-700"),
  "icon-critical": getColor16("critical-700"),
  "icon-inverted": getColor16("neutral-800"),
  "icon-contrast-secondary": getColor16("secondary-700"),
  "icon-contrast-light": getColor16("neutral-0"),
  "icon-contrast-dark": getColor16("neutral-800"),
  "icon-secondary-inverted": getColor16("neutral-200"),
  "icon-interactive-default": getColor16("neutral-200"),
  "icon-interactive-default-hover": getColor16("neutral-200"),
  "icon-interactive-default-active": getColor16("neutral-100"),
  "icon-interactive-primary": getColor16("primary-500"),
  "icon-interactive-primary-hover": getColor16("primary-300"),
  "icon-interactive-primary-active": getColor16("primary-100"),
  "icon-interactive-informative": getColor16("informative-500"),
  "icon-interactive-informative-hover": getColor16("informative-600"),
  "icon-interactive-informative-active": getColor16("informative-500"),
  "icon-interactive-secondary": getColor16("secondary-300"),
  "icon-interactive-secondary-hover": getColor16("secondary-200"),
  "icon-interactive-secondary-active": getColor16("secondary-100"),
  "icon-interactive-critical": getColor16("critical-700"),
  "icon-interactive-critical-hover": getColor16("critical-600"),
  "icon-interactive-critical-active": getColor16("critical-500"),
  "icon-interactive-warning": getColor16("warning-500"),
  "icon-interactive-warning-hover": getColor16("warning-600"),
  "icon-interactive-warning-active": getColor16("warning-500"),
  // End Icon
  // Call type
  "call-assigned": getColor16("primary-700"),
  "call-answered": getColor16("primary-500"),
  "call-missed": getColor16("critical-500"),
  "call-callback": getColor16("informative-500"),
  "call-abandoned": getColor16("neutral-400"),
  "call-voicemail": getColor16("warning-500"),
  // End Call type
  "surface-primary-alpha": "rgba(255, 255, 255, 0.11)",
  "surface-secondary-alpha": "rgba(255, 255, 255, 0.04)",
  "surface-primary-contrast-dark-alpha": "rgba(255, 255, 255, 0.11)",
  "surface-secondary-contrast-dark-alpha": "rgba(255, 255, 255, 0.04)"
};
var alphaColorTokens = generateHexAlphaVariants({
  white: "#FFFFFF",
  black: "#000000"
});
var colors = __spreadProps(__spreadValues(__spreadValues(__spreadValues({}, colorPalette), lightColorTokens), alphaColorTokens), {
  modes: {
    dark: darkColorTokens
  }
});

// src/styles/duration.ts
var durations = {
  instant: "100ms",
  "fast-in": "250ms",
  "fast-out": "200ms",
  "slow-in": "300ms",
  "slow-out": "250ms"
};

// src/styles/font.ts
var fonts = {
  default: [
    "Fellix",
    "-apple-system",
    "BlinkMacSystemFont",
    "Helvetica Neue",
    "Arial",
    "sans-serif"
  ].join(", ")
};

// src/styles/grid.ts
var gridTemplateColumns = {
  1: "repeat(1, minmax(0, 1fr))",
  2: "repeat(2, minmax(0, 1fr))",
  3: "repeat(3, minmax(0, 1fr))",
  4: "repeat(4, minmax(0, 1fr))",
  5: "repeat(5, minmax(0, 1fr))",
  6: "repeat(6, minmax(0, 1fr))",
  7: "repeat(7, minmax(0, 1fr))",
  8: "repeat(8, minmax(0, 1fr))",
  9: "repeat(9, minmax(0, 1fr))",
  10: "repeat(10, minmax(0, 1fr))",
  11: "repeat(11, minmax(0, 1fr))",
  12: "repeat(12, minmax(0, 1fr))"
};
var gridTemplateRows = {
  1: "repeat(1, minmax(0, 1fr))",
  2: "repeat(2, minmax(0, 1fr))",
  3: "repeat(3, minmax(0, 1fr))",
  4: "repeat(4, minmax(0, 1fr))",
  5: "repeat(5, minmax(0, 1fr))",
  6: "repeat(6, minmax(0, 1fr))"
};

// src/styles/radii.ts
var radii = {
  none: "0",
  xs: "4px",
  sm: "8px",
  md: "12px",
  default: "16px",
  lg: "24px",
  full: "9999px"
};

// src/styles/screen.ts
var screens = {
  _: 0,
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

// src/styles/shadow.ts
var shadows = {
  1: "0px 1px 10px rgba(0, 0, 0, 0.12)",
  2: "0px 8px 10px rgba(0, 0, 0, 0.12)",
  3: "0px -5px 20px rgba(0, 0, 0, 0.1)",
  4: "0px 2px 2px rgba(0, 0, 0, 0.08)",
  5: "0px 8px 20px rgba(16, 24, 32, 0.1)",
  6: "0px 18px 30px rgba(16, 24, 32, 0.1)"
};

// src/styles/space.ts
var space5 = {
  0: 0,
  0.5: 2,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 40,
  8: 64,
  9: 80,
  xxxs: 4,
  xxs: 8,
  xs: 12,
  s: 16,
  m: 24,
  l: 32,
  xl: 40,
  xxl: 64,
  xxxl: 80
};

// src/styles/state.ts
var states = {
  _: null,
  motionSafe: "@media (prefers-reduced-motion: no-preference)",
  motionReduce: "@media (prefers-reduced-motion: reduce)",
  first: "&:first-child",
  last: "&:last-child",
  odd: "&:odd",
  even: "&:even",
  visited: "&:visited",
  checked: "&:checked",
  focusWithin: "&:focus-within",
  hover: "&:hover",
  focus: "&:focus",
  focusVisible: "&:focus-visible",
  active: "&:active",
  disabled: "&:disabled, &[aria-disabled=true]",
  placeholder: "&::placeholder"
};

// src/styles/typography.ts
var fontWeightLight = {
  fontWeight: 300
};
var fontWeightRegular = {
  fontWeight: 400
};
var fontWeightMedium = {
  fontWeight: 500
};
var fontWeightSemibold = {
  fontWeight: 600
};
var fontWeightBold = {
  fontWeight: 700
};
var supportingXS = {
  fontSize: "10px",
  lineHeight: "12px"
};
var supportingS = {
  fontSize: "12px",
  lineHeight: "16px"
};
var bodyS = {
  fontSize: "14px",
  lineHeight: "18px"
};
var bodyM = {
  fontSize: "16px",
  lineHeight: "20px"
};
var headingXS = {
  fontSize: "18px",
  lineHeight: "20px"
};
var headingS = {
  fontSize: "20px",
  lineHeight: "24px"
};
var headingM = {
  fontSize: "32px",
  lineHeight: "40px"
};
var headingL = {
  fontSize: "42px",
  lineHeight: "40px"
};
var headingXL = {
  fontSize: "48px",
  lineHeight: "48px"
};
var newTypography = {
  supportingRegularXS: __spreadValues(__spreadValues({}, supportingXS), fontWeightRegular),
  supportingMediumXS: __spreadValues(__spreadValues({}, supportingXS), fontWeightMedium),
  supportingSemiboldXS: __spreadValues(__spreadValues({}, supportingXS), fontWeightSemibold),
  supportingRegularS: __spreadValues(__spreadValues({}, supportingS), fontWeightRegular),
  supportingMediumS: __spreadValues(__spreadValues({}, supportingS), fontWeightMedium),
  supportingSemiboldS: __spreadValues(__spreadValues({}, supportingS), fontWeightSemibold),
  bodyRegularS: __spreadValues(__spreadValues({}, bodyS), fontWeightRegular),
  bodyMediumS: __spreadValues(__spreadValues({}, bodyS), fontWeightMedium),
  bodySemiboldS: __spreadValues(__spreadValues({}, bodyS), fontWeightSemibold),
  bodyRegularM: __spreadValues(__spreadValues({}, bodyM), fontWeightRegular),
  bodyMediumM: __spreadValues(__spreadValues({}, bodyM), fontWeightMedium),
  bodySemiboldM: __spreadValues(__spreadValues({}, bodyM), fontWeightSemibold),
  headingLightXS: __spreadValues(__spreadValues({}, headingXS), fontWeightLight),
  headingMediumXS: __spreadValues(__spreadValues({}, headingXS), fontWeightMedium),
  headingBoldXS: __spreadValues(__spreadValues({}, headingXS), fontWeightBold),
  headingLightS: __spreadValues(__spreadValues({}, headingS), fontWeightLight),
  headingMediumS: __spreadValues(__spreadValues({}, headingS), fontWeightMedium),
  headingBoldS: __spreadValues(__spreadValues({}, headingS), fontWeightBold),
  headingLightM: __spreadValues(__spreadValues({}, headingM), fontWeightLight),
  headingMediumM: __spreadValues(__spreadValues({}, headingM), fontWeightMedium),
  headingBoldM: __spreadValues(__spreadValues({}, headingM), fontWeightBold),
  headingLightL: __spreadValues(__spreadValues({}, headingL), fontWeightLight),
  headingMediumL: __spreadValues(__spreadValues({}, headingL), fontWeightMedium),
  headingBoldL: __spreadValues(__spreadValues({}, headingL), fontWeightBold),
  headingLightXL: __spreadValues(__spreadValues({}, headingXL), fontWeightLight),
  headingMediumXL: __spreadValues(__spreadValues({}, headingXL), fontWeightMedium),
  headingBoldXL: __spreadValues(__spreadValues({}, headingXL), fontWeightBold)
};
var typography2 = __spreadValues({}, newTypography);

// src/styles/theme.ts
var defaultTheme = {
  // Don't use dark mode based on the query media.
  // This would create confusion especially in storybook.
  useColorSchemeMediaQuery: false,
  colors,
  space: space5,
  inset: space5,
  screens,
  durations,
  radii,
  shadows,
  gridTemplateColumns,
  gridTemplateRows,
  fonts,
  typography: typography2,
  transitions,
  transitionProperties,
  timingFunctions,
  animations,
  states
};

// src/styles/ThemeProvider.tsx
import * as React210 from "react";
import { ThemeProvider as BaseThemeProvider } from "@xstyled/styled-components";
import merge from "lodash.merge";
var ThemeProvider = ({
  children,
  theme,
  deepMerge = true
}) => {
  const mergedTheme = deepMerge ? mergeTheme(theme) : __spreadValues(__spreadValues({}, defaultTheme), theme);
  return /* @__PURE__ */ React210.createElement(BaseThemeProvider, { theme: mergedTheme }, children);
};
var mergeTheme = (theme) => {
  if (!theme) {
    return defaultTheme;
  }
  if (typeof theme === "function") {
    return theme(defaultTheme);
  }
  return merge({}, defaultTheme, theme);
};
var ThemeProvider_default = ThemeProvider;

// src/internal/Tractor.tsx
import * as React211 from "react";
import { ColorModeProvider } from "@xstyled/styled-components";
var Tractor = ({
  theme,
  icons,
  injectStyle = false,
  colorModeTargetSelector = "",
  children,
  toastConfig,
  bannerConfig,
  deepMerge = true
}) => {
  return /* @__PURE__ */ React211.createElement(ThemeProvider_default, { theme, deepMerge }, /* @__PURE__ */ React211.createElement(ColorModeProvider, { targetSelector: colorModeTargetSelector }, /* @__PURE__ */ React211.createElement(IconProvider, { value: { icons } }, /* @__PURE__ */ React211.createElement(ToastManager, __spreadValues({}, toastConfig), /* @__PURE__ */ React211.createElement(BannerManager, __spreadValues({}, bannerConfig), children, injectStyle && // FIXME
  // @ts-ignore
  /* @__PURE__ */ React211.createElement(InjectGlobalStyle, null), /* @__PURE__ */ React211.createElement(Squircle_default, null))))));
};
var Tractor_default = Tractor;
export {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  ActionBar,
  ActionMenu,
  Audio2 as Audio,
  AudioBar,
  AudioContext,
  AudioCurrentTime,
  AudioDuration,
  AudioManager,
  AudioManagerContext,
  AudioTimeContext,
  Avatar,
  AvatarFallback,
  AvatarIcon,
  AvatarImg,
  AvatarText,
  Badge,
  Banner,
  BannerButton,
  BannerContext,
  BannerHeading,
  BannerIcon,
  BannerManager,
  BannerParagraph,
  BannerSuffix,
  Box_default as Box,
  Button,
  Checkbox,
  CheckboxDescription,
  CheckboxLabel,
  ColumnTextAlign,
  ComboBox,
  ComboBoxContent,
  ComboBoxItem,
  ComboBoxMenu,
  ComboBoxTrigger,
  Container8 as Container,
  CounterBadge,
  DEFAULT_PAGE_SIZE,
  DatePicker,
  Divider,
  DividerOrientation,
  DividerSize,
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  Dropdown,
  DropdownButton,
  FlagIcon,
  Flex_default as Flex,
  FocusTrap_default as FocusTrap,
  Form_default as Form,
  FormContext,
  FormItem_default as FormItem,
  FormItemContext,
  Gauge_default as Gauge,
  Grid,
  Icon_default as Icon,
  IconButton_default as IconButton,
  IconComponent,
  IconContext,
  IconProvider,
  InjectGlobalStyle,
  Link_default as Link,
  List,
  ListFooter,
  ListItem,
  ListView,
  ListViewBase,
  MAX_Z_INDEX,
  Menu,
  MenuContext,
  MenuItem,
  MenuItemCheckIcon,
  MenuItemDescription,
  MenuItemGroup,
  MenuItemLabel,
  MenuItemPrefix,
  MenuItemSuffix,
  MenuProvider,
  ModalBody,
  ModalClose,
  ModalContext,
  ModalDialog,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  MotionBox,
  OrderDirection,
  Pagination,
  PasswordInput,
  PlayButton,
  Popover,
  PopoverArrowContext,
  PopoverContext,
  PopoverPlacementContext,
  Portal,
  QuickAudioPlayer,
  QuickAvatar,
  Radio,
  RadioDescription,
  RadioGroup,
  RadioLabel,
  RowActionType,
  SegmentedControl,
  SegmentedControlContext,
  SegmentedControlOption,
  SegmentedControlOptionLabel,
  SegmentedControlOptionPrefix,
  SegmentedControlOptionSuffix,
  SegmentedControlOptionTag,
  SegmentedControlProvider,
  SegmentedControlSeparator,
  Select,
  SidenavDropdown,
  SidenavDropdownItem,
  SidenavDropdownItemLabel,
  SidenavDropdownSeparator,
  SidenavItem,
  SidenavItemIndicator,
  SidenavItemTitle,
  Skeleton,
  Slider,
  Spacer,
  Squircle_default as Squircle,
  StickTo,
  StyledListItem,
  StyledListView,
  StyledMenuItemDescription,
  StyledMenuItemLabel,
  TabContainer,
  TabContent,
  TabItem,
  TabMenu,
  TabMenuItem,
  TabToggle,
  Table3 as Table,
  Tag,
  TagDeleteIcon,
  TagLabel,
  TextContentFormatter,
  TextInput,
  Textarea_default as Textarea,
  ThemeProvider_default as ThemeProvider,
  Toast,
  ToastButton,
  ToastCloseIcon,
  ToastConfigContext,
  ToastContext,
  ToastIcon,
  ToastManager,
  ToastMessage,
  Toggle,
  ToggleDescription,
  ToggleLabel,
  Tooltip,
  Tractor_default as Tractor,
  Tree,
  TreeSelect,
  TreeSelectContent,
  TreeSelectRoot,
  TreeSelectTrigger,
  Typography_default as Typography,
  WhatsAppTemplatePreview,
  banners,
  defaultAudioContext,
  defaultTheme,
  fromTheme,
  generateHexAlphaVariants,
  getColor,
  getRadii,
  getShadow,
  getSpace,
  isScrollAtBottom,
  isScrollAtTop,
  join,
  mapValues,
  noop,
  textColor,
  toasts,
  useAudio,
  useAudioManager,
  useAudioTime,
  useBanner,
  useColor2 as useColor,
  useColorMode,
  useComboBox,
  useDown,
  useDropdownContext,
  useElementEdgeInView,
  useElementPosition,
  useFormContext,
  useFormItemContext,
  useIconContext,
  useMenu,
  useMenuSelection,
  useModalContext,
  usePopoverArrow,
  usePopoverContext,
  usePopoverPlacement,
  useRadius,
  useScreens,
  useSegmentedControl,
  useSegmentedControlSelection,
  useSelect,
  useShadow,
  useSpace,
  useTh,
  useTheme,
  useToast,
  useToastConfig,
  useTree,
  useUp,
  useViewportWidth
};
